/* Construit par shopify/outils/construire-theme.mjs : maquettes/verre-salon/app.js (commit 474d6247) + shopify/outils/adaptateur-shopify.js, 45 retouches documentées dans le script. Ne pas modifier à la main. */
/* =========================================================
   Caplia — maquette « Verre · Salon » — application
   Routage par hash, rendu depuis /site/data/*.json
   ========================================================= */
(() => {
  'use strict';
  /* =========================================================
     Adaptateur Shopify (inséré dans app.js par shopify/outils/construire-theme.mjs, juste après 'use strict')
     - window.CAPLIA (snippets/caplia-config.liquid) : adresses des fichiers du thème, page ouverte, produits et
       panier Shopify, médias du produit ouvert ;
     - adresses : les chemins de la maquette (/site/assets/…, #/…) deviennent ceux de Shopify ;
     - produits : prix, couleurs et tailles en vente lus dans les variantes Shopify ;
     - panier : le tableau `cart` de la maquette est le reflet du panier Shopify (Cart AJAX API) ;
     - formulaires : contact, rétractation, inscription e-mail et « Me prévenir » envoyés à Shopify.
     ========================================================= */
  const CAPLIA = window.CAPLIA || {};
  const ROOT = String(CAPLIA.racine || '/').replace(/\/$/, '');
  const R = (path) => ROOT + path;
  const BASE = CAPLIA.base || '';
  /* paramètres de l'adresse (?couleur=, ?s=, ?m=, ?variant=) : la maquette les lisait après le « # » */
  const qsAll = () => new URLSearchParams(location.search);

  /* ---------- Fichiers du thème : /site/assets/a/b.webp -> <assets>/a--b.webp ---------- */
  const THEME_PHOTOS = new Set();
  const flat = (u) => u.replace(/^\/site\/assets\//, '').replace(/^\/maquettes\//, 'maquettes/').replace(/\//g, '--');
  function ASSET(u) {
    if (typeof u !== 'string' || !/^\/(site\/assets|maquettes)\//.test(u)) return u;
    const m = u.match(/^\/site\/assets\/produits\/([^/]+)\/([^/]+)-(\d+)\.(\w+)$/);
    if (m && !THEME_PHOTOS.has(u)) {
      /* photo du thème (k1…) demandée à une autre largeur (vignettes en 300) : son fichier de 640 */
      const u640 = u.replace(/-\d+\.(\w+)$/, '-640.$1');
      return MEDIA_URL(m[1], m[2], Number(m[3])) || (THEME_PHOTOS.has(u640) ? BASE + flat(u640) : CUT(m[1]));
    }
    return BASE + flat(u);
  }
  /* images du thème : version ajoutée (?v=) pour que le cache d'un an des navigateurs ne garde pas une ancienne image */
  let IMGV = '';
  const BASE_RE = new RegExp(BASE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[^"\'\\s,)<>?]+\\.(?:webp|avif|jpe?g|png)(?![?\\w])', 'g');
  const VERSION = (html) => (IMGV && BASE ? html.replace(BASE_RE, (u) => `${u}?v=${IMGV}`) : html);
  const ASSETS_IN = (html) => VERSION(String(html).replace(/(?<![\w.:\/-])\/(?:site\/assets|maquettes)\/[^"'\s,)<>]+/g, (u) => ASSET(u)));
  /* données : toute chaîne qui commence par /site/assets/ (fichier ou dossier) pointe vers les fichiers du thème */
  function MAP_DATA(o) {
    if (typeof o === 'string') return /^\/(site\/assets|maquettes)\//.test(o) ? BASE + flat(o) : o;
    if (Array.isArray(o)) return o.map(MAP_DATA);
    if (o && typeof o === 'object') { Object.keys(o).forEach((k) => { o[k] = MAP_DATA(o[k]); }); }
    return o;
  }
  /* image de repli d'une pièce (la maquette avait ses détourés) : sa carte en vraie photo dans le studio gris */
  function CUT(slug) {
    const e = PHOTO && PHOTO.pieces && PHOTO.pieces[typeof slug === 'string' ? slug : slug.slug];
    return e && e.fichier ? `${PHOTO.dossier}${e.fichier}-720.webp` : '';
  }

  /* ---------- Médias Shopify du produit ouvert, reliés aux photos du catalogue ---------- */
  const MEDIA = {};   /* slug -> { id photo du catalogue -> adresse Shopify } */
  let MEDIAS_IMPORT = {};   /* slug -> { fichiers: { nom -> id }, alts: { texte -> id } }, depuis caplia-donnees.json */
  const normTxt = (s) => String(s || '').toLowerCase().replace(/œ/g, 'oe').replace(/æ/g, 'ae').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const withWidth = (src, w) => (/[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, `$1${w}`) : src + (src.includes('?') ? '&' : '?') + 'width=' + w);
  function MEDIA_URL(slug, id, w) {
    const m = MEDIA[slug];
    const src = (m && m[id]) || MEDIA_ANY(slug, id);
    return src ? withWidth(src, w) : '';
  }
  /* Vitesse (08/10) : photos des pièces (galerie, cartes, « la pièce ») en 375 à 1 600 px au lieu de 640 et 1 280 (le
     téléphone prenait 1 280 px pour un écran de 375). Mêmes largeurs que la 1re photo rendue par Liquid
     (snippets/caplia-img-galerie.liquid) : le navigateur reprend le fichier déjà chargé. Photos du thème (k1…) : 640 et 1 280. */
  const GAL_W = [375, 550, 750, 1100, 1400, 1600];
  function GAL_SRCSET(p, id, ext = 'webp') {
    const u = (w) => `/site/assets/produits/${p.slug}/${id}-${w}.${ext}`;
    if (THEME_PHOTOS.has(u(1280)) || !MEDIA_URL(p.slug, id, 1280)) return [640, 1280].map((w) => `${ASSET(u(w))} ${w}w`).join(', ');
    return GAL_W.map((w) => `${MEDIA_URL(p.slug, id, w)} ${w}w`).join(', ');
  }
  /* Refonte du 07/10 : les cartes et les pages montrent aussi les photos de salon des autres pièces. Elles viennent des
     médias Shopify de chaque produit (caplia-produits-json > m : texte alternatif et adresse), reliés aux photos du
     catalogue par leur texte alternatif, comme sur la fiche ; rien n'est copié dans le thème. */
  const MEDIA_ALL = {};
  function MEDIA_ANY(slug, id) {
    if (!(slug in MEDIA_ALL)) {
      MEDIA_ALL[slug] = {};
      const p = BY[slug], sp = p && shopOf(p);
      if (sp && Array.isArray(sp.m)) {
        const byAlt = new Map(p.images.map((im) => [normTxt(im.alt), im.id]));
        sp.m.forEach((x) => { const k = byAlt.get(normTxt(x.a)); if (k && !MEDIA_ALL[slug][k]) MEDIA_ALL[slug][k] = x.s; });
      }
    }
    return MEDIA_ALL[slug][id] || '';
  }
  /* nom de fichier d'un média sans extension ni suffixe ajouté par Shopify (« 01-1280_3f2a…webp » -> « 01-1280 ») */
  const mediaName = (n) => String(n || '').toLowerCase().replace(/\.[a-z0-9]+$/, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{20,}$/, '');
  function idFromName(name, slug, ids) {
    const n = mediaName(name);
    return ids.find((id) => { const i = String(id).toLowerCase(); return n === i || n.startsWith(i + '-') || n.endsWith('-' + i) || n.includes(`${slug}-${i}-`) || n.includes(`${slug}_${i}`) || n === `${slug}-${i}`; }) || null;
  }
  function LINK_MEDIA(p) {
    const list = (CAPLIA.medias || []).filter((m) => m.src);
    if (!list.length || !shopOf(p) || (CAPLIA.route || {}).handle !== shopOf(p).handle) return;
    const ids = p.images.map((im) => im.id);
    const byAlt = new Map(p.images.map((im) => [normTxt(im.alt), im.id]));
    /* fichiers et textes de l'import (shopify/import/images/correspondance.csv) */
    const imp = MEDIAS_IMPORT[p.slug] || { fichiers: {}, alts: {} };
    Object.entries(imp.alts || {}).forEach(([a, id]) => { if (!byAlt.has(normTxt(a))) byAlt.set(normTxt(a), id); });
    const map = {}, used = new Set();
    list.forEach((m) => {
      /* par le texte alternatif seulement (unique, tenu à jour par sync-produits.mjs). Bug du 07/10 : les noms de
         fichier de l'import sont renumérotés quand une photo est insérée et pointaient vers une photo d'une autre couleur */
      const id = byAlt.get(normTxt(m.alt)) || idFromName(m.nom, p.slug, ids);
      if (id && !map[id]) { map[id] = m.src; used.add(m.id); }
    });
    const extra = list.filter((m) => !used.has(m.id));
    if (!Object.keys(map).length) {
      /* aucun média relié : la galerie montre les médias Shopify dans leur ordre ; une couleur citée dans le texte
         alternatif (ou l'image de la variante) range la photo dans cette couleur */
      p.images = list.map((m, i) => ({ id: 's' + i, alt: m.alt || p.nom }));
      list.forEach((m, i) => { map['s' + i] = m.src; });
      const g = { _communes: [] };
      const sp = shopOf(p);
      list.forEach((m, i) => {
        const a = normTxt(m.alt);
        const c = p.couleurs.find((k) => a.includes(normTxt(k.nom)) || (sp && sp.variantes.some((v) => v.media === m.id && colorMatch(p, sp, v, k))));
        if (c && p.couleurs.length > 1) (g[c.nom] = g[c.nom] || []).push('s' + i); else g._communes.push('s' + i);
      });
      GALERIES[p.slug] = g;
      CADRAGE[p.slug] = {};
    } else {
      /* photos du catalogue absentes de Shopify : retirées de la galerie ; médias en plus (inconnus du catalogue) : jamais
         montrés, car leur couleur n'est pas connue (règle stricte du 07/10 : une galerie ne montre que sa couleur) */
      /* les photos refaites de la refonte (k1…, KSCENES d'app.js) sont des fichiers du thème, pas des médias Shopify : gardées */
      const keepK = (id) => /^k\d+$/.test(id);
      p.images = p.images.filter((im) => map[im.id] || keepK(im.id));
      if (extra.length) console.warn('Caplia : médias Shopify inconnus du catalogue, non montrés :', extra.map((m) => m.alt || m.nom));
      const g = GALERIES[p.slug];
      if (g) {
        Object.keys(g).forEach((k) => { if (Array.isArray(g[k]) && k !== '_retirees') g[k] = g[k].filter((id) => map[id] || keepK(id)); });
      }
      const x = MAT && MAT.pieces && MAT.pieces[p.slug];
      if (x && x.gros) Object.keys(x.gros).forEach((k) => { const v = x.gros[k]; if (v && !v.includes('/') && !map[v]) delete x.gros[k]; });
    }
    MEDIA[p.slug] = map;
  }

  /* ---------- Produits Shopify ---------- */
  const SHOP = CAPLIA.produits || {};
  const SHOP_LIST = Object.values(SHOP);
  const SHOP_EMPTY = !SHOP_LIST.length;
  let HANDLES = {};          /* slug -> handle (seo-pages.json), depuis caplia-donnees.json */
  function shopOf(p) {
    if (!p) return null;
    if (p._sp !== undefined) return p._sp;
    let sp = SHOP[HANDLES[p.slug]] || null;
    if (!sp) { const base = refBase(p).toUpperCase(); sp = SHOP_LIST.find((x) => x.variantes.some((v) => v.sku && (v.sku.toUpperCase() === base || v.sku.toUpperCase().startsWith(base + '-')))) || null; }
    if (!sp) { const n = normTxt(p.nom); sp = SHOP_LIST.find((x) => (` ${normTxt(x.titre)} `).includes(` ${n} `)) || null; }
    p._sp = sp;
    if (sp) p._h = sp.handle;
    return sp;
  }
  const handleOf = (slug) => { const p = (CAT && CAT.produits || []).find((x) => x.slug === slug); return (p && shopOf(p) && p._h) || HANDLES[slug] || slug; };
  const slugOfHandle = (h) => { const p = (CAT && CAT.produits || []).find((x) => !x.masque && (HANDLES[x.slug] === h || (shopOf(x) && x._h === h))); return p ? p.slug : null; };
  function optIdx(p, sp) {
    if (sp._oi) return sp._oi;
    const names = (sp.options || []).map(normTxt);
    let c = names.findIndex((n) => /couleur|color|coloris|teinte/.test(n));
    let t = names.findIndex((n) => /taille|size|dimension|format/.test(n));
    if (c < 0 && p.couleurs.length > 1) c = names.findIndex((n, i) => i !== t && sp.variantes.some((v) => p.couleurs.some((k) => normTxt(k.nom) === normTxt(v.o[i]))));
    if (t < 0 && p.tailles) t = names.findIndex((n, i) => i !== c && sp.variantes.some((v) => /\d/.test(v.o[i] || '')));
    return (sp._oi = { c, t });
  }
  const sizeKey = (s) => (String(s || '').match(/\d+/g) || []).join('x');
  function colorMatch(p, sp, v, k) {
    const { c } = optIdx(p, sp);
    if (c >= 0) return normTxt(v.o[c]) === normTxt(k.nom) || (!!k.cle && normTxt(v.o[c]) === normTxt(k.cle));
    if (v.sku && /^CAP-/.test(k.ref || '')) return v.sku.toUpperCase() === k.ref.toUpperCase() || v.sku.toUpperCase().startsWith(k.ref.toUpperCase() + '-');
    return p.couleurs.filter((x) => !x.retiree).length === 1;
  }
  function sizeMatch(p, sp, v, t) {
    const { t: i } = optIdx(p, sp);
    if (i >= 0) return sizeKey(v.o[i]) === sizeKey(t.nom);
    if (v.sku && t.ref) return v.sku.toUpperCase().endsWith('-' + String(t.ref).toUpperCase());
    return p.tailles.length === 1;
  }
  function SHOP_VARIANT(p, colorName, sizeName) {
    const sp = shopOf(p);
    if (!sp) return null;
    const live = p.couleurs.filter((x) => !x.retiree);
    if (sp.variantes.length === 1 && live.length === 1 && !(p.tailles && p.tailles.length > 1)) return sp.variantes[0];
    const k = p.couleurs.find((x) => x.nom === colorName || x.cle === colorName) || p.couleurs[0];
    const t = p.tailles ? p.tailles.find((x) => x.nom === sizeName) || p.tailles[0] : null;
    return sp.variantes.find((v) => colorMatch(p, sp, v, k) && (!t || sizeMatch(p, sp, v, t))) || null;
  }
  /* une pièce existe sur le site si elle existe dans la boutique (aperçu complet tant que la boutique n'a aucun produit) */
  const SHOP_KEEP = (p) => SHOP_EMPTY || !!shopOf(p);
  function SHOP_MERGE(p) {
    const sp = shopOf(p);
    if (!sp) return p;
    const vs = sp.variantes;
    const live = p.couleurs.filter((k) => !k.retiree);
    live.forEach((k) => { k.rupture = !vs.some((v) => v.dispo && colorMatch(p, sp, v, k)); });
    if (p.tailles) {
      p.tailles.forEach((t) => {
        const mine = vs.filter((v) => sizeMatch(p, sp, v, t));
        if (!mine.length) { t.rupture = true; return; }
        t.prix = Math.min(...mine.map((v) => v.prix)) / 100;
        t.rupture = !mine.some((v) => v.dispo);
        t.ruptureCouleurs = live.filter((k) => !mine.some((v) => v.dispo && colorMatch(p, sp, v, k))).map((k) => k.nom);
      });
    }
    const sold = vs.filter((v) => v.dispo);
    p.prix = Math.min(...(sold.length ? sold : vs).map((v) => v.prix)) / 100;
    return p;
  }
  /* variante Shopify -> ligne de panier de la maquette */
  const VARIANT_INDEX = {};
  function INDEX_VARIANTS() {
    PRODS.forEach((p) => {
      if (!shopOf(p)) return;
      const sizes = p.tailles ? p.tailles.map((t) => t.nom) : [''];
      p.couleurs.forEach((k) => sizes.forEach((s) => { const v = SHOP_VARIANT(p, k.nom, s); if (v && !VARIANT_INDEX[v.id]) VARIANT_INDEX[v.id] = { slug: p.slug, color: k.nom, size: s }; }));
    });
  }
  /* ?variant=<id> : la couleur (et la taille) de la variante ; sinon -1 */
  function SHOP_VARIANT_COLOR(p, id) {
    const hit = id && VARIANT_INDEX[id];
    if (!hit || hit.slug !== p.slug) return -1;
    if (p.tailles && hit.size) { const k = p.tailles.findIndex((t) => t.nom === hit.size); if (k >= 0) PDP.size = k; }
    return p.couleurs.findIndex((k) => k.nom === hit.color);
  }
  /* adresse partageable de la fiche pour une couleur : ?variant= (Shopify), sinon ?couleur= */
  function SHOP_URL(p, colorName) {
    const v = SHOP_VARIANT(p, colorName, p.tailles ? (p.tailles[PDP.size] || p.tailles[0]).nom : '');
    return location.pathname + (v ? `?variant=${v.id}` : `?couleur=${colorSlug(colorName)}`);
  }
  /* un ensemble ne s'annonce « dans votre panier » que si chacune de ses pièces peut y entrer */
  function SHOP_ENS_OK(e) {
    const ok = e.items.every(([slug, color, size]) => {
      const p = BY[slug];
      if (!p) return false;
      const c = colorIn(p, color), s = sizeFor(p, c, size || '');
      return s !== null && !isOut(p.couleurs.find((k) => k.nom === c)) && !!SHOP_VARIANT(p, c, s);
    });
    if (!ok) toast(null, SHOP_EMPTY ? `${e.nom} n’est pas encore en vente en ligne.` : `${e.nom} n’est pas disponible en entier pour le moment.`, true);
    return ok;
  }
  function SHOP_CAN_ADD(p, color, size) {
    if (SHOP_VARIANT(p, color, size)) return true;
    toast(null, SHOP_EMPTY ? `${p.nom} n’est pas encore en vente en ligne.` : `${p.nom} n’est pas disponible dans cette version.`, true);
    return false;
  }

  /* ---------- Adresses : #/… de la maquette -> vraies pages Shopify ---------- */
  const PAGE_ROUTES = ['livraison', 'matieres', 'arrivee', 'cadeaux', 'a-propos', 'questions', 'contact', 'renoncer', 'mentions-legales',
    'conditions-de-vente', 'confidentialite', 'garantie', 'tout-va-bien', 'un-souci', 'petits-espaces', 'jeunes-parents', 'pourquoi-caplia', 'selection', 'paiement'];
  const PAGE_HANDLE = (r) => (CAPLIA.pages && CAPLIA.pages[r]) || r;
  function TO_URL(h) {
    const raw = String(h).replace(/^#/, '');
    const i = raw.indexOf('?');
    const path = i < 0 ? raw : raw.slice(0, i), q = i < 0 ? '' : raw.slice(i);
    let m;
    if (!path || path === '/') return R('/') + q;
    if ((m = path.match(/^\/p\/([\w-]+)\/?$/))) return R('/products/' + handleOf(m[1])) + q;
    if ((m = path.match(/^\/(canapes|fauteuils|decoration|sleep)\/?$/))) return R('/collections/' + m[1]) + q;
    if ((m = path.match(/^\/(?:collections|sleep)\/([\w-]+)\/?$/))) return R('/collections/' + m[1]) + q;
    if (/^\/(panier|reserver-en-3-fois)\/?$/.test(path)) return R('/cart') + q;
    if (/^\/merci\/?$/.test(path)) return R('/');
    if ((m = path.match(/^\/([\w-]+)\/?$/))) return R('/pages/' + PAGE_HANDLE(m[1])) + q;
    return R('/');
  }
  const LINKS = (html) => String(html).replace(/href="(#\/[^"]*)"/g, (all, h) => `href="${TO_URL(h.replace(/&amp;/g, '&')).replace(/&/g, '&amp;')}"`);
  function FIX_LINKS(root) { $$('a[href^="#/"]', root || document).forEach((a) => a.setAttribute('href', TO_URL(a.getAttribute('href')))); }
  /* filet de sécurité : un lien #/… oublié mène quand même à la bonne page */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href^="#/"]');
    if (!a || e.defaultPrevented || a.hasAttribute('data-toc')) return;
    e.preventDefault();
    location.href = TO_URL(a.getAttribute('href'));
  });

  /* ---------- Page ouverte (posée par Liquid) -> route de la maquette ; null = garder le rendu Liquid ---------- */
  function CAPLIA_PATH() {
    const r = CAPLIA.route || {};
    const el = document.querySelector('[data-caplia-route]');
    const forced = el ? el.getAttribute('data-caplia-route') : '';
    const h = forced || r.handle || '';
    switch (r.gabarit) {
      case 'index': return '/';
      case 'product': { const s = slugOfHandle(r.handle); return s ? '/p/' + s : null; }
      case 'collection': return catBy(h) ? '/' + h : SUBS[h] || SEO[h] ? '/collections/' + h : null;
      case 'page': return PAGE_ROUTES.includes(h) ? '/' + h : null;
      case 'cart': return '/panier';
      case '404': return '/__introuvable';
      default: return null;
    }
  }
  /* rendu Liquid gardé (page inconnue des données) : on l'affiche, liens et en-tête compris */
  function KEEP_SSR() {
    document.documentElement.classList.add('caplia-pret');
    FIX_LINKS(document);
  }
  /* formulaires Shopify (contact, rétractation) rendus par Liquid : déplacés à leur place dans la page de la maquette */
  function KEEP_TAKE(app) {
    const out = {};
    $$('[data-caplia-keep]', app).forEach((w) => { const f = w.firstElementChild; if (f) out[w.getAttribute('data-caplia-keep')] = f; });
    return out;
  }
  /* Paiement express (07/10) : les boutons Shopify (payment_button de la fiche, content_for_additional_checkout_buttons
     du panier) sont gardés en mémoire ; sans place dans le rendu (accessoire, pièce pas encore en vente), ils ne
     s'affichent pas ; le panier refait (refreshCart) les remet à leur place (SLOT_REFILL). */
  const KEPT_LIVE = {};
  const isExpressKey = (k) => /^express/.test(k);
  function KEEP_PUT(app, kept) {
    Object.keys(kept).forEach((k) => { if (isExpressKey(k)) KEPT_LIVE[k] = kept[k]; });
    $$('[data-caplia-slot]', app).forEach((s) => { const k = s.getAttribute('data-caplia-slot'), f = kept[k]; if (f) { s.replaceWith(f); delete kept[k]; } else s.remove(); });
    /* un élément gardé sans place dans le rendu (page sans pied de page…) : à la fin ; jamais les boutons express */
    Object.keys(kept).forEach((k) => { if (!isExpressKey(k)) app.appendChild(kept[k]); });
    SHOP_EXPRESS_SYNC();
  }
  function SLOT_REFILL(root) {
    $$('[data-caplia-slot]', root).forEach((s) => { const f = KEPT_LIVE[s.getAttribute('data-caplia-slot')]; if (f) s.replaceWith(f); else s.remove(); });
  }
  /* la variante choisie sur la fiche (couleur, taille) part dans le formulaire des boutons express */
  function SHOP_EXPRESS_SYNC() {
    const f = KEPT_LIVE.express && KEPT_LIVE.express.querySelector('input[name="id"]');
    if (!f || !PDP.p) return;
    const p = PDP.p;
    const v = SHOP_VARIANT(p, p.couleurs[PDP.color].nom, p.tailles ? (p.tailles[PDP.size] || p.tailles[0]).nom : '');
    if (v && String(f.value) !== String(v.id)) { f.value = v.id; f.dispatchEvent(new Event('change', { bubbles: true })); }
    /* variante absente ou épuisée, couleur épuisée, pièce pas encore en vente : pas de paiement express */
    const box = KEPT_LIVE.express.closest('.fp-express');
    if (box) box.hidden = !v || !v.dispo || isOut(p.couleurs[PDP.color]) || notYet(p);
  }

  /* ---------- Panier Shopify ---------- */
  let SHOPCART = CAPLIA.panier || { items: [] };
  const GIFT_IDS = (CAPLIA.cadeaux || []).map((x) => Number(x) || 0);
  const isGiftItem = (it) => GIFT_IDS.includes(it.variant_id) || !!(it.properties && it.properties._cadeau);
  function SHOP_CART_LINES() {
    return (SHOPCART.items || []).filter((it) => VARIANT_INDEX[it.variant_id]).map((it) => ({ ...VARIANT_INDEX[it.variant_id], qty: it.quantity }));
  }
  /* lignes du panier Shopify que la maquette ne connaît pas (autre produit de la boutique) : montrées et comptées */
  const SHOP_EXTRAS = () => (SHOPCART.items || []).filter((it) => !VARIANT_INDEX[it.variant_id] && !isGiftItem(it));
  const SHOP_EXTRA_TOTAL = () => SHOP_EXTRAS().reduce((s, it) => s + it.final_line_price / 100, 0);
  const SHOP_EXTRA_COUNT = () => SHOP_EXTRAS().reduce((s, it) => s + it.quantity, 0);
  function SHOP_EXTRA_HTML() {
    return SHOP_EXTRAS().map((it) => {
      const img = it.featured_image && it.featured_image.url ? `<img src="${esc(withWidth(it.featured_image.url, 240))}" alt="" loading="lazy" decoding="async">` : '';
      return `<li class="line line--shop" data-line="${esc(it.key)}">
        <a class="line__thumb" href="${esc(it.url)}" aria-label="${esc(it.product_title)}">${img}</a>
        <div class="line__info"><a class="line__name" href="${esc(it.url)}">${esc(it.product_title)}</a>${it.variant_title ? `<p class="line__var">${esc(it.variant_title)}</p>` : ''}</div>
        <div class="qty" role="group" aria-label="Quantité de ${esc(it.product_title)}">
          <button type="button" data-action="shop-qty" data-key="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Retirer un exemplaire"${it.quantity < 2 ? ' disabled' : ''}>${I.minus}</button>
          <output aria-live="polite">${it.quantity}</output>
          <button type="button" data-action="shop-qty" data-key="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Ajouter un exemplaire">${I.plus}</button>
        </div>
        <p class="line__total">${price(it.final_line_price / 100)}</p>
        <button class="line__x" type="button" data-action="shop-qty" data-key="${esc(it.key)}" data-q="0" aria-label="Retirer ${esc(it.product_title)} du panier">Retirer</button>
      </li>`;
    }).join('');
  }
  const cartJSON = (r) => r.json().then((j) => { if (!r.ok) throw j; return j; });
  const post = (url, body) => fetch(R(url), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(cartJSON);
  /* la maquette change `cart` puis appelle saveCart() : on envoie l'état voulu à Shopify, un envoi à la fois (le dernier état gagne) */
  let syncBusy = false, syncAgain = false, syncDone = Promise.resolve();
  let syncResolve = null;
  function SHOP_CART_SYNC() {
    syncAgain = true;
    if (syncBusy) return syncDone;
    syncBusy = true;
    syncDone = new Promise((ok) => { syncResolve = ok; });
    (async () => {
      while (syncAgain) {
        syncAgain = false;
        const want = {};
        cart.forEach((l) => { const v = SHOP_VARIANT(BY[l.slug], l.color, l.size); if (v) want[v.id] = (want[v.id] || 0) + l.qty; });
        const cur = {};
        (SHOPCART.items || []).forEach((it) => { if (VARIANT_INDEX[it.variant_id]) cur[it.variant_id] = (cur[it.variant_id] || 0) + it.quantity; });
        Object.keys(cur).forEach((id) => { if (!(id in want)) want[id] = 0; });
        const add = [], upd = {};
        Object.keys(want).forEach((id) => { if (!(id in cur)) { if (want[id] > 0) add.push({ id: Number(id), quantity: want[id] }); } else if (cur[id] !== want[id]) upd[id] = want[id]; });
        try {
          if (Object.keys(upd).length) SHOPCART = await post('/cart/update.js', { updates: upd });
          if (add.length) { await post('/cart/add.js', { items: add }); SHOPCART = await fetch(R('/cart.js'), { headers: { Accept: 'application/json' } }).then(cartJSON); }
          await SHOP_GIFTS_SYNC();
        } catch (err) {
          /* refusé (stock insuffisant, pièce retirée) : on reprend le panier tel que Shopify le connaît */
          await SHOP_CART_RELOAD(true);
          toast(null, (err && (err.description || err.message)) ? `${err.description || err.message}` : 'Le panier n’a pas pu être mis à jour. Réessayez.', true);
          syncAgain = false;
        }
      }
      syncBusy = false;
      syncResolve();
    })();
    return syncDone;
  }
  /* relit le panier Shopify ; la page n'est refaite que s'il a changé (ou après un refus) */
  const cartSig = (c) => ((c && c.items) || []).map((it) => `${it.key}:${it.quantity}`).join('|');
  async function SHOP_CART_RELOAD(force) {
    /* un envoi en cours (panier recréé par un lien « Envoyer mon panier ») passe d'abord : sinon la relecture le défait */
    if (syncBusy && !force) await syncDone;
    const avant = cartSig(SHOPCART);
    try { SHOPCART = await fetch(R('/cart.js'), { headers: { Accept: 'application/json' } }).then(cartJSON); } catch (e) { return; }
    if (!force && cartSig(SHOPCART) === avant) return;
    loadCart(); updateBadge(); refreshCart();
  }
  /* Cadeaux par palier (site.json > paliers) : réglages du thème « Cadeaux » (une variante par palier). Vides = rien
     n'est ajouté (le panier les montre seulement). Remplis : la variante du palier atteint est ajoutée (propriété _cadeau),
     retirée sous le seuil ; une remise automatique Shopify la rend gratuite. */
  async function SHOP_GIFTS_SYNC() {
    if (!GIFT_IDS.some(Boolean) || !SITE || !SITE.paliers) return;
    /* les meubles seulement : les coussins et plaids achetés seuls ne comptent pas pour les cadeaux (giftBase, app.js) */
    const total = giftBase();
    const items = SHOPCART.items || [];
    const add = [], upd = {};
    SITE.paliers.forEach((pl, i) => {
      const id = GIFT_IDS[i];
      if (!id) return;
      const have = items.filter((it) => it.variant_id === id).reduce((s, it) => s + it.quantity, 0);
      const want = total >= pl.seuil ? 1 : 0;
      if (have === want) return;
      /* plaid offert à la place d'un plaid acheté (plaidSwap, app.js) : sa couleur part avec le cadeau, visible sur la commande */
      const coul = pl.produit === PLAID && i === SITE.paliers.findIndex((x) => x.produit === PLAID) ? plaidPref() : '';
      if (!have) add.push({ id, quantity: 1, properties: Object.assign({ _cadeau: String(pl.seuil) }, coul ? { Couleur: coul } : {}) }); else upd[id] = want;
    });
    if (Object.keys(upd).length) SHOPCART = await post('/cart/update.js', { updates: upd });
    if (add.length) { await post('/cart/add.js', { items: add }); SHOPCART = await fetch(R('/cart.js'), { headers: { Accept: 'application/json' } }).then(cartJSON); }
  }
  async function SHOP_CHECKOUT(btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    await SHOP_CART_SYNC();
    location.href = R('/checkout');
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-action="shop-qty"]');
    if (!b) return;
    e.preventDefault();
    post('/cart/change.js', { id: b.dataset.key, quantity: Math.max(0, Number(b.dataset.q) || 0) })
      .then((c) => { SHOPCART = c; updateBadge(); refreshCart(); })
      .catch(() => SHOP_CART_RELOAD(true));
  });
  /* retour arrière (page gardée en mémoire par le navigateur) : le panier a pu changer ailleurs */
  window.addEventListener('pageshow', (e) => { if (e.persisted && CAT) SHOP_CART_RELOAD(); });

  /* ---------- Formulaires ---------- */
  const MAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  /* inscription Shopify (form_type=customer) : client avec ses étiquettes, accord e-mail donné */
  async function SHOP_SUBSCRIBE(email, tags) {
    const fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', ['caplia', ...tags].filter(Boolean).join(', ').slice(0, 250));
    try {
      const r = await fetch(R('/contact'), { method: 'POST', body: fd, credentials: 'same-origin' });
      return r.ok && !/\/challenge/.test(r.url);
    } catch (e) { return false; }
  }
  /* inscription (pied de page : vrai formulaire Shopify ; « Ma sélection » : envoyé en arrière-plan) */
  function SHOP_NEWS(e, nf) {
    const msg = $('[data-news-msg]', nf);
    const input = nf.querySelector('input[type="email"]');
    const ok = nf.querySelector('input[type="checkbox"]');
    const mail = input ? input.value.trim() : '';
    const sel = nf.hasAttribute('data-selmail');
    const say = (t) => { if (msg) { msg.hidden = false; msg.textContent = fr(t); } };
    if (!MAIL_RE.test(mail)) { e.preventDefault(); say('Indiquez une adresse e-mail valide.'); if (input) input.focus(); return; }
    if (!sel && ok && !ok.checked) { e.preventDefault(); say('Cochez la case pour recevoir nos e-mails.'); return; }
    if (nf.getAttribute('action')) return;   /* formulaire Shopify : il part tel quel */
    e.preventDefault();
    const tags = sel ? ['selection', ...fav.map((s) => 'piece-' + s)] : ['newsletter'];
    if (sel && ok && ok.checked) tags.push('newsletter');
    SHOP_SUBSCRIBE(mail, tags).then((done) => {
      if (!done) { say('L’envoi n’a pas abouti. Réessayez dans un instant.'); return; }
      say(sel ? `C’est noté : votre sélection part à ${mail}${ok && ok.checked ? ', avec les nouvelles couleurs et le guide' : ''}.` : `Merci : c’est noté pour ${mail}.`);
    });
  }
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.id === 'caplia-contact') {
      const nom = f.querySelector('#f-nom'), mail = f.querySelector('#f-mail'), txt = f.querySelector('#f-msg'), msg = $('[data-form-msg]', f);
      if (!nom.value.trim() || !MAIL_RE.test(mail.value.trim()) || !txt.value.trim()) {
        e.preventDefault();
        if (msg) { msg.hidden = false; msg.textContent = fr('Merci d’indiquer votre nom, une adresse e-mail valide et votre message.'); }
      }
      return;
    }
    if (f.id === 'caplia-renonce') {
      const m = $('[data-renonce-msg]', f);
      const nom = f.querySelector('#r-nom'), cmd = f.querySelector('#r-cmd'), mail = f.querySelector('#r-mail');
      const bad = !nom.value.trim() ? nom : !cmd.value.trim() ? cmd : !MAIL_RE.test(mail.value.trim()) ? mail : null;
      if (bad) {
        e.preventDefault();
        m.hidden = false; m.classList.add('is-warn');
        m.textContent = bad === mail ? 'Indiquez une adresse e-mail valide : l’accusé de réception y sera envoyé.' : bad === nom ? 'Indiquez votre nom et votre prénom.' : 'Indiquez votre numéro de commande : il figure dans l’e-mail de confirmation.';
        bad.focus();
      }
    }
  }, true);


  const KEY = 'prelasse-maquette-verre-salon';
  const NB = ' ';
  const NNB = ' ';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const isMobile = () => window.innerWidth < 760;

  let CAT = null;
  let SITE = null;
  const STUDIO = {};   /* images studio gris HD par slug (site/data/studio.json) */
  let DETOURE = {};    /* taille [largeur, hauteur] des détourés de repli */
  /* Galerie des fiches, lues au chargement (une autre équipe les complète : rien n'est codé en dur) :
     GALERIES = vraies photos par couleur (galeries.json : _communes, _retirees) ; VUES = vues studio par couleur
     (vues-couleurs.json) ; MODELES = modèles 3D et couleurs qu'ils savent montrer (modeles-3d.json). */
  let GALERIES = {};
  /* place de la pièce dans chaque vraie photo de galerie (cadrage-photos.json, BiRefNet) : la galerie ne la coupe jamais */
  let CADRAGE = {};
  /* notices en français par produit (site/data/notices.json, 07/10) : volet « Montage et notice » de la fiche, facultatif */
  let NOTICES = {};
  /* pièces masquées (catalogue.json « masque », 05/10 : pas de vraie photo) : absentes de PRODS et de BY, donc de tout le
     site ; MASK_RE reconnaît leur nom dans les textes des pages (seo-pages.json) pour sauter la phrase qui les cite */
  let MASK_RE = null;
  let VUES = {};
  let MODELES = {};
  /* pages de valeur (05/10) : matières, arrivée et cadeaux (site/data/matieres.json, livraison.json, cadeaux.json), facultatives */
  let MAT = null, ARR = null, GIFTS = null, AVIS = null;
  /* fiches techniques (site/data/fiches-techniques.json, 07/10) : confort, tissu, déballage, technique relevés chez le vendeur */
  let FT = {};
  /* images des cartes et des ensembles, toutes les pièces à la même distance (site/data/cartes.json,
     maquettes/outils/cartes-echelle.py) : { cartes: { largeurs, echelle: { slug } }, ensembles: { slug: { largeurs } } } */
  let CARTES = { cartes: { echelle: {} }, ensembles: {} };
  /* cartes en vraies photos (cartes.json > photo) : voir pieceImg ; null tant qu'elles ne sont pas chargées */
  let PHOTO = null;
  let PRODS = [];
  const BY = {};
  let lenis = null;
  let cleanups = [];
  let firstRender = true;

  const G = () => (window.gsap ? window.gsap : null);
  const ST = () => (window.ScrollTrigger ? window.ScrollTrigger : null);

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const pad = (n) => String(n).padStart(2, '0');

  /* Typographie française : insécables avant : ; ? ! et dans les guillemets */
  const frTxt = (s) => s
    .replace(/ ([:;?!])(?=[\s<"&]|$)/g, NB + '$1')
    .replace(/« /g, '«' + NB)
    .replace(/ »/g, NB + '»')
    /* « e-mail » ne se coupe jamais après le trait d'union (« par e- / mail ») : un liant invisible (U+2060) */
    .replace(/e-mail/g, 'e-\u2060mail')
    /* de même « Écrivez-nous », « envoyez-nous », « éco-participation » : jamais coupés après le trait d'union */
    .replace(/([a-zà-ÿ])-(nous|vous)\b/gi, '$1-\u2060$2')
    .replace(/éco-participation/g, 'éco-\u2060participation');
  const fr = (s) => LINKS(ASSETS_IN(fr0(s)));
  /* les attributs href restent tels quels (supervision du 08/10) : ni insécable ni liant invisible dans une adresse ou le
     texte prérempli d'un lien mailto:, que le client enverrait dans son e-mail */
  const fr0 = (s) => String(s).split(/(href="[^"]*")/).map((x, i) => (i % 2 ? x : frTxt(x))).join('');

  const price = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NNB) + NB + '€';
  const numFr = (n) => String(n).replace('.', ',');
  const cm = (n) => numFr(n) + NB + 'cm';
  /* chiffres et unités jamais séparés en fin de ligne (« 200 × 182 cm ») */
  const nbUnits = (s) => String(s).replace(/(\d) × (\d)/g, `$1${NB}×${NB}$2`).replace(/(\d) (cm|kg|€)/g, `$1${NB}$2`);
  /* textes des pages (seo-pages.json) : ni « 290 / € », ni « 1 / 090 € », ni « 4 / cm » coupés en fin de ligne */
  const nbTxt = (s) => nbUnits(String(s).replace(/(\d) (\d{3})(?=\D|$)/g, `$1${NNB}$2`));

  /* ---------------- Chemins d'images ---------------- */
  const photo = (p, id, size = 1280, ext = 'webp') => ASSET(`/site/assets/produits/${p.slug}/${id}-${size}.${ext}`);
  const cut = (p) => CUT(p.slug);
  const tab = (id, v = '1920', ext = 'webp') => ASSET(`/site/assets/tableaux/${id}-${v}.${ext}`);

  /* Image studio gris tirée des rendus 3D (maquettes/outils/images-site.py) : seulement la vue studio des galeries de fiches.
     Partout ailleurs, la vraie photo de la pièce (carte ou cadres : voir pieceImg). Options : alt, sizes (largeur affichée),
     eager (image vue dès l'arrivée), cls (sur <picture>), imgCls (sur <img>). */
  function studioImg(p, { alt = '', sizes = '(max-width: 760px) 100vw, 50vw', eager = false, cls = '', imgCls = '', carte = false, cadres = null } = {}) {
    if ((carte || cadres) && carteOf(p)) return pieceImg(p, { alt, sizes, eager, cls, imgCls, cadres: cadres || ['45'] });
    const s = null;
    const charge = eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"';
    const ic = imgCls ? ` class="${esc(imgCls)}"` : '';
    if (!s) {
      const d = DETOURE[p.slug];
      return `<img${ic} src="${cut(p)}" alt="${esc(alt)}"${d ? ` width="${d[0]}" height="${d[1]}"` : ''} ${charge} decoding="async" draggable="false">`;
    }
    const dir = '/site/assets/studio/';
    const set = (ext) => s.largeurs.map((w) => `${dir}${p.slug}-${w}.${ext} ${w}w`).join(', ');
    const repli = s.largeurs.includes(1080) ? 1080 : s.largeurs[s.largeurs.length - 1];
    const w = s.largeurs[s.largeurs.length - 1];
    return `<picture class="simg${cls ? ' ' + esc(cls) : ''}">`
      + `<source type="image/avif" srcset="${set('avif')}" sizes="${esc(sizes)}">`
      + `<source type="image/webp" srcset="${set('webp')}" sizes="${esc(sizes)}">`
      + `<img${ic} src="${dir}${p.slug}-${repli}.webp" alt="${esc(alt)}" width="${w}" height="${Math.round(w / s.ratio)}" ${charge} decoding="async" draggable="false">`
      + '</picture>';
  }

  /* ---------------- Vraies photos des pièces (cartes, vignettes, pages) ----------------
     maquettes/outils/cartes-echelle.py photo : la vraie pièce détourée, posée dans le studio gris avec son ombre de contact,
     toutes à la même distance (site/data/cartes.json > photo). Une carte par couleur en vente qui a sa photo, et des
     recadrages du même studio pour les cadres des pages : « 45 » (carte entière), « 11 », « 54 », « 43 ». La pièce n'est
     jamais coupée : chaque cadre reçoit l'image à son rapport. */
  const carteOf = (p, color) => {
    const e = PHOTO && PHOTO.pieces && PHOTO.pieces[p.slug];
    if (!e || !e.fichier) return null;
    /* sans couleur demandée : la couleur de la carte par défaut si elle est en vente, sinon la première en vente */
    const inSale = (n) => p.couleurs.some((k) => !k.rupture && (k.nom === n || k.cle === n));
    const want = color || (e.couleur && !inSale(e.couleur) ? (p.couleurs.find((k) => !k.rupture) || {}).nom : '');
    const c = want && e.couleurs && e.couleurs[want];
    return c && c.fichier && c.fichier !== e.fichier ? { fichier: c.fichier, box: c.box, fen: null } : e;
  };
  /* cadres : [cadre] ou [[media, cadre], …, [null, cadre]] (le dernier sans media) */
  function pieceImg(p, { color = '', alt = '', sizes = '(max-width: 760px) 100vw, 33vw', eager = false, cls = '', imgCls = '', cadres = ['45'] } = {}) {
    const c = carteOf(p, color);
    const charge = eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"';
    const ic = imgCls ? ` class="${esc(imgCls)}"` : '';
    if (!c) return `<img${ic} src="${cut(p)}" alt="${esc(alt)}" ${charge} decoding="async" draggable="false">`;
    const ws = PHOTO.largeurs, w = ws[ws.length - 1], d = PHOTO.dossier;
    const list = cadres.map((x) => (Array.isArray(x) ? x : [null, x]));
    const nom = (r) => (r === '45' || !c.fen || c.fen[r] == null ? c.fichier : `${c.fichier}-r${r}`);
    const rat = (r) => (nom(r) === c.fichier ? PHOTO.ratio || .8 : PHOTO.cadres[r]);
    const set = (r, ext) => ws.map((x) => `${d}${nom(r)}-${x}.${ext} ${x}w`).join(', ');
    const src = (m, r) => ['avif', 'webp'].map((ext) => `<source${m ? ` media="${m}"` : ''} type="image/${ext}" srcset="${set(r, ext)}" sizes="${esc(sizes)}">`).join('');
    const last = list[list.length - 1][1];
    return `<picture class="simg${cls ? ' ' + esc(cls) : ''}">${list.map(([m, r]) => src(m, r)).join('')}`
      + `<img${ic} src="${d}${nom(last)}-${ws.includes(1080) ? 1080 : w}.webp" alt="${esc(alt)}" width="${w}" height="${Math.round(w / rat(last))}" ${charge} decoding="async" draggable="false"></picture>`;
  }
  /* Vignette carrée (panier, suggestions, barre d'achat, Merci) : la pièce entière et grande (80 % du cadre), centrée, sur le
     studio de sa carte, dans la couleur choisie quand elle a sa photo. px : côté de la vignette affichée. */
  function pieceFit(p, color, px = 96) {
    const c = carteOf(p, color);
    if (!c) return studio(p, { cls: 'studio--mini' });
    const [x0, y0, x1, y1] = c.box, R = 1 / (PHOTO.ratio || .8);
    const k = Math.max(1, .8 / Math.max(x1 - x0, (y1 - y0) * R));
    const left = Math.min(0, Math.max(1 - k, .5 - (x0 + x1) / 2 * k));
    const top = Math.min(0, Math.max(1 - R * k, .5 - (y0 + y1) / 2 * R * k));
    const ws = PHOTO.largeurs, w = ws.find((x) => x >= px * k * 2) || ws[ws.length - 1];
    return `<img class="tthumb" src="${PHOTO.dossier}${c.fichier}-${w}.webp" alt="" loading="lazy" decoding="async" draggable="false" style="width:${(k * 100).toFixed(1)}%;height:auto;left:${(left * 100).toFixed(1)}%;top:${(top * 100).toFixed(1)}%">`;
  }

  const TABLEAU = {
    incurve: 'incurve-sel',
    'petit-incurve': 'petit-incurve-galerie',
    capiton: 'capiton-matin',
    meridienne: 'meridienne-platre',
    'petit-mouton': 'petit-mouton-paris',
    causeuse: 'causeuse-arches'
  };
  /* Fond flou pour les pièces sans tableau */
  const SOFT = {
    courbe: 'capiton-matin',
    'noix-de-cajou': 'incurve-sel',
    galet: 'petit-mouton-paris',
    berceuse: 'capiton-matin',
    veilleuse: 'meridienne-platre',
    'miroir-onde': 'petit-incurve-galerie',
    'table-nuage': 'incurve-sel'
  };
  const CAUSEUSE_FINAL = '/final/causeuse-verte--arches-ocre-16x9--reserve.jpg';
  /* Proportions des détourés (largeur / hauteur) */
  const RATIO = { berceuse: .93, capiton: 2.4, causeuse: 2.26, courbe: 2.02, galet: .91, incurve: 3.01, meridienne: 1.68, 'miroir-onde': .33, 'noix-de-cajou': 1.72, 'petit-incurve': 2.18, 'petit-mouton': 1.62, 'table-nuage': 1.38, veilleuse: 1.27, 'angle-cotele': 2.72, 'u-cotele': 2.79, coquillage: .72, 'miroir-organique': 1.38 };
  const shape = (p) => { const r = RATIO[p.slug] || 1.6; return r < .6 ? 'tall' : r < 1.32 ? 'square' : 'wide'; };

  const PAYS_DE = { FR: 'la France', DE: "l'Allemagne", ES: "l'Espagne", PL: 'la Pologne', CN: 'la Chine' };
  const PAYS_EN = { FR: 'en France', DE: 'en Allemagne', ES: 'en Espagne', PL: 'en Pologne', CN: 'en Chine' };
  /* Entrepôts européens hors de France, lus dans site.json > livraison.delais : une seule source pour les textes généraux
     (09/10 : la Pologne, d'où partent Hamac et Lierre, manquait dans la page Livraison, les CGV et les questions) */
  const EU_KEYS = () => Object.keys(SITE.livraison.delais).filter((k) => k !== 'FR');
  const euDe = (ap = "'") => orList(EU_KEYS().map((k) => PAYS_DE[k])).replace(/'/g, ap);
  const euEn = () => orList(EU_KEYS().map((k) => PAYS_EN[k]));
  const euMin = () => Math.min(...EU_KEYS().map((k) => SITE.livraison.delais[k][0]));
  const euMax = () => Math.max(...EU_KEYS().map((k) => SITE.livraison.delais[k][1]));
  /* Coût de retour d'une pièce volumineuse (art. L221-23) : hypothèse à confirmer avec le transporteur, voir _tests/AUDIT.md */
  /* Coût d'un retour : une seule source (site.json > retours.estimation), la même phrase partout (information due, ton neutre) */
  /* 07/10 : retour offert pour les fauteuils, poufs, coussins, plaids et objets de décoration (site.json > retours.retourOffert) ;
     canapés et lits : frais à la charge du client, montants estimés de site.json > retours.estimation */
  const retourOffert = (p) => !!p && (SITE.retours.retourOffert || []).includes(p.collection) && !isBed(p);
  const retourCout = () => { const E = SITE.retours.estimation; return `Le retour est offert pour les fauteuils, les poufs, les coussins, les plaids et la décoration : nous payons le transport du retour. Pour un canapé ou un lit, les frais de retour sont à votre charge : environ ${price(E.canapes)} pour un canapé${E.lits ? `, ${price(E.lits)} pour un lit en kit` : ''}. Une pièce volumineuse repart avec un transporteur adapté, que nous vous indiquons.`; };
  /* Contact : une seule coordonnée mise en avant, l'e-mail ; un seul délai de réponse, le même sur le site et dans les
     e-mails (site.json > reponse). Le nom complet et le téléphone ne figurent que dans les mentions légales. */
  const reponse = () => SITE.reponse || 'dans la journée';
  const mailLink = (cls = 'link') => `<a${cls ? ` class="${cls}"` : ''} href="mailto:${SITE.email}">${SITE.email}</a>`;

  /* ---------------- Icônes ---------------- */
  const sv = (d, extra = '') => `<svg viewBox="0 0 24 24" aria-hidden="true" ${extra}>${d}</svg>`;
  const I = {
    ne: sv('<path d="M7 17L17 7M9 7h8v8"/>', 'class="arrow-ne"'),
    right: sv('<path d="M5 12h14M13 6l6 6-6 6"/>'),
    left: sv('<path d="M19 12H5M11 6l-6 6 6 6"/>'),
    chevL: sv('<path d="M14.5 6l-6 6 6 6"/>'),
    chevR: sv('<path d="M9.5 6l6 6-6 6"/>'),
    plus: sv('<path d="M12 5v14M5 12h14"/>'),
    minus: sv('<path d="M5 12h14"/>'),
    x: sv('<path d="M6 6l12 12M18 6L6 18"/>'),
    loupe: sv('<circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5M11 8.5v5M8.5 11h5"/>'),
    truck: sv('<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>'),
    back: sv('<path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>'),
    card: sv('<rect x="3" y="6" width="18" height="12" rx="3"/><path d="M3 10h18M7 15h4"/>'),
    gift: sv('<rect x="4" y="10" width="16" height="10" rx="2"/><path d="M3 7.5h18V10H3zM12 7.5V20M12 7.5c-1.4-3.2-5.2-3.2-5.2-1.2 0 1.2 2.6 1.2 5.2 1.2zm0 0c1.4-3.2 5.2-3.2 5.2-1.2 0 1.2-2.6 1.2-5.2 1.2z"/>'),
    check: sv('<circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.6 2.5L16 9.5"/>'),
    box: sv('<path d="M4 8l8-4 8 4v8l-8 4-8-4zM4 8l8 4 8-4M12 12v8"/>'),
    ruler: sv('<path d="M3 15L15 3l6 6L9 21zM7 11l2 2M10 8l2 2M13 5l2 2"/>'),
    door: sv('<path d="M6 21V4h12v17M3 21h18M14.5 12.5h.01"/>'),
    seat: sv('<path d="M4 18v-5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5M4 15h16M6 18v2M18 18v2M7 10V7a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3"/>'),
    mail: sv('<path d="M4 6.5h16v11H4zM4.5 7l7.5 6 7.5-6"/>'),
    phone: sv('<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>'),
    pin: sv('<path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>'),
    bag: sv('<path d="M6 8h12l-1 11H7L6 8zM9 8V7a3 3 0 0 1 6 0v1"/>'),
    shield: sv('<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M8.5 12l2.4 2.4 4.6-4.8"/>'),
    pause: sv('<rect x="6" y="5" width="4" height="14" rx="1.2"/><rect x="14" y="5" width="4" height="14" rx="1.2"/>'),
    play: sv('<path d="M7 5l12 7-12 7z"/>'),
    leaf: sv('<path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14zM5 19l7-7"/>'),
    euro: sv('<path d="M17 6.5a6.5 6.5 0 1 0 0 11M4 10.5h9M4 13.5h9"/>'),
    arc: sv('<path d="M3 17c0-6 4-10 9-10s9 4 9 10"/><path d="M7 17c0-3.5 2.2-6 5-6s5 2.5 5 6"/>'),
    hand: sv('<path d="M8 13V6.5a1.5 1.5 0 0 1 3 0V12M11 11.5V5a1.5 1.5 0 0 1 3 0v6.5M14 11.5V6.5a1.5 1.5 0 0 1 3 0V14c0 4-2.5 7-6 7-2.6 0-4-1.4-5.5-3.6L4 15a1.5 1.5 0 0 1 2.4-1.8L8 15"/>'),
    foam: sv('<rect x="3" y="14" width="18" height="5" rx="2.5"/><rect x="4.5" y="9" width="15" height="5" rx="2.5"/><path d="M8 6.5c1.5-1 2.5 1 4 0s2.5 1 4 0"/>'),
    palette: sv('<circle cx="8" cy="9" r="3"/><circle cx="16" cy="9" r="3"/><circle cx="12" cy="16" r="3"/>'),
    modules: sv('<rect x="2.5" y="9" width="8.5" height="8" rx="3"/><rect x="13" y="9" width="8.5" height="8" rx="3"/><path d="M5 9V7M19 9V7"/>'),
    cushion: sv('<path d="M5 6c2 1 12 1 14 0 1 4 1 8 0 12-2-1-12-1-14 0-1-4-1-8 0-12z"/>'),
    wave: sv('<path d="M3 15c3-5 6 3 9-2s6 3 9-2"/><path d="M3 19h18"/>'),
    rock: sv('<path d="M7 4v8a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V8"/><path d="M3 19c5 2.5 13 2.5 18 0"/><path d="M8 15l-1.5 4.5M16 15l1.5 4.5"/>'),
    feet: sv('<rect x="4" y="9" width="16" height="7" rx="3.5"/><path d="M6.5 16v3M17.5 16v3"/>'),
    shelf: sv('<path d="M5 4h14v16H5zM5 11h14M10 7.5h4M10 14.5h4"/>'),
    mirror: sv('<path d="M12 3c3.3 0 5 3 5 9s-1.7 9-5 9-5-3-5-9 1.7-9 5-9z"/><path d="M10 8l2-2M10 12l4-4"/>'),
    legs: sv('<path d="M3 10h18M6 10v9M18 10v9M9.5 10v5M14.5 10v5"/>'),
    plate: sv('<path d="M4 10c0-2.5 3-4 8-4s8 1.5 8 4-3 4-8 4-8-1.5-8-4z"/><path d="M7 13.5V19M17 13.5V19"/>'),
    sun: sv('<circle cx="12" cy="12" r="4"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4"/>'),
    camera: sv('<path d="M4 8h3l1.5-2h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>'),
    knot: sv('<path d="M3 8c3-2 6 1 9 4s6 6 9 4M3 16c3 2 6-1 9-4s6-6 9-4"/>'),
    throw: sv('<path d="M4 5h16v11H4zM4 16l2 3M8 16l1 3M12 16v3M16 16l-1 3M20 16l-2 3"/>'),
    pouf: sv('<ellipse cx="12" cy="9.5" rx="8" ry="3"/><path d="M4 9.5v4.5c0 1.7 3.6 3 8 3s8-1.3 8-3V9.5"/>'),
    paw: sv('<ellipse cx="12" cy="15.5" rx="4.2" ry="3.6"/><circle cx="6.5" cy="10.5" r="1.7"/><circle cx="9.8" cy="6.8" r="1.7"/><circle cx="14.2" cy="6.8" r="1.7"/><circle cx="17.5" cy="10.5" r="1.7"/>'),
    ask: sv('<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.2-2.4 3.7M12 17h.01"/>'),
    ok: sv('<path d="M5 12.5l4.5 4.5L19 7.5"/>'),
    heart: sv('<path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20z"/>'),
    link: sv('<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>'),
    cal: sv('<rect x="4" y="5.5" width="16" height="14" rx="3"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4"/>')
  };
  /* Icône d'un point fort (champ « icone » du catalogue) */
  const FORT_ICON = { courbe: 'arc', matiere: 'hand', assise: 'seat', carton: 'box', mousse: 'foam', couleurs: 'palette', mesure: 'ruler', modules: 'modules', coussins: 'cushion', vague: 'wave', dossier: 'seat', bascule: 'rock', repos: 'feet', rangement: 'shelf', lumiere: 'sun', miroir: 'mirror', pieds: 'legs', plateau: 'plate' };
  const fortIcon = (k) => I[FORT_ICON[k]] || I.check;

  /* ---------------- Aléatoire déterministe (suggestions) ---------------- */
  const hash = (s) => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };

  /* ---------------- Fonds doux tirés du produit ---------------- */
  /* Couleur de fond de la grande carte pour la 1re couleur de chaque pièce */
  const FOND = {
    incurve: '#E8DCCB',          /* sable */
    'petit-incurve': '#E4E0D4',  /* lin */
    capiton: '#EEDFD3',          /* crème rosée */
    causeuse: '#D5DCC9',         /* sauge */
    courbe: '#E3DCCD',           /* grège */
    'noix-de-cajou': '#EBDBC6',  /* biscuit */
    meridienne: '#DCDFCF',       /* sauge pâle */
    'petit-mouton': '#ECE3D6',   /* crème */
    galet: '#E2D8CB',            /* argile */
    berceuse: '#EAD9C8',         /* caramel clair */
    veilleuse: '#D7E3DD',        /* vert d'eau */
    'miroir-onde': '#E7DFD3',    /* plâtre */
    'table-nuage': '#DCE2E3'     /* ciel pâle */
  };
  const NOM_FOND = { incurve: 'sable', 'petit-incurve': 'lin', capiton: 'crème rosée', causeuse: 'sauge', courbe: 'grège', 'noix-de-cajou': 'biscuit', meridienne: 'sauge', 'petit-mouton': 'crème', galet: 'argile', berceuse: 'caramel', veilleuse: "vert d'eau", 'miroir-onde': 'plâtre', 'table-nuage': 'ciel' };
  const hexRgb = (h) => { const n = parseInt(h.replace('#', ''), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
  const mixHex = (h1, h2, t) => { const a = hexRgb(h1), b = hexRgb(h2); return '#' + a.map((v, i) => Math.round(v + (b[i] - v) * t).toString(16).padStart(2, '0')).join(''); };
  /* Fond pour une couleur : la 1re garde sa teinte choisie, les autres sont des pastels de la couleur */
  /* Un seul studio pour toutes les pièces : la charte prime sur la couleur du tissu */
  const STUDIO_BG = '#F0EFEB';   /* fond clair des photos (studio-clair.py) */
  function bgOf() { return STUDIO_BG; }

  /* une nouvelle tentative, puis repli sur la première vraie photo gardée (jamais une photo retirée de galeries.json) */
  const fallbackAttr = (p) => { const im = okImages(p)[0]; return `onerror="if(!this.dataset.retry){this.dataset.retry=1;var i=this;setTimeout(function(){i.src='${cut(p)}?r=1'},500)}else{this.onerror=null;${im ? `this.src='${photo(p, im.id, 640)}';this.classList.add('is-photo')` : ''}}"`; };

  function prodImg(p, { alt = '', eager = false } = {}) {
    return `<img src="${cut(p)}" alt="${esc(alt)}" ${eager ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async" draggable="false" ${fallbackAttr(p)}>`;
  }
  function objHtml(p, o = {}) {
    return `<span class="studio__shadow" aria-hidden="true"></span>${prodImg(p, o)}`;
  }

  /* Studio : fond doux, sol, ombre de contact réaliste, pièce détourée posée au sol */
  function studio(p, { cls = '', alt = '', eager = false, k = 0, extra = '', attrs = '' } = {}) {
    return `<div class="studio studio--${shape(p)} ${cls}" style="--bg:${bgOf(p, k)};--r:${RATIO[p.slug] || 1.6}" ${attrs}>
      <div class="studio__obj">${objHtml(p, { alt, eager })}</div>
      ${extra}
    </div>`;
  }
  /* compatibilité : ancien nom */
  const stage = (p, o = {}) => studio(p, { k: o.k || 0, cls: o.cls || '' });

  /* Vignette : la carte en vraie photo de la couleur choisie (pièce entière, voir pieceFit) ; sans carte, la photo gardée de
     la couleur, sinon le détouré */
  function thumbFor(p, colorName) {
    if (carteOf(p)) return pieceFit(p, colorName);
    const k = Math.max(0, p.couleurs.findIndex((x) => x.nom === colorName));
    const c = p.couleurs[k];
    if (c.image && k > 0 && !retirees(p).has(c.image)) return `<img class="thumb-photo" src="${photo(p, c.image, 640)}" alt="" loading="lazy" decoding="async">`;
    return studio(p, { k, cls: 'studio--mini' });
  }

  /* ---------------- Dates de livraison (jours ouvrés) ---------------- */
  function easter(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  function holidays(y) {
    const e = easter(y);
    const add = (dt, n) => { const x = new Date(dt); x.setDate(x.getDate() + n); return x; };
    return [new Date(y, 0, 1), add(e, 1), new Date(y, 4, 1), new Date(y, 4, 8), add(e, 39), add(e, 50), new Date(y, 6, 14), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25)].map((x) => x.toDateString());
  }
  function addBusiness(from, n) {
    const d = new Date(from);
    const hs = new Set(holidays(d.getFullYear()).concat(holidays(d.getFullYear() + 1)));
    let c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6 && !hs.has(d.toDateString())) c++; }
    return d;
  }
  const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const dayLbl = (d, m) => `${JOURS[d.getDay()]}${NB}${d.getDate() === 1 ? '1er' : d.getDate()}${m ? NB + MOIS[d.getMonth()] : ''}`;
  /* Délai d'une pièce : celui de son pays d'expédition ; les accessoires vendus seuls ont aussi les leurs (site.json >
     livraison > delaisAccessoires, coussins nœud depuis la Chine), hors des délais généraux du site */
  const DL = (p) => SITE.livraison.delais[p.pays] || (SITE.livraison.delaisAccessoires || {})[p.pays] || SITE.livraison.delais.FR;
  /* Date de livraison (07/10, chantier 2) : une seule date, la borne la plus prudente du délai de l'entrepôt de la pièce
     (3 à 7 jours ouvrés depuis la France, 4 à 8 depuis l'Allemagne, l'Espagne ou la Pologne), en jours ouvrés hors jours fériés.
     « d’ici le vendredi 16 octobre » ; le thème Shopify sert la même date dans le HTML (snippets/caplia-date-livraison). */
  function delivery(p) {
    return `d’ici le ${dayLbl(addBusiness(new Date(), DL(p)[1]), true)}`;
  }
  /* Date d'un cadeau (supervision du 08/10) : celle de l'article vendu seul qu'il est (site.json > paliers > produit) :
     coussins depuis la Chine (6 à 12 jours ouvrés), plaid depuis l'Espagne ; il voyage dans son propre colis */
  const giftProd = (pl) => (pl && BY[pl.produit]) || null;
  const giftWhen = (pl) => { const g = giftProd(pl); return g ? delivery(g) : ''; };
  /* la même date, courte (barre d'achat du téléphone) : « d’ici le 16 octobre » */
  const MOIS_C = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const deliveryShort = (p) => { const d = addBusiness(new Date(), DL(p)[1]); return `${isFem(p) ? 'Livrée' : 'Livré'} d’ici le ${d.getDate() === 1 ? '1er' : d.getDate()}${NB}${MOIS_C[d.getMonth()]}`; };
  const delayTxt = (p) => { const [a, b] = DL(p); return `${a} à ${b} jours ouvrés`; };
  const deliveryEnd = (p) => dayLbl(addBusiness(new Date(), DL(p)[1]), true);

  /* ---------------- Libellés produit ---------------- */
  function dimsLabel(p) {
    if (p.tailles) return p.tailles.map((t) => t.nom.replace(/ cm$/, '')).join(', ').replace(/, ([^,]*)$/, ' ou $1') + NB + 'cm';
    const d = p.dimensions;
    return `${numFr(d.largeur)}${NB}×${NB}${numFr(d.profondeur)}${NB}cm`;
  }
  const heightLabel = (p) => (p.tailles && isMirror(p) ? sizeNums(p, 0) : cm(p.dimensions.hauteur));
  const colorsLabel = (p) => (p.couleurs.length === 1 ? p.couleurs[0].nom : `${p.couleurs.length} couleurs`);
  function specs(p, which = 'all') {
    const [a, b] = DL(p);
    const all = [
      ['Dimensions', dimsLabel(p)],
      ['Hauteur', heightLabel(p)],
      ['Matière', p.matiere],
      [p.couleurs.length === 1 ? 'Couleur' : 'Couleurs', colorsLabel(p)],
      ['Expédition', `Depuis ${PAYS_DE[p.pays]}`],
      ['Livraison', `Offerte · ${a} à ${b} j ouvrés`]
    ];
    const list = which === 'short' ? all.slice(0, 3) : all;
    return list.map(([k, v]) => `<div><dt>${k}</dt><dd>${esc(v)}</dd></div>`).join('');
  }
  const unitPriceOf = (p, size) => { if (p.tailles) { const t = p.tailles.find((x) => x.nom === size) || p.tailles[0]; return t.prix; } return p.prix; };
  const colName = (slug) => CAT.collections.find((c) => c.slug === slug);

  /* ---------------- Cadeaux (paliers de site.json) ---------------- */
  const GIFT_SHORT = ['coussins nœud', 'plaid', 'second plaid'];
  const GIFT_TO = ['aux coussins nœud offerts', 'au plaid offert', 'au second plaid offert'];
  const cap1 = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const lc1 = (s) => s.charAt(0).toLowerCase() + s.slice(1);
  /* Couleurs en rupture (« rupture »: true dans catalogue.json) : visibles, jamais ajoutées au panier */
  const isOut = (c) => !!(c && c.rupture);
  /* Rupture d'une taille : « ruptureCouleurs » (les couleurs épuisées dans cette taille) ou « rupture »: true (toutes) */
  const sizeOutFor = (t, color) => !!(t && (t.rupture === true || (t.ruptureCouleurs || []).includes(color)));
  /* Pièce visible mais pas encore en vente (« bientot »: true) : ni bouton d'achat, ni panier, l'e-mail de mise en vente */
  const notYet = (p) => !!(p && p.bientot);
  /* Accessoire vendu seul (catalogue.json « accessoire » : coussins nœud, plaid) : hors des paliers, des suggestions et des salons */
  const isAcc = (p) => !!(p && p.accessoire);
  /* En vente : pas « bientôt », et au moins une couleur encore disponible dans au moins une taille (Mirage, 06/10 : plus aucune) */
  const onSale = (p) => !!p && !notYet(p) && p.couleurs.some((c) => !c.rupture && (!p.tailles || p.tailles.some((t) => !sizeOutFor(t, c.nom))));
  /* Ce qui est en vente, préparé une fois au chargement :
     - une couleur « retiree » (plus aucun fournisseur) n'apparaît nulle part, ses données restent dans catalogue.json ;
     - une taille épuisée dans toutes les couleurs montrées disparaît, et le prix de la pièce devient celui des tailles
       restantes (Mirage, seul en 160 × 50 cm : « 290 € », sans « dès »). */
  function prepare(p) {
    const keep = p.couleurs.filter((c) => !c.retiree);
    if (keep.length) p.couleurs = keep;
    if (p.tailles) {
      const shown = p.couleurs.filter((c) => !c.rupture);
      const ref = shown.length ? shown : p.couleurs;
      const ts = p.tailles.filter((t) => ref.some((c) => !sizeOutFor(t, c.nom)));
      if (ts.length) p.tailles = ts;
      p.prix = Math.min(...p.tailles.map((t) => t.prix));
    }
    return p;
  }
  /* « dès » seulement quand plusieurs prix restent en vente */
  const fromOf = (p) => (p.tailles && new Set(p.tailles.map((t) => t.prix)).size > 1 ? 'dès ' : '');
  /* Taille à enregistrer pour une couleur : celle demandée si elle est en vente dans cette couleur, sinon la première
     en vente ('' sans tailles ; null quand la combinaison demandée est épuisée) */
  const sizeFor = (p, color, size) => {
    if (!p.tailles) return '';
    const t = size ? p.tailles.find((x) => x.nom === size) : p.tailles.find((x) => !sizeOutFor(x, color));
    return t && !sizeOutFor(t, color) ? t.nom : null;
  };
  /* Couleur montrée par l'image studio : la première, sauf quand elle est épuisée et qu'une image de la couleur en vente
     a été faite (maquettes/outils/variantes-stock.py) */
  const STUDIO_COLOR = { berceuse: 'Caramel beurre salé', 'miroir-onde': 'Sable blond' };
  const studioColor = (p) => STUDIO_COLOR[p.slug] || p.couleurs[0].nom;
  const firstIn = (p) => Math.max(0, p.couleurs.findIndex((c) => !c.rupture));
  const colorIn = (p, name) => { const c = p.couleurs.find((x) => x.nom === name || (x.cle && x.cle === name)); return c && !c.rupture ? c.nom : p.couleurs[firstIn(p)].nom; };
  function swatchBtn(c, k, checked, action) {
    const out = isOut(c);
    return `<button class="swatch${out ? ' is-out' : ''}" type="button" role="radio" aria-checked="${checked}" aria-label="${esc(c.nom)}${out ? ', bientôt de retour' : ''}" title="${esc(c.nom)}${out ? ' · Bientôt de retour' : ''}" style="--c:${c.hex}" data-action="${action}" data-k="${k}"></button>`;
  }
  /* « un plaid côtelé et sherpa » → « Plaid côtelé et sherpa » */
  const giftLabel = (pl) => cap1(pl.cadeau.replace(/^(un|une)\s+/i, ''));
  /* accord tiré du texte : « Offerts », « Offert », « Offerte » */
  const giftWord = (pl) => (pl.detail.match(/^Offerte?s?/) || ['Offert'])[0];
  const giftsFor = (total) => SITE.paliers.filter((pl) => total >= pl.seuil);
  /* Valeur d'un cadeau : le prix de vente sur le site du même article vendu seul (site.json > paliers > produit, catalogue.json
     « accessoire ») ; rien quand l'article n'est pas en vente (jamais une valeur inventée) */
  const giftValue = (pl) => { const a = pl && pl.produit && BY[pl.produit]; return a && onSale(a) ? a.prix : null; };
  const giftsSaved = (list) => list.reduce((s, pl) => s + (giftValue(pl) || 0), 0);
  /* valeur d'un cadeau : son prix vendu seul, jamais barré (refonte du 07/10, règle de l'utilisateur) */
  const strike = (v) => (v ? `<span class="was num">(valeur ${price(v)})</span>` : '');
  /* Vraie photo du cadeau (cadeaux.json : la pièce posée dans le studio gris, 640 px), chargement différé */
  function giftPic(pl, cls = 'gpic') {
    const i = SITE.paliers.indexOf(pl);
    const ph = GIFTS && GIFTS.paliers && GIFTS.paliers[i] && GIFTS.paliers[i].photos && GIFTS.paliers[i].photos[0];
    if (!ph) return '';
    const k = ph.tailles && ph.tailles['640'] ? '640' : Object.keys(ph.tailles || { 640: 1 })[0];
    return `<span class="${cls}"><picture>${ph.avif ? `<source type="image/avif" srcset="/site/assets/${ph.src}-${k}.avif">` : ''}<img src="/site/assets/${ph.src}-${k}.webp" alt="" width="640" height="640" loading="lazy" decoding="async" draggable="false"></picture></span>`;
  }
  const andList = (a) => (a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' et ' + a[a.length - 1]);
  const orList = (a) => (a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' ou ' + a[a.length - 1]);

  /* ---------------- Ensembles « Le salon assorti » (prix = somme exacte) ---------------- */
  /* L'image de chaque ensemble (cartes-echelle.py) montre ces couleurs-là : la changer ici, c'est refaire l'image */
  const ENS = [
    { nom: 'Le salon Corolle', photo: ['incurve', '03'], items: [['incurve', 'Crème de lait'], ['miroir-onde', 'Sable blond', '160 × 50 cm']] },
    { nom: 'Le salon Éclipse', photo: ['noix-de-cajou', '10'], items: [['noix-de-cajou', 'Crème clair de lune'], ['galet', 'Crème meringue']] },
    { nom: 'Le salon Jade', img: 'causeuse-arches', items: [['causeuse', 'Vert sous-bois'], ['galet', 'Crème meringue'], ['miroir-onde', 'Sable blond', '160 × 50 cm']] },
    { nom: 'Le salon Ondine', img: 'meridienne-platre', items: [['meridienne', 'Blanc coquillage'], ['galet', 'Crème meringue']] },
    { nom: 'Le salon Opaline', img: 'petit-incurve-galerie', items: [['petit-incurve', "Blanc coquille d'œuf"], ['galet', 'Crème meringue']] },
    { nom: 'Le petit salon Flocon', img: 'petit-mouton-paris', items: [['petit-mouton', 'Crème guimauve'], ['galet', 'Crème meringue']] },
    /* Caplia Sleep : les chambres assorties, montrées seulement dans l'univers Sleep (sleepSets) */
    { nom: 'La chambre Songe', sleep: true, items: [['songe', 'Beige lin', '140 × 200 cm'], ['dune', 'Crème meringue']] },
    { nom: 'La chambre Brume', sleep: true, items: [['brume', 'Blanc ivoire', '140 × 200 cm'], ['sillon', 'Gris tourterelle']] }
  ];
  const ensTotal = (e) => e.items.reduce((s, [slug, , size]) => s + unitPriceOf(BY[slug], size), 0);
  /* un ensemble n'est proposé que si chacune de ses pièces est en vente dans la couleur et la taille de l'ensemble
     (jamais une pièce masquée, épuisée ou pas encore en vente) */
  const ensOk = (e) => e.items.every(([s, color, size]) => {
    const p = BY[s];
    if (!onSale(p)) return false;
    const c = p.couleurs.find((x) => x.nom === color);
    return !!c && !c.rupture && sizeFor(p, c.nom, size || '') !== null;
  });
  const ensFor = (slug) => ENS.find((e) => e.items[0][0] === slug && ensOk(e));

  /* ---------------- « Passera-t-il chez vous ? » ----------------
     Un meuble passe une porte de profil : il suffit que sa plus petite mesure soit plus étroite que la porte (2 cm de marge).
     Pièce compressée : c'est son plus grand carton qui passe la porte. Ses cotes (livraison.json > pieces > carton_cm,
     [longueur, largeur, hauteur] en cm) ne sont écrites que quand le vendeur les donne ; sans elles, aucune réponse ne dit
     qu'elle passe : le client envoie ses mesures, nous vérifions les cotes du carton et répondons par écrit dans la journée.
     Pièce livrée montée ou en modules (Corolle, fauteuils) : ses propres mesures. */
  const isCompressed = (p) => /compress/i.test((p.carton || []).join(' ') + ' ' + p.description.join(' '));
  const cartonCm = (p) => { const a = arrOf(p), c = a && a.carton_cm; return Array.isArray(c) && c.length === 3 && c.every((x) => x > 0) ? c : null; };
  /* la mesure qui passe la porte : la plus petite du plus grand carton (pièce compressée), sinon celle de la pièce ; null = pas encore connue */
  /* Pièce livrée en kit (livraison.json « kit » : Valse) : c'est son colis qui passe la porte, pas la pièce montée */
  const isKit = (p) => !isCompressed(p) && !!(arrOf(p) && arrOf(p).kit);
  /* Pièce livrée en colis à monter (07/10 : la notice du fabricant le dit, fiches-techniques.json > deballage > Montage) :
     ce sont ses colis qui passent la porte, pas le canapé monté */
  const isFlat = (p) => !isCompressed(p) && !isKit(p) && (((FT[p.slug] || {}).deballage || []).some(([a, v]) => a === 'Montage' && !/^aucun/i.test(v)));
  const boxed = (p) => isCompressed(p) || isKit(p) || isFlat(p);
  const doorMin = (p) => { if (boxed(p)) { const c = cartonCm(p); return c ? Math.min(...c) : null; } return minDim(p); };
  const dims3 = (c) => `${c.slice(0, 2).map(numFr).join(`${NB}×${NB}`)}${NB}×${NB}${cm(c[2])}`;
  /* Ce qui rassure sur l'arrivée, en faits : compressé (carton plus petit que la pièce, sans outil) ou en modules */
  function easyIn(p) {
    const f = isFem(p) ? 'e' : '';
    if (isCompressed(p)) {
      const n = colisN(p), c = cartonCm(p), il = f ? 'Elle' : 'Il';
      return [`Livré${f} compressé${f}`, c ? `Son plus grand carton mesure ${dims3(c)} : il passe une porte de ${cm(Math.ceil(Math.min(...c) + 2))}. ${il} s'installe sans outil.`
        : `${n > 1 ? `Ses ${n} cartons sont plus petits` : 'Son carton est plus petit'} ${f ? "qu'elle" : 'que lui'}, et ${il.toLowerCase()} s'installe sans outil.`];
    }
    if (isFlat(p)) { const n = colisN(p); return [n ? `Livré${f} en ${n} colis` : `Livré${f} en colis`, `${n > 1 ? 'Ses colis sont plus petits' : 'Son colis est plus petit'} ${f ? "qu'elle" : 'que lui'}, et ${f ? 'elle' : 'il'} se monte sur place.`]; }
    if (isKit(p)) { const c = cartonCm(p); return [`Livré${f} en kit`, c ? `Son colis mesure ${dims3(c)} : il passe une porte de ${cm(Math.ceil(Math.min(...c) + 2))}. Le montage est simple.` : `Son colis est plus petit ${f ? "qu'elle" : 'que lui'}, et le montage est simple.`]; }
    const parts = (p.carton || []).find((t) => /^\d+ (modules|parties)$/i.test(t));
    if (parts) return [`Livré${f} en ${parts.toLowerCase()}`, `De profil, chacun passe une porte de ${cm(Math.ceil(minDim(p) + 2))}.`];
    return null;
  }
  function doorAnswer(p, w, x = {}) {
    const e = isFem(p), il = e ? 'elle' : 'il';
    const ok = w >= 30 && w <= 300;
    /* escalier ou couloir (facultatif, 07/10) : le passage le plus étroit des deux compte */
    const st = x.esc >= 30 && x.esc <= 300 ? x.esc : null;
    const lim = ok && st ? Math.min(w, st) : w;
    const where = ok && st && st < w ? `votre escalier ou couloir de ${cm(st)}` : `votre porte de ${cm(w)}`;
    /* l'e-mail part prérempli : la largeur tapée, l'escalier et l'étage s'ils sont donnés */
    const body = `Bonjour,\n\nPièce : ${p.nom}\nLargeur de ma porte la plus étroite : ${ok ? numFr(w) : '…'} cm\nLargeur de mon escalier ou couloir : ${st ? numFr(st) : '…'} cm\nÉtage : ${x.etage || '…'}\n`;
    const ask = (t) => `<a href="mailto:${SITE.email}?subject=${encodeURIComponent('Passera-t-il chez moi ? ' + p.nom)}&body=${encodeURIComponent(body)}">${t} vos mesures</a>`;
    if (!ok) return { ok: false, done: false, html: 'Indiquez la largeur de votre porte la plus étroite, en centimètres.' };
    const min = doorMin(p), c = boxed(p) ? cartonCm(p) : null;
    /* cotes du carton pas encore connues : jamais « elle passe », la vérification se fait par écrit */
    if (min == null && isFlat(p)) return { ok: null, done: true, html: `<b>${e ? 'Elle arrive' : 'Il arrive'} en ${colisN(p) > 1 ? `${colisN(p)} colis` : 'colis'}</b>, plus petits ${e ? "qu'elle" : 'que lui'}, et se monte sur place. Pour ${where}, ${ask('envoyez-nous')}${st ? '' : ', escalier compris'} : nous vérifions les cotes des colis et vous répondons par écrit dans la journée.` };
    if (min == null && isKit(p)) return { ok: null, done: true, html: `<b>${e ? 'Elle arrive en kit' : 'Il arrive en kit'}</b>, dans un colis plus petit ${e ? "qu'elle" : 'que lui'}. Pour ${where}, ${ask('envoyez-nous')}${st ? '' : ', escalier compris'} : nous vérifions et vous répondons par écrit dans la journée.` };
    if (min == null) return { ok: null, done: true, html: `<b>${e ? 'Elle arrive compressée' : 'Il arrive compressé'}</b>, ${colisN(p) > 1 ? 'dans des cartons plus petits' : 'dans un carton plus petit'} ${e ? "qu'elle" : 'que lui'}. Pour ${where}, ${ask('envoyez-nous')}${st ? '' : ', escalier compris'} : nous vérifions les cotes du carton et vous répondons par écrit dans la journée.` };
    const what = c ? `la plus petite mesure de son plus grand carton fait ${cm(min)}` : `sa plus petite mesure fait ${cm(min)}`;
    if (lim >= min + 2) return { ok: true, done: true, html: `<b>Bonne nouvelle</b> : ${what}, ${c ? 'il passe' : `${il} passe`} de profil ${where}. Pour la confirmation écrite qui nous engage, ${ask('envoyez-nous')}${st ? '' : ', escalier et couloir compris'}.` };
    return { ok: false, done: true, html: `<b>C'est juste</b> : ${what}, pour ${where}. ${ask('Envoyez-nous')}, porte, escalier et étage : nous vous répondons par écrit avant l'achat.` };
  }

  /* ---------------- Panier ---------------- */
  let cart = [];
  function loadCart() {
    try {
      const v = SHOP_CART_LINES();
      /* jamais une couleur épuisée ou retirée, une taille épuisée dans la couleur, ni une pièce pas encore en vente */
      const rows = Array.isArray(v) ? v.filter((l) => l && BY[l.slug] && l.qty > 0 && !notYet(BY[l.slug]) && !(l.color && !BY[l.slug].couleurs.some((x) => x.nom === l.color || x.cle === l.color)) && !isOut(BY[l.slug].couleurs.find((x) => x.nom === l.color)))
        .map((l) => { const p = BY[l.slug], color = colorIn(p, l.color || ''); return { slug: l.slug, color, size: sizeFor(p, color, l.size || ''), qty: Math.min(9, Math.max(1, l.qty | 0)) }; })
        .filter((l) => l.size !== null) : [];
      cart = [];
      rows.forEach((l) => { const o = cart.find((x) => x.slug === l.slug && x.color === l.color && x.size === l.size); if (o) o.qty = Math.min(9, o.qty + l.qty); else cart.push(l); });
    } catch (e) { cart = []; }
    plaidGifts = plaidGiftCount();
  }
  function saveCart() { plaidSwap(); SHOP_CART_SYNC(); }
  /* Plaid acheté seul et plaid offert ne vont jamais ensemble (supervision du 08/10). Quand le panier franchit un palier
     qui offre le plaid alors qu'un plaid payé y est déjà, le plaid offert le remplace : la ligne payée part, sa couleur
     devient celle du plaid offert (PLAID_PREF, envoyée à Shopify avec le cadeau) et le panier le dit (SWAP_MSG).
     Un plaid ajouté exprès quand le plaid est déjà offert reste (on ne compare qu'au franchissement du palier). */
  const PLAID = 'plaid', PLAID_PREF = 'caplia-plaid-offert';
  let plaidGifts = 0, SWAP_MSG = '';
  const plaidGiftCount = () => giftsFor(giftBase()).filter((pl) => pl.produit === PLAID).length;
  const plaidPref = () => { try { return localStorage.getItem(PLAID_PREF) || ''; } catch (e) { return ''; } };
  function plaidSwap() {
    SWAP_MSG = '';
    swapSeen();
    const n = plaidGiftCount(), before = plaidGifts;
    plaidGifts = n;
    try { if (!n) localStorage.removeItem(PLAID_PREF); } catch (e) { /* stockage indisponible */ }
    const l = cart.find((x) => x.slug === PLAID);
    if (n <= before || !l) return;
    try { localStorage.setItem(PLAID_PREF, l.color); } catch (e) { /* stockage indisponible */ }
    l.qty -= 1;
    if (l.qty < 1) cart.splice(cart.indexOf(l), 1);
    plaidGifts = plaidGiftCount();
    SWAP_MSG = `Votre plaid ${lc1(l.color)} est maintenant offert : nous l’avons retiré de vos achats, ${price(BY[PLAID].prix)} de moins.`;
    try { sessionStorage.setItem(PLAID_PREF + '-msg', SWAP_MSG); } catch (e) { /* stockage indisponible */ }
  }
  /* le message suit le client jusqu'au panier (ajout depuis une fiche, puis « Voir le panier ») jusqu'au changement suivant du panier */
  const swapMsg = () => { if (SWAP_MSG) return SWAP_MSG; try { return sessionStorage.getItem(PLAID_PREF + '-msg') || ''; } catch (e) { return ''; } };
  const swapSeen = () => { try { sessionStorage.removeItem(PLAID_PREF + '-msg'); } catch (e) { /* stockage indisponible */ } };
  const lineKey = (l) => `${l.slug}|${l.color}|${l.size}`;
  const lineTotal = (l) => unitPriceOf(BY[l.slug], l.size) * l.qty;
  const cartCount = () => cart.reduce((s, l) => s + l.qty, 0) + SHOP_EXTRA_COUNT();
  const cartTotal = () => cart.reduce((s, l) => s + lineTotal(l), 0) + SHOP_EXTRA_TOTAL();
  /* Montant qui compte pour les cadeaux : les meubles seulement (un plaid acheté ne fait pas gagner le plaid offert) */
  const giftBase = () => cart.reduce((s, l) => (isAcc(BY[l.slug]) ? s : s + lineTotal(l)), 0);

  function updateBadge(bump) {
    const n = cartCount();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n ? String(n) : '';
      if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    const link = $('.nav__cart');
    if (link) link.setAttribute('aria-label', `Panier, ${n} article${n > 1 ? 's' : ''}`);
  }
  function addToCart(slug, color, size, qty = 1, silent = false) {
    const p = BY[slug];
    if (!p) return false;
    if (p.couleurs.every(isOut) || notYet(p)) return false;
    const c = colorIn(p, color);
    const s = sizeFor(p, c, size);
    if (s === null) return false;
    if (!SHOP_CAN_ADD(p, c, s)) return false;
    const before = giftsFor(giftBase()).length;
    const l = cart.find((x) => x.slug === slug && x.color === c && x.size === s);
    if (l) l.qty = Math.min(9, l.qty + qty); else cart.push({ slug, color: c, size: s, qty });
    saveCart();
    updateBadge(true);
    const what = [p.nom].concat(c && p.couleurs.length > 1 ? [lc1(c)] : [], s ? [s] : []);
    if (!silent) addedToast(`${what.join(', ')}${what.length > 1 ? ',' : ''} est dans votre panier.${SWAP_MSG ? ' ' + SWAP_MSG : ''}`, giftsFor(giftBase()).slice(before));
    if (PDP.p === p && !silent) { PDP.done.cart = true; pdpSteps(); }
  }
  /* firstColor : la couleur choisie sur la fiche pour la première pièce (sinon celle de l'ensemble) */
  function addEnsemble(i, firstColor) {
    const e = ENS[i];
    if (!e) return;
    if (!SHOP_ENS_OK(e)) return;
    const before = giftsFor(giftBase()).length;
    e.items.forEach(([slug, color, size], k) => addToCart(slug, colorIn(BY[slug], k === 0 && firstColor ? firstColor : color), size, 1, true));
    addedToast(`${e.nom} est dans votre panier.`, giftsFor(giftBase()).slice(before));
    refreshCart();
  }
  /* Confirmation sans fenêtre bloquante : la phrase, le total et « Voir le panier » ; un cadeau débloqué passe devant,
     avec sa photo (« Coussins nœud offerts ✓ ») */
  function addedToast(text, won) {
    const tot = `Total : ${price(cartTotal())}.`;
    const g = won && won.length ? won[won.length - 1] : null;
    if (g) {
      const ss = won.map((pl) => GIFT_SHORT[SITE.paliers.indexOf(pl)]);
      const many = ss.length > 1 || plural(ss[0]);
      toast(null, '', false, '', `${giftPic(g, 'toast__pic')}<p><b>${esc(cap1(andList(ss)))} offert${many ? 's' : ''} ✓</b><br>${esc(text)} ${tot}</p>`);
    } else toast(null, `${text} ${tot}`);
  }
  /* L'effet d'ajout, sobre et sous 600 ms : la vignette part vers le panier, le compteur rebondit (updateBadge), le bouton
     dit « Ajouté ✓ » 1,5 s ; une vibration très courte au téléphone. Mouvement réduit demandé : seul l'état change. */
  function cartFx(btn, src) {
    try { if (navigator.vibrate && matchMedia('(pointer: coarse)').matches) navigator.vibrate(12); } catch (err) { /* sans vibration */ }
    if (btn) {
      const lbl = $('.cta__label', btn) || btn;
      if (!btn.dataset.lbl) btn.dataset.lbl = lbl.textContent;
      lbl.textContent = 'Ajouté ✓'; btn.classList.add('is-done');
      clearTimeout(btn._t); btn._t = setTimeout(() => { lbl.textContent = btn.dataset.lbl; delete btn.dataset.lbl; btn.classList.remove('is-done'); }, 1500);
    }
    if (reduce || !src || !src.animate) return;
    const img = src.tagName === 'IMG' ? src : $('img', src);
    const to = $$('.nav__cart').find((x) => x.getBoundingClientRect().width > 0);
    if (!img || !to) return;
    const a = src.getBoundingClientRect(), b = to.getBoundingClientRect();
    if (!a.width || !b.width || a.bottom < 0 || a.top > innerHeight) return;
    const sz = Math.min(120, a.width, a.height);
    const g = document.createElement('img');
    g.src = img.currentSrc || img.src; g.alt = ''; g.className = 'fly';
    Object.assign(g.style, { left: `${a.left + a.width / 2 - sz / 2}px`, top: `${a.top + a.height / 2 - sz / 2}px`, width: `${sz}px`, height: `${sz}px` });
    document.body.appendChild(g);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const an = g.animate([{ transform: 'translate(0, 0) scale(1)', opacity: 1 }, { transform: `translate(${dx}px, ${dy}px) scale(.18)`, opacity: .4 }], { duration: 520, easing: 'cubic-bezier(.22, 1, .36, 1)' });
    const end = () => g.remove();
    an.onfinish = end; setTimeout(end, 700);
  }

  /* ---------------- Ma sélection (favoris, stockage local) ---------------- */
  const FAV_KEY = KEY + '-selection';
  let fav = [];
  function loadFav() {
    try { const v = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); fav = Array.isArray(v) ? [...new Set(v.filter((s) => BY[s]))] : []; } catch (e) { fav = []; }
  }
  function saveFav() { try { localStorage.setItem(FAV_KEY, JSON.stringify(fav)); } catch (e) { /* stockage indisponible */ } }
  const isFav = (slug) => fav.includes(slug);
  function favBadge() {
    $$('[data-fav-count]').forEach((el) => { el.textContent = fav.length ? String(fav.length) : ''; });
    $$('[data-fav-link]').forEach((el) => { el.hidden = !fav.length; });
    document.documentElement.classList.toggle('has-fav', fav.length > 0);
    const l = $('.nav__fav');
    if (l) l.setAttribute('aria-label', `Ma sélection, ${fav.length} pièce${fav.length > 1 ? 's' : ''}`);
  }
  function favBtnSync() {
    $$('[data-action="fav"]').forEach((b) => {
      const on = isFav(b.dataset.slug);
      b.setAttribute('aria-pressed', String(on));
      const t = $('[data-fav-label]', b);
      if (t) t.textContent = on ? 'Dans ma sélection' : 'Enregistrer dans ma sélection';
    });
  }
  function toggleFav(slug, force) {
    if (!BY[slug]) return;
    const on = force === undefined ? !isFav(slug) : force;
    fav = fav.filter((s) => s !== slug);
    if (on) fav.unshift(slug);
    saveFav(); favBadge(); favBtnSync();
  }

  /* ---------------- Commande simulée (page Merci) ---------------- */
  const ORDER_KEY = KEY + '-commande';
  function loadOrder() { try { const o = JSON.parse(localStorage.getItem(ORDER_KEY) || 'null'); return o && Array.isArray(o.items) ? o : null; } catch (e) { return null; } }
  function saveOrder(o) { try { localStorage.setItem(ORDER_KEY, JSON.stringify(o)); } catch (e) { /* stockage indisponible */ } }

  /* ---------------- Dates ---------------- */
  const plusDays = (n, from = new Date()) => { const d = new Date(from); d.setDate(d.getDate() + n); return d; };
  const dateLbl = (d) => `${d.getDate() === 1 ? '1er' : d.getDate()} ${MOIS[d.getMonth()]}`;

  /* ---------------- La peur n° 1 de chaque avatar, en une ligne sous le prix ---------------- */
  const FEAR = {
    incurve: ['paw', 'Enfants, chat : une tache se tamponne au chiffon humide, sans frotter.'],
    'noix-de-cajou': ['paw', 'Enfants, chat : une tache se tamponne au chiffon humide, sans frotter.'],
    capiton: ['paw', 'Enfants, chien : une tache se tamponne au chiffon humide, sans frotter.'],
    meridienne: ['paw', 'Une tache sur la chenille ? Elle se tamponne au chiffon humide, sans frotter.'],
    causeuse: ['door', 'À deux, sans hésiter : envoyez-nous vos mesures, nous vérifions qu’il passe chez vous et vous répondons par écrit.'],
    'petit-incurve': ['door', 'À deux, sans hésiter : envoyez-nous vos mesures, nous vérifions qu’il passe chez vous et vous répondons par écrit.'],
    courbe: ['door', 'Envoyez-nous vos mesures : nous vérifions qu’il passe chez vous et vous répondons par écrit.'],
    'petit-mouton': ['box', 'Un carton, aucun outil : il reprend sa forme en 72 heures.'],
    veilleuse: ['seat', 'Après bébé, il reste au salon : le fauteuil des soirées lecture, repose-pieds compris.'],
    berceuse: ['seat', 'D’abord dans la chambre de bébé, ensuite au salon : il va partout.'],
    galet: ['hand', 'Une tache sur la bouclette ? Elle se tamponne au chiffon humide, sans frotter.'],
    'miroir-onde': ['camera', 'Un souci à la livraison ? Une photo par e-mail suffit, nous nous en occupons.'],
    'table-nuage': ['camera', 'Un souci à la livraison ? Une photo par e-mail suffit, nous nous en occupons.']
  };

  /* Copier un texte (lien de fiche) : presse-papiers, sinon sélection manuelle */
  async function copyText(txt, input) {
    try { await navigator.clipboard.writeText(txt); return true; } catch (e) {
      if (input) { input.focus(); input.select(); try { return document.execCommand('copy'); } catch (e2) { return false; } }
      return false;
    }
  }
  const pageUrl = (hash) => location.origin + TO_URL(hash);

  /* ---------------- Envoyer (fiche, panier, sélection) ----------------
     Un canapé se choisit en plusieurs fois, souvent d'abord au téléphone : le client s'envoie la page pour la rouvrir
     plus tard, ici ou sur un ordinateur. Téléphone : le partage du système (e-mail, messagerie, notes). Ailleurs : un
     petit menu « Copier le lien », « M'envoyer par e-mail » (objet et lien déjà écrits, le client met son adresse).
     Les liens rouvrent la même couleur et la même taille (fiche), recréent le panier ou la sélection (takeShared). */
  const touchShare = () => !!navigator.share && matchMedia('(pointer: coarse)').matches;
  function shareData(kind) {
    if (kind === 'fiche' && PDP.p) {
      const p = PDP.p, c = p.couleurs[PDP.color] || p.couleurs[0], t = p.tailles ? p.tailles[PDP.size] : null;
      const q = [`couleur=${colorSlug(c.nom)}`, t ? `taille=${colorSlug(t.nom)}` : ''].filter(Boolean).join('&');
      const what = [p.couleurs.length > 1 ? c.nom : '', t && p.tailles.length > 1 ? t.nom : ''].filter(Boolean).join(', ');
      const line = `${p.nom}${what ? ` (${what})` : ''} : ${price(unitPriceOf(p, t ? t.nom : ''))}`;
      return { url: pageUrl(`#/p/${p.slug}?${q}`), title: `${p.nom} · Caplia`, line, subject: `Caplia : ${p.nom}` };
    }
    if (kind === 'panier') {
      const code = cart.map((l) => [l.slug, colorSlug(l.color || ''), l.size ? colorSlug(l.size) : '', l.qty].join('.')).join(',');
      const names = cart.map((l) => BY[l.slug].nom + (l.qty > 1 ? ` × ${l.qty}` : ''));
      return { url: pageUrl(`#/panier?pieces=${code}`), title: 'Mon panier Caplia', line: `Mon panier Caplia : ${names.join(', ')}. Total : ${price(cartTotal())}, livraison offerte.`, subject: 'Mon panier Caplia' };
    }
    const list = fav.filter((s) => BY[s]);
    return { url: pageUrl(`#/selection?pieces=${list.join(',')}`), title: 'Ma sélection Caplia', line: `Ma sélection Caplia : ${list.map((s) => BY[s].nom).join(', ')}.`, subject: 'Ma sélection Caplia' };
  }
  const shareUi = (kind, label) => `<div class="share" data-share="${kind}">
      <button class="share__btn" type="button" data-action="share-open" aria-expanded="false" aria-controls="share-${kind}">${label}</button>
      <div class="share__menu" id="share-${kind}" hidden>
        <button class="share__item" type="button" data-action="share-copy">Copier le lien</button>
        <a class="share__item" href="mailto:" data-sharemail>M’envoyer par e-mail</a>
        <p class="share__msg" role="status" aria-live="polite"></p>
      </div>
    </div>`;
  function shareMenu(box, open) {
    $$('[data-share]').forEach((b) => { if (b !== box || !open) { const m = $('.share__menu', b); if (m) m.hidden = true; $('.share__btn', b).setAttribute('aria-expanded', 'false'); } });
    if (!open) return;
    const d = shareData(box.dataset.share);
    const m = $('.share__menu', box);
    $('[data-sharemail]', box).href = `mailto:?subject=${encodeURIComponent(d.subject)}&body=${encodeURIComponent(`${d.line}\n\n${d.url}\n`)}`;
    $('.share__msg', box).textContent = '';
    m.hidden = false;
    /* le menu s'ouvre vers la gauche quand le mot est dans la moitié droite : jamais coupé par le bord de l'écran */
    m.classList.toggle('share__menu--end', box.getBoundingClientRect().left > innerWidth / 2);
    $('.share__btn', box).setAttribute('aria-expanded', 'true');
  }
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-share]') || e.target.closest('[data-sharemail]')) { const o = $('.share__menu:not([hidden])'); if (o) shareMenu(o.closest('[data-share]'), false); } });
  document.addEventListener('keydown', (e) => { if (e.key !== 'Escape') return; const o = $('.share__menu:not([hidden])'); if (o) { const b = o.closest('[data-share]'); shareMenu(b, false); $('.share__btn', b).focus(); } });
  /* Lien envoyé : #/panier?pieces=<pièce.couleur.taille.quantité>,… recrée le panier (jamais une couleur épuisée, une
     taille absente ni une pièce pas encore en vente ; ouvrir deux fois le lien ne double rien), #/selection?pieces=a,b
     ajoute les pièces à la sélection. Le paramètre est ensuite retiré de l'adresse. */
  function takeShared(kind) {
    const raw = qsAll().get('pieces');
    if (raw == null) return;
    history.replaceState(history.state, '', location.pathname + location.hash.split('?')[0]);
    const bits = raw.split(',').map((x) => x.trim()).filter(Boolean).slice(0, 40);
    if (kind === 'selection') {
      const ok = [...new Set(bits)].filter((s) => BY[s]);
      ok.slice().reverse().forEach((s) => { if (!isFav(s)) toggleFav(s, true); });
      if (ok.length) setTimeout(() => toast(null, ok.length > 1 ? `${ok.length}${NB}pièces ajoutées à votre sélection.` : `${BY[ok[0]].nom} est dans votre sélection.`, true), 300);
      return;
    }
    const later = [];
    let n = 0;
    bits.forEach((b) => {
      const [slug, cs = '', ts = '', qn] = b.split('.');
      const p = BY[slug];
      if (!p || notYet(p)) return;
      const c = p.couleurs.find((k) => colorSlug(k.nom) === cs || (k.cle && colorSlug(k.cle) === cs)) || (p.couleurs.length === 1 ? p.couleurs[0] : null);
      const t = p.tailles ? p.tailles.find((x) => colorSlug(x.nom) === ts) : null;
      if (!c || isOut(c) || (p.tailles && (!t || sizeOutFor(t, c.nom)))) { later.push(p.nom); return; }
      const size = sizeFor(p, c.nom, t ? t.nom : '');
      if (size === null) { later.push(p.nom); return; }
      const qty = Math.min(9, Math.max(1, parseInt(qn, 10) || 1));
      const l = cart.find((x) => x.slug === slug && x.color === c.nom && x.size === size);
      if (l) l.qty = Math.max(l.qty, qty); else cart.push({ slug, color: c.nom, size, qty });
      n++;
    });
    if (n) { saveCart(); updateBadge(true); }
    const soon = later.length ? ` ${andList([...new Set(later)])} revien${later.length > 1 ? 'nent' : 't'} bientôt dans cette version : retrouvez-${later.length > 1 ? 'les' : 'le'} sur ${later.length > 1 ? 'leur' : 'sa'} fiche.` : '';
    if (n || soon) setTimeout(() => toast(null, `${n ? 'Votre panier est prêt.' : ''}${soon}`.trim(), true), 300);
  }

  let toastTimer = 0;
  function toast(p, text, plain, colorName, html) {
    const t = $('#toast');
    /* une bande d'encre plate, une phrase et un lien : pas d'ombre (au téléphone, elle prend la place de la barre d'achat
       le temps du message) ; html : un cadeau débloqué, avec sa photo */
    const body = html || `<p>${esc(text)}</p>`;
    t.innerHTML = fr(plain ? body : `${body}<a class="toast__go" href="#/panier">Voir le panier</a>`);
    t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
    document.documentElement.classList.add('toast-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.classList.remove('is-on'); document.documentElement.classList.remove('toast-on'); }, 4200);
  }

  /* ---------------- Fond (scène) ---------------- */
  const SC = { cur: 'a', key: '', token: 0, userPaused: reduce, wantVideo: false };
  function setTint(hex) {
    const sc = $('#scene');
    if (hex) sc.style.setProperty('--tint', hex);
    sc.classList.toggle('has-tint', !!hex);
  }
  function setScene(o) {
    const sc = $('#scene');
    const v = $('.scene__video', sc);
    setTint(o.tint || null);
    sc.classList.toggle('is-dim', !!o.dim);
    SC.wantVideo = !!o.video;
    if (o.video) {
      if (!v.dataset.ready) {
        const m = isMobile();
        v.poster = m ? tab('incurve-sel', 'mobile', 'webp') : tab('incurve-sel', '1920', 'webp');
        v.innerHTML = m
          ? '<source src="/site/assets/tableaux/incurve-sel-mobile.webm" type="video/webm"><source src="/site/assets/tableaux/incurve-sel-mobile.mp4" type="video/mp4">'
          : '<source src="/site/assets/tableaux/incurve-sel-1080.webm" type="video/webm"><source src="/site/assets/tableaux/incurve-sel-1080.mp4" type="video/mp4">';
        v.dataset.ready = '1';
        v.preload = 'auto';
        v.load();
      }
      v.classList.add('is-on');
      playVideo();
    } else {
      v.classList.remove('is-on');
      v.pause();
    }
    const key = o.img + '|' + (o.soft ? 1 : 0);
    if (key === SC.key) return;
    SC.key = key;
    const token = ++SC.token;
    const next = SC.cur === 'a' ? 'b' : 'a';
    const el = $(`[data-layer="${next}"]`, sc);
    const old = $(`[data-layer="${SC.cur}"]`, sc);
    const pre = new Image();
    const swap = () => {
      if (token !== SC.token) return;
      el.style.backgroundImage = `url("${o.soft ? softUrl(pre, o.img) : o.img}")`;
      el.classList.toggle('is-soft', !!o.soft);
      el.classList.add('is-on');
      old.classList.remove('is-on');
      SC.cur = next;
    };
    pre.onload = swap;
    pre.onerror = () => { if (o.fallback && token === SC.token) { o.img = o.fallback; o.fallback = null; pre.src = o.img; } else swap(); };
    pre.src = o.img;
  }
  /* Fond flou pré-calculé (petite image lissée) : ne dépend pas du filtre CSS */
  const SOFT_CACHE = {};
  function softUrl(im, src) {
    if (SOFT_CACHE[src]) return SOFT_CACHE[src];
    try {
      const w = 120, h = Math.max(1, Math.round(w * (im.naturalHeight / Math.max(1, im.naturalWidth))));
      const c = document.createElement('canvas');
      c.width = w; c.height = h;
      const ctx = c.getContext('2d');
      ctx.filter = 'blur(3px) saturate(1.12)';
      ctx.drawImage(im, -6, -6, w + 12, h + 12);
      SOFT_CACHE[src] = c.toDataURL('image/jpeg', .86);
    } catch (e) { SOFT_CACHE[src] = src; }
    return SOFT_CACHE[src];
  }
  function playVideo() {
    const v = $('.scene__video');
    if (!SC.wantVideo || SC.userPaused || document.hidden) return;
    const pr = v.play();
    if (pr && pr.catch) pr.catch(() => {});
  }
  function pauseVideo() { $('.scene__video').pause(); }
  function syncVideoButtons() {
    $$('[data-action="video-toggle"]').forEach((b) => {
      const paused = SC.userPaused;
      b.innerHTML = paused ? I.play : I.pause;
      b.setAttribute('aria-label', paused ? 'Relancer la vidéo du fond' : 'Mettre en pause la vidéo du fond');
      b.setAttribute('aria-pressed', paused ? 'true' : 'false');
    });
  }

  /* ---------------- Composants ---------------- */
  /* Cartel des cartes (accueil, collections, sélection, « Pour finir le salon ») : le nom et le prix, puis la forme en
     quelques mots. Ni matière, ni mesures, ni pastilles : la carte reste légère au téléphone, tout est sur la fiche.
     tag : élément du nom (h3 dans un article, span dans un lien). */
  function cartel(p, { tag = 'h3', cls = '' } = {}) {
    const from = fromOf(p);
    const inner = tag === 'span' ? 'span' : 'p';
    return `<span class="cartel${cls ? ' ' + cls : ''}">
        <span class="cartel__row"><${tag} class="cartel__name">${esc(p.nom)}</${tag}><${inner} class="cartel__price num">${from}${price(p.prix)}</${inner}></span>
        <${inner} class="cartel__type">${esc(cardType(p)).replace(/(\d) /g, `$1${NB}`)}</${inner}>
      </span>`;
  }
  /* Carte produit : la pièce dans le studio gris, à la même distance que ses voisines (cartes-echelle.py : un miroir de
     70 cm paraît vraiment plus petit qu'un canapé de 277 cm), puis un cartel de musée : le nom et le prix, la forme et
     les couleurs, la matière et les mesures. Toute la carte mène à la fiche. L'affiche large (big) prend l'image élargie. */
  const VIDE = '/site/assets/studio/_vide-';
  /* Photos en situation refaites (refonte du 07/10, 2e boucle) : là où la photo du vendeur était la plus faible (cadrage
     serré, décor chargé, pièce sombre), une image Krea (GPT Image 2) rendue avec la photo du vendeur en référence, la
     pièce intégrée et fidèle, dans la même pièce à la chaux que l'accueil. Fichiers site/assets/produits/<slug>/k1-*.
     Ce n'est pas une photo du produit : elle ne passe jamais en 1re image (fiche ni carte), elle vient après les vraies
     photos du vendeur comme image d'ambiance, avec un texte alternatif « Mise en scène de… », et au survol des cartes.
     Elle n'est jamais envoyée dans les médias Shopify (donc jamais à Google). */
  const KSCENES = {
    veilleuse: { couleur: 'Blanc petit matin', box: [0.26, 0.27, 0.84, 0.89], alt: 'Mise en scène de Aurore en Blanc petit matin avec son repose-pieds, dans une chambre aux murs à la chaux, au soleil de fin d’après-midi' },
    chauffeuse: { couleur: 'Gris galet', box: [0.33, 0.42, 0.74, 0.9], alt: 'Mise en scène de Pétale en Gris galet sur un tapis de laine, dans une pièce aux murs à la chaux, au soleil de fin d’après-midi' },
    'petit-velours': { couleur: 'Gris tourterelle', box: [0.29, 0.35, 0.88, 0.86], alt: 'Mise en scène de Mimosa en Gris tourterelle dans un salon aux murs à la chaux, au soleil de fin d’après-midi' },
    'u-modulable': { couleur: 'Gris anthracite', box: [0.12, 0.46, 0.89, 0.78], alt: 'Mise en scène de Baie en Gris anthracite sur un tapis de laine, dans un grand salon aux murs à la chaux, au soleil de fin d’après-midi' },
    'chauffeuse-dossier': { couleur: 'Bleu nuit', box: [0.29, 0.32, 0.78, 0.85], alt: 'Mise en scène de Escale en Bleu nuit sur un tapis de laine, dans une pièce aux murs à la chaux, au soleil de fin d’après-midi' },
    'convertible-coffre': { couleur: 'Gris orage', box: [0.2, 0.41, 0.78, 0.84], alt: 'Mise en scène de Alizé en Gris orage dans un salon aux murs à la chaux, au soleil de fin d’après-midi' },
    'chauffeuse-2-places': { couleur: 'Gris anthracite', box: [0.27, 0.44, 0.74, 0.87], alt: 'Mise en scène de Hamac en Gris anthracite sur un tapis de laine, dans une pièce aux murs à la chaux, au soleil de fin d’après-midi' },
    'coussins-noeud': { couleur: 'Crème et gris', r: 1, box: [0.29, 0.28, 0.81, 0.57], alt: 'Mise en scène des deux coussins nœud, crème et gris, posés sur le fauteuil Perle, dans une pièce aux murs à la chaux' },
    plaid: { couleur: 'Gris clair', r: 1, box: [0.2, 0.34, 0.8, 0.75], alt: 'Mise en scène du plaid gris clair plié, un coin retourné sur son côté sherpa, dans une niche de fenêtre à la chaux' },
    brume: { couleur: 'Blanc ivoire', box: [0.22, 0.36, 0.87, 0.92], alt: 'Mise en scène de Brume en Blanc ivoire, lit fait, dans une chambre aux murs à la chaux, au soleil de fin d’après-midi' },
    'pouf-plisse': { couleur: 'Crème', box: [0.4, 0.5, 0.61, 0.82], alt: 'Mise en scène de Margot en Crème sur un tapis de laine, dans une pièce aux murs à la chaux, au soleil de fin d’après-midi' },
    sillon: { couleur: 'Gris tourterelle', box: [0.26, 0.5, 0.74, 0.86], alt: 'Mise en scène de Sillon en Gris tourterelle au pied d’un lit, dans une chambre aux murs à la chaux, au soleil de fin d’après-midi' },
    'cotele-230': { couleur: 'Beige sable', box: [0.21, 0.46, 0.88, 0.83], alt: 'Mise en scène de Brise en Beige sable dans un salon aux murs à la chaux, au soleil de fin d’après-midi' }
  };
  function kScenes() {
    Object.entries(KSCENES).forEach(([slug, k]) => {
      const p = CAT.produits.find((x) => x.slug === slug);
      if (!p || p.images.some((im) => im.id === 'k1')) return;
      p.images.push({ id: 'k1', alt: k.alt, legende: k.alt });
      const g = GALERIES[slug] = GALERIES[slug] || {};
      g[k.couleur] = [...(g[k.couleur] || []).filter((id) => id !== 'k1'), 'k1'];
      CADRAGE[slug] = CADRAGE[slug] || {};
      CADRAGE[slug].k1 = [k.r || 4 / 3, ...k.box];
    });
  }
  /* Carte en vraie photo de salon (refonte du 07/10, direction photo) : la photo en situation du vendeur, recadrée sur la
     pièce ; au survol, une autre photo en situation (sinon la pièce seule sur fond clair). Sans photo en situation dans
     cette couleur : la carte du studio, comme avant. */
  const focusXY = (p, id) => { const c = (CADRAGE[p.slug] || {})[id]; return c ? `${Math.round(((c[1] + c[3]) / 2) * 100)}% ${Math.round(Math.min(.62, Math.max(.38, (c[2] + c[4]) / 2)) * 100)}%` : '50% 55%'; };
  const focusWide = (p, id) => { const c = (CADRAGE[p.slug] || {})[id]; return c ? `${Math.round(((c[1] + c[3]) / 2) * 100)}% ${Math.round(((c[2] + c[4]) / 2) * 100)}%` : '50% 55%'; };
  /* 08/10 : une photo de salon large recadrée dans une carte carrée est agrandie d'autant (cover) : le navigateur doit
     choisir un fichier plus large que la carte, sinon elle est floue (x1,5 à x2 sur les cartes au survol) */
  const sceneSizes = (p, im, sizes, wide) => { const c = (CADRAGE[p.slug] || {})[im.id], f = wide || !c ? 1 : Math.min(2.5, Math.max(1, c[0])); return f > 1.05 ? sizes.replace(/(\d+(?:\.\d+)?)vw/g, (m, n) => `${Math.round(n * f)}vw`) : sizes; };
  const sceneImg = (p, im, { alt, sizes: sz, eager, cls, wide = false }) => { const sizes = sceneSizes(p, im, sz, wide); return `<picture class="${cls}"><source type="image/avif" srcset="${GAL_SRCSET(p, im.id, 'avif')}" sizes="${esc(sizes)}"><img src="${photo(p, im.id, 640)}" srcset="${GAL_SRCSET(p, im.id)}" sizes="${esc(sizes)}" alt="${esc(alt)}" width="1280" height="960" style="object-position:${wide ? focusWide(p, im.id) : focusXY(p, im.id)}" ${eager ? 'loading="eager"' : 'loading="lazy"'} decoding="async" draggable="false"></picture>`; };
  /* Cadrages du 07/10 (soir) : dans une grille, toutes les cartes suivent la même règle. 1re image = la vraie photo
     studio du vendeur, sur le fond clair du studio, la pièce entière et à l'échelle de ses voisines (cartes-echelle.py) ;
     au survol, l'image d'ambiance (Krea, sinon la vraie photo de salon). Seule une pièce sans photo studio garde sa
     photo de salon en 1re image. Les rangées de l'accueil prennent le même cadre carré que
     les collections (le carré recadré en 4:5 coupait les côtés de la pièce). */
  /* Même marge dans chaque carte : la plupart des photos studio remplissent déjà la place prévue (80 % de la largeur ou
     52 % de la hauteur du cadre 4:5) ; quelques-unes, faites à l'échelle « compressée » (Éclipse, Ondine, Capucine,
     Nuée…), restent plus petites. k = agrandissement qui les amène à la même place, autour de leur point au sol. */
  const fitK = (p, color) => { const c = carteOf(p, color), b = c && c.box; if (!b) return 1; const k = Math.min(.8 / (b[2] - b[0]), .52 / (b[3] - b[1])); return k > 1.04 ? +Math.min(k, 2).toFixed(3) : 1; };
  /* Photos des cartes (08/10, demande de l'utilisateur) : sans ouvrir la fiche, on voit les autres photos de la pièce.
     Téléphone : on fait glisser la photo (défilement natif aimanté), des points donnent la place ; ordinateur : flèches et
     points au survol. Toute la photo reste un lien vers la fiche, les flèches sont de vrais boutons.
     Photos montrées : celles de la galerie de la fiche pour la couleur de la carte, dans le même ordre (photoOrder), 5 au
     plus avec la 1re de la carte ; jamais le schéma des dimensions, ni une photo que la fiche ne montre pas, ni une photo
     où le vendeur a coupé la pièce. La photo de la carte elle-même n'est pas répétée (carte studio = la photo « fond
     clair » 40 + n° de la couleur, carte de salon = sa photo en situation).
     Vitesse : seule la 1re photo se charge ; les suivantes reçoivent leur adresse au premier survol, toucher ou focus
     (cgalWake), en 360 à 720 px. CARD_W et cardPhotoOk sont retouchés pour Shopify par construire-theme.mjs. */
  const CARD_MAX = 5;
  const CARD_W = [360, 540, 720];
  const cardPhotoOk = (p, id) => { const u = photo(p, id, 720); return !!u && u !== CUT(p.slug); };
  /* couleur montrée par la carte (même règle que carteOf et scenesFor) */
  const cardColor = (p, color, studio) => {
    if (color) return color;
    const e = studio && PHOTO && PHOTO.pieces && PHOTO.pieces[p.slug];
    if (e && e.couleur && p.couleurs.some((k) => !k.rupture && k.nom === e.couleur)) return e.couleur;
    return (p.couleurs[firstIn(p)] || {}).nom || '';
  };
  function cardMore(p, cName, skip) {
    const c = p.couleurs.find((x) => x.nom === cName) || p.couleurs[firstIn(p)];
    if (!c) return [];
    const pics = colorPhotos(p, c), l0 = leadOf(p, c), lead = l0 && pics.find((im) => im.id === l0.id);
    return [lead, ...restOrder(pics, lead)].filter((im) => im && !skip.includes(im.id) && !coupee(p, im) && cardPhotoOk(p, im.id)).slice(0, CARD_MAX - 1);
  }
  const cardSlide = (p, im, sizes, wide) => `<div class="cimg cimg--more" data-photo="${esc(im.id)}"><img data-srcset="${CARD_W.map((w) => `${photo(p, im.id, w)} ${w}w`).join(', ')}" data-src="${photo(p, im.id, CARD_W[CARD_W.length - 1])}" sizes="${esc(sceneSizes(p, im, sizes, wide))}" alt="${esc(im.alt)}" width="1280" height="960" style="object-position:${wide ? focusWide(p, im.id) : focusXY(p, im.id)}" loading="lazy" decoding="async" draggable="false"></div>`;
  function cardGal(p, first, more, sizes, wide) {
    if (!more.length) return first;
    const n = more.length + 1;
    return `<div class="cgal" data-cgal><a class="cgal__track" href="#/p/${p.slug}" tabindex="-1" aria-hidden="true" draggable="false">${first}${more.map((im) => cardSlide(p, im, sizes, wide)).join('')}</a>`
      + `<button class="cgal__nav cgal__nav--prev" type="button" data-action="cgal" data-d="-1" aria-label="Photo précédente">${I.chevL}</button>`
      + `<button class="cgal__nav cgal__nav--next" type="button" data-action="cgal" data-d="1" aria-label="Photo suivante">${I.chevR}</button>`
      + `<span class="cgal__dots" aria-hidden="true">${Array.from({ length: n }, (x, i) => `<i${i ? '' : ' class="is-on"'}></i>`).join('')}</span></div>`;
  }
  function cardImg(p, { alt = '', sizes = '(max-width: 760px) 100vw, 33vw', eager = false, big = false, deux = false, color = '', studioOnly = false } = {}) {
    const sc = studioOnly ? [] : scenesFor(p, color);
    const gen = studioOnly ? null : genFor(p, color);
    const hov = (wide) => (gen ? sceneImg(p, gen, { alt: '', sizes, eager: false, cls: 'cimg__b', wide })
      : sc[0] ? sceneImg(p, sc[0], { alt: '', sizes, eager: false, cls: 'cimg__b', wide }) : '');
    if (carteOf(p, color)) {
      const cadres = deux ? [['(max-width: 760px)', '11'], [null, '54']] : ['11'];
      const k = deux ? 1 : fitK(p, color);   /* le cadre 5:4 (fichier r54) a sa propre mise en place */
      const sz = k > 1 ? sizes.replace(/(\d+(?:\.\d+)?)vw/g, (m, n) => `${Math.round(n * k)}vw`) : sizes;
      const cn = cardColor(p, color, true), ci = p.couleurs.findIndex((x) => x.nom === cn);
      const more = studioOnly ? [] : cardMore(p, cn, [String(40 + Math.max(0, ci))]);
      return cardGal(p, `<div class="cimg cimg--hov"${k > 1 ? ` style="--k:${k}"` : ''}>${pieceImg(p, { alt, sizes: sz, eager, color, cadres })}${more.length ? '' : hov(big)}</div>`, more, sizes, big);
    }
    if (sc.length) {
      const more = cardMore(p, cardColor(p, color, false), [sc[0].id]);
      const back = more.length ? '' : gen ? sceneImg(p, gen, { alt: '', sizes, eager: false, cls: 'cimg__b', wide: big }) : sc[1] ? sceneImg(p, sc[1], { alt: '', sizes, eager: false, cls: 'cimg__b', wide: big }) : '';
      return cardGal(p, `<div class="cimg cimg--scene${big ? ' cimg--wide' : ''}">${sceneImg(p, sc[0], { alt, sizes, eager, cls: 'cimg__a', wide: big })}${back}</div>`, more, sizes, big);
    }
    const r = RATIO[p.slug] || 1.6;
    const mur = p.dimensions && p.dimensions.profondeur < 6;   /* miroir mural : plus petit, posé contre le fond */
    const w = Math.min(mur ? 56 : 80, 52.5 * r);
    const set = (ext) => [720, 1080, 1600].map((x) => `${VIDE}${x}.${ext} ${x}w`).join(', ');
    const charge = eager ? 'loading="eager"' : 'loading="lazy"';
    /* détouré avec son ombre de contact cuite (maquettes/outils/ombres-repli.py : marges de 5 % sur les côtés, 10 % en bas) ;
       sans ce fichier, le détouré nu */
    return `<div class="cimg cimg--repli" style="--w:${w.toFixed(1)}%"><picture class="simg"><source type="image/avif" srcset="${set('avif')}" sizes="${esc(sizes)}"><source type="image/webp" srcset="${set('webp')}" sizes="${esc(sizes)}"><img src="${VIDE}1080.webp" alt="" width="1600" height="2000" ${charge} decoding="async" draggable="false"></picture>`
      + `<img class="cimg__obj" src="/site/assets/studio/repli/${p.slug}.webp" alt="${esc(alt)}" ${charge} decoding="async" draggable="false" onerror="this.onerror=null;this.classList.add('is-nu');this.src='${cut(p)}'"></div>`;
  }
  /* la forme, sans la largeur quand elle est déjà dans les mesures (« Canapé courbé 240 cm » -> « Canapé courbé ») */
  /* forme courte pour les cartels (une ou deux lignes sur une carte de téléphone, jamais plus) */
  const CARD_TYPE = {
    veilleuse: 'Fauteuil d’allaitement', 'chauffeuse-dossier': 'Chauffeuse convertible', chauffeuse: 'Chauffeuse convertible',
    'convertible-coffre': 'Canapé d’angle convertible', 'angle-reversible': 'Canapé d’angle côtelé', gigogne: 'Canapé convertible gigogne',
    'angle-modulable': 'Canapé d’angle modulable', 'petit-angle': 'Petit canapé d’angle', 'petit-incurve': 'Canapé nuage arrondi',
    'u-modulable': 'Canapé en U modulable', plaid: 'Plaid côtelé et sherpa', 'petit-velours': 'Petit canapé velours',
    'cotele-poches': 'Canapé velours côtelé', 'cotele-230': 'Canapé velours côtelé', 'grand-arrondi': 'Grand canapé arrondi',
    meridienne: 'Méridienne ondulée', 'noix-de-cajou': 'Canapé arrondi 2 modules', 'coussins-noeud': 'Coussins en velours'
  };
  const cardType = (p) => CARD_TYPE[p.slug] || p.type.replace(/,?\s+\d+(?:[,.]\d+)?\s?cm$/, '');
  function pcard(p, opts = {}) {
    const from = fromOf(p);
    const big = /pcard--big/.test(opts.cls || '');
    const quick = opts.quick && onSale(p) ? quickAdd(p) : '';
    return `<article class="pcard${opts.cls ? ' ' + opts.cls : ''}${quick ? ' pcard--quick' : ''}" data-piece="${p.slug}">
      <a class="pcard__link" href="#/p/${p.slug}" aria-label="${esc(p.nom)}, ${esc(lc1(p.type))}, ${from}${price(p.prix)}"></a>
      ${cardImg(p, { alt: `${p.nom}, ${lc1(p.type)}`, sizes: opts.sizes || '(max-width: 760px) 80vw, 30vw', eager: !!opts.eager, big, deux: !!opts.deux, color: quick ? quickColor(p) : '' })}
      <div class="pcard__body">${cartel(p)}</div>
      ${quick}
    </article>`;
  }

  /* Ajout rapide sur une carte (« Pour finir le salon ») : les couleurs en vente en pastilles cliquables, la première en vente
     choisie (celle de la photo de la carte quand elle est en vente), puis « Ajouter », sans passer par la fiche */
  const saleColors = (p) => p.couleurs.filter((c) => !c.rupture && (!p.tailles || p.tailles.some((t) => !sizeOutFor(t, c.nom))));
  const quickColor = (p) => { const cs = saleColors(p), e = PHOTO && PHOTO.pieces && PHOTO.pieces[p.slug]; return (cs.find((c) => e && c.nom === e.couleur) || cs[0]).nom; };
  function quickAdd(p) {
    const cs = saleColors(p), c0 = quickColor(p);
    const sw = cs.length > 1 ? `<div class="qa__sw" role="radiogroup" aria-label="Couleur de ${esc(p.nom)}">${cs.map((c) => `<button class="swatch" type="button" role="radio" aria-checked="${c.nom === c0}" aria-label="${esc(c.nom)}" title="${esc(c.nom)}" style="--c:${c.hex}" data-action="qa-color" data-slug="${p.slug}" data-color="${esc(c.nom)}"></button>`).join('')}<span class="qa__cn" data-qa-cn>${esc(c0)}</span></div>` : '';
    return `<div class="qa">${sw}<button class="pill qa__add" type="button" data-action="qa-add" data-slug="${p.slug}" data-color="${esc(c0)}" aria-label="Ajouter ${esc(p.nom)}${cs.length > 1 ? ', ' + esc(c0) : ''}, au panier"><span class="cta__label">Ajouter</span></button></div>`;
  }
  function quickColorPick(btn) {
    const card = btn.closest('.pcard'), p = BY[btn.dataset.slug];
    if (!card || !p) return;
    const c = btn.dataset.color;
    $$('[data-action="qa-color"]', card).forEach((b) => b.setAttribute('aria-checked', String(b === btn)));
    const cn = $('[data-qa-cn]', card); if (cn) cn.textContent = c;
    const add = $('[data-action="qa-add"]', card);
    if (add) { add.dataset.color = c; add.setAttribute('aria-label', `Ajouter ${p.nom}, ${c}, au panier`); }
    const im = $('.cgal', card) || $('.cimg', card);   /* la carte et ses autres photos suivent la couleur */
    if (im) im.outerHTML = fr(cardImg(p, { alt: `${p.nom}, ${lc1(p.type)}`, sizes: '(max-width: 760px) 80vw, 30vw', color: c }));
  }
  /* Délai des accessoires expédiés d'ailleurs (coussins nœud depuis la Chine), pour la page Livraison et les CGV */
  const accDelay = () => { const a = (SITE.livraison.delaisAccessoires || {}).CN; const c = PRODS.find((x) => x.pays === 'CN'); return a && c ? ` Les ${esc(c.nom.toLowerCase())} vendus seuls partent de Chine : ${a[0]} à ${a[1]} jours ouvrés.` : ''; };
  const CHAPO = 'N’offrez à votre intérieur que ce que vous aimez vraiment.';
  /* Ce qui compte pour les paliers, dit sans jargon (panier, questions, livraison, page des cadeaux) */
  const GIFT_RULE = 'Seuls vos meubles comptent pour les cadeaux : les coussins et les plaids achetés seuls s’ajoutent en plus. La valeur de chaque cadeau est son prix quand il est vendu seul sur caplia.fr.';

  /* Pied de page : trois colonnes de liens, l'inscription, puis qui vend (marque, SIRET, ville, e-mail : une marque
     inconnue se montre identifiable, PLAN-MAITRE C4 ; identité complète dans les mentions légales) et les moyens de
     paiement, sans commentaire (K5). */
  const FOOT_COLS = [
    ['Boutique', [['#/canapes', 'Canapés'], ['#/fauteuils', 'Fauteuils'], ['#/decoration', 'Décoration'], ['#/sleep', 'Caplia Sleep'], ['#/petits-espaces', 'Petits espaces'], ['#/jeunes-parents', 'Jeunes parents']]],
    ['Aide', [['#/livraison', 'Livraison et retours'], ['#/questions', 'Vos questions'], ['#/paiement', 'Paiement et sécurité'], ['#/garantie', 'Garantie légale'], ['/account', 'Suivre ma commande'], ['#/un-souci', 'Un souci à la livraison ?'], ['#/contact', 'Contact']]],
    ['La maison', [['#/pourquoi-caplia', 'Pourquoi Caplia'], ['#/matieres', 'Nos matières'], ['#/arrivee', 'L’arrivée chez vous'], ['#/cadeaux', 'Les cadeaux'], ['#/a-propos', 'Qui sommes-nous']]]
  ];
  const FOOT_LEGAL = [['#/mentions-legales', 'Mentions légales'], ['#/conditions-de-vente', 'Conditions de vente'], ['#/confidentialite', 'Confidentialité'], ['#/renoncer', 'Renoncer au contrat ici']];
  function footer() { return '<div data-caplia-slot="caplia-pied"></div>'; }
  function footerMaquette() {
    const list = (items) => `<ul>${items.map(([h, t]) => `<li><a href="${h}">${t}</a></li>`).join('')}</ul>`;
    return `<footer class="foot wrap">
      <div class="foot__top">
        <a class="foot__logo" href="#/" aria-label="Caplia, accueil"><span class="brand">Caplia.<span class="brand-mark" aria-hidden="true"></span></span></a>
        <nav class="foot__cols" aria-label="Plan du site">
          ${FOOT_COLS.map(([t, items]) => `<div><h2 class="foot__h">${t}</h2>${list(items)}</div>`).join('')}
        </nav>
        <div class="foot__news">
          <h2 class="foot__h">Les nouvelles couleurs, par e-mail</h2>
          ${newsForm()}
        </div>
      </div>
      <div class="foot__id">
        <p>Écrivez-nous à <a href="mailto:${SITE.email}">${SITE.email}</a> : réponse ${reponse()}, par e-mail.</p>
        <p class="foot__pay"><span class="sr-only">Moyens de paiement : </span>${SITE.paiements.map((m) => `<span>${esc(m)}</span>`).join('')}</p>
      </div>
      <div class="foot__bottom">
        <p>© ${new Date().getFullYear()} Caplia</p>
        <ul class="foot__legal">${FOOT_LEGAL.map(([h, t]) => `<li><a href="${h}">${t}</a></li>`).join('')}</ul>
      </div>
    </footer>`;
  }
  /* Inscription sans code promo : case d'accord jamais pré-cochée (règle CNIL pour les prospects) */
  let newsN = 0;
  function newsForm(cls = '') {
    const id = 'nl' + (++newsN);
    return `<form class="news ${cls}" data-news novalidate>
      <label class="news__lbl" for="${id}-m">Votre adresse e-mail</label>
      <div class="news__row">
        <input id="${id}-m" name="email" type="email" autocomplete="email" inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="nom@exemple.fr">
        <button class="btn" type="submit">Recevoir</button>
      </div>
      <label class="check" for="${id}-c"><input id="${id}-c" name="ok" type="checkbox"><span>Recevoir nos nouveautés, nos conseils et un rappel des pièces vues. Désinscription en un clic.</span></label>
      <p class="news__msg" data-news-msg aria-live="polite" hidden></p>
    </form>`;
  }
  /* 13013872000011 → 130 138 720 00011 */
  const siretFmt = (s) => String(s).replace(/^(\d{3})(\d{3})(\d{3})(\d{5})$/, `$1${NB}$2${NB}$3${NB}$4`);

  /* Sous le titre de l'accueil : une seule ligne courte, deux faits vrais pour toutes les pièces. Les preuves longues
     (passage vérifié, nouvelles à chaque étape) sont sur les fiches et dans les conditions, avec leurs conditions.
     Point de séparation porté par chaque morceau et masqué en début de ligne (même procédé que le cartel). */
  const HERO_LINE = ['Livraison offerte', 'Date de livraison avant de payer'];
  const heroLine = (cls) => `<p class="${cls}"><span class="${cls}-in">${HERO_LINE.map((t) => `<span>${t}</span>`).join('')}</span></p>`;

  /* Parallaxe en couches : tableau / mot géant / canapé détouré, dans un même cadre.
     Boîte du canapé mesurée sur les pixels opaques de chaque calque (fractions de l'image) :
     [gauche, droite, haut du dossier (médiane de la partie centrale), bas] */
  const SOFA = {
    'incurve-sel': [.355, .653, .508, .699],
    'capiton-matin': [.240, .963, .533, .953],
    'meridienne-platre': [.191, .685, .585, .881],
    'petit-mouton-paris': [.356, .883, .465, .975],
    'petit-incurve-galerie': [.180, .657, .591, .844],
    'causeuse-arches': [.282, .718, .534, .799]
  };
  const STAR = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 1.5c.7 12.4 9.6 21.3 22.5 22.5C33.6 25.2 24.7 34.1 24 46.5 23.3 34.1 14.4 25.2 1.5 24 14.4 22.8 23.3 13.9 24 1.5z"/></svg>';

  /* ---------------- Plan coté SVG ---------------- */
  function planKind(p) {
    if (p.slug === 'miroir-onde' || p.slug === 'miroir-ondule') return 'mirror';
    /* 07/10 : têtes de lit, tapis et plaid n'ont pas de plan dessiné ici (le schéma des dimensions est dans la galerie) */
    if (['tete-de-lit-murale', 'tete-de-lit-boudins', 'tapis-vagues', 'plaid-sherpa'].includes(p.slug)) return null;
    if (['angle-pouf-beige', 'angle-cotele-nuage', 'angle-convertible-cotele', 'angle-convertible-effet-lin', 'angle-reversible-chenille-bleu', 'angle-chenille-pouf-moutarde'].includes(p.slug)) return 'L';
    if (p.slug === 'u-cotele-poufs') return 'U';
    if (p.slug === 'pouf-plisse' || p.slug === 'pouf-bouclette') return 'cyl';
    if (p.slug === 'miroir-organique') return 'wall';
    if (['angle-cotele', 'angle-reversible', 'angle-modulable'].includes(p.slug)) return 'L';
    if (['u-cotele', 'u-modulable'].includes(p.slug)) return 'U';
    if (p.slug === 'table-nuage') return 'table';
    if (p.slug === 'galet') return 'round';
    if (p.slug === 'songe' || p.slug === 'brume' || p.slug === 'lit-coffre-bouclette') return 'bed';
    if (p.slug === 'dune' || p.slug === 'sillon') return 'bench';
    if (p.slug === 'bulle') return 'cyl';
    if (p.slug === 'duo') return 'nest';
    if (p.slug === 'lune') return 'ctable';
    if (p.collection === 'fauteuils') return 'chair';
    if (['incurve', 'petit-incurve', 'courbe', 'noix-de-cajou'].includes(p.slug)) return 'curve';
    return 'sofa';
  }
  /* PK : taille des cotes (1 ; 2 pour le plan du téléphone, voir planSVG) */
  let PK = 1;
  function chip(x, y, t, cls = '') {
    const w = (t.length * 8.6 + 20) * PK, hh = 12 * PK;
    return `<rect class="chip" x="${(x - w / 2).toFixed(1)}" y="${(y - hh).toFixed(1)}" width="${w.toFixed(1)}" height="${2 * hh}" rx="${hh}"/><text class="${cls}" x="${x.toFixed(1)}" y="${(y + 4.5 * PK).toFixed(1)}" text-anchor="middle">${t}</text>`;
  }
  function hdim(x1, x2, y, t) {
    return `<line class="dim" x1="${x1}" y1="${y}" x2="${x2}" y2="${y}"/><line class="dim" x1="${x1}" y1="${y - 6}" x2="${x1}" y2="${y + 6}"/><line class="dim" x1="${x2}" y1="${y - 6}" x2="${x2}" y2="${y + 6}"/>${chip((x1 + x2) / 2, y, t)}`;
  }
  function vdim(x, y1, y2, t, cls) {
    return `<line class="${cls ? 'seat' : 'dim'}" x1="${x}" y1="${y1}" x2="${x}" y2="${y2}"/><line class="dim" x1="${x - 6}" y1="${y1}" x2="${x + 6}" y2="${y1}"/><line class="dim" x1="${x - 6}" y1="${y2}" x2="${x + 6}" y2="${y2}"/>${chip(x, (y1 + y2) / 2, t, cls || '')}`;
  }
  function wavy(cx, cy, rx, ry, waves, amp, phase = 0, square = 0) {
    const pts = [];
    for (let k = 0; k < 240; k++) {
      const t = (k / 240) * Math.PI * 2;
      const c = Math.cos(t), s = Math.sin(t);
      /* super-ellipse pour les formes rectangulaires */
      const e = square ? 2 / (2 + square * 6) : 1;
      const bx = Math.sign(c) * Math.pow(Math.abs(c), e);
      const by = Math.sign(s) * Math.pow(Math.abs(s), e);
      const m = 1 + amp * Math.sin(waves * t + phase);
      pts.push(`${(cx + bx * rx * m).toFixed(1)},${(cy + by * ry * m).toFixed(1)}`);
    }
    return `M${pts.join('L')}Z`;
  }
  /* Plan coté dessiné à partir de catalogue.json (traits fins, cotes en Geist, voir fiche.css).
     La vignette reprend la même figure ; ses cotes et ses textes y sont masqués en CSS. */
  /* contour fermé et lisse passant par des points (Catmull-Rom converti en courbes de Bézier) */
  function blob(pts) {
    const n = pts.length, P = (i) => pts[(i + n) % n], f = (v) => v.toFixed(1);
    let d = `M${f(pts[0][0])},${f(pts[0][1])}`;
    for (let i = 0; i < n; i++) {
      const p0 = P(i - 1), p1 = P(i), p2 = P(i + 1), p3 = P(i + 2);
      d += ` C${f(p1[0] + (p2[0] - p0[0]) / 6)},${f(p1[1] + (p2[1] - p0[1]) / 6)} ${f(p2[0] - (p3[0] - p1[0]) / 6)},${f(p2[1] - (p3[1] - p1[1]) / 6)} ${f(p2[0])},${f(p2[1])}`;
    }
    return d + 'Z';
  }
  /* silhouette du miroir Mirage (relevée sur la photo du produit), en proportions de sa largeur et de sa hauteur */
  const MIRAGE = [[.56, 0], [.82, .04], [.9, .18], [.84, .38], [.93, .58], [1, .8], [.9, .98], [.6, 1], [.28, .985], [.1, .9], [.07, .68], [0, .46], [.08, .27], [.2, .13], [.34, .05]];
  /* Plan coté. big : version du téléphone, cotes deux fois plus grosses (lisibles sans zoomer dans un cadre de 390 px),
     marges élargies pour qu'aucune cote ne sorte du dessin */
  function planSVG(p, big) {
    if (!big) return planSVG0(p);
    PK = 2;
    try {
      return planSVG0(p).replace('class="plan-svg"', 'class="plan-svg plan-svg--big"')
        .replace(/viewBox="0 0 600 ([\d.]+)"/, (m, h) => `viewBox="-80 -14 760 ${(Number(h) + 44).toFixed(0)}"`);
    } finally { PK = 1; }
  }
  function planSVG0(p) {
    const D = p.dimensions;
    const kind = planKind(p);
    const f = (n) => numFr(n) + ' cm';
    if (kind === 'mirror') {
      /* les tailles en vente seulement (« 160 × 50 cm » = hauteur × largeur) ; la plus petite, s'il y en a deux, en pointillé */
      const T = (p.tailles || [{ nom: `${D.hauteur} × ${D.largeur} cm` }]).map((t) => (t.nom.match(/[\d,.]+/g) || []).map((v) => Number(v.replace(',', '.'))));
      const [H1, W1] = T[T.length - 1], small = T.length > 1 ? T[0] : null;
      const s = 300 / H1, w = W1 * s, h = H1 * s, x0 = 300 - w / 2, y0 = 44;
      const h2 = small ? small[0] * s : 0, w2 = small ? small[1] * s : 0;
      return `<svg class="plan-svg" viewBox="0 0 600 ${y0 + h + 50}" role="img" aria-label="Plan coté du ${esc(p.nom)} : ${T.map(([a, b]) => `${numFr(a)} × ${numFr(b)} cm`).join(' ou ')}">
        <text class="lbl" x="300" y="22" text-anchor="middle">${small ? 'Vue de face · deux tailles' : 'Vue de face'}</text>
        <path class="shape" d="${blob(MIRAGE.map(([a, b]) => [x0 + a * w, y0 + b * h]))}"/>
        ${small ? `<path class="ln" d="${blob(MIRAGE.map(([a, b]) => [300 - w2 / 2 + a * w2, y0 + h - h2 + b * h2]))}" stroke-dasharray="4 4"/>` : ''}
        <line class="ext" x1="${x0 - 50}" y1="${y0 + h}" x2="${x0 + w + 50}" y2="${y0 + h}"/>
        ${vdim(x0 + w + 46, y0, y0 + h, f(H1))}
        ${small ? vdim(x0 - 46, y0 + h - h2, y0 + h, f(small[0]), 'seat-t') : ''}
        ${hdim(x0, x0 + w, y0 + h + 30, f(W1))}
      </svg>`;
    }
    if (kind === 'wall') {
      const s = 380 / D.largeur, w = D.largeur * s, h = D.hauteur * s, x0 = 300 - w / 2, y0 = 44;
      return `<svg class="plan-svg" viewBox="0 0 600 ${y0 + h + 56}" role="img" aria-label="Plan coté de ${esc(p.nom)} : ${f(D.largeur)} × ${f(D.hauteur)}">
        <text class="lbl" x="${x0}" y="22">Vue de face</text>
        <path class="shape" d="${wavy(300, y0 + h / 2, w / 2 / 1.07, h / 2 / 1.07, 3, .06, 2.2, .1)}"/>
        <path class="ln" d="${wavy(300, y0 + h / 2, w / 2 / 1.07 - 12, h / 2 / 1.07 - 12, 3, .06, 2.2, .1)}"/>
        ${vdim(x0 + w + 34, y0, y0 + h, f(D.hauteur))}
        ${hdim(x0, x0 + w, y0 + h + 30, f(D.largeur))}
      </svg>`;
    }
    const W = D.largeur, P = D.profondeur, H = D.hauteur;
    const s = Math.min(420 / W, 190 / P, 170 / H);
    const w = W * s, d = P * s, h = H * s;
    const x0 = (600 - w) / 2 - 10, y0 = 46;
    let top = '';
    if (kind === 'curve') {
      const k = w * .13;
      top = `<path class="shape" d="M${x0},${y0 + d} C${x0},${y0 - d / 3} ${x0 + w},${y0 - d / 3} ${x0 + w},${y0 + d} L${x0 + w - k},${y0 + d} C${x0 + w - k},${y0 + d * .35} ${x0 + k},${y0 + d * .35} ${x0 + k},${y0 + d} Z" stroke-linejoin="round"/>
        <path class="ln" d="M${x0 + w * .055},${y0 + d * .9} C${x0 + w * .055},${y0 + d * .02} ${x0 + w * .945},${y0 + d * .02} ${x0 + w * .945},${y0 + d * .9}"/>`;
    } else if (kind === 'table') {
      top = `<path class="shape" d="${wavy(x0 + w / 2, y0 + d / 2, w / 2 * .93, d / 2 * .9, 6, .07, .6)}"/>`;
    } else if (kind === 'round') {
      top = `<rect class="shape" x="${x0}" y="${y0}" width="${w}" height="${d}" rx="${w * .44}"/>
        <path class="ln" d="M${x0 + w * .12},${y0 + d * .55} C${x0 + w * .12},${y0 + d * .14} ${x0 + w * .88},${y0 + d * .14} ${x0 + w * .88},${y0 + d * .55}"/>`;
    } else if (kind === 'bed') {
      const hb = Math.max(6, 9 * s), pw = (w - 3 * 10) / 2;
      top = `<rect class="shape" x="${x0}" y="${y0}" width="${w}" height="${d}" rx="10"/>
        <rect class="inner" x="${x0 + 6}" y="${y0 + hb + 4}" width="${w - 12}" height="${d - hb - 10}" rx="8"/>
        <line class="ln" x1="${x0 + 4}" y1="${y0 + hb}" x2="${x0 + w - 4}" y2="${y0 + hb}"/>
        <rect class="ln" x="${x0 + 10}" y="${y0 + hb + 10}" width="${pw}" height="${Math.min(d * .16, 34)}" rx="9"/>
        <rect class="ln" x="${x0 + 20 + pw}" y="${y0 + hb + 10}" width="${pw}" height="${Math.min(d * .16, 34)}" rx="9"/>`;
    } else if (kind === 'bench') {
      top = `<rect class="shape" x="${x0}" y="${y0}" width="${w}" height="${d}" rx="${d / 2}"/>
        <rect class="ln" x="${x0 + 7}" y="${y0 + 7}" width="${w - 14}" height="${d - 14}" rx="${d / 2 - 7}"/>`;
    } else if (kind === 'cyl' || kind === 'ctable') {
      top = `<rect class="shape" x="${x0}" y="${y0}" width="${w}" height="${d}" rx="${Math.min(w, d) / 2}"/>
        <rect class="ln" x="${x0 + 6}" y="${y0 + 6}" width="${w - 12}" height="${d - 12}" rx="${Math.min(w, d) / 2 - 6}"/>`;
    } else if (kind === 'nest') {
      top = `<path class="ln" d="${wavy(x0 + w * .6, y0 + d * .62, w / 2 * .7, d / 2 * .72, 2, .05, 1.2)}" stroke-dasharray="4 4"/>
        <path class="shape" d="${wavy(x0 + w / 2, y0 + d / 2, w / 2 * .96, d / 2 * .94, 2, .05, .3)}"/>`;
    } else if (kind === 'L' || kind === 'U') {
      /* vue de dessus en L (méridienne à gauche) ou en U (une méridienne de chaque côté), coins arrondis */
      const cw = (kind === 'L' ? 100 : 93.5) * s, bd = d * (kind === 'L' ? 104 / 175 : .55), back = 18 * s, r = 14;
      const pts = kind === 'L'
        ? [[x0, y0], [x0 + w, y0], [x0 + w, y0 + bd], [x0 + cw, y0 + bd], [x0 + cw, y0 + d], [x0, y0 + d]]
        : [[x0, y0], [x0 + w, y0], [x0 + w, y0 + d], [x0 + w - cw, y0 + d], [x0 + w - cw, y0 + bd], [x0 + cw, y0 + bd], [x0 + cw, y0 + d], [x0, y0 + d]];
      const n = pts.length;
      let dP = '';
      pts.forEach((pt, i) => {
        const a = pts[(i + n - 1) % n], b = pts[(i + 1) % n];
        const u = (q) => { const dx = q[0] - pt[0], dy = q[1] - pt[1], l = Math.hypot(dx, dy); return [pt[0] + dx / l * r, pt[1] + dy / l * r]; };
        const p1 = u(a), p2 = u(b);
        dP += `${i ? 'L' : 'M'}${p1[0].toFixed(1)},${p1[1].toFixed(1)} Q${pt[0].toFixed(1)},${pt[1].toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)} `;
      });
      const xs = kind === 'L' ? [x0 + cw, x0 + cw + (w - cw) / 2] : [x0 + cw, x0 + w - cw];
      let cuts = `<line class="ln" x1="${x0 + 8}" y1="${y0 + back}" x2="${x0 + w - 8}" y2="${y0 + back}"/>`;
      xs.forEach((cx) => { cuts += `<line class="ln" x1="${cx}" y1="${y0 + back + 6}" x2="${cx}" y2="${y0 + bd - 6}"/>`; });
      const mer = kind === 'L' ? `<text class="lbl lbl-in" x="${(x0 + cw / 2).toFixed(1)}" y="${(y0 + (bd + d) / 2 + 5).toFixed(1)}" text-anchor="middle">Méridienne</text>` : '';
      top = `<path class="shape" d="${dP}Z"/>${cuts}${mer}`;
    } else {
      const arm = p.slug === 'meridienne' ? 0 : Math.min(w * .1, 17 * s);
      const back = Math.min(d * .3, 18 * s);
      const rx = Math.min(d * .3, kind === 'chair' ? 30 : 26);
      const inX = x0 + arm + 4, inW = w - 2 * arm - 8, inY = y0 + back, inH = d - back - 6;
      const n = kind === 'chair' ? 1 : (W > 180 ? 3 : 2);
      let cuts = '';
      for (let c = 1; c < n; c++) { const cx = inX + (inW / n) * c; cuts += `<line class="ln" x1="${cx}" y1="${inY + 6}" x2="${cx}" y2="${inY + inH - 6}"/>`; }
      top = `<rect class="shape" x="${x0}" y="${y0}" width="${w}" height="${d}" rx="${rx}"/>
        <rect class="inner" x="${inX}" y="${inY}" width="${inW}" height="${inH}" rx="${Math.max(8, rx * .6)}"/>${cuts}`;
    }
    const yD = y0 + d + 30;
    const yF = yD + 74;
    let front = '';
    const floor = yF + h;
    if (kind === 'bed') {
      const fr0 = floor - h * .42;
      front = `<rect class="shape" x="${x0}" y="${yF}" width="${w}" height="${h}" rx="12"/>
        <rect class="shape" x="${x0 - 4}" y="${fr0}" width="${w + 8}" height="${h * .3}" rx="10"/>
        <line class="ln" x1="${x0 + w * .06}" y1="${fr0 + h * .3}" x2="${x0 + w * .06}" y2="${floor}"/><line class="ln" x1="${x0 + w * .94}" y1="${fr0 + h * .3}" x2="${x0 + w * .94}" y2="${floor}"/>`;
    } else if (kind === 'bench') {
      const lift = h * .26;
      front = `<rect class="shape" x="${x0}" y="${yF}" width="${w}" height="${h - lift}" rx="${Math.min((h - lift) * .45, 30)}"/>
        <path class="ln" d="M${x0 + w * .12},${yF + h - lift} L${x0 + w * .1},${floor} M${x0 + w * .88},${yF + h - lift} L${x0 + w * .9},${floor}"/>`;
    } else if (kind === 'cyl') {
      front = `<rect class="shape" x="${x0}" y="${yF}" width="${w}" height="${h}" rx="10"/>
        <line class="ln" x1="${x0 + 3}" y1="${yF + h / 3}" x2="${x0 + w - 3}" y2="${yF + h / 3}"/><line class="ln" x1="${x0 + 3}" y1="${yF + h * 2 / 3}" x2="${x0 + w - 3}" y2="${yF + h * 2 / 3}"/>`;
    } else if (kind === 'ctable') {
      const t = Math.max(4, 3 * s);
      front = `<path class="shape" d="M${x0},${yF} H${x0 + w} V${yF + t} H${x0 + w * .22 + t} V${floor - t} H${x0 + w * .86} V${floor} H${x0 + w * .22} V${yF + t} H${x0} Z" stroke-linejoin="round"/>`;
    } else if (kind === 'nest') {
      const th = Math.max(4, 3 * s);
      front = `<rect class="shape" x="${x0}" y="${yF}" width="${w}" height="${th}" rx="${th / 2}"/>
        <path class="ln" d="M${x0 + w * .14},${yF + th} L${x0 + w * .08},${floor} M${x0 + w * .86},${yF + th} L${x0 + w * .92},${floor} M${x0 + w * .36},${yF + th} L${x0 + w * .32},${floor} M${x0 + w * .64},${yF + th} L${x0 + w * .68},${floor}"/>`;
    } else if (kind === 'table') {
      const th = 6 * s, leg = 16 * s;
      front = `<rect class="shape" x="${x0}" y="${yF}" width="${w}" height="${th}" rx="${th / 2}"/>
        <rect class="inner" x="${x0 + w * .08}" y="${yF + th}" width="${leg}" height="${h - th}" rx="3"/>
        <rect class="inner" x="${x0 + w * .92 - leg}" y="${yF + th}" width="${leg}" height="${h - th}" rx="3"/>
        <rect class="inner" x="${x0 + w * .55}" y="${yF + th}" width="${leg}" height="${h - th}" rx="3"/>`;
    } else {
      /* fauteuils à bascule : des patins ; fauteuils sur pieds : quatre pieds fins ; chauffeuse : posée au sol */
      const rocking = ['berceuse', 'veilleuse'].includes(p.slug), legs = kind === 'round' || p.slug === 'coquillage';
      const lift = legs ? (kind === 'round' ? 12 : 22) * s : rocking ? 10 * s : 0;
      const bodyH = h - lift;
      front = `<rect class="shape" x="${x0}" y="${yF}" width="${w}" height="${bodyH}" rx="${Math.min(bodyH * .3, 26)}"/>`;
      if (legs) front += `<line class="ln" x1="${x0 + w * .2}" y1="${yF + bodyH}" x2="${x0 + w * .16}" y2="${floor}"/><line class="ln" x1="${x0 + w * .8}" y1="${yF + bodyH}" x2="${x0 + w * .84}" y2="${floor}"/>`;
      if (rocking) front += `<path class="ln" d="M${x0 - 8},${floor - 8} Q${x0 + w / 2},${floor + 10} ${x0 + w + 8},${floor - 8}"/>`;
      if (D.hauteurAssise) {
        const ys = floor - D.hauteurAssise * s;
        front += `<line class="seat" x1="${x0 + 6}" y1="${ys}" x2="${x0 + w - 6}" y2="${ys}"/>`;
        front += vdim(x0 - 34, ys, floor, f(D.hauteurAssise), 'seat-t');
      }
    }
    return `<svg class="plan-svg" viewBox="0 0 600 ${floor + 34}" role="img" aria-label="Plan coté de ${esc(p.nom)} : largeur ${f(W)}, profondeur ${f(P)}, hauteur ${f(H)}${D.hauteurAssise ? ', assise à ' + f(D.hauteurAssise) : ''}">
      <text class="lbl" x="${x0}" y="24">Vue de dessus</text>
      ${top}
      <line class="ext" x1="${x0}" y1="${y0 + d + 4}" x2="${x0}" y2="${yD + 6}"/><line class="ext" x1="${x0 + w}" y1="${y0 + d + 4}" x2="${x0 + w}" y2="${yD + 6}"/>
      ${hdim(x0, x0 + w, yD, f(W))}
      ${vdim(x0 + w + 34, y0, y0 + d, f(P))}
      <text class="lbl" x="${x0}" y="${yF - 18}">Vue de face</text>
      ${front}
      <line class="ext" x1="${x0 - 60}" y1="${floor}" x2="${x0 + w + 60}" y2="${floor}"/>
      ${vdim(x0 + w + 34, yF, floor, f(H))}
    </svg>`;
  }

  /* =========================================================
     PAGES
     ========================================================= */

  /* ---------------- Accueil ---------------- */
  const H = { i: 0, k: 0, s: 0, timer: 0, stop: false, busy: 0 };

  const SALON = () => [
    ['incurve', 'incurve-sel'],
    ['capiton', 'capiton-matin'],
    ['causeuse', 'causeuse-arches'],
    ['meridienne', 'meridienne-platre'],
    ['petit-mouton', 'petit-mouton-paris'],
    ['petit-incurve', 'petit-incurve-galerie']
  ];
  /* Texte alternatif d'un tableau (Jade n'a pas encore de tableau dans le catalogue) */
  const tabAlt = (p, id) => (id === 'causeuse-arches' || !p.tableau ? `${p.nom} en velours côtelé Vert sous-bois devant des arches ocre` : p.tableau.alt);

  function heroBuy(p) {
    const c = p.couleurs[H.k] || p.couleurs[0];
    const size = p.tailles ? p.tailles[H.s].nom : '';
    return `
      <h2 class="buy__name display"><a href="#/p/${p.slug}">${esc(p.nom)}</a></h2>
      <div class="buy__price"><strong class="num" data-hero-price>${price(unitPriceOf(p, size))}</strong><a class="round round--white" href="#/p/${p.slug}" aria-label="Voir la fiche de ${esc(p.nom)}">${I.ne}</a></div>
      <fieldset class="opt"><legend class="sr-only">Couleur : <span data-hero-colname>${esc(c.nom)}</span></legend>
        <div class="swatches" role="radiogroup" aria-label="Couleur de ${esc(p.nom)}">
          ${p.couleurs.map((x, k) => swatchBtn(x, k, k === H.k, 'hero-color')).join('')}
        </div>
      </fieldset>
      ${p.tailles && p.tailles.length > 1 ? `<fieldset class="opt"><legend class="sr-only">Taille</legend>
        <div class="sizes" role="radiogroup" aria-label="Taille">
          ${p.tailles.map((t, k) => `<button class="pill pill--sm${sizeOutFor(t, c.nom) ? ' is-out' : ''}" type="button" role="radio" aria-checked="${k === H.s}" data-action="hero-size" data-k="${k}"${sizeOutFor(t, c.nom) ? ' disabled' : ''}>${esc(t.nom)}</button>`).join('')}
        </div>
      </fieldset>` : ''}
      <div class="buy__perks">
        <div class="buy__ship"><span class="round round--white">${I.truck}</span><p><strong>Livraison offerte</strong><span>Chez vous ${delivery(p)}</span></p></div>
        ${(() => { const e = easyIn(p); return e ? `<div class="buy__ship"><span class="round round--white">${I.door}</span><p><strong>${esc(e[0])}</strong><span>${esc(e[1])}</span></p></div>` : ''; })()}
      </div>
      <button class="cta cta--block buy__cta" type="button" data-action="hero-add"${isOut(c) || notYet(p) ? ' disabled' : ''}><span class="cta__label">${notYet(p) ? 'Bientôt disponible' : isOut(c) ? 'Bientôt de retour' : 'Ajouter au panier'}</span><span class="cta__plus">${I.plus}</span></button>`;
  }

  function heroPeek(p) {
    const c = p.couleurs[H.k];
    if (!c || !c.image || H.k === 0 || retirees(p).has(c.image)) return '';
    return `<img src="${photo(p, c.image, 640)}" alt="${esc(p.nom)} en ${esc(c.nom.toLowerCase())}, photo du produit" decoding="async">`;
  }


  /* Carte d'un ensemble : les pièces posées ensemble dans le studio, la liste, le prix exact, les cadeaux débloqués.
     Le bouton est un lien souligné : plusieurs cartes sont visibles à la fois, et un seul bouton noir par écran. */
  /* L'image de l'ensemble : ses pièces posées côte à côte dans le studio, à l'échelle réelle entre elles
     (cartes-echelle.py) ; sans cette image, les détourés posés sur le studio dessiné en CSS */
  /* l'image d'un ensemble en vraies photos (cadre 4:3, cartes.json > photo > ensembles), ou '' */
  function ensPic(first, alt, sizes = '(max-width: 980px) min(84vw, 420px), 31vw') {
    /* refonte du 07/10 : plus de détourés collés côte à côte, la vraie photo de la première pièce dans une pièce */
    const fp = BY[first], fs = fp && scenesFor(fp, '');
    if (fs && fs.length) return sceneImg(fp, fs[0], { alt: fs[0].alt, sizes, eager: false, cls: '', wide: true });
    const E = PHOTO && PHOTO.ensembles, im = E && E.images && E.images[first];
    if (!im) return '';
    const set = (ext) => im.largeurs.map((w) => `${E.dossier}${first}-${w}.${ext} ${w}w`).join(', ');
    const w = im.largeurs[im.largeurs.length - 1];
    return `<picture><source type="image/avif" srcset="${set('avif')}" sizes="${sizes}"><source type="image/webp" srcset="${set('webp')}" sizes="${sizes}"><img src="${E.dossier}${first}-${im.largeurs.includes(1200) ? 1200 : w}.webp" alt="${esc(alt)}" width="${w}" height="${Math.round(w / (im.ratio || 4 / 3))}" loading="lazy" decoding="async" draggable="false"></picture>`;
  }
  function ensMedia(e) {
    const first = e.items[0][0];
    const label = andList(e.items.map(([sl]) => BY[sl].nom));
    const pic = ensPic(first, `${label}, côte à côte dans le studio`);
    if (!pic) return `<div class="ens__media ens__media--studio" role="img" aria-label="${esc(label)}">${e.items.map(([sl]) => `<span class="ens__piece" style="--h:${BY[sl].dimensions.hauteur || 70};--w:${BY[sl].dimensions.largeur || 100}">${prodImg(BY[sl], { alt: '' })}</span>`).join('')}</div>`;
    return `<div class="ens__media ens__media--scene">${pic}</div>`;
  }
  /* Carte d'un ensemble : l'image, le nom, pour qui, puis la liste des pièces comme un cartel (nom et taille à gauche,
     prix à droite), les cadeaux en une phrase, le prix exact et l'ajout. Pas de vignettes : l'image montre déjà chaque pièce. */
  function ensCard(e, i) {
    const total = ensTotal(e);
    const gifts = giftsFor(total);
    const sizeOf = (p, size) => (size && p.tailles ? (isBed(p) ? `, ${size.replace(/ /g, NB)}` : `, ${(size.match(/^\d+/) || [''])[0]}${NB}cm`) : '');
    return `<article class="ens">
      ${ensMedia(e)}
      <div class="ens__body">
        <h3 class="ens__name">${esc(e.nom)}</h3>
        <div class="ens__contenu"><ul class="ens__list">${e.items.map(([slug, , size]) => { const p = BY[slug]; return `<li><a href="#/p/${slug}">${esc(p.nom)}<span class="ens__kind">${esc(lc1(cardType(p)))}${sizeOf(p, size)}</span></a><span class="num">${price(unitPriceOf(p, size))}</span></li>`; }).join('')}</ul>
        ${gifts.length ? `<p class="ens__offer">Offerts avec l’ensemble : ${esc(andList(gifts.map((pl) => GIFT_HOME[SITE.paliers.indexOf(pl)] || pl.cadeau)))}.</p>` : ''}</div>
        <div class="ens__foot"><strong class="num">${price(total)}</strong><button class="btn btn--sm ens__add" type="button" data-action="ens-add" data-i="${i}">Ajouter l’ensemble</button></div>
      </div>
    </article>`;
  }


  /* Accueil, charte « affiche de meuble » : un seul studio gris (les rendus studio-gris), une pièce par cadre,
     un grand mot, beaucoup de vide.
     Ouverture : le mot géant « Caplia » passe entre le studio et le canapé (deux calques du même cadrage,
     maquettes/outils/hero-accueil.py), puis passage au noir et étoile, au fil du défilement natif
     (section collante, aucun épinglage JavaScript : rien ne bloque la molette). */
  const HERO_SLUG = 'incurve';
  /* Pièces secondaires (plan maître A19, L5) : en fin de grille, après les formes douces, de la plus chère à la moins chère */
  const SECONDAIRES = ['angle-cotele', 'u-cotele', 'coquillage', 'miroir-organique'];
  const byChoice = (list) => [...list.filter((p) => !SECONDAIRES.includes(p.slug)), ...list.filter((p) => SECONDAIRES.includes(p.slug))];
  /* les cadeaux des paliers, écrits pour la phrase du « salon assorti » (même ordre que SITE.paliers) */
  const GIFT_HOME = ['2 coussins nœud', 'un plaid', 'un second plaid'];
  /* Description de la page pour les moteurs de recherche, remise par défaut quand on quitte la page */
  let DESC_DEFAULT = null;
  /* Description (balise meta) propre à chaque page d'aide et légale (07/10, chantier 9) : plus la phrase générique du site.
     Une page qui écrit la sienne (setDesc dans son « after ») la remplace. */
  const PAGE_DESC = {
    livraison: () => `Livraison offerte en France métropolitaine : ${SITE.livraison.delais.FR[0]} à ${SITE.livraison.delais.FR[1]} jours ouvrés depuis la France, ${euMin()} à ${euMax()} depuis ${euDe('’')}. La date sur chaque fiche, ${SITE.retours.delaiJours} jours pour changer d’avis.`,
    matieres: () => 'Bouclette, chenille, velours côtelé, effet lin : le toucher de chaque tissu Caplia, en photos de près, et comment l’entretenir au quotidien.',
    arrivee: () => 'Comment arrive votre canapé : colis, carton compressé, temps de reprise de forme et installation sans outil, étape par étape en photos.',
    'a-propos': () => 'Qui est derrière Caplia : une boutique en ligne française de canapés aux formes douces, livrés depuis des entrepôts en Europe.',
    questions: () => 'Livraison, passage de porte, colis, retours, garantie, entretien : les réponses aux questions posées le plus souvent avant d’acheter chez Caplia.',
    contact: () => `Une question sur une pièce, une mesure ou une commande ? Écrivez à ${SITE.email} : la réponse arrive ${reponse()}.`,
    renoncer: () => `Renoncer à votre commande Caplia dans les ${SITE.retours.delaiJours} jours qui suivent la réception : le formulaire, et la marche à suivre pour le retour.`,
    'mentions-legales': () => 'Mentions légales du site Caplia : éditeur, hébergeur, médiation de la consommation et propriété des contenus.',
    'conditions-de-vente': () => 'Conditions générales de vente de Caplia : commande, prix, paiement, livraison, droit de rétractation, garanties et médiation.',
    confidentialite: () => 'Comment Caplia utilise vos données : commande, e-mails choisis, cookies, durée de conservation et vos droits.',
    paiement: () => 'Paiement chez Caplia : carte bancaire, Shop Pay, PayPal ou Apple Pay, paiement chiffré par Shopify, remboursement sous 14 jours si vous changez d’avis.',
    garantie: () => 'La garantie légale de conformité de 2 ans, expliquée simplement avec des exemples : ce qu’elle couvre et comment la faire jouer chez Caplia.',
    'tout-va-bien': () => 'Votre pièce Caplia est arrivée : les gestes des premiers jours, l’entretien et à qui écrire si une question se pose.',
    'un-souci': () => 'Un pied abîmé, une pièce qui manque à l’arrivée ? Envoyez une photo : Caplia s’occupe du reste, sans frais pour vous.',
    'petits-espaces': () => 'Petits canapés et fauteuils pour studio ou petit salon : largeurs, passage de porte et livraison compressée, chez Caplia.',
    'jeunes-parents': () => 'Fauteuils à bascule et d’allaitement pour la chambre de bébé : balancement doux, repose-pieds et livraison offerte.',
    'pourquoi-caplia': () => 'Pourquoi acheter chez Caplia : la date de livraison, le passage de porte et le prix connus avant de payer.'
  };
  function setDesc(t) {
    const m = document.querySelector('meta[name="description"]');
    if (!m) return;
    if (DESC_DEFAULT === null) DESC_DEFAULT = m.content;
    m.content = t;
    cleanups.push(() => { m.content = DESC_DEFAULT; });
  }

  /* Accueil (refonte du 07/10) : un récit en formats alternés, jamais deux fois le même de suite :
     affiche (la pièce dans une vraie pièce à la chaux, montrée entière à chaque largeur : cadrages du 07/10, le mot
     « Caplia. » en surimpression et le défilement décalé de la photo sont retirés), rangée de pièces,
     diptyque (la matière), affiche d'univers, rangée, diptyque (un salon assorti), affiche d'univers, rangée, et une
     dernière image pleine largeur avant le pied de page. */
  const HOME_HERO = { img: 'accueil', alt: 'Mise en scène de Corolle, canapé arrondi en bouclette crème, dans un salon aux murs à la chaux, au soleil de fin d’après-midi' };
  /* Affiche de l'accueil (08/10) : Corolle entière dans le studio clair (cristal, calque complet de hero-accueil.py, sans
     le grand mot) ; cadre haut au téléphone, cadre large au-delà de 700 px, une largeur par écran (AVIF puis WebP),
     demandée tout de suite. Le thème Shopify la rend aussi par Liquid et la précharge (caplia-affiche-accueil). */
  const HY_LG = [750, 1080, 1600, 2400], HY_HT = [720, 1080, 1440];
  const HY_ALT = 'Corolle, canapé arrondi en bouclette crème, dans un studio clair';
  const hySet = (cadre, ws, ext) => ws.map((l) => `/site/assets/affiches/cristal-${cadre}-${l}.${ext} ${l}w`).join(', ');
  const hyPic = () => `<picture class="hy__img"><source media="(max-width: 700px)" type="image/avif" srcset="${hySet('haut', HY_HT, 'avif')}" sizes="100vw"><source media="(max-width: 700px)" type="image/webp" srcset="${hySet('haut', HY_HT, 'webp')}" sizes="100vw"><source type="image/avif" srcset="${hySet('large', HY_LG, 'avif')}" sizes="100vw"><img src="/site/assets/affiches/cristal-large-1600.webp" srcset="${hySet('large', HY_LG, 'webp')}" sizes="100vw" width="1600" height="800" alt="${esc(HY_ALT)}" loading="eager" fetchpriority="high" draggable="false"></picture>`;
  function homeRow(c) {
    if (!c || picksOf(c).length < 2) return '';
    return `<section class="wrap hrow" aria-labelledby="hrow-${c.slug}">
      <div class="hrow__head"><h2 class="t-2 hrow__t" id="hrow-${c.slug}"><a href="${c.route}">${esc(c.nom)}</a></h2>
        <ul class="hrow__subs" role="list">${subsOf(c).map((s) => `<li><a href="${subHref(s)}">${esc(s.nom)}</a></li>`).join('')}</ul></div>
      <div class="hrow__grid hrow__grid--n${picksOf(c).length}">${picksOf(c).map((p) => pcard(p, { sizes: '(max-width: 760px) 80vw, 25vw' })).join('')}</div>
      <a class="link hrow__all" href="${c.route}">${CAT_LINK[c.slug] || `Voir : ${esc(c.nom)}`}</a>
    </section>`;
  }
  function homeUni(slug, h) {
    const u = UNIVERS[slug], ref = SUBS[slug];
    if (!u || !ref) return '';
    return `<a class="uni uni--home${u.shade ? ' uni--shade' : ''}${u.ty != null ? ' uni--top' : ''}" href="${subHref(ref.sub)}" style="${uniVars(u)}" aria-label="${esc(h)} : voir la collection">${uniImg(u, false)}
      <span class="uni__txt"><span class="t-1 uni__t">${esc(h)}</span><span class="uni__l">${esc(u.line)}</span><span class="uni__go">Voir la collection</span></span></a>`;
  }
  function homeMatiere() {
    const p = BY.galet || BY.incurve;
    const m = MAT && MAT.matieres && MAT.matieres.bouclette;
    if (!p || !m) return '';
    const im = p.images.find((x) => x.id === '07') || p.images.find((x) => closeUp(x.alt));
    if (!im) return '';
    return `<section class="wrap hdip" aria-labelledby="hdip-mat">
      <figure class="hdip__img">${momentPic(p, im, '(max-width: 760px) 100vw, 58vw')}</figure>
      <div class="hdip__txt"><h2 class="t-2" id="hdip-mat">La bouclette, de près</h2><p class="hdip__p">${esc(m.toucher)}</p><a class="link" href="#/matieres">Nos matières</a></div>
    </section>`;
  }
  const GIFT_SHORT_TXT = ['2 coussins nœud', 'un plaid', 'un second plaid'];
  function homeSalon() {
    const k = [1, 3, 4, 0, 2, 5].find((i) => ENS[i] && ensOk(ENS[i]));
    if (k == null) return '';
    const e = ENS[k], first = BY[e.items[0][0]];
    const sc = scenesFor(first, e.items[0][1]);
    if (!sc.length) return '';
    const total = ensTotal(e), g = giftsFor(total), P = SITE.paliers;
    const row = ([slug, c, size]) => {
      const x = BY[slug], xs = scenesFor(x, c);
      return `<li class="hset__i"><a href="#/p/${slug}"><span class="hset__pic">${xs.length ? sceneImg(x, xs[0], { alt: '', sizes: '96px', eager: false, cls: '' }) : pieceFit(x, c, 72)}</span><span class="hset__n"><b>${esc(x.nom)}</b><span>${esc(cardType(x))}</span></span><span class="num">${price(unitPriceOf(x, size))}</span></a></li>`;
    };
    const im = sc[1] || sc[0];
    return `<section class="wrap hdip hdip--r" aria-labelledby="hdip-set">
      <figure class="hdip__img">${sceneImg(first, im, { alt: im.alt, sizes: '(max-width: 760px) 100vw, 58vw', eager: false, cls: '' })}</figure>
      <div class="hdip__txt"><h2 class="t-2" id="hdip-set">${esc(e.nom)}</h2>
        <ul class="hset" role="list">${e.items.map(row).join('')}</ul>
        <p class="hset__tot"><span>L’ensemble</span><span class="num">${price(total)}</span></p>
        ${g.length ? `<p class="hset__g">Offerts avec : ${esc(andList(g.map((pl) => GIFT_SHORT_TXT[P.indexOf(pl)] || pl.cadeau)))}.</p>` : ''}
        <button class="pill hset__add" type="button" data-action="ens-add" data-i="${k}"><span class="cta__label">Ajouter l’ensemble</span></button>
      </div>
    </section>`;
  }
  function homeEnd() {
    const p = BY.incurve, im = p && p.images.find((x) => x.id === '06');
    return im ? `<figure class="hend">${momentPic(p, im, '100vw')}</figure>` : '';
  }
  function renderHome() {
    const hp = BY[HERO_SLUG];
    const cat = (k) => CATS.find((c) => c.slug === k);
    const html = `
    <section class="hy" data-hy aria-labelledby="hy-t">
      <div class="hy__frame">${hyPic()}</div>
      <div class="hy__cartel">
        <h1 class="hy__t" id="hy-t">${esc(noDot(SITE.slogan))}</h1>
        <p class="hy__p">${hp ? `${esc(hp.nom)}, ${esc(lc1(cardType(hp)))}, <span class="num">${price(hp.prix)}</span>. ` : ''}Livraison offerte, date connue avant de payer.</p>
        <a class="link hy__go" href="#/canapes">Voir les canapés</a>
      </div>
    </section>
    ${homeRow(cat('canapes'))}
    ${homeMatiere()}
    ${homeUni('canape-bulle', 'Canapés bulle') || homeUni('canape-nuage', 'Canapés nuage')}
    ${homeRow(cat('fauteuils'))}
    ${homeSalon()}
    ${homeUni('canape-modulable', 'Canapés modulables') || homeUni('canape-angle', 'Canapés d’angle')}
    ${homeRow(cat('decoration'))}
    ${homeEnd()}
    ${footer()}`;
    return { title: `Caplia · ${SITE.slogan.replace(/\.$/, '')}`, html, scene: null, after: afterHome };
  }

  function afterHome(root) {
    setDesc(`${SITE.slogan} Canapés aux formes douces en bouclette, chenille ou velours côtelé, fauteuils et miroirs. Livraison offerte, et la date de livraison connue avant de payer : ${SITE.livraison.delais.FR[0]} à ${Math.max(...Object.values(SITE.livraison.delais).map((x) => x[1]))} jours ouvrés.`);
  }
  function rackFilter(btn) {
    const sec = btn.closest('.coll');
    const col = btn.dataset.col;
    $$('.tab', sec).forEach((b) => b.setAttribute('aria-selected', String(b === btn)));
    $$('.tile', sec).forEach((it) => { it.hidden = col !== 'all' && it.dataset.col !== col; });
    /* la pièce mise en avant ne garde sa grande place que dans « Tout » */
    sec.classList.toggle('is-filtered', col !== 'all');
  }

  function heroSyncPicker(root, i) {
    const row = $('[data-picker]', root);
    $$('.pick', row).forEach((b, j) => b.setAttribute('aria-pressed', String(j === i)));
    const act = $$('.pick', row)[i];
    if (act && row.scrollWidth > row.clientWidth + 4) row.scrollTo({ left: act.offsetLeft - row.clientWidth / 2 + act.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
  }

  function heroGo(target, dir) {
    const n = PRODS.length;
    const i = (target + n) % n;
    if (i === H.i) return;
    H.i = i; H.k = firstIn(PRODS[i]); H.s = 0;
    const p = PRODS[i];
    const root = $('[data-hero]');
    if (!root) return;
    const g = G();
    const anim = g && !reduce;
    const show = $('[data-hero-studio]', root);
    const obj = $('[data-hero-obj]', root);
    const buy = $('[data-hero-buy]', root);
    const peek = $('[data-hero-peek]', root);
    heroSyncPicker(root, i);
    show.style.setProperty('--bg', bgOf(p, H.k));
    peek.hidden = true; peek.innerHTML = '';
    const token = ++H.busy;
    const swapObj = () => {
      show.className = `studio studio--hero studio--${shape(p)}`;
      show.style.setProperty('--r', RATIO[p.slug] || 1.6);
      obj.innerHTML = objHtml(p, { alt: p.nom + ', ' + p.type.toLowerCase(), eager: true });
    };
    const swapText = () => { buy.innerHTML = fr(heroBuy(p)); if (H.k) heroColor(H.k); };
    if (!anim) { swapObj(); swapText(); return; }
    g.killTweensOf([obj, buy]);
    g.to(obj, {
      x: -70 * dir, opacity: 0, duration: .32, ease: 'power2.in',
      onComplete: () => {
        if (token !== H.busy) return;
        swapObj();
        g.fromTo(obj, { x: 90 * dir, opacity: 0 }, { x: 0, opacity: 1, duration: .9, ease: 'expo.out' });
      }
    });
    g.to(buy, {
      opacity: 0, y: -8, duration: .22, ease: 'power2.in',
      onComplete: () => {
        if (token !== H.busy) return;
        swapText();
        g.fromTo(buy, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: .55, ease: 'expo.out' });
      }
    });
  }

  function heroColor(k) {
    const root = $('[data-hero]');
    if (!root) return;
    const p = PRODS[H.i];
    H.k = k;
    const c = p.couleurs[k];
    $$('[data-action="hero-color"]', root).forEach((b) => b.setAttribute('aria-checked', String(Number(b.dataset.k) === k)));
    $('[data-hero-colname]', root).textContent = c.nom;
    const hb = $('[data-action="hero-add"]', root);
    if (hb) { hb.disabled = isOut(c) || notYet(p); $('.cta__label', hb).textContent = notYet(p) ? 'Bientôt disponible' : isOut(c) ? 'Bientôt de retour' : 'Ajouter au panier'; }
    /* une taille épuisée dans cette couleur ne se choisit pas */
    $$('[data-action="hero-size"]', root).forEach((b) => { const o = sizeOutFor(p.tailles[Number(b.dataset.k)], c.nom); b.disabled = o; b.classList.toggle('is-out', o); });
    if (p.tailles && sizeOutFor(p.tailles[H.s], c.nom)) { const k2 = p.tailles.findIndex((t) => !sizeOutFor(t, c.nom)); if (k2 >= 0) heroSize(k2, $(`[data-action="hero-size"][data-k="${k2}"]`, root)); }
    $('[data-hero-studio]', root).style.setProperty('--bg', bgOf(p, k));
    const peek = $('[data-hero-peek]', root);
    const ph = heroPeek(p);
    peek.innerHTML = ph;
    peek.hidden = !ph;
    if (ph && G() && !reduce) G().fromTo(peek, { opacity: 0, y: 14, scale: .96 }, { opacity: 1, y: 0, scale: 1, duration: .6, ease: 'expo.out' });
  }

  function heroSize(k, btn) {
    const root = $('[data-hero]');
    const p = PRODS[H.i];
    H.s = k;
    $$('[data-action="hero-size"]', root).forEach((b) => b.setAttribute('aria-checked', String(b === btn)));
    const s = $('[data-hero-sizename]', root); if (s) s.textContent = p.tailles[k].nom;
    const el = $('[data-hero-price]', root);
    el.textContent = price(unitPriceOf(p, p.tailles[k].nom));
    if (G() && !reduce) G().fromTo(el, { yPercent: 30, opacity: 0 }, { yPercent: 0, opacity: 1, duration: .5, ease: 'expo.out' });
  }

  function heroAuto() {
    clearInterval(H.timer);
    if (reduce || H.stop) return;
    H.timer = setInterval(() => { if (!document.hidden) heroGo(H.i + 1, 1); }, 7000);
  }
  function heroStop() { H.stop = true; clearInterval(H.timer); }


  /* Rail horizontal : glisser à la souris, molette, boutons */
  function setupRail(root) {
    $$('[data-rail]', root).forEach((rail) => {
      const bar = rail.parentElement.querySelector('[data-rail-bar]');
      const upd = () => {
        if (!bar) return;
        const ratio = rail.clientWidth / Math.max(1, rail.scrollWidth);
        bar.style.width = `${Math.min(100, ratio * 100)}%`;
        bar.style.transform = `translateX(${(rail.scrollLeft / Math.max(1, rail.clientWidth)) * 100}%)`;
      };
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      cleanups.push(() => window.removeEventListener('resize', upd));
      upd();
      let wheelT = 0;
      rail.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        const max = rail.scrollWidth - rail.clientWidth;
        const dir = Math.sign(e.deltaY);
        if ((dir > 0 && rail.scrollLeft < max - 2) || (dir < 0 && rail.scrollLeft > 2)) {
          e.preventDefault();
          rail.classList.add('is-wheel');
          rail.style.scrollSnapType = 'none';
          rail.scrollLeft += e.deltaY * (e.deltaMode === 1 ? 40 : 1.2);
          clearTimeout(wheelT);
          wheelT = setTimeout(() => { rail.style.scrollSnapType = ''; rail.classList.remove('is-wheel'); }, 220);
        }
      }, { passive: false });
      let down = false, moved = false, startX = 0, startL = 0;
      rail.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;
        down = true; moved = false; startX = e.clientX; startL = rail.scrollLeft;
      });
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      cleanups.push(() => { window.removeEventListener('pointermove', onMove); window.removeEventListener('pointerup', onUp); });
      function onMove(e) {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) { moved = true; rail.classList.add('is-drag'); }
        if (moved) { rail.scrollLeft = startL - dx; e.preventDefault(); }
      }
      function onUp() {
        if (!down) return;
        down = false;
        if (moved) setTimeout(() => rail.classList.remove('is-drag'), 30);
      }
      rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      rail.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  /* Parallaxe en couches :
     - tableau + calque du canapé : mêmes dimensions, même mouvement (montée + zoom lent) ;
     - mot géant : monte moins vite, donc le dossier du canapé recouvre peu à peu le bas des lettres ;
     - ouverture (mode « hero ») : section épinglée, le texte s'efface, la scène passe au noir, puis l'étoile ;
     - tableaux : pas d'épinglage, le mouvement suit simplement le passage de la section à l'écran. */
  const K0 = .2, K1 = .5; /* part de la hauteur des capitales cachée par le dossier, au début et à la fin */
  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  function capHeight(fs) {
    try {
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.font = `800 ${fs}px "Plus Jakarta Sans"`;
      const m = ctx.measureText('H');
      if (m.actualBoundingBoxAscent > 0) return m.actualBoundingBoxAscent;
    } catch (e) { /* repli */ }
    return fs * .72;
  }

  /* ---------------- Collection ---------------- */
  /* Filtres déduits des fiches (type, matière, largeur, prix) : une nouvelle pièce se range toute seule. */
  const CF_FORME = {
    canapes: [['arrondis', 'Arrondis', (p) => !/angle|méridienne|panoramique/i.test(p.type) && /arrondi|nuage|incurv|courb/i.test(p.type)],
      ['droits', 'Droits', (p) => !/angle|méridienne|panoramique|arrondi|nuage|incurv|courb/i.test(p.type)],
      ['meridienne', 'Angle et méridienne', (p) => /angle|méridienne|panoramique/i.test(p.type)]],
    fauteuils: [['bascule', 'À bascule', (p) => /bascule/i.test(p.type)], ['fixes', 'Fixes', (p) => !/bascule/i.test(p.type)]],
    decoration: [['miroirs', 'Miroirs', (p) => /miroir/i.test(p.type)], ['tables', 'Tables', (p) => /table/i.test(p.type)]]
  };
  const cfMat = (p) => (/bouclette/i.test(p.matiere) ? 'Bouclette' : /chenille/i.test(p.matiere) ? 'Chenille' : /velours/i.test(p.matiere) ? 'Velours' : /lin/i.test(p.matiere) ? 'Effet lin' : /mouton/i.test(p.matiere) ? 'Effet mouton' : p.matiere);
  const CF_LARG = [['lt200', 'Moins de 2 m', (p) => p.dimensions.largeur < 200], ['200-240', `2 à 2,40${NB}m`, (p) => p.dimensions.largeur >= 200 && p.dimensions.largeur <= 240], ['gt240', `Plus de 2,40${NB}m`, (p) => p.dimensions.largeur > 240]];
  const PRIX = [
    ['lt1000', `Moins de 1${NNB}000${NB}€`, (p) => p.prix < 1000],
    ['1000-1200', `1${NNB}000 à 1${NNB}200${NB}€`, (p) => p.prix >= 1000 && p.prix <= 1200],
    ['gt1200', `Plus de 1${NNB}200${NB}€`, (p) => p.prix > 1200]
  ];
  const CF_TRI = [['choix', 'Nos choix'], ['prix-asc', 'Prix croissant'], ['prix-desc', 'Prix décroissant'], ['largeur', 'Largeur, du plus étroit']];
  const COLF = { slug: '', forme: 'all', mat: 'all', larg: 'all', prix: 'all', tri: 'choix' };
  const CF_NOUN = { canapes: ['canapé', 'canapés'], fauteuils: ['fauteuil', 'fauteuils'], decoration: ['pièce', 'pièces'] };
  const cfWords = (slug) => CF_NOUN[slug] || ['pièce', 'pièces'];
  const cfNoun = (slug, n) => `${n}${NB}${cfWords(slug)[n > 1 ? 1 : 0]}`;
  function cfItems() {
    const all = PRODS.filter((p) => p.collection === COLF.slug);
    const f = (CF_FORME[COLF.slug] || []).find((x) => x[0] === COLF.forme);
    const l = CF_LARG.find((x) => x[0] === COLF.larg);
    const pr = PRIX.find((x) => x[0] === COLF.prix);
    const out = all.filter((p) => (!f || f[2](p)) && (COLF.mat === 'all' || cfMat(p) === COLF.mat) && (!l || l[2](p)) && (!pr || pr[2](p)));
    const t = COLF.tri;
    if (t === 'choix') return { all, out: byChoice(out) };
    if (t === 'prix-asc') out.sort((a, b) => a.prix - b.prix);
    else if (t === 'prix-desc') out.sort((a, b) => b.prix - a.prix);
    else if (t === 'largeur') out.sort((a, b) => a.dimensions.largeur - b.dimensions.largeur);
    return { all, out };
  }
  const CG_SIZES = '(max-width: 760px) 47vw, (max-width: 1100px) 50vw, 32vw';
  const CG_SIZES_BIG = '(max-width: 1100px) 100vw, 66vw';
  /* Mise en page sans trou, la même grille sur les trois collections : 3 colonnes sur ordinateur (2 au téléphone),
     et une ou deux affiches larges (sur 2 colonnes) pour finir les lignes : la pièce y garde sa taille, avec plus de
     studio autour. Les pièces basses et larges passent en large de préférence ; 4 pièces : la première et la dernière.
     Au téléphone, deux cartes par ligne ; l'affiche large garde la hauteur de ses voisines. */
    /* cadrages du 07/10 : toutes les cartes d'une grille ont le même cadre carré (plus de carte sur deux colonnes : sa
     photo large ne gardait pas la même échelle que ses voisines) ; une ou deux pièces : deux colonnes */
  function cgLayout(list) {
    return { cls: list.length <= 2 ? 'cgrid--2' : '', big: {} };
  }
  const CG_SIZES_2 = '(max-width: 760px) 100vw, 50vw';
  function cgCards(list, eagerN = 3) {
    const { big, cls } = cgLayout(list);
    const sz = cls ? CG_SIZES_2 : CG_SIZES;   /* une ou deux pièces : deux par ligne */
    const bigSz = cls === 'cgrid--1' ? '(max-width: 760px) 100vw, 92vw' : CG_SIZES_BIG;   /* pièce seule : toute la largeur */
    return list.map((p, i) => pcard(p, { eager: i < eagerN, sizes: big[i] ? bigSz : sz, cls: big[i] || '', deux: cls === 'cgrid--2' })).join('');
  }
  const cgClass = (list) => `cgrid ${cgLayout(list).cls}`.trim();
  function cfGrid(list, all) {
    if (!list.length) {
      const w = cfWords(COLF.slug);
      return `<div class="cempty"><p class="t-3">Élargissons un peu la recherche.</p><p class="cempty__txt">Retirez un filtre pour revoir les ${all.length} ${w[1]}.</p><button class="link" type="button" data-cf-reset>Revoir les ${all.length} ${w[1]}</button></div>`;
    }
    return cgCards(list);
  }
  /* Textes de chaque collection : titre de l'onglet, phrase d'introduction (faits + livraison), description pour les moteurs.
     Le délai est celui des pièces de la collection, du plus court au plus long. */
  const COL_COPY = {
    canapes: {
      title: 'Canapés arrondis et incurvés, livraison offerte · Caplia',
      /* la pièce la plus large de la catégorie, nommée par sa forme (« au canapé panoramique en U modulable de 369 cm ») */
      intro: (r, dl) => `Du 2 places de ${r.min}${NB}cm au ${lc1(r.large.type.replace(/,.*$/, ''))} de ${r.max}${NB}cm, en ${orList(r.mats)}. Livraison offerte, chez vous en ${dl}.`,
      desc: (r, dl) => `Canapés aux formes douces : arrondis, nuage, d’angle, modulables, convertibles, en velours, méridienne, de ${r.min} à ${r.max} cm, en ${orList(r.mats)}. Livraison offerte en ${dl}. Envoyez vos mesures : nous vérifions qu’il passe chez vous.`
    },
    fauteuils: {
      title: 'Fauteuils ronds, à bascule et d’allaitement · Caplia',
      intro: (r, dl) => `Un fauteuil rond pour le coin lecture, un fauteuil à bascule, un fauteuil d’allaitement et son repose-pieds${r.slugs.includes('chauffeuse') ? ', des chauffeuses qui se déplient en lit d’appoint' : ''}. Livraison offerte, chez vous en ${dl}.`,
      desc: (r, dl) => `Fauteuils aux formes douces : fauteuil rond en bouclette, fauteuil à bascule, fauteuil d’allaitement avec repose-pieds. Livraison offerte en ${dl}.`
    },
    decoration: {
      title: 'Miroirs ondulés et table basse nuage · Caplia',
      intro: (r, dl) => `${r.slugs.filter((k) => /^miroir/.test(k)).length > 1 ? 'Des miroirs aux bords ondulés' : 'Un miroir sur pied aux bords ondulés'}${r.slugs.includes('table-nuage') ? ' et une table basse en forme de nuage' : ''}, pour prolonger les courbes du canapé. Livraison offerte, chez vous en ${dl}.`,
      desc: (r, dl) => `${andList(['Miroir sur pied ondulé', r.slugs.includes('miroir-organique') ? 'miroir mural aux contours arrondis' : '', r.slugs.includes('table-nuage') ? 'table basse en forme de nuage' : ''].filter(Boolean))} : la décoration qui va avec les canapés arrondis. Livraison offerte en ${dl}.`
    }
  };
  /* Trois largeurs de canapé, trois prix (plan maître M8, L2) : le milieu de gamme se lit comme le choix raisonnable */
  const SIZE_TRIO = ['petit-incurve', 'courbe', 'capiton', 'incurve'];   /* la plus petite, la 1re du milieu en ligne, la plus grande */
  function sizeTrio() {
    const all = SIZE_TRIO.map((k) => BY[k]).filter(Boolean);
    const list = all.length > 3 ? [all[0], all[1], all[all.length - 1]] : all;
    if (list.length < 3) return '';
    const max = Math.max(...list.map((p) => p.dimensions.largeur));
    return `<nav class="ctrio" aria-labelledby="ctrio-t">
      <h2 class="ctrio__t" id="ctrio-t">Quelle largeur pour votre salon ?</h2>
      <ul class="ctrio__list">${list.map((p) => `<li><a class="ctrio__a" href="#/p/${p.slug}">
        <span class="ctrio__bar" style="--w:${(p.dimensions.largeur / max * 100).toFixed(1)}%" aria-hidden="true"></span>
        <span class="ctrio__w num">${cm(p.dimensions.largeur)}</span>
        <span class="ctrio__name">${esc(p.nom)}<span class="ctrio__type">, ${esc(lc1(cardType(p)))}</span></span>
        <span class="ctrio__p num">${price(p.prix)}</span>
      </a></li>`).join('')}</ul>
    </nav>`;
  }
  function renderCollection(slug) {
    const c = colName(slug);
    Object.assign(COLF, { slug, forme: 'all', mat: 'all', larg: 'all', prix: 'all', tri: 'choix' });
    const { all, out } = cfItems();
    const cc = COL_COPY[slug] || {};
    const ws = all.map((p) => p.dimensions.largeur);
    const r = { min: Math.min(...ws), max: Math.max(...ws) };
    const ds = all.map((p) => DL(p));
    const dl = `${Math.min(...ds.map((d) => d[0]))} à ${Math.max(...ds.map((d) => d[1]))}${NB}jours ouvrés`;
    const intro = cc.intro ? cc.intro(r, dl) : c.intro;
    const big = all.length > 6;
    const formes = (CF_FORME[slug] || []).filter((x) => all.some(x[2]));
    const mats = big ? [...new Set(all.map(cfMat))] : [];
    const largs = big ? CF_LARG.filter((x) => all.some(x[2])) : [];
    const prix = big ? PRIX.filter((x) => all.some(x[2])) : [];
    const sel = (key, label, first, opts) => `<label class="cf__field"><span class="sr-only">${label}</span><select class="input cf__select" data-cf="${key}"><option value="all">${first}</option>${opts.map(([v, t]) => `<option value="${esc(v)}">${t}</option>`).join('')}</select></label>`;
    const more = [
      mats.length > 1 ? sel('mat', 'Matière', 'Matière', mats.map((m) => [m, esc(m)])) : '',
      largs.length > 1 ? sel('larg', 'Largeur', 'Largeur', largs) : '',
      prix.length > 1 ? sel('prix', 'Prix', 'Prix', prix) : ''
    ].join('');
    const tri = `<label class="cf__field cf__field--tri"><span class="sr-only">Trier</span><select class="input cf__select" data-cf="tri">${CF_TRI.filter(([v]) => v !== 'largeur' || slug === 'canapes').map(([v, t]) => `<option value="${v}">${v === 'choix' ? 'Trier : nos choix' : t}</option>`).join('')}</select></label>`;
    const others = CAT.collections.filter((x) => x.slug !== slug);
    const html = `
    <section class="wrap cpage">
      <header class="chead">
        <h1 class="t-display chead__title">${esc(c.nom)}</h1>
        ${intro ? `<p class="lead chead__intro">${esc(intro)}</p>` : ''}
      </header>
      ${slug === 'canapes' ? sizeTrio() : ''}
      ${big ? `<div class="cf cf--more" data-cf-bar>
        ${formes.length > 1 ? `<div class="cf__formes" role="group" aria-label="Forme">
          <button class="tab" type="button" data-action="filter" data-group="forme" data-value="all" aria-pressed="true">Tous</button>
          ${formes.map(([id, l]) => `<button class="tab" type="button" data-action="filter" data-group="forme" data-value="${id}" aria-pressed="false">${l}</button>`).join('')}
        </div>` : ''}
        <div class="cf__status"><p class="cf__count" data-cf-count aria-live="polite">${cfNoun(slug, all.length)}</p><button class="link cf__reset" type="button" data-cf-reset hidden>Tout effacer</button><button class="link cf__toggle" type="button" aria-expanded="false" aria-controls="cf-more" data-cf-toggle>Filtrer et trier</button></div>
        <div class="cf__more" id="cf-more">${more}${tri}</div>
      </div>` : `<div class="cf cf--seul" data-cf-bar><div class="cf__status"><p class="cf__count" data-cf-count>${cfNoun(slug, all.length)}</p></div></div>`}
      <div class="${cgClass(out)}" data-grid>${cfGrid(out, all)}</div>
      <p class="cpage__promise">${HERO_LINE.map((t) => `<span>${t}</span>`).join('')}</p>
      <nav class="cnext" aria-label="Autres collections">
        ${others.map((o) => `<a class="cnext__a" href="#/${o.slug}"><span class="cnext__name">${esc(o.nom)}</span><span class="cnext__n">${cfNoun(o.slug, PRODS.filter((p) => p.collection === o.slug).length)}</span></a>`).join('')}
      </nav>
    </section>
    ${footer()}`;
    return {
      title: cc.title || `${c.nom} · Caplia`,
      html,
      scene: {},
      nav: slug,
      after: () => {
        if (cc.desc) setDesc(cc.desc(r, dl));
        const bar = $('[data-cf-bar]');
        if (!bar) return;
        $$('[data-cf]', bar).forEach((s) => s.addEventListener('change', () => applyFilter(s.dataset.cf, s.value)));
        const tg = $('[data-cf-toggle]', bar);
        if (tg) tg.addEventListener('click', () => { const on = tg.getAttribute('aria-expanded') !== 'true'; tg.setAttribute('aria-expanded', String(on)); bar.classList.toggle('is-open', on); });
        $('.cpage').addEventListener('click', (e) => { if (e.target.closest('[data-cf-reset]')) applyFilter('reset'); });
      }
    };
  }
  /* Filtre de collection : forme (choix .pill), matière, largeur, prix et tri (listes) ; « reset » remet tout à zéro sauf le tri */
  function applyFilter(group, value) {
    const bar = $('[data-cf-bar]');
    if (!bar) return;
    if (group === 'reset') {
      Object.assign(COLF, { forme: 'all', mat: 'all', larg: 'all', prix: 'all' });
      $$('[data-cf]', bar).forEach((s) => { if (s.dataset.cf !== 'tri') s.value = 'all'; });
    } else COLF[group] = value;
    $$('[data-action="filter"][data-group="forme"]', bar).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.value === COLF.forme)));
    const { all, out } = cfItems();
    const active = ['forme', 'mat', 'larg', 'prix'].filter((k) => COLF[k] !== 'all').length;
    $('[data-cf-count]', bar).textContent = active ? `${out.length} sur ${cfNoun(COLF.slug, all.length)}` : cfNoun(COLF.slug, all.length);
    const rs = $('.cf__reset', bar); if (rs) rs.hidden = !active;
    const tg = $('[data-cf-toggle]', bar);
    if (tg) { const n = ['mat', 'larg', 'prix'].filter((k) => COLF[k] !== 'all').length; tg.textContent = n ? `Filtrer et trier (${n})` : 'Filtrer et trier'; }
    const grid = $('[data-grid]');
    grid.className = cgClass(out);
    grid.innerHTML = fr(cfGrid(out, all));
    if (ST()) ST().refresh();
  }

  /* ---------------- Fiche produit ---------------- */
  const PDP = { p: null, color: 0, size: 0, img: -1, list: [], done: {} };
  /* « 21 h. Personne… » : l'heure en relief */
  const sceneHtml = (s) => { const m = String(s).match(/^([^.]*\d+ h[^.]*)\.\s*(.*)$/); return m ? `<b>${esc(m[1])}.</b> ${esc(m[2])}` : esc(s); };
  /* Sous le prix : ce que le prix comprend, et le garde-fou du prix (M4, M5) */
  /* Montant d'éco-participation : affiché dès que l'adhésion Ecomaison donne les vrais montants (site.json > ecomaison) */
  const ecoOf = (p) => { const E = SITE.ecomaison; if (!E || E.aConfirmer) return null; const m = E.montants || {}; return p.collection === 'canapes' ? m.canapes : p.collection === 'fauteuils' ? m.fauteuils : m.deco; };
  const priceNote = (p) => { const e = p ? ecoOf(p) : null; return e != null ? `Prix tout compris : livraison offerte, dont ${price(e)} d’éco-participation.` : 'Prix tout compris : livraison offerte, éco-participation comprise.'; };
  /* Plus petite mesure : c'est elle qui passe la porte, de profil (même règle que doorAnswer) */
  /* Mirage : 160 cm présélectionné, l'option par défaut est celle qu'on garde (plan maître A17) */
  const defSize = (p) => (p.tailles && p.slug === 'miroir-onde' ? p.tailles.length - 1 : 0);
  const minDim = (p) => { const D = p.dimensions; return Math.min(D.largeur, D.profondeur, D.hauteur); };
  /* Outil de porte : seulement pour les canapés et les grands fauteuils (plus de 85 cm de haut, les berceuses).
     Un miroir, une table ou une petite pièce passe toujours : la question n'a pas de sens. */
  const hasDoor = (p) => p.collection === 'canapes' || (p.collection === 'fauteuils' && p.dimensions.hauteur >= 85);
  /* Une ligne de cotes toujours visible sous le prix (F2), avec le passage de porte (playbook §7.2) */
  /* Les mesures qui comptent selon la pièce : lit = couchage + tête de lit ; miroir = hauteur × largeur ;
     assise = largeur × profondeur + hauteur d'assise ; table, chevet = plateau + hauteur */
  const isBed = (p) => /^Lit\b/.test(p.type);
  const isMirror = (p) => /^Miroir\b/.test(p.type);
  const xy = (a, b) => `${numFr(a)}${NB}×${NB}${cm(b)}`;
  /* « 140 × 45 cm » -> [140, 45] (tailles des miroirs : hauteur × largeur) */
  const sizeNums = (p, i) => p.tailles.map((t) => (t.nom.match(/[\d,.]+/g) || [])[i]).join(' ou ') + NB + 'cm';
  function cotesParts(p) {
    const D = p.dimensions;
    if (isBed(p)) return [`Couchage ${p.tailles ? dimsLabel(p) : xy(D.largeur, D.profondeur)}`, `tête de lit de ${cm(D.hauteur)} de haut`];
    if (isMirror(p)) return p.tailles ? [`${sizeNums(p, 0)} de haut`, `${sizeNums(p, 1)} de large`] : [`${cm(D.hauteur)} de haut`, `${cm(D.largeur)} de large`];
    /* convertible : la taille en lit, première question de l’acheteur (dimensions.lit, chauffeuse « dépliée ») */
    if (D.hauteurAssise) return [xy(D.largeur, D.profondeur), `assise à ${cm(D.hauteurAssise)} du sol`].concat(D.lit ? [`${/^Chauffeuse/.test(p.type) ? 'dépliée' : `en${NB}lit`}${NB}${xy(D.lit[0], D.lit[1])}`] : []);
    if (D.epaisseur) return [xy(D.largeur, D.profondeur), `${cm(D.epaisseur)} d’épaisseur`];
    if (D.diametre) return [`Ø${NB}${cm(D.diametre)}`, `${cm(D.hauteur)} de haut`];
    if (D.petite) return [`${xy(D.largeur, D.profondeur)} et ${xy(D.petite.largeur, D.petite.profondeur)}`, `${numFr(D.hauteur)} et ${cm(D.petite.hauteur)} de haut`];
    return [xy(D.largeur, D.profondeur), `${cm(D.hauteur)} de haut`];
  }
  function cotesLine(p) {
    const parts = cotesParts(p);
    /* lit livré avec son sommier : dit sous le prix, comme dans l'annonce Google (« avec sommier ») */
    if (isBed(p) && /sommier/i.test((p.carton || []).join(' '))) return `<span class="fp__door">Sommier à lattes compris</span><span class="fp__sep"> · </span>${esc(`pour un matelas de ${p.tailles ? dimsLabel(p) : xy(p.dimensions.largeur, p.dimensions.profondeur)}, ${parts[1]}`)}`;
    if (!hasDoor(p)) return esc(parts.join(', '));
    return `${esc(parts.join(', '))}<span class="fp__sep"> · </span><span class="fp__door">${doorTxt(p)}</span>`;
  }
  /* la porte que la pièce passe (ou, carton aux cotes inconnues, le fait seul : « livré compressé en 2 cartons ») */
  function doorTxt(p) {
    const n = parseInt(p.colis, 10), dm = doorMin(p), f = isFem(p) ? 'e' : '';
    if (isFlat(p)) return `livré${f} en ${n > 1 ? `${n} colis` : 'colis'}, à monter`;
    return isKit(p) ? (dm != null ? `son colis passe une porte de ${cm(Math.ceil(dm + 2))}` : `livré${f} en kit, en ${n > 1 ? `${n} colis` : '1 colis'}`)
      : isCompressed(p) ? (dm != null ? `son plus grand carton passe une porte de ${cm(Math.ceil(dm + 2))}` : `livré${f} compressé${f} en ${n > 1 ? `${n} cartons` : '1 carton'}`)
        : `passe une porte de ${cm(Math.ceil(dm + 2))}`;
  }
  /* Pièces proposées ensuite : écrites à la main (P3). Les pièces secondaires ne sont jamais suggérées. */
  const SECONDARY = ['angle-cotele', 'u-cotele', 'coquillage', 'miroir-organique'];
  const RELATED = {
    /* grand salon où l'on reçoit : Valse plutôt qu'Aurore (fauteuil d'allaitement) quand la table Écume est masquée */
    incurve: ['miroir-onde', 'galet', 'table-nuage', 'berceuse'],
    'noix-de-cajou': ['miroir-onde', 'galet', 'table-nuage', 'berceuse'],
    'petit-incurve': ['galet', 'berceuse', 'miroir-onde'],
    causeuse: ['galet', 'miroir-onde', 'table-nuage'],
    capiton: ['galet', 'miroir-onde', 'table-nuage'],
    courbe: ['galet', 'miroir-onde', 'table-nuage'],
    meridienne: ['miroir-onde', 'table-nuage', 'galet'],
    'petit-mouton': ['galet', 'berceuse', 'miroir-onde'],
    veilleuse: []
  };
  /* Frais de retour estimés selon le type de pièce (information due, ton neutre) */
  function returnCost(p) {
    const E = SITE.retours.estimation;
    if (isBed(p) && E.lits) return [E.lits, 'un lit en kit'];
    return p.collection === 'canapes' ? [E.canapes, 'un canapé'] : p.collection === 'fauteuils' ? [E.fauteuils, 'un fauteuil'] : [E.deco, 'une pièce de décoration'];
  }
  /* Les « oui » successifs : chaque étape se coche quand elle est faite */
  function pdpSteps() {
    const d = PDP.done;
    const state = { color: d.color, door: d.door, date: d.door, cart: d.cart };
    $$('[data-yes] [data-step]').forEach((li) => li.classList.toggle('is-done', !!state[li.dataset.step]));
  }

  /* Marque Apple dessinée simplement (logo de moyen de paiement accepté) */
  const APPLE = '<svg class="apple" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.4 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9s-1.8-.9-3-.8C6.9 7.4 5.4 8.3 4.6 9.8c-1.7 2.9-.4 7.2 1.2 9.5.8 1.1 1.7 2.4 2.9 2.4 1.2 0 1.6-.8 3-.8s1.8.8 3 .8c1.3 0 2.1-1.2 2.8-2.3.9-1.3 1.3-2.6 1.3-2.6s-2.5-1-2.4-4.2zM14.1 5.8c.6-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.1 1.8-1 2.9 1 .1 2.1-.6 2.8-1.4z"/></svg>';
  /* Liste de naissance : copie le lien de la fiche et explique comment l'ajouter */
  const birthBtn = (p) => `<div class="birth" data-birth>
      <button class="savebtn" type="button" data-action="birth" data-slug="${p.slug}">${I.gift}<span>Ajouter à ma liste de naissance</span></button>
      <div class="birth__help" hidden>
        <p><b>Lien copié.</b> Sur votre liste de naissance en ligne, choisissez l’ajout d’un article d’un autre site (souvent « ajouter un lien »), puis collez-le : vos proches pourront vous offrir ${esc(p.nom)}.</p>
        <label class="sr-only" for="birth-${p.slug}">Lien de la fiche ${esc(p.nom)}</label>
        <input id="birth-${p.slug}" class="birth__url" type="text" readonly value="">
      </div>
    </div>`;

  /* ---------------- Fiche produit : aides ---------------- */
  let SANTE = null;   /* site/data/sante.json, lu à la première fiche ouverte */
  /* Fermeté : seulement quand le fournisseur la décrit (catalogue.json) */
  const FERMETE = {
    causeuse: ['Ferme mais moelleuse', 'Mousse haute densité 32 kg/m³ (32D) : l’assise tient, on ne s’y enfonce pas.'],
    courbe: ['Souple et stable', 'La mousse cède un peu, les lattes à ressorts vous tiennent.'],
    'angle-cotele': ['Ferme et douce', 'Les ressorts ensachés soutiennent, la mousse adoucit.'],
    'u-cotele': ['Enveloppante', 'La mousse à mémoire de forme épouse le dos, puis reprend sa forme.']
  };
  const isSeat = (p) => p.collection !== 'decoration' && !!p.dimensions.hauteurAssise;
  const colisTxt = (p) => (/^\d/.test(p.colis) ? p.colis : isCompressed(p) ? 'Colis compressés' : 'Plusieurs colis');
  /* Place de la pièce dans l'image studio (4:5) : cadrage vertical pour un cadre de proportion A (largeur / hauteur) */
  function studioPos(p, A) {
    const s = STUDIO[p.slug];
    if (!s || A <= s.ratio) return 50;
    const f = s.ratio / A, cy = (s.piece[1] + s.piece[3]) / 2;
    return Math.round(Math.max(0, Math.min(1, (cy - 0.56 * f) / (1 - f))) * 100);
  }
  /* Format du cadre de la galerie (06/10/2026, règle de l'utilisateur : pièce jamais coupée, aucune bande vide) : pour la
     couleur montrée, le format (de 1:1 à 16:10) où ses vraies photos remplissent le mieux le cadre sans que la boîte de la
     pièce (cadrage-photos.json) en sorte. Coût d'une photo = la part du cadre qu'elle laisse vide ; les gros plans
     remplissent toujours. Même format au téléphone et à l'ordinateur. */
  const FORMATS = [1, 1.1, 1.2, 4 / 3, 1.45, 1.6];
  function stageFormat(p, k) {
    const c = p.couleurs[k] || p.couleurs[0];
    const ph = colorPhotos(p, c).filter((im) => !/^(Détail|Une main)/.test(im.alt)).map((im) => (CADRAGE[p.slug] || {})[im.id]).filter(Boolean);
    if (!ph.length) return 1.2;
    let best = 1.2, bestCout = Infinity;
    for (const A of FORMATS) {
      let cout = 0;
      for (const [N, x0, y0, x1, y1] of ph) {
        const cover = Math.max(A, N);                      /* largeur de la photo (cadre A x 1) qui couvre le cadre */
        const tient = Math.min(A / Math.max(.01, x1 - x0 + .02), N / Math.max(.01, y1 - y0 + .02));
        const W = Math.min(cover, Math.max(Math.min(A, N), tient));
        cout += 1 - Math.min(1, W / cover) * Math.min(1, W / cover);   /* part vide du cadre */
      }
      cout += Math.abs(A - 1.2) * .01;                     /* à égalité : près de 1,2 (la pièce grande à l'écran) */
      if (cout < bestCout) { bestCout = cout; best = A; }
    }
    return best;
  }
  /* refonte du 07/10 : au téléphone, la photo en situation en tête donne son format au cadre (aucune bande autour) */
  /* Cadrages du 08/10 (règle : la pièce jamais coupée).
     fitsIn : la boîte de la pièce (cadrage-photos.json) tient-elle dans un cadre de format A quand la photo le couvre ?
     bandsIn : part du cadre que les photos d'une couleur laisseraient aux couleurs de leurs bords si elles y étaient
     réduites juste assez pour garder la pièce entière (photoFit) ; 0 quand toutes tiennent (gros plans exceptés). */
  const fitsIn = (b, A) => { const [N, x0, y0, x1, y1] = b, ex = Math.min(1, x1 + .01) - Math.max(0, x0 - .01), ey = Math.min(1, y1 + .01) - Math.max(0, y0 - .01); return N > A ? ex * N / A <= 1.001 : ey * A / N <= 1.001; };   /* marge de photoFit (FIT_MARGE) */
  const bandIn = (b, A) => { const [N, x0, y0, x1, y1] = b; return fitsIn(b, A) ? 0 : 1 - Math.min(1, N > A ? (A / N) / (Math.min(1, x1 + .01) - Math.max(0, x0 - .01)) : (N / A) / (Math.min(1, y1 + .01) - Math.max(0, y0 - .01))); };
  const bandsIn = (p, c, A) => colorPhotos(p, c).filter((im) => !closeUp(im.alt)).reduce((s, im) => {
    const b = (CADRAGE[p.slug] || {})[im.id];
    return s + (b ? bandIn(b, A) : 0);
  }, 0);
  /* la 1re photo de la galerie d'une couleur : une photo en situation entière, sinon la pièce seule (gallerySlides) */
  const leadOf = (p, c) => {
    const pics = colorPhotos(p, c);
    return sceneOf(p, pics) || pics.find((im) => !closeUp(im.alt) && !isGen(im) && !coupee(p, im)) || pics.find((im) => !closeUp(im.alt) && !isGen(im)) || null;
  };
  /* cadre du téléphone (une piste, un seul format pour toutes les photos) : le format de la photo de tête si toutes les
     pièces y tiennent, sinon le format qui laisse le moins de place aux bords, près de celui de la photo de tête */
  const FORMATS_M = [1, 1.1, 1.2, 4 / 3, 1.45, 1.6, 16 / 9, 2];
  const mobileFrame = (p, c, im, a) => {
    const b = im && (CADRAGE[p.slug] || {})[im.id];
    const n = b && isScene(im.alt) && b[0] > 0.75 && b[0] < 2.2 ? b[0] : 0, pref = n || Number(a);
    let best = pref, score = Infinity;
    for (const A of [pref, ...FORMATS_M]) { const sc = bandsIn(p, c, A) + 0.15 * Math.abs(A - pref); if (sc < score - 1e-9) { score = sc; best = A; } }
    return String(Math.round(best * 1000) / 1000);
  };
  /* ordinateur : la 1re case de la mosaïque prend le format de sa photo (photo en situation, ou pièce qui ne tiendrait pas
     entière en 4:3) ; sinon 4:3 */
  const leadAspect = (p, im) => {
    const b = im && (CADRAGE[p.slug] || {})[im.id];
    return b && ((isScene(im.alt) && b[0] > 0.75 && b[0] < 2.2) || !fitsIn(b, 4 / 3)) ? b[0].toFixed(3) : '';
  };
  const STAGE_A = (p, k) => {
    const kk = k == null ? PDP.initColor : k, a = stageFormat(p, kk);
    const c = p.couleurs[kk] || p.couleurs[0], lead = leadOf(p, c);
    return { m: mobileFrame(p, c, lead, a), d: a, lead: leadAspect(p, lead) };
  };
  /* le cadre suit la couleur choisie */
  function stageSet(p, k) {
    const st = $('[data-fp-stage]'), th = $('.fp-thumbs');
    if (!st) return;
    const A = STAGE_A(p, k);
    st.style.setProperty('--am', A.m); st.style.setProperty('--ad', A.d); if (A.lead) st.style.setProperty('--lead', A.lead); else st.style.removeProperty('--lead');
    if (th) th.style.setProperty('--ad', A.d);   /* vignettes au format du cadre : la pièce y reste entière */
  }

  /* Cadeaux de la fiche, en vraies photos, juste sous le bouton : ceux que la pièce débloque seule (valeur barrée = prix de
     l'article vendu seul) et la somme économisée, puis le cadeau suivant en plus petit. Jamais sur un accessoire, ni sur
     Aurore (repose-pieds compris), ni dans Caplia Sleep quand le premier cadeau n'y est pas atteignable. */
  function giftsBlock(p) {
    if (notYet(p) || isAcc(p) || p.slug === 'veilleuse' || !GIFTS || !GIFTS.paliers) return '';
    if (isSleep(p) && !giftReachable(true)) return '';
    const P = SITE.paliers, v = unitPriceOf(p);
    const got = P.filter((pl) => v >= pl.seuil), next = P.find((pl) => v < pl.seuil);
    const the = (pl) => { const s = GIFT_SHORT[P.indexOf(pl)]; return `${plural(s) ? 'Les' : 'Le'} ${s}`; };
    const offert = (pl) => (plural(GIFT_SHORT[P.indexOf(pl)]) ? 'vous sont offerts' : 'vous est offert');
    const voir = '<a class="fp-inline" href="#/cadeaux">Voir les cadeaux</a>';
    /* à moins de 300 € du premier palier : la pièce assortie la moins chère qui le débloque (jamais une pièce secondaire) */
    const gap = P[0].seuil - v;
    const add = !got.length && gap <= 300 ? PRODS.filter((x) => x.slug !== p.slug && sameWorld(x, p) && !SECONDARY.includes(x.slug) && onSale(x) && !isAcc(x) && unitPriceOf(x) >= gap).sort((a, b) => unitPriceOf(a) - unitPriceOf(b))[0] : null;
    const nextTxt = !next ? '' : got.length
      ? `${the(next)} ${strike(giftValue(next))} s’y ajoute${plural(GIFT_SHORT[P.indexOf(next)]) ? 'nt' : ''} dès ${price(next.seuil)} de meubles.`
      : add ? `Avec ${esc(add.nom)} (${price(unitPriceOf(add))}), ${lc1(the(next))} ${strike(giftValue(next))} ${offert(next)}.`
      : `${the(next)} ${strike(giftValue(next))} ${offert(next)} dès ${price(next.seuil)} de meubles.`;
    const saved = giftsSaved(got);
    if (!got.length) return next ? `<div class="fp-gift fp-gift--next"><p class="fp-gift__next">${giftPic(next, 'fp-gift__mini')}<span>${nextTxt} ${voir}</span></p></div>` : '';
    return `<div class="fp-gift">
      <div class="fp-gift__pics">${got.map((pl) => giftPic(pl, 'fp-gift__pic')).join('')}</div>
      <div class="fp-gift__txt">
        <p class="fp-gift__t"><b>Offerts avec ${esc(p.nom)}</b> : ${andList(got.map((pl) => `${esc(pl.cadeau)} ${strike(giftValue(pl))}`))}.</p>
        ${saved ? `<p class="fp-gift__save">Vous économisez <b class="num">${price(saved)}</b>. ${voir}</p>` : `<p class="fp-gift__save">${voir}</p>`}
        ${next ? `<p class="fp-gift__next">${giftPic(next, 'fp-gift__mini')}<span>${nextTxt}</span></p>` : ''}
      </div>
    </div>`;
  }
  /* Le salon assorti de la pièce (canapés) : la pièce dans la couleur choisie + son fauteuil, le total, ce qui est offert,
     et l'ajout des deux d'un clic */
  function salonBlock(p, color) {
    if (p.collection !== 'canapes') return '';
    const e = ensFor(p.slug);
    if (!e) return '';
    const i = ENS.indexOf(e), total = ensTotal(e), g = giftsFor(total), saved = giftsSaved(g);
    const P = SITE.paliers;
    const many = g.length > 1 || (g.length && plural(GIFT_SHORT[P.indexOf(g[0])]));
    const thumb = (slug, c, first) => `<a class="fp-ens__pic" href="#/p/${slug}" aria-label="${esc(BY[slug].nom)}"${first ? ' data-ens-first' : ''}>${pieceFit(BY[slug], c, 72)}</a>`;
    return `<div class="fp-ens">
      <div class="fp-ens__pics">${e.items.map(([s, c], k) => thumb(s, k ? c : color, !k)).join('<span class="fp-ens__plus" aria-hidden="true">+</span>')}</div>
      <div class="fp-ens__txt">
        <p class="fp-ens__t"><b>${esc(e.nom)}</b> : ${esc(andList(e.items.map(([s]) => BY[s].nom)))}, <span class="num">${price(total)}</span></p>
        ${g.length ? `<p class="fp-ens__g">${esc(cap1(andList(g.map((pl) => GIFT_SHORT[P.indexOf(pl)]))))} offert${many ? 's' : ''}${saved ? ` ${strike(saved)}` : ''}</p>` : ''}
      </div>
      <button class="pill fp-ens__add" type="button" data-action="ens-add" data-i="${i}" data-pdp="1"><span class="cta__label">Ajouter les deux</span></button>
    </div>`;
  }

  /* Cadeaux débloqués par la pièce seule, puis le palier suivant ; le lien mène aux cadeaux en photos (#/cadeaux) */
  function giftsTxt(p) {
    const P = SITE.paliers, v = unitPriceOf(p);
    const got = P.filter((pl) => v >= pl.seuil), next = P.find((pl) => v < pl.seuil);
    const k = next ? P.indexOf(next) : -1;
    const voir = GIFTS && GIFTS.paliers ? ` <a class="fp-inline" href="#/cadeaux">Voir les cadeaux</a>` : '';
    if (got.length) return `<b>Offerts avec ${esc(p.nom)}</b> : ${esc(andList(got.map((pl) => pl.cadeau)))}.${next ? ` Le ${GIFT_SHORT[k]} s’y ajoute dès ${price(next.seuil)} d’achat.` : ''}${voir}`;
    if (p.slug === 'veilleuse') return '<b>Repose-pieds assorti compris</b>, dans le même colis que le fauteuil.';
    /* À moins de 300 € du premier palier : la pièce assortie la moins chère qui le débloque (jamais une pièce secondaire) */
    const gap = P[0].seuil - v;
    const add = gap <= 300 ? PRODS.filter((x) => x.slug !== p.slug && sameWorld(x, p) && !SECONDARY.includes(x.slug) && !notYet(x) && unitPriceOf(x) >= gap).sort((a, b) => unitPriceOf(a) - unitPriceOf(b))[0] : null;
    if (add) return `<b>Ajoutez ${esc(add.nom)} (${price(unitPriceOf(add))})</b> : ${esc(P[0].cadeau)} vous sont offerts.${voir}`;
    return `<b>Offerts dès ${price(P[0].seuil)} d’achat</b> : ${esc(P[0].cadeau)}. Puis le ${GIFT_SHORT[1]} dès ${price(P[1].seuil)}, le ${GIFT_SHORT[2]} dès ${price(P[2].seuil)}.${voir}`;
  }

  /* « Avec un chat », « Avec des enfants » : deux questions de la FAQ, dites en positif
     (une pièce dont le catalogue pose déjà la question ne la reçoit pas deux fois) */
  function petsKids(p) {
    const m = p.matiere.toLowerCase();
    const asked = (re) => p.faq.some(([q]) => re.test(q));
    if (p.slug === 'table-nuage') return [['Et avec des enfants ?', 'Un plateau tout en courbes, sans angle vif. Le blanc laqué se nettoie d’un coup d’éponge.']];
    if (p.collection === 'decoration' || p.collection === 'sleep') return [];
    if (p.slug === 'veilleuse') return [['Et avec bébé ?', matOf(p) ? 'Une goutte de lait se tamponne tout de suite, avec les gestes d’entretien plus haut : le tissu reste net nuit après nuit.' : 'Une goutte de lait se tamponne tout de suite au chiffon humide, avec un peu de savon de Marseille, sans frotter. Le tissu reste net nuit après nuit.']];
    let chat;
    /* aucune promesse sur les griffes (dossiers produit) : la place du chat, le geste si un fil se tire, la brosse */
    if (/teddy|moumoute/.test(m)) chat = 'Un plaid sur le dossier devient vite sa place préférée. La moumoute a un poil court et bouclé : un coup de brosse douce enlève les poils et lui garde son gonflant.';
    else if (/boucl|mouton|sherpa/.test(m)) chat = 'Un plaid sur le dossier devient vite sa place préférée ; une boucle tirée se recoupe aux ciseaux, sans tirer. Les poils partent d’un coup de brosse douce.';
    else chat = 'Un plaid sur le dossier devient vite sa place préférée ; un fil tiré se recoupe aux ciseaux, sans tirer. Les poils partent d’un coup de brosse douce.';
    const plaid = unitPriceOf(p) >= SITE.paliers[1].seuil ? `Le plaid offert avec ${p.nom} protège l’assise des petites mains.` : `Le plaid, offert dès ${price(SITE.paliers[1].seuil)} d’achat, protège l’assise des petites mains.`;
    const care = !!matOf(p);
    if (care) chat = 'Un plaid sur le dossier devient vite sa place préférée. Un fil tiré, des poils : les gestes d’entretien, plus haut, suffisent.';
    const kids = care ? plaid : `Une tache se tamponne au chiffon humide, avec un peu de savon de Marseille, sans frotter. ${plaid}`;
    return [asked(/chat/i) ? null : ['Et avec un chat ?', chat], asked(/enfant/i) ? null : ['Et avec des enfants ?', kids]].filter(Boolean);
  }

  /* ---------------- Le confort, mesuré (avec ce que dit la science) ----------------
     Une seule section : les mesures, chacune sur une règle graduée, la phrase qui la traduit,
     puis la ligne de science qui l'explique. Les autres faits de sante.json suivent, sans jamais
     redire une phrase déjà écrite sur la fiche (points forts compris). */
  const norm = (t) => String(t || '').toLowerCase().replace(/[’']/g, ' ').replace(/[^a-z0-9àâçéèêëîïôûùüÿœ]+/g, ' ').trim();
  const lead1 = (t) => (norm(t).match(/^\d+(?: \d+)? cm/) || [''])[0];
  /* faits de mesure : « Assise à 40 cm du sol », « 52 cm de profondeur d'assise » */
  const isHsFact = (f) => /du sol/i.test(f.fait);
  const isPrFact = (f) => /profondeur/i.test(f.fait);
  /* points forts montrés dans « de près » : sans ceux qui redisent une mesure déjà montrée plus haut */
  /* Un même sujet n'est traité qu'une fois sur la fiche :
     - le tissu appartient à « de près » (le toucher) : ses faits de science n'y sont pas répétés ;
     - un fait de science qui reprend la mesure d'un point fort (« 277 cm… ») laisse la place au point fort ;
     - un point fort qui reprend un fait de science (« Dossier ondulé ») ou la phrase d'accroche s'efface. */
  const FABRIC = /velours|chenille|boucl|teddy|\blin\b|sherpa|mouton|tissu/i;
  const STOP = new Set(['assise', 'assises', 'votre', 'vous', 'avec', 'dans', 'toute', 'tout', 'pieces', 'piece']);
  const keys = (t) => new Set(norm(t).split(' ').filter((w) => w.length >= 5 && !STOP.has(w)).map((w) => w.replace(/(es|s|e)$/, '')));
  const overlap = (a, b) => { const B = keys(b); return [...keys(a)].some((k) => B.has(k)); };
  function sciFacts(p, S) {
    const x = S && S.pieces && S.pieces[p.slug];
    if (!x || x.blocScience === false) return { x: null, faits: [], rest: [] };
    const seat = isSeat(p);
    const fortsLead = new Set((p.forts || []).map((f) => lead1(f.fait)).filter(Boolean));
    const fortsTxt = new Set((p.forts || []).map((f) => norm(f.consequence)));
    const rest = x.faits.filter((f) => !(seat && (isHsFact(f) || isPrFact(f))) && !(p.toucher && FABRIC.test(f.fait))
      && !fortsTxt.has(norm(f.pourVous)) && !(lead1(f.fait) && fortsLead.has(lead1(f.fait))));
    return { x, faits: x.faits, rest };
  }
  function storyForts(p, S) {
    const D = p.dimensions, { x, rest } = sciFacts(p, S);
    const acc = x && x.accroche ? norm(x.accroche) : '';
    return (p.forts || []).filter((f) => !(isSeat(p) && ((D.hauteurAssise && /du sol/i.test(f.fait)) || (D.profondeurAssise && /profondeur/i.test(f.fait))))
      && !rest.some((r) => overlap(r.fait, f.fait))
      && !(acc && lead1(f.fait) && acc.includes(lead1(f.fait))));
  }
  const fortsHtml = (forts) => (forts.length ? `<ul class="fp-forts" data-forts>${forts.map((f) => `<li><h3>${esc(f.fait)}</h3><p>${esc(f.consequence)}</p></li>`).join('')}</ul>` : '<ul class="fp-forts" data-forts hidden></ul>');
  function ruler({ lo, hi, v, me, refs = [], zones = [], label }) {
    const pos = (x) => ((Math.max(lo, Math.min(hi, x)) - lo) / (hi - lo)) * 100;
    const side = (x) => (pos(x) < 14 ? ' is-l' : pos(x) > 86 ? ' is-r' : '');
    return `<div class="fp-ruler" role="img" aria-label="${esc(label)}">
      <span class="fp-ruler__line"></span>
      ${zones.slice(1).map((z) => `<span class="fp-ruler__tick" style="left:${pos(z[0]).toFixed(1)}%"></span>`).join('')}
      ${zones.map((z) => `<span class="fp-ruler__zone" style="left:${pos(z[0]).toFixed(1)}%;width:${(pos(z[1]) - pos(z[0])).toFixed(1)}%">${esc(z[2])}</span>`).join('')}
      ${refs.map(([x, t]) => `<span class="fp-ruler__mark fp-ruler__mark--ref${side(x)}" style="left:${pos(x).toFixed(1)}%"><i></i><em>${t}</em></span>`).join('')}
      <span class="fp-ruler__mark fp-ruler__mark--me${side(v)}" style="left:${pos(v).toFixed(1)}%"><i></i><em>${esc(me)}</em></span>
    </div>`;
  }
  const confItem = (k, v, unit, rl, txt, sci) => `<div class="fp-conf__item">
      <h3 class="fp-conf__k">${k}</h3>
      <p class="fp-conf__v num">${v}<small>${unit}</small></p>
      ${rl}
      <p class="fp-conf__p">${esc(txt)}</p>
      ${sci ? `<p class="fp-conf__sci">${esc(sci)}</p>` : '<span></span>'}
    </div>`;
  function confortHtml(p, S) {
    const { x, faits, rest: sciRest } = sciFacts(p, S);
    const sciOk = !!x;
    const D = p.dimensions, hs = D.hauteurAssise, pr = D.profondeurAssise;
    const items = [];
    const used = new Set((p.forts || []).map((f) => norm(f.consequence)));
    const shown = [];
    if (isSeat(p)) {
      const hsF = faits.find(isHsFact), prF = faits.find(isPrFact);
      const hTxt = hs >= 45 ? 'À hauteur de chaise : on s’assoit et on se relève sans effort.'
        : hs >= 41.5 ? 'Plus haut que la moyenne des canapés : on se relève sans effort.'
          : hs > 38 ? 'Un peu plus haut que la moyenne des canapés de salon.'
            : 'Plus bas que la moyenne des canapés : une assise de détente, où l’on se pose sans se tenir droit.';
      const t1 = hsF ? hsF.pourVous : hTxt;
      items.push(confItem('Hauteur d’assise', numFr(hs), 'cm', ruler({ lo: 30, hi: 52, v: hs, me: p.nom, refs: [[38, 'Salon, en moyenne<br>38 cm'], [45, 'Chaise<br>45 cm']], label: `${p.nom} : assise à ${numFr(hs)} cm. Sièges de salon, en moyenne : 38 cm. Chaise : environ 45 cm.` }), t1, hsF && hsF.science));
      used.add(norm(t1)); if (hsF) shown.push(hsF);
      if (pr) {
        const pTxt = pr <= 56 ? 'Assis au fond, le dos touche le dossier et les pieds restent à plat.'
          : pr <= 68 ? 'De quoi replier une jambe sous soi. Un coussin dans le dos, et l’on s’adosse droit.'
            : 'De quoi s’asseoir en tailleur ou s’allonger. Un coussin dans le dos, et l’on s’adosse droit.';
        const t2 = prF ? prF.pourVous : pTxt;
        items.push(confItem('Profondeur d’assise', numFr(pr), 'cm', ruler({ lo: 40, hi: 88, v: pr, me: p.nom, zones: [[40, 56, 'Assis droit'], [56, 68, 'Jambe pliée'], [68, 88, 'En tailleur']], label: `${p.nom} : ${numFr(pr)} cm de profondeur d’assise. Jusqu’à 56 cm, on s’assoit droit ; de 56 à 68 cm, on replie une jambe ; au-delà, on s’assoit en tailleur.` }), t2, prF && prF.science));
        used.add(norm(t2)); if (prF) shown.push(prF);
      }
      const fm = FERMETE[p.slug];
      if (fm && p.fermete) {
        items.push(confItem('Fermeté', p.fermete, 'sur 5', ruler({ lo: 1, hi: 5, v: p.fermete, me: p.nom, zones: [[1, 2.33, 'Moelleux'], [2.33, 3.67, 'Équilibré'], [3.67, 5, 'Ferme']], label: `Fermeté de ${p.nom} : ${p.fermete} sur 5.` }), `${fm[0]}. ${fm[1]}`, ''));
      } else if (D.hauteur - hs >= 12) {
        const up = Math.round(D.hauteur - hs);
        const txt = p.slug === 'veilleuse' ? `Dossier à oreilles, ${cm(up)} au-dessus de l’assise : il enveloppe le dos pendant la tétée.`
          : p.slug === 'berceuse' ? `Dossier capitonné de ${cm(up)} au-dessus de l’assise, coussin d’appui-tête compris.`
          : up >= 55 ? `Le dossier monte à ${cm(up)} au-dessus de l’assise : le dos est soutenu jusqu’aux épaules.`
            : D.hauteur <= 66 ? 'Un dossier bas : il laisse la pièce ouverte et la vue dégagée.'
              : `Le dossier monte à ${cm(up)} au-dessus de l’assise : il tient le bas${up >= 35 ? ' et le milieu' : ''} du dos.`;
        items.push(confItem('Hauteur totale', numFr(D.hauteur), 'cm', ruler({ lo: 55, hi: 95, v: D.hauteur, me: p.nom, zones: [[55, 66, 'Dossier bas'], [66, 85, 'Mi-dos'], [85, 95, 'Dossier haut']], label: `${p.nom} : ${numFr(D.hauteur)} cm de haut, dossier compris.` }), txt, ''));
        used.add(norm(txt));
      }
    }
    /* les autres faits : seulement ceux qui n'ont pas déjà été dits (même phrase, ou même mesure qu'un point fort) */
    const rest = sciRest.filter((f) => !shown.includes(f) && !used.has(norm(f.pourVous)));
    rest.forEach((f) => shown.push(f));
    if (!items.length && !rest.length) return '<section class="wrap fp-sec fp-conf" data-fp-conf hidden></section>';
    const ids = S ? [...new Set(shown.flatMap((f) => f.sources || []))].filter((id) => S.sources[id]) : [];
    const title = items.length ? 'Le confort, mesuré' : 'Ce que dit la science';
    /* le nombre de mesures annoncé est celui des mesures montrées (un banc n'en a qu'une : sa hauteur d'assise) */
    const lead = sciOk && x.accroche ? x.accroche
      : items.length > 1 ? `${['', '', 'Deux', 'Trois', 'Quatre'][items.length] || items.length} mesures font la sensation d’une assise. Les voici, à côté de repères que vous connaissez déjà.`
        : items.length ? 'Sa hauteur d’assise fait la sensation du siège. La voici, à côté de repères que vous connaissez déjà.' : '';
    return `<section class="wrap fp-sec fp-conf" data-fp-conf aria-labelledby="fp-conf-t">
      <div class="fp-sec__head">
        <h2 class="t-2 fp-h" id="fp-conf-t">${title}</h2>
        ${lead ? `<p class="lead">${esc(lead)}</p>` : ''}
      </div>
      ${items.length ? `<div class="fp-conf__grid" style="--n:${items.length}">${items.join('')}</div>` : ''}
      ${rest.length ? `<ul class="fp-conf__more">${rest.map((f) => `<li><h3>${esc(f.fait)}</h3><p>${esc(f.pourVous)}</p><p class="fp-conf__sci">${esc(f.science)}</p></li>`).join('')}</ul>` : ''}
      ${ids.length ? `<div class="fp-conf__src">${acc('Les études citées', `<ul class="fp-src">${ids.map((id) => { const s = S.sources[id]; return `<li>${s.lien ? `<a href="${esc(s.lien)}" target="_blank" rel="noopener">${esc(s.court)}</a>` : esc(s.court)}${s.resultat ? `<span>${esc(s.resultat)}</span>` : ''}</li>`; }).join('')}</ul>`)}</div>` : ''}
    </section>`;
  }

  /* ---------------- La matière (site/data/matieres.json) ----------------
     Sur chaque fiche de salon en tissu : un gros plan réel du tissu, dans la couleur choisie (photo de détail de sa galerie,
     ou recadrage d'une vraie photo), le toucher en mots simples et l'entretien en trois gestes. Rien d'inventé : les phrases
     reprennent les fiches et les dossiers produit. Sans gros plan pour la couleur, le bloc reste en texte seul. */
  const asset = (src, w) => ASSET(`/site/assets/${src}-${w}.webp`);
  const deN = (n) => (/^[aeiouyàâéèêîôœh]/i.test(n) ? 'd’' : 'de ') + n;
  function matOf(p) {
    const x = MAT && MAT.pieces && MAT.pieces[p.slug];
    const m = x && MAT.matieres && MAT.matieres[x.matiere];
    return m && !isSleep(p) ? { key: x.matiere, m, x } : null;
  }
  function matPic(p, k) {
    const o = matOf(p);
    if (!o) return null;
    const c = p.couleurs[k] || p.couleurs[0];
    const g = o.x.gros || {};
    const v = g[c.nom] || (c.cle && g[c.cle]);
    if (!v) return null;
    const alt = `${cap1(o.x.court || o.m.court)} ${deN(p.nom)} en ${c.nom}, de près`;
    return v.includes('/') ? { src: asset(v, 640), srcset: `${asset(v, 640)} 640w`, alt }
      : { src: photo(p, v, 1280), srcset: `${photo(p, v, 640)} 640w, ${photo(p, v, 1280)} 1280w`, alt };
  }
  const careHtml = (m) => `<ol class="mat-care">${m.entretien.map(([t, d]) => `<li><h4 class="mat-care__t">${esc(t)}</h4><p>${esc(d)}</p></li>`).join('')}</ol>`;
  function matiereHtml(p, k) {
    const o = matOf(p);
    if (!o) return '';
    const v = matPic(p, k);
    return `<section class="wrap fp-sec fp-mat${v ? '' : ' fp-mat--txt'}" data-mat aria-labelledby="fp-mat-t">
      <figure class="fp-mat__img"${v ? '' : ' hidden'}><img ${v ? `src="${v.src}" srcset="${v.srcset}" alt="${esc(v.alt)}"` : 'alt=""'} sizes="(max-width: 980px) calc(100vw - 32px), 40vw" data-mat-img loading="lazy" decoding="async"></figure>
      <div class="fp-mat__txt">
        <h2 class="t-2 fp-h" id="fp-mat-t">${esc(cap1(o.x.court || o.m.court))} ${esc(deN(p.nom))}</h2>
        <p class="fp-mat__touch">${esc(o.m.toucher)}</p>
        <h3 class="mat-h3">L’entretien, en trois gestes</h3>
        ${careHtml(o.m)}
        ${o.x.plus ? `<p class="fp-mat__plus">${esc(o.x.plus)}</p>` : ''}
        <p class="fp-mat__more"><a class="link" href="#/matieres?m=${o.key}">Nos matières, de près</a></p>
      </div>
    </section>`;
  }

  /* ---------------- Comment il arrive chez vous (site/data/livraison.json) ----------------
     Pièces compressées : les colis, l'ouverture, le temps exact de reprise de forme (recopié de la fiche, contrôlé par
     maquettes/outils/verifier-pages-valeur.js), la mise en place. Les photos d'étapes ne vont que sur la fiche de la pièce
     qu'elles montrent (Opaline, Nacre) ; les autres fiches renvoient à la page #/arrivee. */
  const arrOf = (p) => (ARR && ARR.pieces && ARR.pieces[p.slug]) || null;
  const stepOf = (id) => (ARR && ARR.etapes ? ARR.etapes.find((e) => e.id === id) : null);
  const colisN = (p) => Number((String(p.colis || '').match(/^\d+/) || [0])[0]);
  const isFem = (p) => /^(méridienne|chauffeuse)/i.test(p.type);
  const stepPic = (e, sizes) => `<img src="${asset(e.photo.src, 640)}" srcset="${asset(e.photo.src, 640)} 640w${e.photo.w > 640 ? `, ${asset(e.photo.src, 1280)} ${Math.min(1280, e.photo.w)}w` : ''}" sizes="${sizes}" alt="${esc(e.photo.alt)}" width="${e.photo.w}" height="${e.photo.h}" loading="lazy" decoding="async">`;
  function arrSteps(p, a) {
    const n = colisN(p), f = isFem(p);
    const dans = p.carton ? `Dans ${n > 1 ? 'les cartons' : 'le carton'} : ${esc(lc1(p.carton.map((t, i) => (i ? t.toLowerCase() : t)).join(', ')))}. ` : '';
    return [
      [n ? `${n} colis` : 'Ses colis', `${dans}${a.poids ? esc(a.poids) + '. ' : ''}${n === 1 ? 'Le colis a' : 'Chaque colis a'} son numéro de suivi.`],
      ['L’ouverture', 'Des ciseaux à bouts ronds pour ouvrir le film, en douceur.'],
      [a.forme, a.detail ? esc(a.detail) : `Le temps qu’${f ? 'elle' : 'il'} reprenne sa forme, une fois le carton ouvert.`],
      ['En place', esc(a.geste)]
    ];
  }
  function arriveeHtml(p) {
    const a = arrOf(p);
    if (!a || !a.compresse) return '';
    const pics = (a.photos || []).map(stepOf).filter((e) => e && e.photo);
    return `<div class="fp-arr">
        <h2 class="t-2 fp-h" id="fp-arr-t">Comment ${isFem(p) ? 'elle' : 'il'} arrive chez vous</h2>
        <ol class="fp-arr__steps">${arrSteps(p, a).map(([t, d], i) => `<li><h3 class="${i === 2 ? 'fp-arr__fig num' : 'fp-arr__t'}">${esc(t)}</h3><p>${d}</p></li>`).join('')}</ol>
        ${pics.length ? `<div class="fp-arr__pics" style="--n:${pics.length}">${pics.map((e) => `<figure>${stepPic(e, `(max-width: 760px) calc(100vw - 32px), ${Math.round(100 / pics.length)}vw`)}</figure>`).join('')}</div>` : ''}
        <p class="fp-arr__more"><a class="link" href="#/arrivee">Les étapes en photos</a></p>
      </div>`;
  }


  /* ---------------- Avis d'acheteurs de ce modèle (site/data/avis.json, construit par maquettes/outils/avis.py) ----------------
     Version légale validée par l'utilisateur le 07/10 (art. L111-7-2 et D111-17 du Code de la consommation) : avis laissés
     chez d'autres revendeurs du même modèle (avis.json > produits), traduits ; mêmes règles de retrait quelle que soit la note ;
     08/10 : section affichée dès 1 avis, quelle que soit la moyenne (les pièces signalées par avis.py ne sont pas dans avis.json) ;
     jamais de photo d'acheteur. Les avis d'acheteurs Caplia (avis.json > caplia) passent devant le jour où ils existent. Aucune donnée structurée d'avis, rien vers Google. */
  const AVIS_VUS = 4;
  const avisOf = (p) => {
    const c = AVIS && AVIS.caplia && AVIS.caplia[p.slug];
    if (c && c.nombre >= 2) return Object.assign({ caplia: true }, c);
    const a = AVIS && AVIS.produits && AVIS.produits[p.slug];
    return a && a.nombre >= 1 ? a : null;
  };
  const note1 = (n) => n.toFixed(1).replace('.', ',');
  const AVIS_STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"/></svg>';
  const stars = (n) => `<span class="stars" style="--fill:${Math.round((n / 5) * 100)}%" aria-hidden="true"><span class="stars__bg">${AVIS_STAR.repeat(5)}</span><span class="stars__fg">${AVIS_STAR.repeat(5)}</span></span>`;
  function avisRate(p) {
    const a = avisOf(p);
    return a ? `<button class="fp-rate" type="button" data-fp="avis">${stars(a.moyenne)}<span><b class="num">${note1(a.moyenne)}</b> · ${a.nombre} avis sur ce modèle</span></button>` : '';
  }
  function avisHtml(p) {
    const a = avisOf(p);
    if (!a) return '';
    const li = (x, i) => `<li class="fp-avis__it"${i >= AVIS_VUS ? ' hidden data-avis-more' : ''}>
          <p class="fp-avis__n">${stars(x.note)}<span class="sr-only">${x.note} sur 5</span></p>
          <blockquote class="fp-avis__q"><p>${esc(x.texte)}</p></blockquote>
          <p class="fp-avis__m">${esc(x.pays)} · ${esc(x.mois)}</p>
        </li>`;
    const reste = a.nombre - AVIS_VUS;
    /* 09/10 : provenance dite en clair à côté des avis, sans avoir à ouvrir « D’où viennent ces avis ? » (art. D111-17) */
    const src = a.caplia ? 'Avis de nos clients, après la livraison.' : 'Avis d’acheteurs de ce modèle chez d’autres revendeurs, traduits en français.';
    const how = a.caplia ? '' : `<details class="fp-avis__how">
          <summary>D’où viennent ces avis ?</summary>
          <p>Ce modèle est aussi vendu par d’autres revendeurs. Ces avis ont été laissés sur leurs sites par des acheteurs de ce modèle, là où seul un acheteur peut noter. Nous ne pouvons pas vérifier nous-mêmes ces achats.</p>
          <p>Nous les avons traduits en français, sans en changer le sens. Nous gardons toutes les notes, et nous appliquons les mêmes règles à chaque avis, quelle que soit sa note : nous laissons de côté ceux qui n’ont pas de texte ou tiennent en moins de trois mots, les textes en double, les propos grossiers, et ceux qui parlent du prix payé, du vendeur, du site ou de la livraison d’un autre revendeur, ou d’un autre produit. Nous n’affichons jamais les photos des acheteurs. Ils sont classés du plus récent au plus ancien.</p>
          <p>La note affichée est la moyenne des avis gardés. Ce ne sont pas les avis de nos clients : ceux-ci s’afficheront ici, à leur place.</p>
        </details>`;
    return `<section class="wrap fp-sec fp-avis" id="fp-avis" aria-labelledby="fp-avis-t">
      <div class="fp-avis__head">
        <h2 class="t-2 fp-h" id="fp-avis-t">Ils l’ont déjà chez eux</h2>
        <p class="fp-avis__sum">${stars(a.moyenne)}<span><b class="num">${note1(a.moyenne)}</b> · ${a.nombre} avis sur ce modèle</span></p>
        <p class="fp-avis__src">${src}</p>
        ${how}
      </div>
      <div class="fp-avis__body">
        <ul class="fp-avis__list">${a.avis.map(li).join('')}</ul>
        ${reste > 0 ? `<button class="pill fp-avis__more" type="button" data-fp="avis-more">Voir ${reste > 1 ? `les ${reste} autres avis` : 'l’autre avis'}</button>` : ''}
        ${a.reponse ? `<p class="fp-avis__rep"><b>Notre réponse</b>${esc(a.reponse)}</p>` : ''}
      </div>
    </section>`;
  }

  /* « Il passe chez vous » : colis, porte, escalier (canapés et grands fauteuils seulement, voir hasDoor) */
  /* Poids et cotes des colis : seulement quand le vendeur les donne (livraison.json > poids, carton_cm) ; jamais un chiffre estimé */
  const colisFacts = (p) => {
    const a = arrOf(p), c = cartonCm(p);
    if (!a || (!a.poids && !c)) return '';
    return `<p><b>Les colis</b> : ${a.poids ? esc(lc1(a.poids)) : ''}${a.poids && c ? ' ; ' : ''}${c ? `le plus grand mesure ${dims3(c)}` : ''}.</p>`;
  };
  const cartonTxt = (p) => (p.carton ? `Dans le carton : ${esc(lc1(p.carton.map((t, i) => (i ? t.toLowerCase() : t)).join(', ')))}. ` : '');
  function passeHtml(p) {
    const arr = arriveeHtml(p);
    if (!hasDoor(p)) return arr ? `<section class="wrap fp-sec fp-passe fp-passe--arr" id="fp-arrivee" aria-labelledby="fp-arr-t">${arr}</section>` : '';
    const e = easyIn(p);
    const D = p.dimensions;
    const H = arr ? 'h3' : 'h2';
    return `<section class="wrap fp-sec fp-passe${arr ? ' fp-passe--arr' : ''}" id="fp-passe" aria-labelledby="${arr ? 'fp-arr-t' : 'fp-passe-t'}">
      ${arr}
      <div class="fp-passe__txt">
        <${H} class="${arr ? 't-3' : 't-2'} fp-h" id="fp-passe-t">${doorMin(p) == null ? `Passera-t-${isFem(p) ? 'elle' : 'il'} chez vous${NB}?` : `${isFem(p) ? 'Elle' : 'Il'} passe chez vous`}</${H}>
        ${arr ? '' : `<p class="fp-passe__p">${e ? `<b>${esc(e[0])}.</b> ${esc(e[1])}` : `<b>Sa plus petite mesure : ${cm(Math.min(D.largeur, D.profondeur, D.hauteur))}.</b> De profil, ${isFem(p) ? 'elle' : 'il'} passe une porte de ${cm(Math.ceil(minDim(p) + 2))}.`} ${cartonTxt(p)}${colisN(p) === 1 ? 'Le colis a' : 'Chaque colis a'} son numéro de suivi.</p>`}
      </div>
      <div class="fp-passe__check">
        <form class="fp-door" data-door novalidate>
          <div class="field">
            <label for="door-w">Largeur de votre porte la plus étroite, en cm</label>
            <div class="fp-door__row">
              <input id="door-w" name="w" type="number" inputmode="numeric" min="30" max="300" placeholder="Par exemple 73">
              <button class="btn fp-door__go" type="submit">Vérifier</button>
            </div>
          </div>
          <p class="fp-door__msg" data-door-msg aria-live="polite" hidden></p>
        </form>
      </div>
    </section>`;
  }
  /* Photo de « de près » : une vraie photo de la couleur choisie, autre que la première de la galerie
     (jamais celle d'une autre couleur). Sans seconde photo, la section reste en texte seul. */
  function storyPic(p, k) {
    const c = p.couleurs[k] || p.couleurs[0];
    /* le gros plan du tissu appartient au bloc « la matière » : jamais deux fois la même photo sur la fiche */
    const o = matOf(p), gid = o && o.x.gros ? (o.x.gros[c.nom] || (c.cle && o.x.gros[c.cle]) || '') : '';
    if (p.couleurs.length > 1) {
      const im = colorPhotos(p, c).slice(1).find((x) => x.id !== gid);
      return im ? { src: photo(p, im.id, 1280), alt: im.alt } : null;
    }
    const imgs = okImages(p).filter((im) => im.id !== gid), tid = TABLEAU[p.slug];
    const touchIm = imgs.find((im) => /^(Détail|Une main)/.test(im.alt));
    if (touchIm) return { src: photo(p, touchIm.id, 1280), alt: touchIm.alt };
    if (tid && tid !== 'causeuse-arches' && p.tableau) return { src: tab(tid, 'portrait-1080'), alt: p.tableau.alt };
    const im = imgs[1] || imgs[0];
    return im ? { src: photo(p, im.id, 1280), alt: im.alt } : null;
  }

  /* ---------------- Galerie d'une couleur ----------------
     Règles (audit n° 2 et supervision du 05/10) : une fiche ne montre que la couleur choisie, toujours dans cet ordre :
     1. les vraies photos de la couleur (galeries.json, dans l'ordre donné : la vraie pièce dans le studio gris,
        l'ambiance, les gros plans, les autres vues ; _communes à la fin, jamais _retirees) ;
     2. le plan coté dessiné (planSVG).
     Jamais d'image de synthèse (ni vue 3D, ni rendu studio) : s'il manque des photos, la galerie en montre moins. */
  const GAL_SIZES = '(max-width: 980px) 100vw, min(58vw, 800px)';
  const colorSlug = (n) => String(n).toLowerCase().replace(/œ/g, 'oe').replace(/æ/g, 'ae').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const photoPic = (p, im, eager) => `<picture>
      <source type="image/avif" srcset="${GAL_SRCSET(p, im.id, 'avif')}" sizes="${GAL_SIZES}">
      <img src="${photo(p, im.id, 1280)}" srcset="${GAL_SRCSET(p, im.id)}" sizes="${GAL_SIZES}" alt="${esc(im.alt)}" ${eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy" fetchpriority="low"'} decoding="async" draggable="false">
    </picture>`;
  const thumbImg = (src, cls = '') => `<img${cls ? ` class="${cls}"` : ''} src="${src}" alt="" loading="lazy" fetchpriority="low" decoding="async" draggable="false">`;
  const retirees = (p) => new Set(((GALERIES[p.slug] || {})._retirees || []).map((r) => (typeof r === 'string' ? r : r.id)));
  /* photos du catalogue encore montrables (sans les retirées) */
  /* schéma des dimensions (« Dimensions de … ») : seulement dans la galerie, jamais comme photo de la pièce ailleurs */
  const isDimsAlt = (alt) => /^Dimensions d(e |’)/.test(alt || '');
  const okImages = (p) => { const out = retirees(p); return p.images.filter((im) => !out.has(im.id) && !isDimsAlt(im.alt)); };
  function colorPhotos(p, c, withDims) {
    const g = GALERIES[p.slug], out = retirees(p);
    /* « cle » : l'ancien nom de la couleur, encore utilisé par galeries.json quand le nom affiché a changé */
    const ids = g ? [...(g[c.nom] || (c.cle && g[c.cle]) || []), ...(g._communes || [])]
      : c.image ? [c.image] : p.couleurs.length === 1 ? p.images.map((im) => im.id) : [];
    return ids.filter((id, i, a) => !out.has(id) && a.indexOf(id) === i).map((id) => {
      const im = p.images.find((x) => x.id === id);
      return { id, alt: im ? im.alt : `${p.nom} en ${c.nom}` };
    }).filter((im) => withDims || !isDimsAlt(im.alt));
  }
  function gallerySlides(p, k) {
    const c = p.couleurs[k] || p.couleurs[0];
    const s = [];
    const all = colorPhotos(p, c, true);
    const photoSlide = (im) => ({ kind: 'photo', key: 'p' + im.id, id: im.id, html: photoPic(p, im, !s.length), label: im.alt, thumb: thumbImg(photo(p, im.id, 300)), zoom: photo(p, im.id, 1280), scene: isScene(im.alt) });
    const plan = { kind: 'plan', key: 'plan', html: `<div class="fp-plan">${planSVG(p)}${planSVG(p, true)}</div>`, label: `Plan coté de ${p.nom}`, thumb: `<span class="fp-thumb__plan" aria-hidden="true">${planSVG(p)}</span><span class="fp-thumb__lbl" aria-hidden="true">Cotes</span>` };
    /* ordre (refonte du 07/10, direction photo, avec les règles strictes de marketing/CONSIGNE-GALERIES-2026-10-07-STRICT.md) :
       la pièce dans une vraie pièce d'abord (photo du vendeur, sans personne), la vidéo du vendeur, la pièce seule sur
       fond clair, les gros plans du tissu, les autres photos en situation, et EN DERNIER le schéma des dimensions avec
       le repère d'1,75 m (photo « Dimensions de … »), ou à défaut le plan coté. Une couleur sans photo en situation
       s'ouvre sur la pièce seule. */
    const dims = all.find((im) => isDimsAlt(im.alt));
    const pics = all.filter((im) => im !== dims);
    const l0 = leadOf(p, c), lead = l0 && pics.find((im) => im.id === l0.id);
    if (lead) s.push(photoSlide(lead));
    const v = p.video;
    if (v && v.src && (!v.couleur || v.couleur === c.nom)) {
      s.push({ kind: 'video', key: 'video', label: v.label || `Vidéo de ${p.nom}`,
        html: `<video class="fp-video" muted loop playsinline disablepictureinpicture preload="none" poster="${esc(v.poster || '')}" data-src="${esc(v.src)}" aria-label="${esc(v.label || `Vidéo de ${p.nom}`)}"${reduce ? ' controls' : ''}></video>`,
        thumb: `${thumbImg(v.poster || '')}<span class="fp-thumb__play" aria-hidden="true"></span>` });
    }
    restOrder(pics, lead).forEach((im) => s.push(photoSlide(im)));
    if (dims) s.push({ ...photoSlide(dims), thumb: thumbImg(photo(p, dims.id, 300), 'fp-thumb__dims') });
    else s.push(plan);
    return mosaic(p, s);
  }
  /* Mosaïque de l'ordinateur (refonte.css, 2 colonnes de cases 4:3) : une photo dont la pièce ne tient pas entière dans une
     case 4:3 prend toute la largeur, à son propre format (fp-slide--own) ; la case restée seule avant elle, ou en fin de
     liste, prend toute la largeur (fp-slide--row). Vignettes du téléphone : chacune au format de sa photo (--own). */
  function mosaic(p, s) {
    let col = 0, prev = null;
    s.forEach((x, i) => {
      const b = x.id && x.kind === 'photo' ? (CADRAGE[p.slug] || {})[x.id] : null;
      if (b) x.own = b[0];
      if (i === 0 || x.kind === 'plan') return;
      if (b && !closeUp(x.label) && !isDimsAlt(x.label) && !fitsIn(b, 4 / 3)) { if (prev) prev.lay = 'row'; x.lay = 'own'; col = 0; prev = null; return; }
      col = 1 - col; prev = col ? x : null;
    });
    if (prev) prev.lay = 'row';
    return s;
  }
  const ownCss = (s) => (s.own ? ` style="--own:${s.own.toFixed(3)}"` : '');
  const slideHtml = (p, s, i) => `<figure class="fp-slide fp-slide--${s.kind}${s.lay ? ` fp-slide--${s.lay}` : ''}" data-i="${i}"${s.id ? ` data-photo="${esc(s.id)}"` : ''}${ownCss(s)} role="group" aria-label="${esc(s.label)}">${s.html}</figure>`;
  const thumbHtml = (s, i, cur) => `<button class="fp-thumb fp-thumb--${s.kind}" type="button" role="tab" aria-selected="${i === cur}" data-fp="go" data-i="${i}"${s.id ? ` data-photo="${esc(s.id)}"` : ''}${ownCss(s)} aria-label="${esc(s.label)}">${s.thumb}</button>`;

  /* ---------------- Cadrage des photos de la galerie ----------------
     Règle de l'utilisateur : la pièce se voit en entier, jamais coupée. Le cadre change de proportion selon l'écran
     (presque carré sur grand écran, plus large à 1440 × 900, 4:3 au téléphone) : chaque photo le remplit autant que
     possible SANS que la boîte de la pièce (cadrage-photos.json) en sorte. Une photo qui remplit déjà le cadre sans rien
     couper garde son rendu (cover, centrée) ; sinon elle est un peu moins agrandie, décalée vers la pièce si besoin,
     et le studio gris finit le cadre. Les gros plans (« Détail… », « Une main… ») remplissent toujours le cadre.
     Photo absente de cadrage-photos.json : elle reste entière à 1,5 % près. */
  const FIT_MARGE = 0.01, FIT_INCONNU = 0.015;
  const closeUp = (alt) => /^(Détail|Une main)/.test(alt || '');
  /* Photo « en situation » : la pièce dans une vraie pièce, d'après son texte alternatif (galeries.json n'y garde aucune
     personne). SCENE_PICK : la plus belle quand la première de la liste ne l'est pas (relu photo par photo le 07/10). */
  const isScene = (alt) => !closeUp(alt) && /\b(dans (un|une|la|le)|pos[ée]+ contre|devant (un|une)|au pied d|sur (un|une) (canapé|lit|console)|près d['’]un)/i.test(alt || '');
  const SCENE_PICK = { dune: ['60', '61'], 'chauffeuse-dossier': ['50', '60'], 'petit-mouton': ['60', '54'], 'plaid-sherpa': ['52', '50'] };
  const isGen = (im) => !!im && /^k\d+$/.test(im.id);   /* image d'ambiance générée (KSCENES) */
  /* ordre des photos après la 1re (galerie de la fiche, photos des cartes) : la pièce seule sur fond clair, les gros plans
     du tissu, les autres photos en situation, les images d'ambiance */
  const restOrder = (pics, lead) => {
    const rest = pics.filter((im) => im !== lead);
    return [...rest.filter((im) => !closeUp(im.alt) && !isScene(im.alt) && !isGen(im)), ...rest.filter((im) => closeUp(im.alt)),
      ...rest.filter((im) => isScene(im.alt) && !isGen(im)), ...rest.filter(isGen)];
  };
  /* 08/10 : photos en situation où le VENDEUR a coupé la pièce (bord de la photo d'origine sur la pièce, boîte de
     cadrage-photos.json au bord, vérifié à l'œil) : jamais en 1re photo ni sur les cartes, elles restent plus loin dans la
     galerie. Sans autre photo en situation entière, la couleur s'ouvre sur la pièce seule sur fond clair. */
  const SCENE_COUPEE = { 'bulle-294': ['50', '51', '53', '54'], 'grand-arrondi': ['50'], 'chauffeuse-2-places': ['50'], 'tete-de-lit-murale': ['50'], 'tete-de-lit-boudins': ['50'], 'convertible-tiroir': ['50'], 'angle-convertible-effet-lin': ['50'] };
  const coupee = (p, im) => (SCENE_COUPEE[p.slug] || []).includes(im.id);
  function sceneOf(p, list) {
    const sc = list.filter((im) => isScene(im.alt) && !isGen(im) && !coupee(p, im));
    const want = SCENE_PICK[p.slug];
    return (want && want.map((id) => sc.find((im) => im.id === id)).find(Boolean)) || sc[0] || null;
  }
  /* Les photos en situation d'une pièce dans une couleur (la 1re = celle des cartes et des fiches), sinon [] */
  function scenesFor(p, colorName) {
    const c = p.couleurs.find((x) => x.nom === colorName) || p.couleurs[firstIn(p)];
    const all = colorPhotos(p, c), lead = sceneOf(p, all);
    return lead ? [lead, ...all.filter((im) => im !== lead && isScene(im.alt) && !isGen(im) && !coupee(p, im))] : [];
  }
  /* l'image d'ambiance générée d'une pièce dans une couleur (survol des cartes, moment « la pièce »), sinon null */
  function genFor(p, colorName) {
    const c = p.couleurs.find((x) => x.nom === colorName) || p.couleurs[firstIn(p)];
    return colorPhotos(p, c).find(isGen) || null;
  }
  /* taille et place de la photo (px) dans un cadre w × h ; null = rendu par défaut */
  function photoFit(slug, id, alt, w, h, nat) {
    const c = (CADRAGE[slug] || {})[id];
    const N = c ? c[0] : nat;
    if (!N || !w || !h || closeUp(alt)) return null;
    const m = c ? FIT_MARGE : 0, b = c ? c.slice(1) : [FIT_INCONNU, FIT_INCONNU, 1 - FIT_INCONNU, 1 - FIT_INCONNU];
    const x0 = Math.max(0, b[0] - m), y0 = Math.max(0, b[1] - m), x1 = Math.min(1, b[2] + m), y1 = Math.min(1, b[3] + m);
    const cover = Math.max(w, h * N), contain = Math.min(w, h * N);
    /* 07/10 (règles strictes) : jamais de bande autour d'une photo, elle remplit toujours le cadre (recadrée, jamais
       déformée), décalée vers la pièce ; seul le schéma des dimensions reste entier (son fond est celui du studio) */
    /* 08/10 : quand la pièce ne tiendrait pas entière dans le cadre (photo du vendeur cadrée serré, format très
       différent du cadre commun du téléphone), la photo est réduite juste assez pour la garder entière ; le reste du
       cadre prend les couleurs de ses bords (bords-photos, fitOne). Jamais plus petite que la photo entière. */
    let W = isDimsAlt(alt) ? contain : cover;
    const need = c ? Math.max((x1 - x0) * W / w, (y1 - y0) * (W / N) / h) : 1;
    if (need > 1.001) W = Math.max(contain, W / need);
    const H = W / N;
    /* centrée comme avant, décalée juste assez pour garder la pièce ; plus petite que le cadre : centrée */
    /* cadrages du 07/10 : si la boîte de la pièce ne tient pas dans le cadre (photo sans boîte mesurée, boîte presque
       pleine), la photo se centre sur la boîte au lieu de se caler sur son bord droit */
    const at = (f, z, a0, a1) => (z <= f ? (f - z) / 2 : (a1 - a0) * z > f ? Math.min(0, Math.max(f - z, f / 2 - (a0 + a1) / 2 * z)) : Math.min(Math.max((f - z) / 2, f - z, -a0 * z), 0, f - a1 * z));
    const L = at(w, W, x0, x1), T = at(h, H, y0, y1);
    if (W >= cover - 0.05 && Math.abs(L - (w - W) / 2) < 0.05 && Math.abs(T - (h - H) / 2) < 0.05) return null;
    return { W, H, L, T };
  }
  function fitOne(box, img, slug) {
    if (!box || !img) return;
    const w = box.clientWidth, h = box.clientHeight;
    const nat = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 0;
    if (!nat && !(CADRAGE[slug] || {})[box.dataset.photo]) { img.addEventListener('load', () => fitOne(box, img, slug), { once: true }); return; }
    const f = photoFit(slug, box.dataset.photo, img.alt || box.getAttribute('aria-label'), w, h, nat);
    box.classList.toggle('is-fit', !!f);
    img.style.cssText = f ? `width:${(f.W / w * 100).toFixed(2)}%;height:${(f.H / h * 100).toFixed(2)}%;left:${(f.L / w * 100).toFixed(2)}%;top:${(f.T / h * 100).toFixed(2)}%` : '';
    /* photo réduite pour garder la pièce entière (08/10) : le cadre prend les couleurs de ses bords, mur en haut et sol en
       bas (ou les deux côtés), au lieu du studio gris ; le schéma des dimensions garde le studio */
    const bd = ((CADRAGE[slug] || {})[box.dataset.photo] || [])[5];
    const bande = f && bd && !isDimsAlt(img.alt || box.getAttribute('aria-label')) && (f.W < w - 1 || f.H < h - 1);
    if (bande) {
      /* bord où la pièce touche la photo (cadrée serré par le vendeur) : la couleur du bord opposé, pas celle de la pièce */
      const k = CADRAGE[slug][box.dataset.photo], e = bd.split(','), v = f.H < h - 1;
      const t = k[2] <= .01 ? e[1] : e[0], b = k[4] >= .99 ? t : e[1], l = k[1] <= .01 ? e[3] : e[2], r = k[3] >= .99 ? l : e[3]; box.style.background = v ? `linear-gradient(${t} 50%, ${b} 50%)` : `linear-gradient(90deg, ${l} 50%, ${r} 50%)`; box.dataset.bande = v ? 'v' : 'h'; }
    else { box.style.removeProperty('background'); delete box.dataset.bande; }
  }
  /* toutes les photos de la galerie visible (diapositives et vignettes) */
  function fitGallery() {
    const p = PDP.p;
    if (!p) return;
    /* 08/10 : et la grande photo « la pièce » sous la galerie (mo__full) */
    $$('[data-fp-track] .fp-slide[data-photo], .fp-thumbs .fp-thumb[data-photo], .mo__full[data-photo]').forEach((box) => fitOne(box, $('img', box), p.slug));
  }
  /* Choix de taille de la fiche : une taille épuisée dans la couleur choisie est barrée et ne se choisit pas */
  const sizePill = (t, k, checked, color) => { const out = sizeOutFor(t, color); return `<button class="pill pill--sm${out ? ' is-out' : ''}" type="button" role="radio" aria-checked="${checked}" data-action="pdp-size" data-k="${k}"${out ? ' disabled' : ''}>${esc(t.nom)}<small>${price(t.prix)}</small>${out ? '<span class="sr-only">, épuisée dans cette couleur</span>' : ''}</button>`; };

  /* Identification du produit (règlement GPSR, art. 19) : référence Caplia de la variante choisie, type et image de la pièce.
     catalogue.json : securite.identifiant = CAP-<NOM> (modèle), couleurs[].ref = CAP-<NOM>-<COULEUR>, tailles[].ref = suffixe.
     Jamais de numéro d'annonce ni de code-barres du fabricant ici (règle des jumeaux) : ils restent dans sourcing.json. */
  const refBase = (p) => (/^CAP-/.test((p.securite && p.securite.identifiant) || '') ? p.securite.identifiant
    : 'CAP-' + p.nom.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, '-'));
  function refOf(p, k, sz) {
    const c = p.couleurs[k] || p.couleurs[0], t = p.tailles && p.tailles[sz];
    return (/^CAP-/.test(c.ref || '') ? c.ref : refBase(p)) + (t && t.ref ? '-' + t.ref : '');
  }
  const refVar = (p, k, sz) => [(p.couleurs[k] || p.couleurs[0]).nom, p.tailles && p.tailles[sz] ? p.tailles[sz].nom : ''].filter(Boolean).join(', ');
  const refHtml = (p, k, sz) => {
    const c = p.couleurs[k] || p.couleurs[0];
    return `<div class="fp-ref__row"><span class="fp-ref__th" role="img" aria-label="${esc(`${p.nom} en ${c.nom}`)}" data-ref-th>${tightThumb(p, c.nom)}</span>
      <p><span data-ref-id>${esc(refOf(p, k, sz))}</span><br>${esc(p.type)}<br><span data-ref-var>${esc(refVar(p, k, sz))}</span></p></div>`;
  };
  /* la référence suit la couleur et la taille choisies */
  function refSync() {
    const p = PDP.p, box = $('.fp-ref');
    if (!p || !box) return;
    const id = $('[data-ref-id]', box), v = $('[data-ref-var]', box), th = $('[data-ref-th]', box), c = p.couleurs[PDP.color] || p.couleurs[0];
    if (id) id.textContent = refOf(p, PDP.color, PDP.size);
    if (v) v.textContent = refVar(p, PDP.color, PDP.size);
    if (th && th.dataset.c !== c.nom) { th.dataset.c = c.nom; th.innerHTML = fr(tightThumb(p, c.nom)); th.setAttribute('aria-label', `${p.nom} en ${c.nom}`); }
  }

  /* ---------------- Fiche épurée (06/10/2026) : petits morceaux du premier écran et des volets ---------------- */
  /* Paiement en 4X PayPal (contrat PayPal FR lu le 08/10/2026 : TAEG 0 %, frais de défaut de paiement « Aucun »,
     de 20 à 3 000 €). Seul le message officiel de PayPal est affiché (SDK « messages » de PayPal, compte PayPal de Caplia),
     jamais un texte fait main. Offre forcée sur le 4X (PAY_LATER_SHORT_TERM) : sans elle, PayPal annonce aussi les 6, 12
     ou 24 mensualités avec intérêts, refusées par Caplia.
     Il n'apparaît que si le paiement Shopify propose vraiment le 4X : bouton PayPal « paylater » éligible dans le SDK des
     boutons de Shopify (au 08/10/2026 : non, PayPal passe par Shopify Payments, qui ne propose pas le 4X). Alors seulement
     le SDK « messages » est chargé (l'app embed PayPal Pay Later Messaging est éteinte : elle ajoutait 40 Ko et son panneau
     de réglage à chaque page). Réponse gardée pour la session (le panier vide n'a pas le SDK des boutons) ; tant qu'elle est
     « non », rien ne s'affiche, rien ne se charge et rien ne bouge. */
  const PP4X_MIN = 20, PP4X_MAX = 3000, PP4X_KEY = 'caplia-pp4x';
  const PP4X_SDK = 'https://www.paypal.com/sdk/js?client-id=AbtXlp5R3xc83T9xW_ZXKTK8IVZ-14EMelDioU4VC285IqSuxUI4yotKxjV0sz_X6YsONYi10vSBPNKM&merchant-id=QLU3PDPLPQKSA&components=messages&currency=EUR';
  const ppMsgOk = () => !!(window.PayPalSDK && typeof window.PayPalSDK.Messages === 'function');
  function ppMsgLoad() {
    if (ppMsgOk()) return Promise.resolve(true);
    return new Promise((done) => {
      const s = document.createElement('script');
      s.src = PP4X_SDK; s.async = true; s.dataset.namespace = 'PayPalSDK';
      s.onload = () => done(ppMsgOk()); s.onerror = () => done(false);
      document.head.appendChild(s);
    });
  }
  let pp4xAsk = null;
  function pp4xEligible() {
    if (pp4xAsk) return pp4xAsk;
    pp4xAsk = new Promise((done) => {
      let n = 0;
      const tick = () => {
        const k = Object.keys(window).find((x) => x.startsWith('paypal-https') && x.includes('componentsbuttons'));
        const sdk = k && window[k];
        if (sdk && typeof sdk.Buttons === 'function') {
          let ok = false;
          try { ok = sdk.Buttons({ fundingSource: sdk.FUNDING.PAYLATER }).isEligible(); } catch (e) { ok = false; }
          try { sessionStorage.setItem(PP4X_KEY, ok ? '1' : '0'); } catch (e) { /* stockage indisponible */ }
          return done(ok);
        }
        if (++n < 40) return setTimeout(tick, 250);
        let mem = null;
        try { mem = sessionStorage.getItem(PP4X_KEY); } catch (e) { /* stockage indisponible */ }
        pp4xAsk = null;   /* SDK des boutons absent (panier vide) : la prochaine page refera la vérification */
        done(mem === '1');
      };
      tick();
    }).then((ok) => (ok ? ppMsgLoad() : false));
    return pp4xAsk;
  }
  /* place (ou met à jour) le message officiel dans chaque [data-pp4x] présent, au montant porté par data-amount */
  function pp4xRender(root = document) {
    const slots = $$('[data-pp4x]', root);
    if (!slots.length) return;
    pp4xEligible().then((ok) => {
      slots.forEach((el) => {
        const amount = Number(el.dataset.amount);
        const show = ok && document.contains(el) && amount >= PP4X_MIN && amount <= PP4X_MAX;
        if (!show) { el.hidden = true; return; }
        if (el.dataset.done === String(amount)) return;
        el.dataset.done = String(amount);
        const box = document.createElement('div');   /* bloc neuf à chaque rendu : jamais deux messages ni l'ancien montant */
        el.replaceChildren(box);
        el.hidden = false;
        window.PayPalSDK.Messages({
          amount, currency: 'EUR', offer: 'PAY_LATER_SHORT_TERM', placement: el.dataset.place || 'product',
          style: { layout: 'text', logo: { type: 'inline' }, text: { color: 'black', size: 12, align: el.dataset.align || 'left' } },
        }).render(box).catch(() => { if (box.isConnected) el.hidden = true; });
      });
    });
  }
  /* déjà « oui » dans cette session : la place est gardée dès le rendu, le message arrive sans rien pousser */
  const pp4xKnown = () => { try { return sessionStorage.getItem(PP4X_KEY) === '1'; } catch (e) { return false; } };
  const pp4xSlot = (cls, amount, place, align) => {
    const keep = pp4xKnown() && amount >= PP4X_MIN && amount <= PP4X_MAX;
    return `<div class="${cls} pp4x" data-pp4x data-amount="${amount}" data-place="${place}"${align ? ` data-align="${align}"` : ''}${keep ? '' : ' hidden'}></div>`;
  };
  const ecoTxt = (p) => { const e = ecoOf(p); return e != null ? `Prix TTC, dont ${price(e)} d’éco-participation` : 'Prix TTC, éco-participation comprise'; };
  /* couleur en vignette photo : la vraie pièce dans cette couleur, nom au survol et lu à voix haute */
  function photoSwatch(p, c, k, checked) {
    const out = isOut(c);
    return `<button class="pswatch${out ? ' is-out' : ''}" type="button" role="radio" aria-checked="${checked}" aria-label="${esc(c.nom)}${out ? ', bientôt de retour' : ''}" title="${esc(c.nom)}${out ? ' · Bientôt de retour' : ''}" data-action="pdp-color" data-k="${k}">${thumbFor(p, c.nom)}</button>`;
  }
  /* cadeaux gagnés par la pièce seule : une ligne, une vignette */
  /* Cadeau sous le prix (07/10) : « Offerts : 2 coussins nœud (69 €) », puis le palier suivant ; sous le premier palier,
     la pièce assortie la moins chère qui l'atteint. Valeur = prix de l'article vendu seul, entre parenthèses (jamais barré). */
  /* Carte des cadeaux, sous le prix (refonte du 07/10, maquette 1 de la critique) : les cadeaux en vraie photo, à la taille
     d'un objet, chacun avec sa valeur (son prix vendu seul sur le site, jamais barré) et le mot « offert ». Les paliers pas
     encore atteints restent pâles, avec le montant qui manque. Une pièce sous le premier palier montre la jauge. */
  const GIFT_ITEM = ['2 coussins nœud en velours', 'Plaid côtelé et sherpa', 'Second plaid, l’autre couleur'];
  function giftLine(p) {
    if (notYet(p) || isAcc(p) || !SITE.paliers || !SITE.paliers.length) return '';
    if (isSleep(p) && !giftReachable(true)) return '';
    const P = SITE.paliers, v = unitPriceOf(p, p.tailles ? p.tailles[PDP.size].nom : '');
    const got = P.filter((pl) => v >= pl.seuil), next = P.find((pl) => v < pl.seuil);
    const shown = got.length ? [...got, ...(next ? [next] : [])] : P;
    const row = (pl) => {
      const k = P.indexOf(pl), on = v >= pl.seuil, val = giftValue(pl);
      const what = on ? `<b class="gcard__st">${plural(GIFT_SHORT[k]) ? 'offerts' : 'offert'}</b>` : `<span class="gcard__st">dès ${price(pl.seuil)}</span>`;
      return `<li class="gcard__row${on ? ' is-on' : ''}" style="--z:${[2.3, 1.85, 1.3][k] || 1.6}">${giftPic(pl, 'gcard__pic')}<span class="gcard__name">${esc(GIFT_ITEM[k] || giftLabel(pl))}${val ? `<small class="num">vendu${plural(GIFT_SHORT[k]) ? 's' : ''} ${price(val)}</small>` : ''}</span>${what}</li>`;
    };
    const saved = giftsSaved(got);
    const gap = P[0].seuil - v;
    const add = !got.length && gap <= 400 ? PRODS.filter((x) => x.slug !== p.slug && sameWorld(x, p) && !isAcc(x) && !SECONDARY.includes(x.slug) && onSale(x) && unitPriceOf(x) >= gap).sort((a, b) => unitPriceOf(a) - unitPriceOf(b))[0] : null;
    const head = got.length
      ? `<p class="gcard__t">Offerts avec ${esc(p.nom)}</p>`
      : `<p class="gcard__t">Encore <span class="num">${price(gap)}</span> pour les coussins offerts</p>`;
    const foot = got.length
      ? `<p class="gcard__foot">Ajoutés tout seuls au panier, sans code${saved ? ` : <b class="num">${price(saved)}</b> de pièces en plus` : ''}.</p>`
      : `<p class="gcard__foot">${add ? `Avec ${esc(add.nom)} (<span class="num">${price(unitPriceOf(add))}</span>), ils vous sont offerts. ` : 'Tous vos meubles comptent, ensemble. '}<button class="fp-inline" type="button" data-action="goto" data-to=".fp-rel">Voir ce qui va avec</button></p>`;
    return `<div class="gcard${got.length ? '' : ' gcard--next'}">${head}<ul class="gcard__list">${shown.map(row).join('')}</ul>${foot}</div>`;
  }
  /* « Ce que vous recevez » (refonte du 07/10) : un reçu typographique sous le bouton d'achat, à la place du tableau
     « Caplia ou ailleurs » et de la rangée d'icônes. Seulement des faits écrits ailleurs sur le site (prix, cadeaux et
     leur prix vendus seuls, livraison offerte, date, vérification de la porte) ; aucun concurrent, aucun droit légal
     présenté comme un avantage. */
  function recuHtml(p) {
    if (notYet(p)) return '';
    const size = p.tailles ? p.tailles[PDP.size].nom : '';
    const v = unitPriceOf(p, size), P = SITE.paliers || [];
    const got = P.filter((pl) => v >= pl.seuil);
    const line = (a, b, cls = '') => `<li class="recu__l${cls}"><span>${a}</span><i aria-hidden="true"></i><span class="num">${b}</span></li>`;
    const saved = giftsSaved(got);
    const rows = [
      line(`${esc(p.nom)}, ${esc(lc1(cardType(p)))}${size ? ` ${esc(size)}` : ''}`, price(v)),
      line(`Livraison ${delivery(p)}`, 'offerte'),
      ...got.map((pl) => { const k = P.indexOf(pl), val = giftValue(pl); return line(`${esc(GIFT_ITEM[k] || giftLabel(pl))} <small>(${val ? `vendu${plural(GIFT_SHORT[k]) ? 's' : ''} ${price(val)}, ` : ''}colis à part ${giftWhen(pl)})</small>`, plural(GIFT_SHORT[k]) ? 'offerts' : 'offert'); })
    ];
    const tot = saved ? `<p class="recu__tot"><span class="num">${price(saved)}</span> de pièces en plus, pour le même prix</p>`
      : `<p class="recu__tot recu__tot--s">Vous payez <span class="num">${price(v)}</span>, livraison comprise</p>`;
    const door = hasDoor(p) ? `<p class="recu__door">Une porte étroite ? Envoyez sa largeur : nous vérifions avant l’achat, et si nous avons dit oui et qu’${isFem(p) ? 'elle' : 'il'} ne passe pas, nous ${isFem(p) ? 'la' : 'le'} reprenons à nos frais. <button class="fp-inline" type="button" data-action="open-passe">Vérifier ma porte</button></p>` : '';
    return `<section class="recu" aria-labelledby="recu-t"><h2 class="recu__h" id="recu-t">Ce que vous recevez</h2><ul class="recu__list">${rows.join('')}</ul>${tot}${door}</section>`;
  }
  /* Repères de confiance juste sous le bouton (fiche) et sous « Passer au paiement » (panier), là où la peur arrive
     (Baymard : 19 % des abandons « pas confiance pour ma carte », 13 % « retours insuffisants » ; chantier confiance du 08/10).
     Seulement des faits vérifiables : paiement traité par Shopify Payments ou PayPal (numéro de carte jamais transmis,
     Protection des achats PayPal : non reçu ou non conforme à la description) ; suivi de chaque colis (e-mail d'expédition) ; le délai de
     rétractation présenté comme la loi le prévoit, jamais comme un cadeau (sauf retour offert, payé par Caplia) ; e-mail. */
  /* « Comment se passe un retour » en 3 étapes courtes (supervision du 08/10) : sur la fiche, dans « Livraison et retour » ;
     au panier, le lien mène à la même marche à suivre, en détail, sur la page Livraison (?s=retractation) */
  const retourSteps = (offert) => {
    const R = SITE.retours.delaiJours;
    return [`Écrivez-nous à ${mailLink('')} avec votre numéro de commande, dans les ${R} jours qui suivent la réception.`,
      `Nous vous envoyons l’adresse de retour et un transporteur adapté à la pièce${offert ? ', payé par nous' : ''}.`,
      `Vous êtes remboursé au plus tard ${R} jours après votre demande, une fois la pièce reçue ou sa preuve d’envoi.`];
  };
  /* ouvre un repli de la fiche (« Livraison et retour », « Est-ce que ça passe ») et le fait venir à l'écran */
  function openAcc(sel) {
    const d = $(sel);
    if (!d) return null;
    d.open = true;
    d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    return d;
  }
  function trustHtml(p) {
    const ret = p && retourOffert(p)
      ? `<b>Retour offert sous ${SITE.retours.delaiJours} jours</b> : nous payons le transport du retour.`
      : `<b>${SITE.retours.delaiJours} jours pour changer d’avis</b>, comme la loi le prévoit.`;
    const how = p ? `<button class="fp-inline" type="button" data-action="open-retour">Comment se passe un retour</button>` : '<a href="#/livraison?s=retractation">Comment se passe un retour</a>';
    return `<ul class="trust" aria-label="Paiement, livraison et retour">
      <li><span class="trust__i" aria-hidden="true">${I.shield}</span><p><b>Paiement sécurisé</b> par carte, ou par PayPal et sa protection des achats. Votre numéro de carte ne nous est jamais transmis.</p></li>
      <li><span class="trust__i" aria-hidden="true">${I.truck}</span><p><b>Chaque colis est suivi</b> : le lien de suivi arrive par e-mail dès son départ.</p></li>
      <li><span class="trust__i" aria-hidden="true">${I.check}</span><p>${ret} ${how}</p></li>
      <li><span class="trust__i" aria-hidden="true">${I.mail}</span><p><b>Une question ?</b> ${mailLink('')}, la réponse arrive ${reponse()}.</p></li>
    </ul>`;
  }
  /* Trois moments sous la galerie (refonte du 07/10) : la matière en gros plan, l'échelle dessinée, la pièce en situation.
     Trois formats différents (diptyque, plan sur le studio, grande photo avec cartel), un seul texte court chacun, tiré
     de la fiche. Une pièce sans gros plan, sans plan ou sans 2e photo en situation saute le moment qui lui manque. */
  const noDot = (t) => String(t || '').trim().replace(/[.\s]+$/, '');
  const focusX = (p, id) => { const c = (CADRAGE[p.slug] || {})[id]; return c ? Math.round(((c[1] + c[3]) / 2) * 100) : 50; };
  const momentPic = (p, im, sizes) => `<picture><source type="image/avif" srcset="${GAL_SRCSET(p, im.id, 'avif')}" sizes="${sizes}"><img src="${photo(p, im.id, 1280)}" srcset="${GAL_SRCSET(p, im.id)}" sizes="${sizes}" alt="${esc(im.alt)}" loading="lazy" decoding="async" draggable="false" style="object-position:${focusX(p, im.id)}% 50%"></picture>`;
  function momentsHtml(p, k) {
    if (isAcc(p)) return '';
    const c = p.couleurs[k] || p.couleurs[0];
    const all = colorPhotos(p, c);
    const close = all.filter((im) => closeUp(im.alt));
    const MAT_RE = /bouclette|chenille|velours|tissu|texture|lin|sherpa|teddy|mouton|côtelé/i;
    /* le gros plan qui montre la matière ET une courbe de la pièce (plus vivant qu'un aplat de tissu) */
    const macro = close.find((im) => MAT_RE.test(im.alt) && /accoudoir|dossier|arrondi|capiton/i.test(im.alt) && !/pied|charni|fermeture|coussin et/i.test(im.alt))
      || close.find((im) => MAT_RE.test(im.alt) && !/coussin|pied|accoudoir|charni|fermeture|bouton/i.test(im.alt))
      || close.find((im) => /bouclette|chenille|velours|tissu|texture|sherpa|teddy|mouton|côtelé/i.test(im.alt)) || close[0];
    const sc = scenesFor(p, c.nom);
    const room = sc[1] || null;
    const D = p.dimensions || {};
    const out = [];
    if (macro && p.toucher) out.push(`<div class="mo mo--mat">
        <figure class="mo__img">${momentPic(p, macro, '(max-width: 760px) 100vw, 58vw')}</figure>
        <div class="mo__txt"><h2 class="t-2 mo__h">${esc(p.matiere)}, ${esc(lc1(c.nom))}</h2><p class="mo__p">${esc(p.toucher)}</p></div>
      </div>`);
    if (planKind(p) && D.largeur && !isMirror(p)) {
      const seat = D.hauteurAssise ? `Assise à ${cm(D.hauteurAssise)} du sol${D.profondeurAssise ? `, ${cm(D.profondeurAssise)} de profondeur` : ''}.` : '';
      out.push(`<div class="mo mo--plan">
        <div class="mo__txt"><h2 class="mo__fig num${p.tailles ? ' mo__fig--s' : ''}">${p.tailles ? esc(dimsLabel(p)) : cm(D.largeur)}</h2><p class="mo__p">${p.tailles ? '' : `${cm(D.profondeur)} de profondeur, ${cm(D.hauteur)} de haut. `}${seat}</p></div>
        <div class="mo__plan fp-plan-big" aria-label="Plan coté de ${esc(p.nom)}">${planSVG(p)}${planSVG(p, true)}</div>
      </div>`);
    }
    if (room) {
      const h = noDot((p.accroche || []).join(' ')) || p.nom;
      out.push(`<figure class="mo mo--room"><div class="mo__full" data-photo="${esc(room.id)}"${(CADRAGE[p.slug] || {})[room.id] ? ` style="--own:${CADRAGE[p.slug][room.id][0].toFixed(3)}"` : ''}>${momentPic(p, room, '100vw')}</div><figcaption class="mo__cartel"><h2 class="t-2 mo__h">${esc(h)}</h2>${p.scene ? `<p class="mo__p">${esc(p.scene)}</p>` : ''}</figcaption></figure>`);
    }
    return out.length ? `<section class="wrap fp-sec mos" aria-label="${esc(p.nom)} de près">${out.join('')}</section>` : '';
  }
  /* volet replié, titre court et icône */
  /* volet « Montage et notice » : notice du fabricant en français, ou fiche d'entretien et de sécurité (site/data/notices.json) */
  const noticeAcc = (p) => {
    const n = NOTICES[p.slug];
    if (!n || !n.fichier) return '';
    const fab = n.type === 'fabricant';
    const poids = n.ko >= 1024 ? `${String(Math.round(n.ko / 102.4) / 10).replace('.', ',')} Mo` : `${n.ko} Ko`;
    return accI(I.box, fab ? 'Montage et notice' : 'Entretien et sécurité', `<p>${fab
      ? 'La notice du fabricant, avec les consignes en français et les schémas de montage étape par étape.'
      : 'Déballage, entretien et consignes de sécurité, en français.'}</p>
        <p class="fp-notice"><a href="${esc(n.fichier)}" target="_blank" rel="noopener">${fab ? 'Notice de montage' : "Fiche d'entretien et de sécurité"}</a><span class="fp-notice__meta">PDF, ${n.pages} page${n.pages > 1 ? 's' : ''}, ${poids}</span></p>
        <p class="fp-more__ask">Une question ? ${mailLink('')}</p>`);
  };
  const accI = (ico, q, r, attrs = '') => `<details class="acc acc--i"${attrs ? ' ' + attrs : ''}><summary><span class="acc__ico" aria-hidden="true">${ico}</span>${q}<span class="round" aria-hidden="true">${I.plus}</span></summary><div class="acc__body">${r}</div></details>`;
  /* matière : gros plan de la couleur choisie, composition, entretien en trois gestes */
  function matBody(p, k) {
    const o = matOf(p), v = o ? matPic(p, k) : null;
    return `${o ? `<figure class="fp-more__mat"${v ? '' : ' hidden'}><img ${v ? `src="${v.src}" srcset="${v.srcset}" alt="${esc(v.alt)}"` : 'alt=""'} sizes="(max-width: 760px) 40vw, 200px" data-mat-img loading="lazy" decoding="async"></figure>` : ''}
      <table class="table"><tbody>
        ${p.details.filter(([a]) => /^(Revêtement|Tissu|Cadre|Dessus|Dessous|Lot)$/.test(a)).concat(ftOf(p).tissu || []).map(([a, b]) => `<tr><th scope="row">${esc(a)}</th><td>${esc(b)}</td></tr>`).join('')}
        <tr><th scope="row">${p.couleurs.length > 1 ? 'Couleurs' : 'Couleur'}</th><td>${esc(p.couleurs.map((c) => c.nom).join(', '))}</td></tr>
      </tbody></table>
      ${o ? `<h3 class="fp-more__h">L’entretien</h3><ul class="fp-more__list">${o.m.entretien.map(([t, d]) => `<li><b>${esc(t)}</b> : ${esc(lc1(d))}</li>`).join('')}</ul>` : ''}`;
  }
  /* pièce compressée : le temps de reprise de forme, en une phrase */
  const compLine = (p) => { const a = arrOf(p); return a && a.compresse ? ` Livré${isFem(p) ? 'e' : ''} compressé${isFem(p) ? 'e' : ''} : ${isFem(p) ? 'elle' : 'il'} reprend sa forme en ${esc(a.forme)}.` : ''; };
  const passeLine = (p) => { const e = easyIn(p); return e ? `${e[0]}. ${e[1]}` : `${cap1(doorTxt(p))}.`; };

  /* ---------------- Doutes du canapé (07/10, chantier 3) ----------------
     Blocs repliés de la fiche, seulement avec les données relevées chez le vendeur (site/data/fiches-techniques.json) :
     une donnée absente n'a pas de ligne, un bloc vide n'existe pas. */
  const ftOf = (p) => FT[p.slug] || {};
  const kvTable = (rows) => `<table class="table"><tbody>${rows.map(([a, v]) => `<tr><th scope="row">${esc(a)}</th><td>${esc(nbTxt(v))}</td></tr>`).join('')}</tbody></table>`;
  const sameLbl = (a, b) => norm(a).split(' ')[0] === norm(b).split(' ')[0];
  function confortBody(p) {
    const rows = ftOf(p).confort || [];
    return rows.length ? kvTable(rows) : '';
  }
  function deballageBody(p) {
    const rows = ftOf(p).deballage || [];
    if (!rows.length) return '';
    const a = arrOf(p);
    return `${kvTable(rows)}${a && a.compresse && ARR && ARR.etapes ? '<p class="fp-more__ask"><a href="#/arrivee">Les étapes du déballage en photos</a></p>' : ''}`;
  }
  /* fiche technique : tout ce qui est relevé, en une table (dimensions, catalogue, vendeur, colis, expédition, couleurs) */
  function techRows(p) {
    const D = p.dimensions, rows = [];
    if (!p.tailles && D.largeur && D.profondeur && D.hauteur && !D.diametre && !D.epaisseur) rows.push(['Dimensions', `${numFr(D.largeur)} × ${numFr(D.profondeur)} × ${numFr(D.hauteur)} cm (L × P × H)`]);
    if (D.hauteurAssise && isSeat(p)) rows.push(['Hauteur d’assise', `${numFr(D.hauteurAssise)} cm`]);
    if (D.profondeurAssise) rows.push(['Profondeur d’assise', `${numFr(D.profondeurAssise)} cm`]);
    p.details.filter(([a]) => !rows.some(([r]) => sameLbl(r, a))).forEach((d) => rows.push(d));
    (ftOf(p).technique || []).filter(([a]) => !rows.some(([r]) => sameLbl(r, a))).forEach((d) => rows.push(d));
    if (/^\d/.test(p.colis || '') && !rows.some(([r]) => /colis/i.test(r))) rows.push(['Colis', p.colis]);
    rows.push(['Expédition', `Depuis ${PAYS_DE[p.pays]}, en ${delayTxt(p)}`]);
    rows.push([p.couleurs.length > 1 ? 'Couleurs' : 'Couleur', p.couleurs.map((c) => c.nom).join(', ')]);
    return rows;
  }
  /* questions propres à la pièce, tirées de ses données (date, colis et montage), quand sa FAQ ne les pose pas déjà */
  function dataFaq(p) {
    const out = [];
    const f = isFem(p), il = f ? 'elle' : 'il', Il = cap1(il);
    if (!notYet(p)) out.push([`Quand sera-t-${il} chez moi ?`, `Commandé${f ? 'e' : ''} aujourd’hui, ${il} arrive chez vous ${delivery(p)} : ${delayTxt(p)} depuis ${PAYS_DE[p.pays]}. La livraison est offerte.`]);
    const deb = ftOf(p).deballage || [];
    const get = (re) => (deb.find(([a]) => re.test(a)) || [])[1];
    const col = get(/^Colis$/), mont = get(/^(Montage|Installation)$/), forme = get(/^Reprise de forme$/);
    if (col || mont) {
      const parts = [];
      if (col) parts.push(`${Il} arrive en ${lc1(col)}.`);
      if (forme) parts.push(`Livré${f ? 'e' : ''} compressé${f ? 'e' : ''}, ${il} reprend sa forme en ${lc1(forme)}.`);
      if (mont) parts.push(/^aucun/i.test(mont) ? 'Aucun montage.' : `Montage : ${lc1(mont)}.`);
      out.push([`Combien de colis, et faut-il ${f ? 'la' : 'le'} monter ?`, parts.join(' ')]);
    }
    return out.filter(([q]) => !p.faq.some(([x]) => overlap(x, q)));
  }
  /* « Recevoir cette fiche et ses dimensions par e-mail » (marketing/FICHE-PAR-EMAIL.md) : sans case cochée, rien n'est
     enregistré (PDF, ou e-mail envoyé par la messagerie du visiteur) ; case cochée, abonnement (client Shopify étiqueté). */
  const FICHE_MAIL_AUTO = false;   /* true quand l'automatisation Shopify Flow « Votre fiche » existe (envoi par Caplia) */
  const keepBlock = (p) => `<div class="fp-keep" data-keep>
      <button class="fp-keep__open" type="button" data-action="keep-open" aria-expanded="false" aria-controls="fp-keep-form">${I.mail}<span>Recevoir cette fiche et ses dimensions par e-mail</span></button>
      <form class="fp-keep__form" id="fp-keep-form" data-keep-form novalidate hidden>
        <p class="fp-keep__t">Gardez cette fiche</p>
        <p class="fp-keep__lead">Les dimensions, les colis et le délai de ${esc(p.nom)}, pour mesurer tranquillement chez vous.</p>
        <label class="sr-only" for="keep-mail">Votre adresse e-mail</label>
        <input id="keep-mail" class="input" name="email" type="email" autocomplete="email" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="Votre adresse e-mail" required aria-describedby="keep-note">
        <label class="check fp-keep__ok" for="keep-ok"><input id="keep-ok" name="ok" type="checkbox"><span>Je veux aussi recevoir les e-mails de Caplia : au plus deux par mois, sur des pièces semblables. Je peux me désinscrire en un clic dans chaque e-mail.</span></label>
        <button class="btn btn--block" type="submit">Recevoir la fiche</button>
        <p class="fp-keep__note" id="keep-note">Caplia utilise votre adresse pour vous envoyer cette fiche et, seulement si vous avez coché la case, ses e-mails. Elle n’est ni vendue ni prêtée. Vous pouvez demander à tout moment sa suppression à ${mailLink('')}. Détails : <a href="#/confidentialite">Confidentialité</a>.</p>
        <div class="fp-keep__msg" data-keep-msg aria-live="polite" hidden></div>
      </form>
    </div>`;
  function keepMailto(p, mail) {
    const size = p.tailles ? p.tailles[PDP.size].nom : '';
    const c = p.couleurs[PDP.color] || p.couleurs[0];
    const D = p.dimensions;
    const lines = [`${p.nom}, ${lc1(p.type)}`, `Couleur : ${c.nom}${size ? `, taille ${size}` : ''}`, `Prix : ${price(unitPriceOf(p, size)).replace(/\s/g, ' ')}, livraison offerte`,
      D.largeur && D.profondeur && D.hauteur && !p.tailles ? `Dimensions : ${numFr(D.largeur)} × ${numFr(D.profondeur)} × ${numFr(D.hauteur)} cm (L × P × H)` : '',
      D.hauteurAssise && isSeat(p) ? `Hauteur d’assise : ${numFr(D.hauteurAssise)} cm` : '', /^\d/.test(p.colis || '') ? `Colis : ${p.colis}` : '',
      `Livraison : ${delayTxt(p)} depuis ${PAYS_DE[p.pays]}`, '', `La fiche : ${location.href}`].filter(Boolean);
    return `mailto:${mail.split('@').map(encodeURIComponent).join('@')}?subject=${encodeURIComponent(`Ma fiche Caplia : ${p.nom}`)}&body=${encodeURIComponent(lines.join('\n'))}`;
  }
  /* Paiement express (07/10, chantier 2). Dans la boutique, la place [data-caplia-slot] reçoit les vrais boutons de
     paiement accéléré de Shopify (Apple Pay, Shop Pay, PayPal selon les réglages de paiement), rendus par Liquid
     (sections/caplia-produit et caplia-panier) ; la maquette y montre leur aperçu. Sur toutes les fiches (décision du 07/10) :
     un achat express ne passe pas par le panier qui ajoute la ligne cadeau, mais le cadeau est expédié quand même, d'après
     le montant des meubles (marketing/PRIX-CADEAUX-DECISION-2026-10-07.md, « Expédition des cadeaux »). */
  const expressOk = (p) => !isAcc(p);
  const APPLE_PAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16.4 12.6c0-2 1.6-2.9 1.7-3a3.7 3.7 0 0 0-2.9-1.6c-1.2-.1-2.4.7-3 .7s-1.6-.7-2.6-.7a3.9 3.9 0 0 0-3.3 2c-1.4 2.4-.4 6 1 8 .7 1 1.5 2 2.5 2s1.4-.6 2.6-.6 1.5.6 2.6.6 1.8-1 2.4-2a8.6 8.6 0 0 0 1.1-2.3 3.4 3.4 0 0 1-2.1-3.1zM14.5 6.6A3.4 3.4 0 0 0 15.3 4a3.5 3.5 0 0 0-2.3 1.2 3.3 3.3 0 0 0-.8 2.5 2.9 2.9 0 0 0 2.3-1.1z"/></svg>';
  const expressMock = (where) => `<div class="express${where === 'fiche' ? ' express--fiche' : ''}" role="group" aria-label="Paiement express" data-caplia-slot="${where === 'fiche' ? 'express' : 'express-panier'}">
      <div class="express__row">
        <button class="express__b" type="button" data-action="${where === 'fiche' ? 'pdp-express' : 'checkout'}" data-express="1" aria-label="Payer avec Apple Pay">${APPLE_PAY}Pay</button>
        <button class="express__b" type="button" data-action="${where === 'fiche' ? 'pdp-express' : 'checkout'}" data-express="1" aria-label="Payer avec PayPal">PayPal</button>
      </div>
    </div>`;
  function renderProduct(slug) {
    const p = BY[slug];
    if (!p) return render404();
    PDP.p = p; PDP.color = 0; PDP.size = defSize(p); PDP.img = -1; PDP.slide = 0; PDP.done = { color: p.couleurs.length === 1 && !p.tailles };
    const qs = qsAll();
    const qc = Number(qs.get('c') || 0);
    /* ?couleur=<nom> : lien partagé d'une couleur précise (même épuisée : la fiche le dit et propose l'e-mail de retour) */
    const qk = qs.get('couleur') ? p.couleurs.findIndex((c) => colorSlug(c.nom) === qs.get('couleur')) : SHOP_VARIANT_COLOR(p, qs.get('variant'));
    /* sinon chaque fiche s'ouvre sur la première couleur disponible, celle du rendu studio quand elle est en stock :
       ce qu'on voit en arrivant est ce que montrent la carte et l'affiche de l'accueil */
    PDP.initColor = qk >= 0 ? qk : qc > 0 && qc < p.couleurs.length && !isOut(p.couleurs[qc]) ? qc : firstIn(p);
    /* ?taille=<nom> : lien envoyé depuis la fiche (bouton « Envoyer ») */
    const qt = p.tailles && qs.get('taille') ? p.tailles.findIndex((t) => colorSlug(t.nom) === qs.get('taille')) : -1;
    if (qt >= 0) PDP.size = qt;
    /* la taille d'ouverture est en vente dans la couleur d'ouverture */
    if (p.tailles && sizeOutFor(p.tailles[PDP.size], p.couleurs[PDP.initColor].nom)) PDP.size = Math.max(0, p.tailles.findIndex((t) => !sizeOutFor(t, p.couleurs[PDP.initColor].nom)));
    const tid = TABLEAU[slug];
    const c0 = p.couleurs[PDP.initColor];   /* couleur d'ouverture : en stock, sauf lien partagé ?couleur= */
    const D = p.dimensions;
    const slides = gallerySlides(p, PDP.initColor);
    PDP.slides = slides; PDP.galColor = PDP.initColor; PDP.galSeq = 0;
    const A = STAGE_A(p, PDP.initColor);

    const dims = isBed(p)
      ? [['Couchage', p.tailles ? dimsLabel(p) : xy(D.largeur, D.profondeur)],
        [p.tailles ? `Au sol (matelas ${p.tailles[0].nom.replace(/ cm$/, '')})` : 'Au sol', xy(D.largeur, D.profondeur)],
        ['Hauteur de la tête de lit', cm(D.hauteur)]]
      : isMirror(p)
      ? [['Hauteur', p.tailles ? sizeNums(p, 0) : cm(D.hauteur)], ['Largeur', p.tailles ? sizeNums(p, 1) : cm(D.largeur)], ['Épaisseur', cm(D.profondeur)]]
      : D.epaisseur ? [['Dimensions', xy(D.largeur, D.profondeur)], ['Épaisseur', cm(D.epaisseur)]]
      : D.diametre ? [['Diamètre', cm(D.diametre)], ['Hauteur', cm(D.hauteur)]]
      : D.petite ? [['Grande table', `${xy(D.largeur, D.profondeur)}, ${cm(D.hauteur)} de haut`], ['Petite table', `${xy(D.petite.largeur, D.petite.profondeur)}, ${cm(D.petite.hauteur)} de haut`]]
      : [['Largeur', cm(D.largeur)], [p.slug === 'miroir-organique' ? 'Épaisseur' : 'Profondeur', cm(D.profondeur)], ['Hauteur', cm(D.hauteur)]]
        .concat(D.hauteurAssise ? [['Hauteur d’assise', cm(D.hauteurAssise)]] : [])
        .concat(D.profondeurAssise ? [['Profondeur d’assise', cm(D.profondeurAssise)]] : []);


    const ens = ensFor(p.slug);
    const mates = ens ? ens.items.slice(1).map(([s]) => s) : [];
    const auto = () => PRODS.filter((x) => x !== p && sameWorld(x, p) && !(isBed(p) && isBed(x)) && !SECONDARY.includes(x.slug) && carteOf(x) && onSale(x) && !isAcc(x))
      .map((x) => ({ x, k: mates.includes(x.slug) ? -1 : (x.collection !== p.collection ? 0 : 1) * 10 + (hash(x.slug + p.slug) % 10) }))
      .sort((a, b) => a.k - b.k).slice(0, 4).map((o) => o.x);
    const hand = RELATED[p.slug] ? RELATED[p.slug].map((s) => BY[s]).filter((x) => x && onSale(x)) : null;
    /* liste écrite à la main : les trois premières pièces en ligne (une quatrième sert de relais quand l'une est masquée) */
    const related = !hand ? auto() : hand.length >= 3 || !RELATED[p.slug].length ? hand.slice(0, 3) : [...hand, ...auto().filter((x) => !hand.includes(x))].slice(0, 3);

    /* Bloc affiché seulement quand fabricant et responsable UE sont relevés (sinon la pièce n'est pas en vente) */
    /* Bloc affiché dès que fabricant et responsable UE sont relevés, avec ce qui est relevé (« aConfirmer » ne le cache pas) */
    const secReady = (x) => !!(x.securite && x.securite.fabricant && x.securite.responsableUE && !/compl/i.test(x.securite.fabricant.nom + x.securite.responsableUE.nom));
    const person = (o) => `${esc(o.nom)}<br>${esc(o.adresse)}${o.email ? '<br>' + esc(o.email) : ''}${o.telephone ? '<br>' + esc(o.telephone) : ''}`;
    const pk = petsKids(p);
    const faqs = p.faq.filter(([q]) => !(matOf(p) && /^comment entretenir/i.test(q))).concat(pk).concat(dataFaq(p));
    const confort = confortBody(p), deballage = deballageBody(p);

    const html = `
    <section class="wrap fp" aria-label="${esc(p.nom)}">
      ${crumbOf(p)}
      <div class="fp__media">
        <div class="fp-stage fp-stage--${shape(p)}" data-fp-stage style="--am:${A.m};--ad:${A.d};${A.lead ? `--lead:${A.lead};` : ''}--py-m:${studioPos(p, A.m)}%;--py-d:${studioPos(p, A.d)}%">
          <div class="fp-track" data-fp-track tabindex="0" role="region" aria-roledescription="carrousel" aria-label="Images de ${esc(p.nom)}">
            ${slides.map((s, i) => slideHtml(p, s, i)).join('')}
          </div>
          <button class="round round--white fp-zoom" type="button" data-action="pdp-zoom" aria-label="Agrandir la photo" hidden>${I.loupe}</button>
          <button class="round round--white fp-fav" type="button" data-action="fav" data-slug="${p.slug}" aria-pressed="${isFav(p.slug)}">${I.heart}<span class="sr-only" data-fav-label>${isFav(p.slug) ? 'Dans ma sélection' : 'Enregistrer dans ma sélection'}</span></button>
          <div class="fp-nav">
            <button class="round round--white" type="button" data-fp="prev" aria-label="Image précédente">${I.chevL}</button>
            <button class="round round--white" type="button" data-fp="next" aria-label="Image suivante">${I.chevR}</button>
          </div>
        </div>
        <div class="fp-thumbs" role="tablist" aria-label="Choisir une image" style="--n:${slides.length};--ad:${A.d}">
          ${slides.map((s, i) => thumbHtml(s, i, 0)).join('')}
        </div>
      </div>

      <aside class="fp__buy" aria-label="Acheter ${esc(p.nom)}">
        <h1 class="fp__name">${esc(p.nom)}</h1>
        <p class="fp__type">${esc(p.type)}</p>
        ${avisRate(p)}
        <div class="fp__price">
          <strong class="num price" data-pdp-price>${price(unitPriceOf(p, p.tailles ? p.tailles[PDP.size].nom : ''))}</strong>
          <p class="fp__incl">${esc(ecoTxt(p))}</p>
          ${pp4xSlot('fp__4x', unitPriceOf(p, p.tailles ? p.tailles[PDP.size].nom : ''), 'product')}
          ${notYet(p) ? '' : `<p class="fp__when" data-pdp-when>Chez vous ${delivery(p)}</p>`}
        </div>
        <div data-pdp-gift>${giftLine(p)}</div>

        <div class="fp-opt${p.couleurs.length === 1 ? ' fp-opt--seule' : ''}">
          <p class="fp-opt__q">Couleur : <b data-pdp-colname>${esc(c0.nom)}</b><span class="soon" data-pdp-soon${isOut(c0) ? '' : ' hidden'}> · Bientôt de retour</span></p>
          ${p.couleurs.length > 1 ? `<div class="pswatches" role="radiogroup" aria-label="Couleur">
            ${p.couleurs.map((c, k) => photoSwatch(p, c, k, k === PDP.initColor)).join('')}
          </div>` : ''}
          ${p.sens ? `<p class="fp-opt__sens">${esc(p.sens)}</p>` : ''}
        </div>
        ${p.tailles && p.tailles.length > 1 ? `<div class="fp-opt">
          <p class="fp-opt__q">Taille : <b data-pdp-sizename>${esc(p.tailles[PDP.size].nom)}</b></p>
          <div class="sizes" role="radiogroup" aria-label="Taille">
            ${p.tailles.map((t, k) => sizePill(t, k, k === PDP.size, c0.nom)).join('')}
          </div>
        </div>` : ''}

        <div class="fp-ctas" data-buy>
          ${notYet(p) ? '' : `<button class="btn btn--block" type="button" data-action="pdp-add"${isOut(c0) ? ' hidden' : ''}><span class="cta__label">Ajouter au panier</span></button>`}
          ${notYet(p) || !expressOk(p) ? '' : `<div class="fp-express"${isOut(c0) ? ' hidden' : ''}>${expressMock('fiche')}</div>`}
          <form class="notify" data-notify novalidate${isOut(c0) || notYet(p) ? '' : ' hidden'}>
            <p class="notify__t">${notYet(p) ? 'Bientôt disponible. Recevez un e-mail le jour de sa mise en vente.' : 'Cette couleur revient bientôt. Recevez un e-mail le jour de son retour.'}</p>
            <div class="notify__row">
              <label class="sr-only" for="notify-mail">Votre e-mail</label>
              <input id="notify-mail" name="email" type="email" autocomplete="email" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="Votre e-mail" required>
              <button class="pill pill--sm" type="submit">Me prévenir</button>
            </div>
            <label class="check notify__ok" for="notify-ok"><input id="notify-ok" name="ok" type="checkbox" required><span>${notYet(p) ? `J'accepte de recevoir l'e-mail de la mise en vente de ${esc(p.nom)}.` : "J'accepte de recevoir l'e-mail du retour de cette couleur."}</span></label>
            <p class="notify__msg" data-notify-msg aria-live="polite" hidden></p>
          </form>
        </div>
        ${notYet(p) ? '' : trustHtml(p)}
        <div data-pdp-recu>${recuHtml(p)}</div>
      </aside>
    </section>

    ${momentsHtml(p, PDP.initColor)}

    ${avisHtml(p)}

    <section class="wrap fp-sec fp-more" aria-labelledby="fp-more-t">
      <h2 class="t-2 fp-h fp-detail-h" id="fp-more-t">${esc(p.nom)}, en détail</h2>
      ${accI(I.ruler, 'Dimensions', `${planKind(p) ? `<div class="fp-more__plan">${planSVG(p)}</div>` : ''}
        <dl class="fp-dims">${dims.map(([l, v]) => `<div><dt>${esc(l)}</dt><dd class="num">${esc(v)}</dd></div>`).join('')}</dl>
        ${hasDoor(p) ? `<p class="fp-more__door">${esc(cap1(doorTxt(p)))}.</p>` : ''}`)}
      ${hasDoor(p) ? accI(I.door, 'Est-ce que ça passe chez vous ?', `<p>${esc(passeLine(p))}</p>
        <form class="fp-door" data-door novalidate>
          <div class="field">
            <label for="door-w">Votre porte la plus étroite, largeur en cm</label>
            <input id="door-w" class="input" name="w" type="number" inputmode="numeric" min="30" max="300" placeholder="Par exemple 73">
          </div>
          <div class="fp-door__more">
            <div class="field">
              <label for="door-s">Escalier ou couloir, largeur en cm <span class="fp-door__opt">(facultatif)</span></label>
              <input id="door-s" class="input" name="s" type="number" inputmode="numeric" min="30" max="300" placeholder="Par exemple 85">
            </div>
            <div class="field">
              <label for="door-e">Étage</label>
              <select id="door-e" name="etage" class="input"><option value="">Choisir</option><option>Rez-de-chaussée</option><option>Étage avec ascenseur</option><option>Étage sans ascenseur</option></select>
            </div>
          </div>
          <button class="btn fp-door__go" type="submit">Vérifier</button>
          <p class="fp-door__msg" data-door-msg aria-live="polite" hidden></p>
        </form>
        <p class="fp-door__engage">Notre engagement : si nous vous avons confirmé par écrit qu’${isFem(p) ? 'elle' : 'il'} passe, d’après vos mesures et les cotes de son carton, et qu’${isFem(p) ? 'elle' : 'il'} ne passe pas, nous ${isFem(p) ? 'la' : 'le'} reprenons à nos frais et vous remboursons. <a href="#/conditions-de-vente?s=passage">Les conditions</a></p>`, 'id="fp-passe"') : ''}
      ${confort ? accI(I.seat, 'Confort', confort) : ''}
      ${accI(I.hand, 'Matière et entretien', matBody(p, PDP.initColor), 'data-mat')}
      ${deballage ? accI(I.box, isCompressed(p) ? 'Déballage' : 'Déballage et montage', deballage) : ''}
      ${accI(I.card, 'Fiche technique', kvTable(techRows(p)))}
      ${noticeAcc(p)}
      ${accI(I.truck, 'Livraison et retour', `<ul class="fp-more__list">
          <li><b>Livraison offerte</b>, en ${delayTxt(p)}, depuis ${PAYS_DE[p.pays]}.</li>
          <li>${esc(colisTxt(p))}, ${colisN(p) === 1 ? 'avec son' : 'chacun avec son'} numéro de suivi.${compLine(p)}</li>
          <li><b>${SITE.retours.delaiJours} jours pour changer d’avis.</b> ${retourOffert(p) ? 'Retour offert : nous payons le transport du retour.' : `Retour à votre charge : environ ${price(returnCost(p)[0])} pour ${returnCost(p)[1]}.`}
            <p class="fp-ret__h">Comment se passe un retour</p>
            <ol class="fp-ret">${retourSteps(retourOffert(p)).map((t) => `<li>${t}</li>`).join('')}</ol></li>
          <li>Garantie légale de 2 ans. <a href="#/livraison">Tout sur la livraison</a></li>
        </ul>`, 'id="fp-retour"')}

      ${faqs.length ? accI(I.ask, 'Questions', `<div class="fp-qs">${faqs.map(([q, r]) => `<details class="fp-q"><summary>${esc(q)}</summary><p>${esc(r)}</p></details>`).join('')}</div>`) : ''}
      ${secReady(p) ? accI(I.shield, 'Sécurité du produit', `<p>Votre contact pour toute question sur ce produit : ${esc(SITE.nom)}, ${esc(SITE.vendeur.adresse.replace(/, France$/, ''))}, <a href="mailto:${SITE.email}">${SITE.email}</a>.</p>
          <div class="sec-list">
            <div class="fp-ref"><h3>Référence</h3>${refHtml(p, PDP.initColor, PDP.size)}</div>
            <div><h3>Fabricant</h3><p>${person(p.securite.fabricant)}</p></div>
            <div><h3>Responsable dans l'UE</h3><p>${person(p.securite.responsableUE)}</p></div>
            <div><h3>Garantie</h3><p>Garantie légale de conformité de 2 ans.</p></div>
          </div>`) : ''}
      <div class="fp-after">
        ${notYet(p) ? '' : keepBlock(p)}
        <p class="fp-contact">Une question avant de commander ? Écrivez-nous à ${mailLink('')} : la réponse arrive ${reponse()}.</p>
      </div>
    </section>

    ${related.length ? `<section class="wrap fp-sec panel fp-rel">
      <div class="rail-head">
        <div class="fp-rel__head">
          <h2 class="t-2 fp-h">${p.collection === 'canapes' ? 'Pour finir le salon' : isSleep(p) ? 'Pour finir la chambre' : 'Pour aller avec'}</h2>
        </div>
        <div class="rail-ctrl">
          <button class="round" type="button" data-action="rail" data-dir="-1" aria-label="Pièces précédentes">${I.chevL}</button>
          <button class="round" type="button" data-action="rail" data-dir="1" aria-label="Pièces suivantes">${I.chevR}</button>
        </div>
      </div>
      ${salonBlock(p, c0.nom)}
      <div class="rail" data-rail data-lenis-prevent-wheel tabindex="0" aria-label="Pièces qui vont avec">${related.map((x) => pcard(x, { reveal: false, quick: true, eager: true })).join('')}</div>
      <div class="rail-progress" aria-hidden="true"><i data-rail-bar></i></div>
    </section>` : ''}
    ${footer()}`;
    let scene;
    if (tid === 'causeuse-arches') scene = { img: tab('incurve-sel', '960'), soft: true, tint: c0.hex };
    else if (tid) scene = { img: isMobile() ? tab(tid, 'portrait-1080') : tab(tid, '1920') };
    else scene = { img: tab(SOFT[slug] || 'incurve-sel', '960'), soft: true, tint: c0.hex };
    return { title: `${p.nom}, ${p.type.toLowerCase()} · Caplia`, html: holdImgs(html), scene, nav: p.collection, after: afterProduct, pdp: true };
  }

  /* Vitesse au téléphone : la première photo de la fiche (fetchpriority="high") part seule ; les autres images de la page
     (photos suivantes, vignettes, cadeaux, pièces assorties) attendent qu'elle soit affichée pour ne pas lui prendre le
     débit (releaseImgs, appelée par afterProduct). Leurs adresses passent dans data-hsrc / data-hsrcset en attendant. */
  const holdTag = (t) => t.replace(/\s(srcset|src)="/g, ' data-h$1="');
  const holdImgs = (html) => html.replace(/<picture\b[\s\S]*?<\/picture>|<img\b[^>]*>/g, (blk) => (/fetchpriority="high"/.test(blk) ? blk : blk.replace(/<(?:img|source)\b[^>]*>/g, holdTag)));
  function releaseImgs(root) {
    const lead = $('img[fetchpriority="high"]', root);
    let done = false;
    const go = () => {
      if (done) return;
      done = true;
      /* une adresse posée entre-temps par la fiche (changement de couleur) n'est jamais écrasée */
      const put = (el, k) => { const v = el.getAttribute('data-h' + k); el.removeAttribute('data-h' + k); if (v && !el.hasAttribute(k)) el.setAttribute(k, v); };
      $$('source[data-hsrcset]', root).forEach((el) => put(el, 'srcset'));
      $$('img[data-hsrcset], img[data-hsrc]', root).forEach((el) => { put(el, 'srcset'); put(el, 'src'); });
    };
    if (!lead || (lead.complete && lead.naturalWidth)) { requestAnimationFrame(go); return; }
    lead.addEventListener('load', () => requestAnimationFrame(go), { once: true });
    lead.addEventListener('error', go, { once: true });
    setTimeout(go, 3000);
  }

  /* Aller à une image de la galerie (i = numéro de diapositive) */
  function fpGo(i, instant) {
    const tr = $('[data-fp-track]');
    if (!tr || !PDP.slides) return;
    const n = PDP.slides.length;
    i = ((i % n) + n) % n;
    PDP.lockTo = i; clearTimeout(PDP.lockT); PDP.lockT = setTimeout(() => { PDP.lockTo = null; }, 1200);
    tr.scrollTo({ left: i * tr.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
    fpSync(i);
  }
  /* Met à jour vignettes, loupe et état quand la diapositive change */
  function fpSync(i) {
    if (!PDP.slides || i === PDP.slide && PDP.synced) return;
    PDP.synced = true;
    PDP.slide = i;
    const s = PDP.slides[i];
    PDP.img = s.kind === 'photo' ? imgIndex(s) : -1;
    $$('.fp-thumb').forEach((t) => t.setAttribute('aria-selected', String(Number(t.dataset.i) === i)));
    const act = $(`.fp-thumb[data-i="${i}"]`);
    if (act) { const box = act.parentElement; const l = act.offsetLeft - (box.clientWidth - act.offsetWidth) / 2; box.scrollTo({ left: Math.max(0, l), behavior: reduce ? 'auto' : 'smooth' }); }
    const z = $('.fp-zoom'); if (z) z.hidden = !s.zoom;
    const stg = $('[data-fp-stage]'); if (stg) stg.classList.toggle('on-studio', s.kind === 'studio');
    fpVideo(i);
  }
  /* vidéo de la galerie : chargée seulement quand sa diapositive s'affiche, lue muette en boucle, arrêtée ailleurs */
  function fpVideo(i) {
    $$('[data-fp-track] .fp-video').forEach((v) => {
      const on = Number(v.closest('.fp-slide').dataset.i) === i;
      if (!on) { if (!v.paused) v.pause(); return; }
      if (!v.getAttribute('src')) { v.src = v.dataset.src; v.preload = 'auto'; }
      if (!reduce) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => { v.controls = true; }); }
    });
  }
  const imgIndex = (s) => (PDP.p ? PDP.p.images.findIndex((im) => im.id === s.id) : -1);
  /* Compatibilité : k = numéro de photo du catalogue (-1 = studio) */
  function pdpShow(k) {
    if (!PDP.slides) return;
    const im = k >= 0 && PDP.p.images[k];
    const i = im ? PDP.slides.findIndex((s) => s.id === im.id) : 0;
    fpGo(i < 0 ? 0 : i);
  }

  /* Changement de couleur : toute la galerie est remplacée (fondu court), en gardant la même vue quand la
     nouvelle couleur l'a (profil reste profil, plan reste plan) ; l'image principale est chargée avant d'apparaître. */
  function setGallery(k, instant) {
    const p = PDP.p, tr = $('[data-fp-track]'), th = $('.fp-thumbs');
    if (!tr || !th) return;
    const seq = ++PDP.galSeq;
    const cur = PDP.slides && PDP.slides[PDP.slide];
    const slides = gallerySlides(p, k);
    const keep = cur ? slides.findIndex((x) => x.key === cur.key) : -1;
    const i = keep < 0 ? 0 : keep;
    const box = document.createElement('div');
    box.innerHTML = fr(slides.map((x, j) => slideHtml(p, x, j)).join(''));
    /* l'image visible tout de suite : chargée sans attendre, et décodée avant le fondu d'entrée */
    const target = box.children[i];
    const main = target && target.querySelector('img');
    if (main) { main.loading = 'eager'; main.setAttribute('fetchpriority', 'high'); }
    const ready = main && !instant && !reduce
      ? Promise.race([main.decode ? main.decode().catch(() => {}) : Promise.resolve(), new Promise((ok) => setTimeout(ok, 450))])
      : Promise.resolve();
    const apply = () => {
      if (seq !== PDP.galSeq || !tr.isConnected) return;
      tr.replaceChildren(...box.childNodes);
      stageSet(p, k);
      th.innerHTML = fr(slides.map((x, j) => thumbHtml(x, j, i)).join(''));
      fitGallery();
      th.style.setProperty('--n', slides.length);
      if (PDP.thumbsMore) PDP.thumbsMore();
      PDP.slides = slides; PDP.galColor = k; PDP.synced = false;
      PDP.lockTo = i; clearTimeout(PDP.lockT); PDP.lockT = setTimeout(() => { PDP.lockTo = null; }, 400);
      tr.scrollLeft = i * tr.clientWidth;
      PDP.slide = -1; fpSync(i);
      tr.classList.remove('is-swap');
    };
    if (instant || reduce) { apply(); return; }
    tr.classList.add('is-swap');
    Promise.all([ready, new Promise((ok) => setTimeout(ok, 200))]).then(apply);
  }

  function pdpPrice() {
    const p = PDP.p;
    const size = p.tailles ? p.tailles[PDP.size].nom : '';
    const v = price(unitPriceOf(p, size));
    $$('[data-pdp-price]').forEach((el) => { if (el.textContent !== v) el.textContent = v; });
    const fx = $('.fp__4x[data-pp4x]'); if (fx) { fx.dataset.amount = String(unitPriceOf(p, size)); pp4xRender(fx.parentNode); }
    const gl = $('[data-pdp-gift]'); if (gl) gl.innerHTML = fr(giftLine(p));
    const rc = $('[data-pdp-recu]'); if (rc) rc.innerHTML = fr(recuHtml(p));
  }
  function pdpSize(k) {
    const p = PDP.p;
    if (!p.tailles || !p.tailles[k] || sizeOutFor(p.tailles[k], p.couleurs[PDP.color].nom)) return;
    PDP.size = k;
    PDP.done.color = true; pdpSteps();
    $$('[data-action="pdp-size"]').forEach((b) => b.setAttribute('aria-checked', String(Number(b.dataset.k) === k)));
    const s = $('[data-pdp-sizename]'); if (s) s.textContent = p.tailles[k].nom;
    pdpPrice();
    refSync();
    /* boutique : les boutons de paiement express suivent la variante choisie (adaptateur Shopify) */
    if (typeof SHOP_EXPRESS_SYNC === 'function') SHOP_EXPRESS_SYNC();
  }
  function pdpColor(k, silent) {
    const p = PDP.p;
    PDP.color = k;
    PDP.done.color = true; pdpSteps();
    const c = p.couleurs[k];
    $$('[data-action="pdp-color"]').forEach((b) => b.setAttribute('aria-checked', String(Number(b.dataset.k) === k)));
    $('[data-pdp-colname]').textContent = c.nom;
    const ef = $('[data-ens-first]');
    if (ef && !isOut(c)) ef.innerHTML = fr(pieceFit(p, c.nom, 72));
    /* la teinte en mots, écrite devant la vraie photo (catalogue.json > couleurs > teinte) */
    const te = $('[data-pdp-teinte]'); if (te) te.textContent = c.teinte || '';
    const out = isOut(c), blocked = out || notYet(p);
    const soon = $('[data-pdp-soon]'); if (soon) soon.hidden = !out;
    const add = $('[data-buy] [data-action="pdp-add"]'); if (add) add.hidden = blocked;
    const ex = $('[data-buy] .fp-express'); if (ex) ex.hidden = blocked;
    const nf = $('[data-notify]');
    if (nf) { nf.hidden = !blocked; nf.classList.remove('is-sent'); $('[data-notify-msg]', nf).hidden = true; }
    const bb = $('#buybar [data-action="pdp-add"] .cta__label'); if (bb) bb.textContent = blocked ? 'Me prévenir' : 'Ajouter au panier';
    /* tailles : celles épuisées dans cette couleur sont barrées ; la taille choisie passe à la première en vente */
    if (p.tailles && p.tailles.length > 1) {
      $$('[data-action="pdp-size"]').forEach((b) => { const t = p.tailles[Number(b.dataset.k)]; b.outerHTML = sizePill(t, Number(b.dataset.k), Number(b.dataset.k) === PDP.size, c.nom); });
      if (sizeOutFor(p.tailles[PDP.size], c.nom)) { const k2 = p.tailles.findIndex((t) => !sizeOutFor(t, c.nom)); if (k2 >= 0) pdpSize(k2); }
    }
    /* la photo de « de près » et la vignette de la barre d'achat suivent la couleur */
    const st = $('[data-story-img]'), v = storyPic(p, k);
    if (st) {
      if (v && st.getAttribute('src') !== v.src) { st.src = v.src; st.alt = v.alt; }
      if (!v) { st.removeAttribute('src'); st.alt = ''; }
      st.parentElement.hidden = !v;
      $('[data-story]').classList.toggle('fp-story--txt', !v);
    }
    /* le gros plan de la matière (volet replié) suit la couleur */
    const mi = $('[data-mat-img]'), mv = matPic(p, k);
    if (mi) {
      if (mv && mi.getAttribute('src') !== mv.src) { mi.srcset = mv.srcset; mi.src = mv.src; mi.alt = mv.alt; }
      if (!mv) { mi.removeAttribute('srcset'); mi.removeAttribute('src'); mi.alt = ''; }
      mi.parentElement.hidden = !mv;
    }
    const bt = $('#buybar .buybar__thumb'); if (bt) bt.innerHTML = fr(tightThumb(p, out ? studioColor(p) : c.nom));
    refSync();
    if (typeof SHOP_EXPRESS_SYNC === 'function') SHOP_EXPRESS_SYNC();
    /* la galerie ne montre que la couleur choisie */
    if (PDP.galColor !== k) setGallery(k, silent);
    /* adresse partageable : la fiche s'ouvrira sur cette couleur */
    if (!silent) { try { history.replaceState(history.state, '', SHOP_URL(p, c.nom)); } catch (e) { /* rien */ } }
  }
  function afterProduct(root) {
    const p = PDP.p;
    releaseImgs(root);
    pp4xRender(root);
    /* un toucher sur la photo l'agrandit (comme la loupe) ; un glissement de la galerie, non */
    const trk = $('[data-fp-track]', root);
    if (trk) {
      let sx = 0, sy = 0;
      trk.addEventListener('pointerdown', (e) => { sx = e.clientX; sy = e.clientY; });
      trk.addEventListener('click', (e) => {
        if (Math.hypot(e.clientX - sx, e.clientY - sy) > 8 || !e.target.closest('.fp-slide img')) return;
        const z = $('.fp-zoom', root);
        if (z && !z.hidden) z.click();
      });
    }
    PDP.synced = false;
    const tr = $('[data-fp-track]', root);
    if (tr) {
      let raf = 0;
      const onScroll = () => { if (raf) return; raf = requestAnimationFrame(() => {
        raf = 0;
        const i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
        if (PDP.lockTo != null) { if (i !== PDP.lockTo) return; PDP.lockTo = null; }
        fpSync(i);
      }); };
      tr.addEventListener('scroll', onScroll, { passive: true });
      tr.addEventListener('keydown', (e) => { if (e.target !== tr) return; if (e.key === 'ArrowRight') { e.preventDefault(); fpGo(PDP.slide + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); fpGo(PDP.slide - 1); } });
      const onResize = () => fpGo(PDP.slide, true);
      window.addEventListener('resize', onResize);
      /* le cadre change de proportion (fenêtre, téléphone tourné) : chaque photo est recadrée sans couper la pièce */
      fitGallery();
      const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(() => fitGallery()) : null;
      if (ro) ro.observe(tr);
      cleanups.push(() => { window.removeEventListener('resize', onResize); cancelAnimationFrame(raf); if (ro) ro.disconnect(); });
    }
    /* actions propres à la fiche (galerie, lien vers « Il passe chez vous ») */
    const onClick = (e) => {
      const b = e.target.closest('[data-fp]');
      if (!b || !root.contains(b)) return;
      const a = b.dataset.fp;
      if (a === 'prev') fpGo(PDP.slide - 1);
      else if (a === 'next') fpGo(PDP.slide + 1);
      else if (a === 'go') fpGo(Number(b.dataset.i));
      else if (a === 'avis') {
        const sec = $('#fp-avis');
        if (sec) { if (lenis) lenis.scrollTo(sec, { offset: -80 }); else sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
      }
      else if (a === 'avis-more') {
        const more = $$('[data-avis-more]');
        more.forEach((li) => { li.hidden = false; });
        b.remove();
        if (more[0]) { more[0].setAttribute('tabindex', '-1'); more[0].focus({ preventScroll: true }); }
      }
      else if (a === 'passe') toPasse(true);
    };
    root.addEventListener('click', onClick);
    cleanups.push(() => root.removeEventListener('click', onClick));
    /* « Il passe chez vous » : l'outil de la porte, plus bas sur la fiche ; ?s=passe y mène en arrivant (lien de l'accueil) */
    function toPasse(smooth) {
      const sec = $('#fp-passe', root);
      if (!sec) return;
      sec.open = true;
      const y = sec.getBoundingClientRect().top + scrollY - 80;
      if (lenis) lenis.scrollTo(y, { immediate: !smooth, force: true }); else window.scrollTo({ top: y, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      setTimeout(() => { const f = $('#door-w', root); if (f) f.focus({ preventScroll: true }); }, smooth && !reduce ? 700 : 0);
    }
    /* « Recevoir cette fiche » : Échap referme le panneau et rend la main au bouton */
    const kf = $('[data-keep-form]', root);
    if (kf) {
      const onKey = (e) => { if (e.key !== 'Escape') return; kf.hidden = true; const o = $('[data-action="keep-open"]', root); if (o) { o.setAttribute('aria-expanded', 'false'); o.focus(); } };
      kf.addEventListener('keydown', onKey);
      cleanups.push(() => kf.removeEventListener('keydown', onKey));
    }
    /* Porte : la réponse arrive dès qu'on quitte le champ, sans chercher le bouton (S3) */
    const dw = $('#door-w', root);
    if (dw) {
      const onDoor = () => { if (dw.value && dw.form.requestSubmit) dw.form.requestSubmit(); };
      dw.addEventListener('change', onDoor);
      cleanups.push(() => dw.removeEventListener('change', onDoor));
    }
    fpSync(0);
    if (PDP.initColor) pdpColor(PDP.initColor, true);
    pdpSteps();
    setupRail(root);
    const sante = Promise.resolve();
    /* arrivée par ?s=passe : on descend à l'outil une fois le confort complété (sa hauteur change ce qui est au-dessus) */
    if (qsAll().get('s') === 'passe') {
      sante.then(() => { const t = setTimeout(() => { if (PDP.p === p && root.isConnected) toPasse(false); }, 80); cleanups.push(() => clearTimeout(t)); });
    }
    /* téléphone : la rangée de vignettes s'estompe à droite tant qu'il en reste à voir */
    const th = $('.fp-thumbs', root);
    if (th) {
      const more = () => th.classList.toggle('is-more', th.scrollLeft + th.clientWidth < th.scrollWidth - 4);
      th.addEventListener('scroll', more, { passive: true });
      window.addEventListener('resize', more);
      PDP.thumbsMore = more; more();
      cleanups.push(() => { window.removeEventListener('resize', more); PDP.thumbsMore = null; });
    }
    /* barre d'achat mobile */
    const bar = $('#buybar');
    bar.innerHTML = fr(`<span class="buybar__thumb">${tightThumb(p, studioColor(p))}</span>
      <span class="buybar__info"><b>${esc(p.nom)} · <span data-pdp-price>${price(unitPriceOf(p, p.tailles ? p.tailles[PDP.size].nom : ''))}</span></b><span>${notYet(p) ? 'Livraison offerte' : deliveryShort(p)}</span></span>
      <button class="btn btn--sm" type="button" data-action="pdp-add"><span class="cta__label">${isOut(p.couleurs[PDP.color]) || notYet(p) ? 'Me prévenir' : 'Ajouter au panier'}</span></button>`);
    bar.hidden = false;
    const ctas = $('[data-buy]', root);
    if ('IntersectionObserver' in window && ctas) {
      /* la position est relue à chaque défilement (un saut ne croise pas le bouton) */
      let raf = 0;
      const place = () => {
        raf = 0;
        /* 08/10 (audit avant la pub, leçon de dapple) : le prix et le bouton visibles dès l'arrivée sur téléphone. La barre
           se montre dès que le bouton principal n'est pas à l'écran, au-dessus (dépassé) ou en dessous (pas encore atteint) ;
           jamais deux boutons à l'écran. */
        const r = ctas.getBoundingClientRect();
        bar.classList.toggle('is-on', r.height > 0 && (r.bottom < 0 || r.top > window.innerHeight - bar.offsetHeight));
      };
      const onSc = () => { if (!raf) raf = requestAnimationFrame(place); };
      window.addEventListener('scroll', onSc, { passive: true });
      place();
      const io = { disconnect: () => { window.removeEventListener('scroll', onSc); cancelAnimationFrame(raf); } };
      const ft = $('.foot', root) || $('.foot');
      const io2 = ft ? new IntersectionObserver((ents) => { ents.forEach((en) => bar.classList.toggle('is-foot', en.isIntersecting)); }, { threshold: 0 }) : null;
      if (io2) io2.observe(ft);
      cleanups.push(() => { io.disconnect(); if (io2) io2.disconnect(); });
    } else bar.classList.add('is-on');
    cleanups.push(() => { bar.hidden = true; bar.classList.remove('is-on', 'is-foot'); bar.innerHTML = ''; });
  }

  /* ---------------- Panier ---------------- */
  /* Barre déjà commencée : la pièce choisie coche la première étape, puis les 3 paliers,
     posés à intervalles égaux (la barre avance par morceaux entre deux paliers) */
  const gaugePos = (total) => {
    const S = [0].concat(SITE.paliers.map((pl) => pl.seuil));
    const n = S.length - 1;
    if (total >= S[n]) return 1;
    const i = S.findIndex((s, k) => total >= s && total < S[k + 1]);
    return (i + (total - S[i]) / (S[i + 1] - S[i])) / n;
  };
  /* Jauge sobre (CHARTE) : un filet fin, de petits points, aucun pictogramme */
  const plural = (g) => /s$/.test(g.split(' ')[0]);
  /* up : suggestions affichées sous la jauge. Quand elles débloquent le cadeau suivant, la jauge ne répète
     plus le montant manquant : elle dit seulement ce qui est déjà offert. Juste après un ajout, la confirmation
     s'affiche au-dessus des suggestions (là où se trouve le regard), ou dans la jauge s'il n'y en a plus. */
  function gaugeHtml(total, up) {
    const P = SITE.paliers;
    const done = giftsFor(total);
    const next = P.find((pl) => total < pl.seuil);
    const shortOf = (pl) => GIFT_SHORT[P.indexOf(pl)];
    const nextG = next ? shortOf(next) : '';
    const saved = giftsSaved(done);
    const doneTxt = done.length ? `${cap1(andList(done.map(shortOf)))} offert${done.length > 1 || plural(shortOf(done[0])) ? 's' : ''}${saved ? ` : vous économisez <strong>${price(saved)}</strong>` : ''}.` : '';
    const flash = UP.flash && !up ? UP.flash : '';
    const msg = flash
      ? esc(flash)
      : !next
        ? `Vos trois cadeaux sont offerts : ${andList(P.map(shortOf))}${saved ? `. Vous économisez <strong>${price(saved)}</strong>` : ''}.`
        : up && up.mode !== 'finish'
          ? doneTxt
          : `${doneTxt ? doneTxt + ' ' : ''}Encore <strong>${price(next.seuil - total)}</strong> et ${plural(nextG) ? 'les' : 'le'} ${nextG} vous ${plural(nextG) ? 'sont offerts' : 'est offert'}${done.length ? ' aussi' : ''}.`;
    const marks = [{ on: true, lbl: '', sub: '' }].concat(P.map((pl, i) => ({ on: total >= pl.seuil, lbl: cap1(GIFT_SHORT[i]), sub: price(pl.seuil), pl })));
    const accIn = cart.some((l) => isAcc(BY[l.slug]));
    const at = (i) => (i / (marks.length - 1)).toFixed(4);
    return `<div class="gauge" data-gauge>
      ${msg ? `<p class="gauge__msg${flash ? ' is-new' : ''}" tabindex="-1">${msg}${GIFTS && GIFTS.paliers ? ' <a class="link gauge__see" href="#/cadeaux">Voir les cadeaux</a>' : ''}</p>` : ''}
      <div class="gauge__track" role="progressbar" aria-label="Progression vers les cadeaux" aria-valuemin="0" aria-valuemax="${P[P.length - 1].seuil}" aria-valuenow="${Math.min(total, P[P.length - 1].seuil)}" aria-valuetext="${price(total)} sur ${price(P[P.length - 1].seuil)}">
        <span class="gauge__fill" style="--p:${gaugePos(total).toFixed(4)}"></span>
        ${marks.map((m, i) => (i ? `<span class="gauge__mark ${m.on ? 'is-on' : ''}" style="--at:${at(i)}"></span>` : '')).join('')}
      </div>
      <ol class="gauge__labels">${marks.map((m, i) => (m.lbl ? `<li class="${m.on ? 'is-on' : ''}${next && P[i - 1] === next ? ' is-next' : ''}" style="--at:${at(i)}"><span class="gauge__picw">${giftPic(m.pl, 'gauge__pic')}</span><span>${m.lbl}</span>${m.sub ? `<small>${m.on ? `Offert${plural(GIFT_SHORT[i - 1]) ? 's' : ''}` : `dès ${m.sub}`}</small>` : ''}</li>` : '')).join('')}</ol>
      ${accIn ? '<p class="gauge__note">Seuls les meubles comptent pour les cadeaux : vos coussins et plaids achetés s’ajoutent en plus.</p>' : ''}
    </div>`;
  }
  /* Suggestions du panier : jusqu'à trois pièces qui débloquent le cadeau suivant en un clic, sans quitter le panier.
     Choix par code : en stock, pas déjà dans le panier, prix au moins égal au manque et au plus près (la moins chère
     qui débloque). Avec un canapé, les pièces qui l'accompagnent passent seules si l'une suffit : jamais un second
     canapé quand une pièce moins chère fait l'affaire. Si aucune ne suffit seule : les trois qui rapprochent le plus.
     Tous les cadeaux obtenus : une seule pièce qui complète le salon, sans parler d'argent.
     Aurore (parents) : rien. Pièces secondaires : jamais (plan maître O2). */
  const SUGG = {
    meridienne: ['miroir-onde', '160 × 50 cm'],
    capiton: ['galet'], courbe: ['galet'], causeuse: ['galet'], 'petit-incurve': ['galet'], 'petit-mouton': ['galet'],
    incurve: ['miroir-onde', '160 × 50 cm'], 'noix-de-cajou': ['miroir-onde', '160 × 50 cm']
  };
  const FINISH = ['galet', 'table-nuage', 'miroir-onde'];
  const SUGG_SLEEP = { songe: ['dune'], brume: ['sillon'] };
  const FINISH_SLEEP = ['dune', 'sillon'];
  /* Ligne de bénéfice : l'accroche du catalogue ; le miroir en 140 cm ne peut pas reprendre « 160 cm de haut » */
  const UP_WHY = { 'miroir-onde': 'Bords ondulés, posé au sol sans perçage.' };
  const UP = { color: {}, flash: '' };
  const kindOf = (p) => p.type.split(/\s(?=\d|à |au |aux |en |avec |sur )/)[0].replace(/,\s*(lot de|pour)$/, '').replace(/,$/, '');
  const upSize = (p, need, color) => {
    if (!p.tailles) return { v: p.prix, size: '' };
    const t = p.tailles.filter((x) => !sizeOutFor(x, color)).sort((a, b) => a.prix - b.prix);
    if (!t.length) return { v: null, size: null };
    const ok = t.find((x) => x.prix >= need) || t[t.length - 1];
    return { v: ok.prix, size: ok.nom };
  };
  /* Couleur par défaut : celle du canapé du panier si la pièce l'a, sinon la première en stock */
  function upColor(p) {
    const keep = p.couleurs.find((c) => c.nom === UP.color[p.slug] && !c.rupture);
    if (keep) return keep.nom;
    const sofa = cart.filter((l) => BY[l.slug].collection === 'canapes' || isBed(BY[l.slug])).sort((a, b) => BY[b.slug].prix - BY[a.slug].prix)[0];
    const same = sofa && p.couleurs.find((c) => c.nom === sofa.color && !c.rupture);
    return same ? same.nom : p.couleurs[firstIn(p)].nom;
  }
  /* Les trois suggestions restent dans le même studio gris : parmi les quatre mieux placées, celles dont la vignette
     est une image studio passent devant une photo d'ambiance (une seule place cédée au plus, l'ordre de prix est gardé) */
  const studioFirst = (list) => { const top = list.slice(0, 4); return top.filter((x) => thumbIsStudio(x.p, x.color)).concat(top.filter((x) => !thumbIsStudio(x.p, x.color))).slice(0, 3).sort((a, b) => list.indexOf(a) - list.indexOf(b)); };
  /* Avec un canapé : Perle d'abord (le même cadeau, la meilleure marge), puis Mirage, puis Valse */
  const UP_ORDER = ['galet', 'miroir-onde', 'berceuse'];
  const upRank = (p) => { const i = UP_ORDER.indexOf(p.slug); return i < 0 ? UP_ORDER.length : i; };
  /* Le premier cadeau est-il atteignable dans cet univers, une pièce de chaque en vente ? Caplia Sleep : non (838 €) */
  const giftReachable = (sleep) => PRODS.filter((p) => isSleep(p) === sleep && onSale(p) && !isAcc(p))
    .reduce((s, p) => s + Math.max(...(p.tailles ? p.tailles.map((x) => x.prix) : [p.prix])), 0) >= SITE.paliers[0].seuil;
  /* La jauge et les mots « cadeau » : seulement quand le cadeau suivant peut vraiment être atteint (jamais dans une chambre seule) */
  const giftsShown = (base) => base >= SITE.paliers[0].seuil || !cart.length || !cart.every((l) => isSleep(BY[l.slug])) || giftReachable(true);
  function upsell(total) {
    if (!cart.length || cart.some((l) => l.slug === 'veilleuse')) return null;
    const inCart = new Set(cart.map((l) => l.slug));
    const sleep = cart.every((l) => isSleep(BY[l.slug]));
    const pool = PRODS.filter((p) => isSleep(p) === sleep && !inCart.has(p.slug) && !SECONDARY.includes(p.slug) && p.slug !== 'veilleuse' && !isAcc(p) && onSale(p));
    const next = SITE.paliers.find((pl) => total < pl.seuil);
    /* Chambre seule, cadeau hors d'atteinte : les bouts de lit, « Pour finir la chambre », sans parler de cadeau */
    if (!giftsShown(total)) {
      const items = FINISH_SLEEP.map((k) => BY[k]).filter((x) => x && pool.includes(x)).map((p) => { const color = upColor(p); return { p, ...upSize(p, 0, color), color }; }).filter((x) => x.v != null);
      return items.length ? { mode: 'room', sleep, items } : null;
    }
    if (!next) {
      const S = sleep ? SUGG_SLEEP : SUGG;
      const lead = cart.map((l) => BY[l.slug]).filter((p) => S[p.slug]).sort((a, b) => b.prix - a.prix)[0];
      const [slug, sz] = lead ? S[lead.slug] : [];
      const p = [slug].concat(sleep ? FINISH_SLEEP : FINISH).map((k) => BY[k]).find((x) => x && pool.includes(x));
      if (!p) return null;
      const t = p.tailles ? p.tailles.find((x) => p.slug === slug && x.nom === sz) || p.tailles[p.tailles.length - 1] : null;
      return { mode: 'finish', sleep, items: [{ p, v: t ? t.prix : p.prix, size: t ? t.nom : '', color: upColor(p) }] };
    }
    const need = next.seuil - total;
    const hasSofa = cart.some((l) => BY[l.slug].collection === 'canapes'), hasBed = cart.some((l) => isBed(BY[l.slug]));
    const sofa2 = (x) => (hasSofa && x.p.collection === 'canapes') || (hasBed && isBed(x.p));
    const all = pool.map((p) => { const color = upColor(p); return { p, ...upSize(p, need, color), color }; }).filter((x) => x.v != null);
    /* Petit panier (un fauteuil : moins de 600 €, sans canapé ni lit) : l'autre fauteuil et le miroir, jamais un canapé
       à plus de 1 000 € ; aucun palier n'est franchi, donc aucun mot de cadeau (« Pour aller avec ») */
    if (!hasSofa && !hasBed && total < 600) {
      const small = all.filter((x) => (x.p.collection === 'fauteuils' || x.p.collection === 'decoration') && x.v < need)
        .sort((a, b) => upRank(a.p) - upRank(b.p) || a.v - b.v).slice(0, 3);
      if (small.length) return { mode: 'pair', sleep, next, items: small };
    }
    const unlock = all.filter((x) => x.v >= need);
    const light = unlock.filter((x) => !sofa2(x));
    /* jamais un second lit : sans pièce légère qui suffise, on montre celles qui rapprochent du cadeau */
    const items = studioFirst((light.length ? light : hasBed ? [] : unlock).sort((a, b) => (hasSofa ? upRank(a.p) - upRank(b.p) : 0) || a.v - b.v));
    if (items.length) return { mode: 'unlock', sleep, next, items };
    const closer = studioFirst(all.filter((x) => !sofa2(x)).sort((a, b) => b.v - a.v));
    return closer.length ? { mode: 'closer', sleep, next, items: closer } : null;
  }
  function upCard({ p, v, size, color }) {
    const cs = p.couleurs.filter((c) => !c.rupture);
    const cm1 = size ? ` ${size.split(' × ')[0]} cm` : '';
    const sw = cs.length > 1 ? `<div class="up__sw" role="radiogroup" aria-label="Couleur de ${esc(p.nom)}">${cs.map((c) => `<button class="swatch" type="button" role="radio" aria-checked="${c.nom === color}" aria-label="${esc(c.nom)}" title="${esc(c.nom)}" style="--c:${c.hex}" data-action="up-color" data-slug="${p.slug}" data-color="${esc(c.nom)}"></button>`).join('')}<span class="up__cn">${esc(color)}</span></div>` : '';
    return `<li class="up__item" data-up="${p.slug}">
      <a class="up__img" href="#/p/${p.slug}" tabindex="-1" aria-hidden="true">${upThumb(p, color, '(max-width: 760px) 80px, 280px')}</a>
      <div class="up__txt">
        <p class="up__name"><a href="#/p/${p.slug}">${esc(p.nom)}</a></p>
        <p class="up__why">${esc(kindOf(p) + cm1)}. ${esc(UP_WHY[p.slug] || p.accroche.join(' '))}</p>
        ${sw}
      </div>
      <div class="up__buy">
        <p class="up__price num">${price(v)}</p>
        <button class="up__add" type="button" data-action="up-add" data-slug="${p.slug}" data-color="${esc(color)}"${size ? ` data-size="${esc(size)}"` : ''} aria-label="Ajouter ${esc(p.nom)}${cm1}, ${esc(color)}, au panier">Ajouter</button>
      </div>
    </li>`;
  }
  /* Le plaid vendu seul (79 €), proposé au panier seulement sous le premier palier (un fauteuil, un banc, une tête de lit) :
     au-dessus, le panier annonce le plaid offert et ne doit jamais le vendre à côté (supervision du 08/10). S'il devient
     offert plus tard, plaidSwap() retire la ligne payée. Les accessoires ne comptent pas pour les paliers (giftBase). */
  const ADDON = 'plaid';
  const addonItem = (p, color) => ({ p, v: p.prix, size: '', color });
  function addonHtml(base) {
    const p = BY[ADDON];
    if (!p || !onSale(p) || cart.some((l) => l.slug === ADDON) || !cart.some((l) => !isAcc(BY[l.slug]))) return '';
    if (base >= SITE.paliers[0].seuil) return '';
    return `<section class="up up--addon" aria-labelledby="addon-h">
      <h2 class="up__head" id="addon-h">Le plaid qui va avec</h2>
      <ul class="up__list">${upCard(addonItem(p, upColor(p)))}</ul>
    </section>`;
  }
  function upHtml(u, total) {
    if (!u) return '';
    const pl = u.next;
    const also = giftsFor(total).length ? 'aussi ' : '';
    const head = u.mode === 'room' ? 'Pour finir la chambre'
      : u.mode === 'pair' ? 'Pour aller avec'
      : u.mode === 'finish'
      ? (u.sleep ? 'Pour compléter votre chambre' : 'Pour compléter votre salon')
      : u.mode === 'unlock'
        ? `${u.items.length > 1 ? "Ajoutez l'une de ces pièces" : 'Ajoutez cette pièce'} et recevez ${also}${esc(pl.cadeau)}, ${lc1(giftWord(pl))}.`
        : `Ces pièces vous rapprochent du cadeau suivant, ${esc(lc1(giftLabel(pl)))}.`;
    return `<section class="up up--${u.mode}" aria-labelledby="up-h">
      ${UP.flash ? `<p class="up__ok">${esc(UP.flash)}</p>` : ''}
      <h2 class="up__head" id="up-h" tabindex="-1">${head}</h2>
      <ul class="up__list">${u.items.map(upCard).join('')}</ul>
    </section>`;
  }
  /* Ajout depuis une suggestion : le panier se met à jour sur place, la jauge avance, un message confirme
     le cadeau, les suggestions passent au palier suivant, la page ne bouge pas et le focus reste dans le bloc. */
  function upAdd(btn) {
    const p = BY[btn.dataset.slug];
    if (!p) return;
    const size = btn.dataset.size || (p.tailles ? p.tailles[0].nom : '');
    const before = giftsFor(giftBase()).length;
    addToCart(p.slug, btn.dataset.color, size, 1, true);
    const won = giftsFor(giftBase()).slice(before);
    const g = won.length ? GIFT_SHORT[SITE.paliers.indexOf(won[won.length - 1])] : '';
    const said = g ? `${plural(g) ? 'Les' : 'Le'} ${g} vous ${plural(g) ? 'sont offerts' : 'est offert'}.` : '';
    UP.flash = said || `${p.nom} est dans votre panier.`;
    /* Le bloc des suggestions est sous les lignes : la nouvelle ligne le pousse vers le bas. On garde le bloc à la même
       place à l'écran, pour que le regard ne perde pas le message de confirmation. */
    const y = window.scrollY;
    const up0 = $('.up');
    const top0 = up0 ? up0.getBoundingClientRect().top + y : null;
    const key = lineKey({ slug: p.slug, color: colorIn(p, btn.dataset.color), size });
    refreshCart();
    UP.flash = '';
    const up1 = $('.up');
    const to = top0 != null && up1 ? y + (up1.getBoundingClientRect().top + window.scrollY - top0) : y;
    if (Math.abs(window.scrollY - to) > 1) { if (lenis) lenis.scrollTo(to, { immediate: true }); else window.scrollTo({ top: to, behavior: 'instant' }); }
    const live = $('[data-cart-live]');
    if (live) { live.textContent = ''; setTimeout(() => { live.textContent = `${p.nom} ajouté au panier. ${said}`.trim(); }, 60); }
    const li = $$('.line').find((x) => x.dataset.line === key);
    if (li && !reduce) li.classList.add('is-new');
    const f = $('#up-h') || $('.gauge__msg');
    if (f) f.focus({ preventScroll: true });
  }
  function upColorPick(btn) {
    const p = BY[btn.dataset.slug];
    const li = btn.closest('.up__item');
    if (!p || !li) return;
    UP.color[p.slug] = btn.dataset.color;
    const u = upsell(giftBase());
    const x = (u && u.items.find((i) => i.p === p)) || (li.closest('.up--addon') ? addonItem(p, btn.dataset.color) : null);
    if (!x) return;
    li.outerHTML = fr(upCard(x));
    const nb = $$('.up__item').find((n) => n.dataset.up === p.slug);
    const sw = nb && $$('.swatch', nb).find((s) => s.dataset.color === btn.dataset.color);
    if (sw) sw.focus({ preventScroll: true });
  }
  /* Vignette d'une ligne : la photo studio HD pour la couleur de base, sinon la photo de la couleur */
  /* vignette en vraie photo dans le studio (toutes les pièces en ont une) */
  const thumbIsStudio = (p) => !!carteOf(p);
  /* refonte du 07/10 : la ligne du panier montre la pièce dans sa pièce (photo en situation de la couleur choisie), cadrée sur elle */
  const cartThumb = (p, color) => { const sc = scenesFor(p, color); return sc.length ? sceneImg(p, sc[0], { alt: '', sizes: '160px', eager: true, cls: 'line__scene' }) : tightThumb(p, color); };
  /* la vraie photo de la couleur choisie, recadrée sur la pièce entière (elle prend 80 % de la vignette) */
  const tightThumb = (p, color) => thumbFor(p, color);
  /* image d'une suggestion : la même vignette, à la taille du cadre (276 px sur ordinateur, 80 px au téléphone) */
  const upThumb = (p, color) => (carteOf(p) ? pieceFit(p, color, 276) : thumbFor(p, color));
  /* Délai de rétractation, sous le bouton de paiement (le détail des frais est sur la fiche et la page Livraison) */
  function returnNote() {
    return `<b>${SITE.retours.delaiJours} jours pour changer d’avis</b>`;
  }
  /* Cadeaux obtenus : une petite liste sous les pièces, alignée sur leurs noms, sans pictogramme (panier et merci).
     rows : [nom, précision, valeur à droite] */
  /* rows : [nom, précision, mot à droite, palier] ; la photo du cadeau, sa valeur barrée (prix de l'article vendu seul) et,
     sous la liste, la somme économisée */
  const giftsHtml = (rows) => {
    if (!rows.length) return '';
    const saved = giftsSaved(rows.map((r) => r[3]).filter(Boolean));
    return `<div class="gifts"><p class="gifts__h">Vos cadeaux</p><ul class="gifts__list">${rows.map(([n, d, v, pl]) => `<li class="gift">${pl ? giftPic(pl, 'gift__pic') : ''}<div><p class="gift__name">${esc(n)}</p><p class="gift__note">${esc(d)}</p></div><p class="gift__v">${pl && giftValue(pl) ? strike(giftValue(pl)) + ' ' : ''}${esc(v)}</p></li>`).join('')}</ul>${saved ? `<p class="gifts__save">Vous économisez <b class="num">${price(saved)}</b></p>` : ''}</div>`;
  };
  const slowestOf = (items) => items.slice().sort((a, b) => DL(b)[1] - DL(a)[1])[0];
  function cartInner() {
    const total = cartTotal();
    if (!cart.length && SHOP_EXTRAS().length) { setTimeout(() => location.reload(), 0); return ''; }
    if (!cart.length) {
      const all = Object.values(SITE.livraison.delais);
      const a = Math.min(...all.map((d) => d[0])), b = Math.max(...all.map((d) => d[1]));
      return `<div class="cart-empty cart-empty--img">
        <div class="cart-empty__txt"><h1 class="t-1">Votre panier est vide</h1>
        <p class="lead">Livraison offerte en France métropolitaine, chez vous en ${a} à ${b} jours ouvrés. Chaque fiche vous donne la date.</p>
        <a class="btn" href="#/canapes">Voir les canapés</a></div>
        <figure class="cart-empty__img"><img src="/site/assets/univers/accueil-ordi.webp" width="2400" height="1029" alt="${esc(HOME_HERO.alt)}" decoding="async" draggable="false"></figure>
      </div>
      <div class="cart-start">
        <h2 class="t-2">Pour commencer</h2>
        <div class="grid">${['incurve', 'causeuse', 'noix-de-cajou', 'galet'].filter((k) => BY[k]).slice(0, 3).map((k) => pcard(BY[k], { reveal: false })).join('')}</div>
      </div>`;
    }
    const base = giftBase();
    const gifts = giftsFor(base);
    const up = upsell(base);
    const items = cart.map((l) => BY[l.slug]);
    const when = delivery(slowestOf(items));
    const count = cartCount();
    /* Plusieurs colis : on l'annonce avant, pour qu'un premier carton arrivé seul n'inquiète pas */
    const nPieces = cart.reduce((s, l) => s + (parseInt(BY[l.slug].colis, 10) || NaN) * l.qty, 0);
    const nColis = nPieces + gifts.length;
    /* le cadeau le plus lent (coussins depuis la Chine) : s'il arrive après les pièces, il a sa propre date */
    const gSlow = gifts.map(giftProd).filter(Boolean).sort((a, b) => DL(b)[1] - DL(a)[1])[0];
    const giftLater = !!gSlow && DL(gSlow)[1] > DL(slowestOf(items))[1];
    /* trois repères, une ligne chacun : la date, le retour, le paiement */
    const whenLine = giftLater
      ? `<b>Livraison offerte</b>, ${nPieces > 1 ? `${nPieces} colis` : 'chez vous'} ${when} ; ${gifts.length > 1 ? 'vos cadeaux, dans des colis à part' : 'votre cadeau, dans un colis à part'}, ${delivery(gSlow)}`
      : `<b>Livraison offerte</b>, ${nColis > 1 ? `${nColis} colis` : 'chez vous'} ${when}`;
    const giftPl = (pl) => plural(GIFT_SHORT[SITE.paliers.indexOf(pl)]);
    return `<div class="cart-head">
        <h1 class="t-1">Votre panier</h1>
        ${giftsShown(base) ? gaugeHtml(base, up) : ''}
      </div>
      <div class="cart__grid">
        <div class="cart__main">
          <h2 class="sr-only">Vos pièces</h2>
          <ul class="lines">
            ${cart.map((l) => {
              const p = BY[l.slug];
              const key = esc(lineKey(l));
              return `<li class="line" data-line="${key}">
                <a class="line__thumb" href="#/p/${p.slug}" aria-label="${esc(p.nom)}">${cartThumb(p, l.color)}</a>
                <div class="line__info"><a class="line__name" href="#/p/${p.slug}">${esc(p.nom)}</a><p class="line__var">${p.couleurs.length > 1 ? esc(l.color) + ' · ' : ''}${esc(cardType(p))}${l.size ? ' · ' + esc(l.size) : ''}</p></div>
                <div class="qty" role="group" aria-label="Quantité de ${esc(p.nom)}">
                  <button type="button" data-action="qty" data-key="${key}" data-d="-1" aria-label="Retirer un exemplaire"${l.qty < 2 ? ' disabled' : ''}>${I.minus}</button>
                  <output aria-live="polite">${l.qty}</output>
                  <button type="button" data-action="qty" data-key="${key}" data-d="1" aria-label="Ajouter un exemplaire"${l.qty > 8 ? ' disabled' : ''}>${I.plus}</button>
                </div>
                <p class="line__total">${price(lineTotal(l))}</p>
                <button class="line__x" type="button" data-action="remove" data-key="${key}" aria-label="Retirer ${esc(p.nom)} du panier">Retirer</button>
              </li>`;
            }).join('')}${SHOP_EXTRA_HTML()}
          </ul>
          ${giftsHtml(gifts.map((pl, i) => [giftLabel(pl), `${pl.produit === PLAID && i === gifts.findIndex((x) => x.produit === PLAID) && plaidPref() ? `${plaidPref()} · ` : ''}Livré${giftPl(pl) ? 's' : ''} dans un colis à part, ${giftWhen(pl)}`, `Offert${giftPl(pl) ? 's' : ''}`, pl]))}
          ${swapMsg() ? `<p class="up__ok cart__swap" role="status">${esc(swapMsg())}</p>` : ''}
          <div class="cart__save"><button class="link" type="button" data-action="save-cart">Enregistrer dans ma sélection</button></div>
          ${upHtml(up, base)}
          ${addonHtml(base)}
        </div>
        <aside class="sum" aria-label="Récapitulatif">
          <dl>
            <div><dt>${count} pièce${count > 1 ? 's' : ''}</dt><dd>${price(total)}</dd></div>
            <div><dt>Livraison</dt><dd>Offerte</dd></div>
            <div><dt>Éco-participation</dt><dd>${(() => { const e = items.reduce((s, p, i) => { const v = ecoOf(p); return v == null || s == null ? null : s + v * cart[i].qty; }, 0); return e == null ? 'Comprise' : `dont ${price(e)}`; })()}</dd></div>
            <div class="total"><dt>Total</dt><dd>${price(total)}</dd></div>
          </dl>
          ${pp4xSlot('sum__4x', total, 'cart', 'right')}
          <p class="sum__tva">${esc(SITE.vendeur.tva.replace('article 293 B du Code général des impôts', 'art. 293 B du CGI'))}.</p>
          <button class="btn btn--block sum__go" type="button" data-action="checkout"><span class="cta__label">Passer au paiement</span></button>
          ${expressMock('panier')}
          <p class="sum__when">${whenLine}.</p>
          ${trustHtml(null)}
          <p class="sum__note">Après votre commande, nous pourrons vous écrire au sujet de pièces assorties. Un clic suffit pour arrêter.</p>
        </aside>
      </div>
      <div class="cartbar" data-cartbar aria-hidden="true">
        <p><span>Livraison offerte</span><b>${price(total)}</b></p>
        <button class="btn btn--sm" type="button" data-action="checkout" tabindex="-1"><span class="cta__label">Passer au paiement</span></button>
      </div>`;
  }
  function renderCart() {
    if (!cart.length && SHOP_EXTRAS().length) return null;
    takeShared('panier');
    const html = `<section class="wrap cart">
      <div data-cart>${cartInner()}</div>
      <p class="sr-only" role="status" aria-live="polite" data-cart-live></p>
    </section>${footer()}`;
    return { title: 'Panier · Caplia', html, scene: { img: tab('petit-incurve-galerie', '960'), soft: true, tint: '#cdb59a' }, after: () => { animateGauge(); cartBar(); pp4xRender(); } };
  }
  /* Téléphone : barre « Total · Payer » toujours en bas, sauf quand le vrai bouton est à l'écran (un seul bouton noir)
     et quand le pied de page arrive (comme la barre d'achat des fiches : elle ne cache pas ses liens) */
  let cartBarIO = null;
  function cartBar() {
    if (cartBarIO) { cartBarIO.disconnect(); cartBarIO = null; }
    const bar = $('[data-cartbar]'), go = $('.sum__go'), foot = $('#app .foot');
    if (!bar || !go || !('IntersectionObserver' in window)) return;
    const seen = new Set();
    cartBarIO = new IntersectionObserver((ents) => {
      ents.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
      const show = seen.size === 0;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      $$('button', bar).forEach((b) => b.setAttribute('tabindex', show ? '0' : '-1'));
    });
    cartBarIO.observe(go);
    if (foot) cartBarIO.observe(foot);
    cleanups.push(() => { if (cartBarIO) { cartBarIO.disconnect(); cartBarIO = null; } });
  }
  function animateGauge() {
    const f = $('.gauge__fill');
    if (!f || reduce) return;
    const v = f.style.getPropertyValue('--p');
    f.style.setProperty('--p', '0');
    requestAnimationFrame(() => requestAnimationFrame(() => f.style.setProperty('--p', v)));
  }
  function refreshCart() {
    const host = $('[data-cart]');
    if (!host) return;
    const oldP = ($('.gauge__fill') || {}).style ? $('.gauge__fill').style.getPropertyValue('--p') : '0';
    host.innerHTML = fr(cartInner());
    pp4xRender(host);
    /* boutique : les vrais boutons de paiement express reprennent leur place dans le panier refait */
    if (typeof SLOT_REFILL === 'function') SLOT_REFILL(host);
    const f = $('.gauge__fill');
    if (f && !reduce) {
      const v = f.style.getPropertyValue('--p');
      f.style.setProperty('--p', oldP || '0');
      requestAnimationFrame(() => requestAnimationFrame(() => f.style.setProperty('--p', v)));
    }
    cartBar();
    if (ST()) ST().refresh();
  }

  /* ---------------- Pages texte ---------------- */
  /* À droite des pages texte (grand écran) : la personne qui répond, plutôt qu'un blanc */
  /* Pages de lecture : titre, phrase d'introduction, sommaire à gauche (grand écran) ou replié (téléphone),
     texte sur 66 caractères de large, contact discret à droite. Les liens du sommaire défilent sans changer
     l'adresse (le routeur lit le « # »). */
  /* Pages d'aide illustrées (refonte du 07/10) : hero = une grande image sous le titre ; strip = les étapes en vraies
     photos ({ src: chemin sans largeur sous site/assets, w, alt, t: légende }) */
  const pagePic = (src, alt, sizes, eager = false, w = 1280) => `<img src="/site/assets/${src}-${w}.webp" srcset="/site/assets/${src}-640.webp 640w, /site/assets/${src}-${w}.webp ${w}w" sizes="${sizes}" alt="${esc(alt)}" ${eager ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async" draggable="false">`;
  function docPage({ title, lead = '', sections, intro = '', media = '', toc, scene, contact = true, hero = '', strip = null }) {
    const withToc = toc ?? sections.length >= 4;
    const here = location.pathname;
    const html = `<section class="wrap lp">
      <header class="lp__head${media ? ' lp__head--media' : ''}">
        <div class="lp__htext"><h1 class="t-1 lp__title">${title}</h1>${lead ? `<p class="lead lp__lead">${lead}</p>` : ''}</div>
        ${media ? `<div class="lp__media">${media}</div>` : ''}
      </header>
      ${hero ? `<figure class="lp__hero">${hero}</figure>` : ''}
      ${strip ? `<ol class="lp__strip" role="list">${strip.map((x) => `<li><figure>${x.html}<figcaption>${esc(x.t)}</figcaption></figure></li>`).join('')}</ol>` : ''}
      ${intro}
      <div class="lp__body${withToc ? '' : ' lp__body--notoc'}">
        ${withToc ? `<nav class="lp__toc" aria-label="Sommaire"><details class="lp__tocbox" open><summary>Sommaire<span class="round" aria-hidden="true">${I.plus}</span></summary>
          <ol>${sections.map((s) => `<li><a href="${here}" data-toc="${s.id}">${s.toc || s.title}</a></li>`).join('')}</ol></details></nav>` : ''}
        <article class="lp__text">
          ${sections.map((s) => (s.fold
            ? `<section class="lp__sec lp__sec--fold" id="${s.id}"><details class="acc lp__fold"><summary><h2 class="lp__h2">${s.title}</h2><span class="round" aria-hidden="true">${I.plus}</span></summary><div class="acc__body">${s.html}</div></details></section>`
            : `<section class="lp__sec" id="${s.id}">${s.pic ? `<div class="lp__h2row"><span class="lp__pic" aria-hidden="true">${s.pic}</span><h2 class="lp__h2">${s.title}</h2></div>` : `<h2 class="lp__h2">${s.title}</h2>`}${s.html}</section>`)).join('')}
        </article>
        ${contact ? `<aside class="lp__contact" aria-label="Nous joindre">
          <p class="lp__ct">${typeof contact === 'string' ? contact : 'Une question ?'}</p>
          <p>Écrivez-nous à ${mailLink()} : nous vous répondons ${reponse()}.</p>
        </aside>` : ''}
      </div>
    </section>${footer()}`;
    const after = (root) => {
      /* ?s=<section> : on arrive sur la section (liens vers « des nouvelles à chaque étape », « Il passe chez vous »…) */
      const s = qsAll().get('s');
      if (s) {
        const t = setTimeout(() => {
          const el = document.getElementById(s);
          if (!el || !el.classList.contains('lp__sec')) return;
          const fd = el.querySelector('details.lp__fold'); if (fd) fd.open = true;
          const y = el.getBoundingClientRect().top + scrollY - 96;
          if (lenis) lenis.scrollTo(y, { immediate: true, force: true }); else window.scrollTo(0, y);
        }, 80);
        cleanups.push(() => clearTimeout(t));
      }
      const box = $('.lp__tocbox', root);
      if (!box) return;
      const wide = matchMedia('(min-width: 1100px)');
      box.open = wide.matches;
      const links = $$('[data-toc]', box);
      const onClick = (e) => {
        const a = e.target.closest('[data-toc]');
        if (!a) return;
        e.preventDefault();
        const el = document.getElementById(a.dataset.toc);
        if (!el) return;
        if (!wide.matches) box.open = false;
        if (lenis) lenis.scrollTo(el, { offset: -96 });
        else el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      };
      box.addEventListener('click', onClick);
      /* Le sommaire suit la lecture : la section à l'écran est en noir */
      const io = new IntersectionObserver((es) => {
        es.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((l) => l.classList.toggle('is-here', l.dataset.toc === en.target.id));
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      $$('.lp__sec', root).forEach((s) => io.observe(s));
      cleanups.push(() => { io.disconnect(); box.removeEventListener('click', onClick); });
    };
    return { html, after, scene: scene || { img: tab('petit-incurve-galerie', '960'), soft: true } };
  }
  const acc = (q, r) => `<details class="acc"><summary>${q}<span class="round" aria-hidden="true">${I.plus}</span></summary><div class="acc__body">${r}</div></details>`;

  /* Carte stylisée des entrepôts (Livraison) : trois points placés à peu près où ils sont, sans frontières, et leur délai */
  function depotsMap(d) {
    const pt = (x, y, t, j, anchor = 'start') => `<circle cx="${x}" cy="${y}" r="7" class="dm__pt"/><text x="${x + (anchor === 'end' ? -14 : 14)}" y="${y - 4}" text-anchor="${anchor}" class="dm__t">${t}</text><text x="${x + (anchor === 'end' ? -14 : 14)}" y="${y + 16}" text-anchor="${anchor}" class="dm__j">${j}</text>`;
    return `<figure class="dm" aria-label="Nos entrepôts en France, en Allemagne et en Espagne">
      <svg viewBox="0 0 520 300" role="img" aria-hidden="true"><path class="dm__route" d="M150 222 Q 200 200 238 168"/><path class="dm__route" d="M390 100 Q 320 120 250 160"/>
        ${pt(150, 222, 'Espagne', `${d.ES[0]} à ${d.ES[1]} jours ouvrés`, 'end')}${pt(390, 100, 'Allemagne', `${d.DE[0]} à ${d.DE[1]} jours ouvrés`)}${pt(245, 165, 'France', `${d.FR[0]} à ${d.FR[1]} jours ouvrés`)}
      </svg></figure>`;
  }
  function renderLivraison() {
    const d = SITE.livraison.delais;
    const R = SITE.retours.delaiJours;
    /* Les pièces regroupées par nombre de colis (« 2 cartons » = « 2 colis ») */
    const colis = {};
    PRODS.filter((p) => p.colis).forEach((p) => {
      const n = (p.colis.match(/^\d+/) || [])[0];
      const k = n ? `${n} colis` : 'Selon la commande';
      (colis[k] = colis[k] || []).push(esc(p.nom));
    });
    const cle = Object.keys(colis).sort((a, b) => (parseInt(a, 10) || 99) - (parseInt(b, 10) || 99));
    const intro = `<ul class="lp__facts">
      <li><p class="lp__fig">${d.FR[0]} à ${d.FR[1]}</p><p>jours ouvrés pour les pièces en stock en France</p></li>
      <li><p class="lp__fig">${euMin()} à ${euMax()}</p><p>jours ouvrés pour les pièces en stock ${euEn()}</p></li>
      <li><p class="lp__fig">0${NB}€</p><p>de livraison, quel que soit le montant</p></li>
    </ul>`;
    const r = docPage({
      contact: 'Une question avant de choisir ?',
      title: 'La date avant de payer, la livraison offerte',
      lead: `Nos pièces attendent dans des entrepôts en Europe : chaque fiche donne leur date de livraison avant que vous payiez, puis des nouvelles arrivent à chaque étape. La livraison est offerte en France métropolitaine, quel que soit le montant.`,
      strip: ARR && ARR.etapes ? ARR.etapes.filter((e) => e.photo).map((e) => ({ t: e.titre, html: `<img src="/site/assets/${e.photo.src}-640.webp" alt="${esc(e.photo.alt)}" width="${e.photo.w}" height="${e.photo.h}" loading="lazy" decoding="async" draggable="false">` })) : null,
      sections: [
        { id: 'delais', title: 'Quand arrive votre pièce', toc: 'Délais', html: `${depotsMap(d)}<p>Comptez <strong>${d.FR[0]} à ${d.FR[1]} jours ouvrés</strong> depuis la France, <strong>${euMin()} à ${euMax()} jours ouvrés</strong> depuis ${euDe()}, du lundi au vendredi hors jours fériés.${accDelay()}</p>
          <p>Vous connaissez la date avant de payer : chaque fiche la calcule le jour de votre visite. ${esc(BY.incurve.nom)}, commandé aujourd'hui, arrive chez vous <strong>${delivery(BY.incurve)}</strong>.</p>` },
        { fold: true, id: 'nouvelles', title: 'Des nouvelles à chaque étape', toc: 'Nouvelles', html: `<p>Vous n'avez rien à demander : un e-mail confirme votre commande et sa date de livraison, un autre part avec le lien de suivi de chaque colis dès qu'il quitte l'entrepôt, un dernier arrive à l'approche de la livraison.</p>
          <p><strong>Si un colis prend du retard, nous vous écrivons avant que vous ayez à le demander</strong>, avec sa nouvelle date. Et quand vous nous écrivez, la réponse arrive ${reponse()}.</p>` },
        { id: 'passage', title: 'Il passe chez vous, ou nous le reprenons', toc: 'Passage', html: `<p>La plupart de nos canapés voyagent compressés ou en modules, dans des cartons plus petits qu'eux.</p>
          <p>Envoyez-nous la largeur de votre porte la plus étroite et de votre escalier, et l'étage : nous vérifions que la pièce passe et vous répondons par écrit, avant l'achat. <strong>Si nous avons dit oui et qu'elle ne passe pas, nous la reprenons à nos frais et vous remboursons.</strong></p>
          <p>Notre réponse s'appuie sur vos mesures et sur celles du plus grand carton de la pièce ; quand elles ne sont pas encore écrites sur la fiche, nous les vérifions avant de vous répondre. Le détail est dans nos <a href="#/conditions-de-vente?s=passage">conditions de vente</a>.</p>` },
        { fold: true, id: 'colis', title: 'Colis et déballage', toc: 'Colis', html: `<p>Les colis sont livrés à votre adresse par un transporteur de colis ; chacun a son numéro de suivi. Les cartons d'un canapé compressé se portent à deux. Une fois ouvert, il reprend sa forme dans le temps écrit sur sa fiche ; les canapés en modules se réunissent sur place, sans outil. <a href="#/arrivee">Les étapes en photos</a>. Le nombre de colis de chaque pièce :</p>
          <dl class="lp__kv">${cle.map((k) => `<dt>${k}</dt><dd>${andList(colis[k])}</dd>`).join('')}</dl>` },
        { fold: true, id: 'retractation', title: `Changer d'avis : ${R} jours`, toc: "Changer d'avis", html: `<p>Comme la loi le prévoit, vous avez <strong>${R} jours après la réception</strong> pour changer d'avis, sans avoir à vous justifier.</p>
          <h3>Comment se passe un retour</h3>
          <ol class="lp__steps">
            <li>Dans les ${R} jours qui suivent la réception, remplissez la page <a href="#/renoncer">Renoncer au contrat ici</a>, ou écrivez-nous à <a href="mailto:${SITE.email}">${SITE.email}</a> avec votre numéro de commande.</li>
            <li>Nous vous indiquons l'adresse de retour et un transporteur adapté à la pièce. ${retourCout()}</li>
            <li>La pièce repart complète, bien protégée, dans les ${R} jours qui suivent votre message. Un canapé qui a pris sa forme ne rentre plus dans son carton, c'est normal : une housse ou un film épais suffit à le protéger.</li>
            <li>Vous êtes remboursé au plus tard ${R} jours après votre demande, sur le moyen de paiement utilisé. Nous pouvons attendre d'avoir reçu la pièce ou la preuve de son envoi.</li>
          </ol>
          <p>Le détail est dans nos <a href="#/conditions-de-vente">conditions de vente</a>.</p>` },
        { fold: true, id: 'conformite', title: 'Un souci à l’arrivée ? Une photo suffit', toc: 'Un souci à l’arrivée', html: `<p>Un pied abîmé, une pièce qui manque ? Envoyez une photo par e-mail ou par le <a href="#/un-souci">formulaire</a> : nous nous occupons du reste, sans frais pour vous.</p>
          <p>Comme la loi le prévoit, chaque pièce a la <strong>garantie légale de conformité de 2 ans</strong> : réparation, remplacement ou remboursement. Ce qu'elle couvre, avec des exemples : <a href="#/garantie">Garantie légale, en clair</a>.</p>` },
        { id: 'cadeaux', title: 'Vos cadeaux', html: `<p>Offerts parce qu'un canapé se pose rarement seul : de quoi habiller votre salon dès le premier soir. Ils s'ajoutent tout seuls au panier, sans code.</p>
          <ul>${SITE.paliers.map((pl) => `<li><strong>Dès ${price(pl.seuil)}</strong> : ${esc(pl.cadeau)}${giftValue(pl) ? ` ${strike(giftValue(pl))}` : ''}, offert${/^\d|coussins/.test(pl.cadeau) ? 's' : ''}.</li>`).join('')}</ul><p>${GIFT_RULE}</p>
          <p>Ils voyagent dans un colis à part. <a href="#/cadeaux">Les cadeaux en photos</a></p>` }
      ],
      scene: { img: tab('petit-mouton-paris', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Livraison offerte et retours · Caplia', nav: 'livraison' });
  }

  /* ---------------- Comment il arrive chez vous (#/arrivee) ----------------
     Les quatre étapes en vraies photos (recadrées, sans texte ni personne), puis chaque pièce : colis, contenu du carton,
     temps de reprise de forme recopié de sa fiche, poids et mesures seulement quand ils sont connus. */
  function renderArrivee() {
    if (!ARR || !ARR.etapes) return render404();
    const E = ARR.etapes;
    const rows = PRODS.filter((p) => arrOf(p) && !isSleep(p) && !notYet(p)).sort((x, y) => (arrOf(y).compresse - arrOf(x).compresse) || (y.prix - x.prix));
    const colisCell = (p, a) => (a.colisTxt ? esc(nbUnits(a.colisTxt)) : colisN(p) ? `${colisN(p)} colis` : esc(p.colis));
    const formeCell = (a) => (a.compresse ? `<strong class="num">${esc(a.forme)}</strong>${a.detail ? `<span>${esc(a.detail)}</span>` : ''}` : '<span>Livré prêt, sans compression</span>');
    const html = `<section class="wrap ar">
      <header class="ar__head">
        <h1 class="t-1">Comment il arrive chez vous</h1>
        <p class="lead ar__lead">Nos canapés compressés voyagent dans des cartons plus petits qu’eux. Le jour de la livraison, voici ce qui se passe, en vraies photos.</p>
      </header>
      <ol class="ar__steps">${E.map((e, i) => `<li class="ar__step${i === E.length - 1 ? ' ar__step--wide' : ''}">
        <figure class="ar__img">${stepPic(e, i === E.length - 1 ? '(max-width: 760px) calc(100vw - 32px), 1280px' : '(max-width: 760px) calc(100vw - 32px), 31vw')}</figure>
        <h2 class="t-3 ar__t">${esc(e.titre)}</h2>
        <p class="ar__p">${esc(e.texte)}</p>
      </li>`).join('')}</ol>
      <section class="ar__table" aria-labelledby="ar-t">
        <h2 class="t-2" id="ar-t">Pièce par pièce</h2>
        <div class="ar__scroll" tabindex="0" role="region" aria-label="Arrivée de chaque pièce">
          <table class="table ar__tbl">
            <thead><tr><th scope="col">Pièce</th><th scope="col">Colis</th><th scope="col">Dans le carton</th><th scope="col">Reprise de forme</th></tr></thead>
            <tbody>${rows.map((p) => { const a = arrOf(p); return `<tr><th scope="row"><a class="ar__pn" href="#/p/${p.slug}">${esc(p.nom)}</a><span>${esc(cardType(p))}</span></th><td data-l="Colis">${colisCell(p, a)}</td><td data-l="Dans le carton">${p.carton ? esc(p.carton.map((t, i) => (i ? lc1(t) : t)).join(', ')) : esc(a.geste)}</td><td data-l="Reprise de forme">${formeCell(a)}</td></tr>`; }).join('')}</tbody>
          </table>
        </div>
      </section>
      <p class="ar__ask">Une question sur une livraison ? Écrivez-nous à ${mailLink()} : réponse ${reponse()}. <a class="link" href="#/livraison">Délais, livraison offerte et retours</a></p>
    </section>${footer()}`;
    return { title: 'Comment il arrive chez vous : livraison compressée · Caplia', html, nav: 'livraison', scene: { img: tab('petit-mouton-paris', '960'), soft: true } };
  }

  /* ---------------- Les cadeaux (#/cadeaux) ----------------
     Les trois paliers de site.json (seuils, accord « Offert(s) »), chacun avec ses vraies photos (cadeaux.json : la pièce
     dans le studio gris, puis de près ou en situation) et deux phrases ; aucune valeur en euros des cadeaux. Avec un panier
     en cours, une ligne dit ce qui est déjà offert et ce qu'il manque. Puis comment ils s'ajoutent. */
  function renderCadeaux() {
    if (!GIFTS || !GIFTS.paliers) return render404();
    const P = SITE.paliers;
    const pic = (ph, sizes, first) => {
      const t = Object.entries(ph.tailles);
      const set = (ext) => t.map(([k, w]) => `/site/assets/${ph.src}-${k}.${ext} ${w}w`).join(', ');
      return `<picture>${ph.avif ? `<source type="image/avif" srcset="${set('avif')}" sizes="${sizes}">` : ''}<img src="/site/assets/${ph.src}-${t[t.length - 1][0]}.webp" srcset="${set('webp')}" sizes="${sizes}" width="${ph.w}" height="${ph.h}" alt="${esc(ph.alt)}" ${first ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async"></picture>`;
    };
    /* le panier en cours : « les coussins nœud et le plaid sont déjà offerts. Encore 110 € et le second plaid… » */
    const total = giftBase();
    const got = giftsFor(total), next = P.find((pl) => total < pl.seuil);
    const short = (pl) => GIFT_SHORT[P.indexOf(pl)];
    const the = (pl) => `${plural(short(pl)) ? 'les' : 'le'} ${short(pl)}`;
    const many = got.length > 1 || (got.length && plural(short(got[0])));
    const now = !total ? '' : `<p class="cx__now">${!next
      ? 'Avec votre panier, vos trois cadeaux sont offerts.'
      : `${got.length ? `Avec votre panier, ${andList(got.map(the))} ${many ? 'sont' : 'est'} déjà offert${many ? 's' : ''}. Encore` : 'Encore'} <strong>${price(next.seuil - total)}</strong>${got.length ? '' : ' dans votre panier'} et ${the(next)} vous ${plural(short(next)) ? 'sont offerts' : 'est offert'}${got.length ? ' aussi' : ''}.`} <a class="link" href="#/panier">Voir mon panier</a></p>`;
    const tiers = P.map((pl, i) => {
      const g = GIFTS.paliers[i];
      if (!g) return '';
      const [main, more0] = g.photos || [];
      /* refonte du 07/10 : plus la photo du vendeur sur un canapé gris qui n'est pas le nôtre (les cadeaux sur Corolle sont en tête de page) */
      const more = more0 && more0.src === 'cadeaux/coussins-noeud' ? null : more0;
      return `<li class="cx__tier${i % 2 ? ' cx__tier--alt' : ''}" id="palier-${i + 1}">
        ${main ? `<figure class="cx__main">${pic(main, '(max-width: 760px) calc(100vw - 32px), (max-width: 1360px) 50vw, 680px', i === 0)}</figure>` : ''}
        <div class="cx__txt">
          <h2 class="t-2 cx__t">${esc(g.titre)}</h2>
          <p class="cx__seuil">${giftWord(pl)} dès <span class="num">${price(pl.seuil)}</span> de meubles</p>
          <p class="cx__p">${esc(nbUnits(g.texte))}</p>
          ${giftValue(pl) && i < 2 ? `<p class="cx__seul">Aussi vendu${plural(GIFT_SHORT[i]) ? 's' : ''} seul${plural(GIFT_SHORT[i]) ? 's' : ''}, ${price(giftValue(pl))} : <a class="link" href="#/p/${pl.produit}">voir ${plural(GIFT_SHORT[i]) ? 'les' : 'le'} ${esc(BY[pl.produit].nom.toLowerCase())}</a></p>` : ''}
          ${more ? `<figure class="cx__more" style="aspect-ratio: ${more.w} / ${more.h}">${pic(more, '(max-width: 760px) calc(100vw - 32px), (max-width: 1360px) 36vw, 480px')}</figure>` : ''}
        </div>
      </li>`;
    }).join('');
    const html = `<section class="wrap cx">
      <header class="cx__head">
        <h1 class="t-1">Les cadeaux</h1>
        <p class="lead cx__lead">Un canapé se pose rarement seul. Selon le montant de vos meubles, ces pièces vous sont offertes, et elles s’additionnent.</p>
        ${now}
      </header>
      <figure class="lp__hero cx__hero"><img src="/site/assets/cadeaux/salon-cadeaux-1600.webp" srcset="/site/assets/cadeaux/salon-cadeaux-800.webp 800w, /site/assets/cadeaux/salon-cadeaux-1600.webp 1600w" sizes="(max-width: 760px) 100vw, 1360px" width="1600" height="1200" alt="Mise en scène de Corolle avec les deux coussins nœud, crème et gris, et le plaid côtelé gris clair plié sur l’assise" fetchpriority="high" decoding="async" draggable="false"></figure>
      <ol class="cx__list">${tiers}</ol>
      <section class="cx__how" aria-labelledby="cx-how">
        <h2 class="t-2" id="cx-how">Comment ils s’ajoutent</h2>
        <ul class="cx__steps">${(GIFTS.ajout || []).map(([t, x]) => `<li><h3 class="cx__st">${esc(t)}</h3><p>${esc(x)}</p></li>`).join('')}</ul>
        <p class="cx__rule">${GIFT_RULE}</p>
      </section>
      <div class="cx__end">
        <a class="btn" href="#/canapes">Voir les canapés</a>
        <p class="cx__ask">Une question sur un cadeau ? Écrivez-nous à ${mailLink()} : réponse ${reponse()}.</p>
      </div>
    </section>${footer()}`;
    const after = () => setDesc(`Les cadeaux Caplia : ${andList(P.map((pl) => `${pl.cadeau} dès ${price(pl.seuil)} d’achat`))}. Ajoutés tout seuls au panier, sans code, livrés dans leur propre colis.`);
    return { title: 'Les cadeaux offerts avec votre commande · Caplia', html, after };
  }

  /* ---------------- Nos matières (#/matieres, ?m=<matière> pour arriver sur l'une d'elles) ----------------
     Chaque tissu de près (vraie photo quand elle est nette, sinon la section reste en texte seul, sur une colonne),
     le toucher, les trois gestes d'entretien et les pièces de salon qui les portent (jamais Caplia Sleep).
     Données : site/data/matieres.json. L'introduction ne compte pas les tissus : une photo retirée ne la rend pas fausse. */
  function renderMatieres() {
    if (!MAT || !MAT.matieres) return render404();
    const piecesOf = (k) => PRODS.filter((p) => { const x = MAT.pieces[p.slug]; return x && x.matiere === k && !isSleep(p) && !notYet(p); });
    /* une matière sans pièce en ligne (pièces masquées) n'est pas présentée */
    const keys = (MAT.ordre || Object.keys(MAT.matieres)).filter((k) => MAT.matieres[k] && piecesOf(k).length);
    const picOf = (m) => {
      const ph = m.photo || {};
      if (ph.src) return { src: asset(ph.src, 640), srcset: `${asset(ph.src, 640)} 640w` };
      const p = BY[ph.slug];
      return p ? { src: photo(p, ph.id, 1280), srcset: `${photo(p, ph.id, 640)} 640w, ${photo(p, ph.id, 1280)} 1280w` } : null;
    };
    const enOf = (k, m) => (k === 'effet-lin' ? 'tissu effet lin' : lc1(m.nom));
    const sec = (k, i) => {
      const m = MAT.matieres[k], ps = piecesOf(k), v = picOf(m);
      return `<section class="mt__sec${!v ? ' mt__sec--txt' : i % 2 ? ' mt__sec--alt' : ''}" id="m-${k}" aria-labelledby="m-${k}-t">
        ${v ? `<figure class="mt__img"><img src="${v.src}" srcset="${v.srcset}" sizes="(max-width: 980px) calc(100vw - 32px), 44vw" alt="${esc(m.photo.alt)}" ${i ? 'loading="lazy"' : 'fetchpriority="high"'} decoding="async"></figure>` : ''}
        <div class="mt__txt">
          <h2 class="t-2" id="m-${k}-t">${esc(m.nom)}</h2>
          <p class="mt__touch">${esc(m.toucher)}</p>
          <h3 class="mat-h3">L’entretien, en trois gestes</h3>
          ${careHtml(m)}
          ${ps.length ? `<h3 class="mat-h3">Nos pièces en ${esc(enOf(k, m))}</h3>
          <ul class="mt__pieces">${ps.map((p) => `<li><a class="mt__piece" href="#/p/${p.slug}"><span class="mt__th" aria-hidden="true">${pieceFit(p, '', 64)}</span><span class="mt__pn">${esc(p.nom)}</span><span class="mt__pt">${esc(cardType(p))}</span></a></li>`).join('')}</ul>` : ''}
        </div>
      </section>`;
    };
    const html = `<section class="wrap mt">
      <header class="mt__head">
        <h1 class="t-1">Nos matières, de près</h1>
        <p class="lead mt__lead">Chaque tissu, au plus près : ce que l’on sent sous la main, et les trois gestes qui le gardent beau.</p>
        <nav class="mt__nav" aria-label="Aller à une matière">${keys.map((k) => `<a class="tab" href="#/matieres?m=${k}" data-mat-go="${k}">${esc(MAT.matieres[k].nom)}</a>`).join('')}</nav>
      </header>
      ${keys.map(sec).join('')}
      <p class="mt__ask">Une question sur un tissu ? Écrivez-nous à ${mailLink()} : réponse ${reponse()}.</p>
    </section>${footer()}`;
    const after = (root) => {
      const go = (k, smooth) => {
        const el = document.getElementById('m-' + k);
        if (!el) return;
        if (lenis) lenis.scrollTo(el, { offset: -96, immediate: !smooth });
        else el.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
      };
      const onClick = (e) => {
        const a = e.target.closest('[data-mat-go]');
        if (!a) return;
        e.preventDefault();
        try { history.replaceState(history.state, '', a.getAttribute('href')); } catch (er) { /* rien */ }
        go(a.dataset.matGo, true);
      };
      root.addEventListener('click', onClick);
      cleanups.push(() => root.removeEventListener('click', onClick));
      const m = qsAll().get('m');
      if (m) setTimeout(() => go(m, false), 80);
    };
    return { title: `Nos matières : ${andList(keys.slice(0, 3).map((k) => lc1(MAT.matieres[k].nom)))} · Caplia`, html, after, nav: 'matieres', scene: { img: tab('petit-incurve-galerie', '960'), soft: true } };
  }

  /* Qui sommes-nous : texte honnête (rapport 04, §4.2), sans rien inventer. « Ce que nous vérifions » : copy-persona §5.5. */
  function renderAbout() {
    const v = SITE.vendeur;
    const p = BY.incurve;
    const r = docPage({
      title: 'Qui sommes-nous',
      lead: `Caplia est une petite maison installée à Bagnolet. Nous choisissons chaque pièce et répondons à chaque message. Que des formes douces : canapés arrondis, méridiennes, fauteuils, et quelques objets qui vont avec.`,
      hero: `<picture><source media="(max-width: 700px)" srcset="/site/assets/univers/atelier-tel.webp"><img src="/site/assets/univers/atelier-ordi.webp" width="1680" height="840" alt="Une table de chêne clair et nos échantillons de bouclette, de chenille, d’effet lin et de velours côtelé, au soleil de fin d’après-midi" fetchpriority="high" decoding="async" draggable="false"></picture>`,
      sections: [
        { id: 'formes', title: 'Pourquoi des formes douces', html: `<p>Un canapé arrondi change un salon. Les angles disparaissent, la pièce paraît plus calme, et on a envie de s'y laisser tomber en rentrant le soir. Toutes nos pièces partagent cette courbe.</p>` },
        { id: 'verifie', title: 'Ce que nous vérifions avant de proposer une pièce', html: `<ul>
            <li><strong>Elle est en stock en Europe</strong>, couleur par couleur, avec son pays de départ : ${orList(['FR', ...EU_KEYS()].map((k) => PAYS_DE[k]))}.</li>
            <li><strong>Ses mesures viennent de la fiche du fabricant</strong>, vérifiées sur ses photos cotées : largeur, profondeur, hauteur et profondeur d'assise, nombre de colis.</li>
            <li><strong>Sa teinte porte un nom</strong>, et ce nom reste le même d'une page à l'autre.</li>
            <li><strong>Son délai est réel</strong> : vous voyez une date, avant de payer.</li>
          </ul>` },
        { id: 'rapide', title: "Pourquoi c'est rapide", html: `<p>Nos pièces partent d'entrepôts en France, en Allemagne, en Espagne et en Pologne. Elles arrivent donc chez vous en ${SITE.livraison.delais.FR[0]} à ${euMax()} jours ouvrés, et pas en plusieurs mois. Sur chaque fiche, vous voyez d'où part votre pièce et le jour où elle arrive.</p>` },
        { id: 'promesses', title: 'Ce que nous vous promettons', html: `<ul>
            <li>Tout est écrit avant de payer : les mesures, la hauteur d'assise, le nombre de colis et la date de livraison.</li>
            <li>Il passe chez vous : envoyez-nous vos mesures, nous vérifions et vous répondons par écrit. Si nous avons dit oui et qu'il ne passe pas, nous le reprenons à nos frais.</li>
            <li>Un défaut dans les 2 ans ? Comme la loi le prévoit, la garantie légale s'applique, et nous l'expliquons avec des exemples : <a href="#/garantie">Garantie légale, en clair</a>.</li>
            <li>Une personne vous répond, pas un robot.</li>
          </ul>` },
        { id: 'qui', title: 'Qui vous répond', html: `<p>Nous lisons chaque message depuis Bagnolet, en Seine-Saint-Denis, et nous y répondons ${reponse()} : une mesure, une couleur, la largeur de votre escalier. Une question ? Écrivez-nous à ${mailLink()}.</p>
          <p class="lp__legal">Identité complète du vendeur : <a href="#/mentions-legales">mentions légales</a>.</p>` }
      ],
      toc: false,
      scene: { img: tab('capiton-matin', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Qui sommes-nous · Caplia' });
  }

  /* Trame de l'e-mail d'avis (bouton « Donner mon avis ») : la pièce, la note, les trois questions de la page, et l'accord
     de publication demandé avant de publier quoi que ce soit (avis.json > caplia, prénom et initiale seulement).
     Sauts de ligne en CRLF (RFC 6068), pour les messageries qui ignorent %0A seul. */
  /* questions et phrase de publication : site.json > avis, les mêmes que l'e-mail du 10e jour (construire.js) */
  const avisQ = () => (SITE.avis && SITE.avis.questions) || [];
  const avisMail = () => ['Ma pièce et sa couleur : ', 'Ma note, de 1 à 5 : ', '', ...avisQ().map((q, i) => `${i + 1}. ${q} `), '',
    'J’accepte que cet avis soit publié sur caplia.fr avec mon prénom et l’initiale de mon nom : oui / non'].join('\r\n');
  /* Trois jours après la livraison : « Tout s'est bien passé ? » (e-mail 4). Les deux réponses mènent à une page, sans filtrer les avis :
     la demande d'avis du 10e jour part à tous les clients. */
  function renderWell() {
    const yes = /[?&]oui\b/.test(location.search);
    const html = `<section class="wrap">
      <div class="lp-mid">
        ${yes ? `<h1 class="t-1">Merci, ça nous fait plaisir</h1>
          <p class="lead">Votre avis aide ceux qui hésitent, parce qu'ils ne peuvent pas voir la pièce chez eux avant d'acheter. Trois questions suffisent :</p>
          <ol class="lp-mid__list">${avisQ().map((q) => `<li>${esc(q)}</li>`).join('')}</ol>
          <a class="btn" href="mailto:${SITE.email}?subject=${encodeURIComponent('Mon avis')}&body=${encodeURIComponent(avisMail())}">Donner mon avis</a>
          <p class="lp-mid__note">${esc(SITE.avis ? SITE.avis.publication : '')}</p>`
        : `<h1 class="t-1">Tout s'est bien passé ?</h1>
          <p class="lead">Votre réponse nous aide à mieux faire. Elle prend une seconde.</p>
          <div class="lp-mid__choices">
            <a class="lp-mid__choice lp-mid__choice--yes" href="#/tout-va-bien?oui">Oui</a>
            <a class="lp-mid__choice" href="#/un-souci">Non</a>
          </div>`}
      </div>
    </section>${footer()}`;
    return { title: 'Tout s’est bien passé ? · Caplia', html, scene: { img: tab('meridienne-platre', '960'), soft: true } };
  }

  function renderIssue() {
    const html = `<section class="wrap lp">
      <div class="lp-form">
        <div class="lp-form__side">
          <h1 class="t-1 lp__title">Dites-nous ce qui ne va pas</h1>
          <p class="lead">Nous vous répondons ${reponse()}. Une photo suffit souvent à tout comprendre.</p>
          <dl class="lp__kv lp__kv--side"><dt>E-mail</dt><dd>${mailLink()}</dd></dl>
          <div class="lp-steps">
            <h2 class="lp-steps__h">Un colis abîmé à l’arrivée</h2>
            <ol>
              <li>Si le carton est abîmé, écrivez-le sur le bon du livreur, par exemple « carton abîmé ».</li>
              <li>Prenez en photo le carton et la pièce.</li>
              <li>Envoyez-nous ces photos avec votre numéro de commande.</li>
            </ol>
            <p>Jusqu’à ce que vous receviez votre pièce, le transport est sous notre responsabilité, comme la loi le prévoit : nous réglons le souci avec le transporteur, et nous vous renvoyons la pièce ou la partie abîmée, ou vous remboursons, sans frais pour vous.</p>
          </div>
          <p class="lp-form__more">Un défaut apparu après quelques mois ? Pendant 2 ans, la garantie légale s'applique. <a class="link" href="#/garantie">Voir des exemples</a></p>
        </div>
        <form class="lp-form__form" data-form data-issue novalidate>
          <div class="form">
            <div class="row">
              <div class="field"><label for="i-nom">Nom</label><input id="i-nom" name="nom" autocomplete="name" required></div>
              <div class="field"><label for="i-mail">E-mail</label><input id="i-mail" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" autocorrect="off" spellcheck="false" required></div>
            </div>
            <div class="field"><label for="i-cmd">Numéro de commande</label><input id="i-cmd" name="commande" inputmode="numeric"></div>
            <div class="field"><label for="i-sujet">Le souci</label><select id="i-sujet" name="sujet"><option>Un colis abîmé</option><option>Une pièce manque</option><option>Un défaut sur la pièce</option><option>Autre chose</option></select></div>
            <div class="field"><label for="i-msg">Ce qui se passe</label><textarea id="i-msg" name="message" required></textarea></div>
            <div class="field lp-file"><label for="i-photo">Une photo</label><input id="i-photo" name="photo" type="file" accept="image/*" capture="environment"></div>
            <button class="btn lp-form__send" type="submit">Préparer l'e-mail</button>
            <p class="form__ok" data-form-msg hidden></p>
          </div>
        </form>
      </div>
    </section>${footer()}`;
    return { title: 'Un souci · Caplia', html, scene: { img: tab('capiton-matin', '960'), soft: true } };
  }

  /* Vos questions : chaque question est une vraie hésitation d'acheteur (MANQUES-DU-MARCHE, PERSONAS), chaque réponse la lève
     par un fait. Aucune question n'existe pour annoncer une règle interne. Les deux premiers mots portent l'information (P5). */
  /* une vignette par thème de questions (vraies photos et images de la maison) */
  const FAQ_PIC = { livraison: '/site/assets/arrivee/cartons-640.webp', confort: '/site/assets/produits/incurve/06-640.webp', retours: '/site/assets/arrivee/en-place-640.webp', prix: '/site/assets/cadeaux/salon-cadeaux-800.webp', pieces: '/site/assets/arrivee/regonflage-640.webp', caplia: '/site/assets/univers/atelier-tel.webp' };
  function renderFaq() {
    const d = SITE.livraison.delais;
    const R = SITE.retours.delaiJours;
    const names = (keys) => andList(keys.filter((k) => BY[k]).map((k) => esc(BY[k].nom)));
    const groups = [
      ['livraison', 'Livraison', [
        ['Combien coûte la livraison ?', `<p>Rien : elle est offerte en France métropolitaine, quel que soit le montant de la commande. Le prix affiché est le prix payé.</p>`],
        ['Jusqu’où est-il livré ?', `<p>Jusqu’à votre adresse, par un transporteur de colis, avec un numéro de suivi pour chaque colis. Les cartons d’un canapé compressé se portent à deux, jusque dans la pièce.</p>`],
        ['Quand serai-je livré ?', `<p>En ${d.FR[0]} à ${d.FR[1]} jours ouvrés depuis la France, ${euMin()} à ${euMax()} jours ouvrés depuis ${euDe()}. Chaque fiche affiche la date, calculée le jour de votre visite : vous la connaissez avant de payer. Ensuite, un e-mail à chaque étape, et si un colis prend du retard, nous vous écrivons avant que vous ayez à le demander.</p>`],
        ['Mon canapé passera-t-il ma porte ?', `<p>Envoyez-nous la largeur de votre porte et de votre escalier : nous vérifions qu'il passe et vous répondons par écrit, avant l'achat. La plupart de nos canapés voyagent compressés ou en modules, dans des cartons plus petits qu'eux. Si nous avons dit oui et que la pièce ne passe pas, nous la reprenons à nos frais.</p>`],
        ['Un canapé compressé, c’est un vrai canapé ?', `<p>Oui. Sa mousse haute élasticité voyage comprimée dans le carton, puis retrouve l'essentiel de sa forme en 48 à 72 heures, et tout son volume en quelques jours. Ensuite, c'est un canapé à sa taille réelle : ${esc(BY['noix-de-cajou'].nom)} fait ${cm(BY['noix-de-cajou'].dimensions.largeur)} de large, ${esc(BY['petit-incurve'].nom)} ${cm(BY['petit-incurve'].dimensions.largeur)}.</p>`]
      ]],
      ['confort', 'Confort', [
        ['Comment savoir s’il est confortable sans l’essayer ?', `<p>Comparez-le à votre canapé actuel, un mètre ruban à la main. Chaque fiche donne la hauteur et la profondeur d'assise, avec un repère connu : ${cm(BY.incurve.dimensions.hauteurAssise)} du sol, c'est un peu plus haut qu'un canapé moyen (38 cm) et un peu plus bas qu'une chaise (45 cm). Une hésitation ? Écrivez-nous : nous vous répondons par écrit, avec les mesures.</p>`],
        ['Mon canapé va-t-il s’affaisser ?', `<p>C'est la mousse qui décide. ${BY.causeuse && BY['angle-cotele'] ? `${esc(BY.causeuse.nom)} a une mousse haute densité de 32 kg/m³ (32D), ${esc(BY['angle-cotele'].nom)} des ressorts ensachés sous la mousse` : `${names(['petit-incurve', 'capiton', 'meridienne'])} sont tout en mousse haute densité`} : l'assise cède sous le poids, puis reprend sa forme. Sur les coussins amovibles, les intervertir chaque mois garde une assise régulière. Et la garantie légale de 2 ans vous couvre, comme la loi le prévoit.</p>`],
        ['Avec des enfants ou un chat, quel tissu choisir ?', `<p>Un tissage serré : la chenille ${deN(esc(BY['noix-de-cajou'].nom))} et de ${esc(BY.capiton.nom)}${BY.causeuse ? `, ou le velours côtelé de ${names(['causeuse'])}` : ''}. Les teintes moyennes, comme le Gris ardoise, restent nettes entre deux coups d'aspirateur. Une tache se tamponne tout de suite avec un chiffon humide, sans frotter.</p>`],
        ['La couleur sera-t-elle celle de l’écran ?', `<p>Chaque teinte a sa propre galerie et garde le même nom sur toutes les pages. Si la teinte reçue est nettement différente de la fiche, c'est couvert par la garantie légale : une photo à la lumière du jour suffit, nous le réglons.</p>`]
      ]],
      ['retours', 'Changer d’avis', [
        ['Et si je change d’avis ?', `<p>Comme la loi le prévoit, vous avez ${R} jours après la réception pour changer d'avis, sans avoir à vous justifier. Écrivez-nous à <a href="mailto:${SITE.email}">${SITE.email}</a> avec votre numéro de commande. <a href="#/livraison">Comment se passe un retour</a>.</p>`],
        ['Combien coûte un retour ?', `<p>${retourCout()} Écrivez-nous avant de renvoyer : nous organisons l'enlèvement avec vous.</p>`],
        ['Et si la pièce arrive abîmée ?', `<p>Une photo par e-mail suffit : nous nous occupons du reste, sans frais pour vous. Comme la loi le prévoit, la garantie légale de conformité s'applique pendant 2 ans : réparation, remplacement ou remboursement.</p>`],
        ['Que couvre la garantie légale ?', `<p>Pendant 2 ans après la livraison, les défauts sont couverts : une assise qui se creuse, une couture qui s'ouvre, une couleur différente de la fiche. Un défaut qui apparaît pendant ces 2 ans est considéré comme présent dès la livraison : vous n'avez pas à prouver qu'il existait avant. <a href="#/garantie">Les exemples, en clair</a>.</p>`]
      ]],
      ['prix', 'Prix et paiement', [
        ['Faut-il un code promo pour les cadeaux ?', `<p>Aucun code : vos cadeaux s'ajoutent tout seuls au panier.</p><ul>${SITE.paliers.map((pl) => `<li>Dès ${price(pl.seuil)} : ${esc(pl.cadeau)}${giftValue(pl) ? ` ${strike(giftValue(pl))}` : ''}, offert${/^\d|coussins/.test(pl.cadeau) ? 's' : ''}.</li>`).join('')}</ul><p>${GIFT_RULE}</p><p>Ils voyagent dans un colis à part. <a href="#/cadeaux">Les cadeaux en photos</a></p>`],
        ['Quels moyens de paiement acceptez-vous ?', `<p>${esc(andList(SITE.paiements))}.</p>`],
        ['Le paiement est-il sécurisé ?', `<p>Oui. Le paiement est traité par Shopify, qui chiffre vos données : votre numéro de carte ne nous est jamais transmis. Avec Apple Pay, Shop Pay ou PayPal, vous ne le tapez même pas. En payant par PayPal, vous profitez aussi de sa protection des achats, selon ses conditions, si un colis n’arrive pas ou ne correspond pas à sa description.</p>`],
        ['La TVA est-elle comprise ?', `<p>Le prix affiché est le prix payé, livraison comprise. TVA non applicable, article 293 B du CGI.</p>`]
      ]],
      ['pieces', 'Montage et entretien', [
        ['Y a-t-il quelque chose à monter ?', `<p>Les canapés compressés arrivent prêts : vous ouvrez le carton, ils prennent leur forme. ${names(['incurve', 'petit-incurve', 'courbe', 'noix-de-cajou'])} arrivent en deux parties${BY['angle-cotele'] || BY['u-cotele'] ? `, ${names(['angle-cotele', 'u-cotele'])} en trois modules` : ''} : on les pose côte à côte, sans outil. Chaque fiche montre ce qu'il y a dans le carton.</p>`],
        ['Comment entretenir la bouclette, la chenille ou le velours ?', `<p>Un passage d'aspirateur avec la brosse douce, une fois par semaine. Une tache se tamponne tout de suite avec un chiffon humide, sans frotter.</p>`]
      ]],
      ['caplia', 'Caplia', [
        ['Qui êtes-vous ?', `<p>Caplia est une entreprise française, installée à Bagnolet (93). Nous lisons chaque message et vous répondons ${reponse()}, par e-mail à ${mailLink('')}. <a href="#/a-propos">Qui sommes-nous</a>.</p>`]
      ]]
    ];
    const r = docPage({
      title: 'Vos questions',
      lead: `Les réponses aux questions qu'on nous pose avant d'acheter. La vôtre n'y est pas ? <a class="link nowrap" href="#/contact">Écrivez-nous</a> : nous vous répondons ${reponse()}.`,
      sections: groups.map(([id, t, qs]) => ({ id, title: t, pic: FAQ_PIC[id] ? `<img src="${FAQ_PIC[id]}" alt="" loading="lazy" decoding="async" draggable="false">` : '', html: `<div class="lp__accs">${qs.map(([q, a]) => acc(esc(q), a)).join('')}</div>` })),
      hero: BY.meridienne ? `<img src="${photo(BY.meridienne, '01', 1280)}" srcset="${photo(BY.meridienne, '01', 640)} 640w, ${photo(BY.meridienne, '01', 1280)} 1280w" sizes="(max-width: 760px) 100vw, 1360px" alt="Ondine, méridienne en chenille blanc coquillage, dans un salon aux étagères arrondies" fetchpriority="high" decoding="async" draggable="false" style="object-position:${focusWide(BY.meridienne, '01')}">` : '',
      scene: { img: tab('meridienne-platre', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Vos questions · Caplia', nav: 'questions' });
  }

  function renderContact() {
    const html = `<section class="wrap lp">
      <div class="lp-form">
        <div class="lp-form__side">
          <h1 class="t-1 lp__title">Écrivez-nous</h1>
          <p class="lead">Nous lisons chaque message et vous répondons ${reponse()}. Une mesure, une couleur, votre escalier : vous avez une réponse écrite avant de commander.</p>
          <dl class="lp__kv lp__kv--side">
            <dt>E-mail</dt><dd><a class="link" href="mailto:${SITE.email}">${SITE.email}</a></dd>
            <dt>Réponse</dt><dd>${reponse().replace(/^./, (c) => c.toUpperCase())}, par e-mail</dd>
          </dl>
          <p class="lp-form__more">Une porte étroite, un escalier tournant ? Donnez-nous leur largeur : nous vérifions que la pièce passe et vous répondons par écrit.</p>
          <p class="lp-form__more">Un souci avec une commande ? <a class="link" href="#/un-souci">Dites-nous ce qui ne va pas</a></p>
        </div>
        <div data-caplia-slot="caplia-contact"></div>
      </div>
    </section>${footer()}`;
    return { title: 'Contact · Caplia', html, scene: { img: tab('capiton-matin', '960'), soft: true } };
  }


  /* ---------------- Renoncer au contrat ici (#/renoncer) ----------------
     Fonction de rétractation en ligne (L221-21, D221-5, en vigueur depuis le 19/06/2026) : nom, numéro de commande, e-mail
     pour l'accusé de réception, puis « Confirmer la rétractation ». Sur Shopify, l'envoi et l'accusé daté seront réels. */
  function renderRenoncer() {
    const R = SITE.retours.delaiJours;
    const html = `<section class="wrap lp">
      <div class="lp-form">
        <div class="lp-form__side">
          <h1 class="t-1 lp__title">Renoncer au contrat ici</h1>
          <p class="lead">Vous avez ${R} jours après la réception de votre commande pour y renoncer, sans donner de motif, comme la loi le prévoit. Remplissez ce formulaire, puis confirmez.</p>
          <dl class="lp__kv lp__kv--side">
            <dt>Délai</dt><dd>${R} jours après la réception ; en plusieurs colis, après le dernier</dd>
            <dt>Ensuite</dt><dd>Nous vous écrivons pour organiser le retour : vous renvoyez la pièce dans les ${R} jours</dd>
            <dt>Remboursement</dt><dd>Au plus tard ${R} jours après votre demande, dès la pièce reçue ou sa preuve d’envoi</dd>
          </dl>
          <p class="lp-form__more">Une question avant de décider ? <a class="link" href="#/contact">Écrivez-nous</a></p>
        </div>
        <div data-caplia-slot="caplia-renonce"></div>
      </div>
    </section>${footer()}`;
    return { title: 'Renoncer au contrat ici · Caplia', html, scene: { img: tab('capiton-matin', '960'), soft: true } };
  }

  function renderMentions() {
    const v = SITE.vendeur, h = SITE.hebergeur;
    const r = docPage({
      title: 'Mentions légales',
      sections: [
        { id: 'editeur', title: 'Éditeur du site', toc: 'Éditeur', html: `<dl class="lp__kv">
          <dt>Nom commercial</dt><dd>${esc(v.nomCommercial)}</dd><dt>Statut</dt><dd>${esc(v.statut)}</dd>
          <dt>Adresse</dt><dd>${esc(v.adresse)}</dd><dt>SIREN</dt><dd>${esc(String(v.siren).replace(/^(\d{3})(\d{3})(\d{3})$/, `$1${NB}$2${NB}$3`))}</dd><dt>SIRET</dt><dd>${siretFmt(v.siret)}</dd>
          <dt>Immatriculation</dt><dd>${esc(v.immatriculation)}</dd><dt>Code APE</dt><dd>${esc(v.ape)}</dd><dt>TVA</dt><dd>${esc(v.tva)}</dd>
          <dt>E-mail</dt><dd><a href="mailto:${SITE.email}">${SITE.email}</a></dd></dl>` },
        { id: 'hebergeur', title: 'Hébergement', html: `<dl class="lp__kv"><dt>Hébergeur</dt><dd>${esc(h.nom)}</dd><dt>Adresse</dt><dd>${esc(h.adresse)}</dd></dl>` },
        { id: 'mediation', title: 'Médiation de la consommation', toc: 'Médiation', html: `<p>${mediationTxt()}</p>` },
        { id: 'ecomaison', title: 'Éco-participation', html: `<p>Identifiant unique (IDU) Ecomaison pour l'ameublement : ${SITE.ecomaison && !SITE.ecomaison.aConfirmer ? esc(SITE.ecomaison.idu) : '<span class="note-soft">en cours d\'attribution</span>'}.</p>` },
        { id: 'propriete', title: 'Propriété intellectuelle', html: `<p>Les textes, la mise en page et les visuels de ce site sont protégés. Toute reproduction sans autorisation écrite est interdite.</p>
          <p class="lp__ident">Entrepreneur individuel et directeur de la publication : ${esc(v.directeurPublication || v.nom)} · téléphone : ${esc(v.telephone)}</p>` }
      ],
      scene: { img: tab('meridienne-platre', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Mentions légales · Caplia' });
  }

  /* Conditions de vente : Code de la consommation (L221-5, L221-18 à L221-24 pour la rétractation, L216-1 à L216-7 pour la
     livraison, L217-3 et suivants pour la conformité), Code civil 1641 à 1649. L'engagement écrit « Il passe chez vous »
     est une garantie commerciale : contenu, durée et conditions écrits ici (PLAN-MAITRE O14, M4). */
  /* Médiateur : nom, adresse et site affichés dès l'adhésion (site.json > mediateur), obligatoire avant la première vente */
  const mediationTxt = () => { const m = SITE.mediateur || {}; return m.nom && !m.aConfirmer
    ? `En cas de litige, adressez d'abord une réclamation écrite à <a href="mailto:${SITE.email}">${SITE.email}</a>. Si elle n'aboutit pas, vous pouvez saisir gratuitement, dans l'année qui suit votre réclamation écrite, le médiateur de la consommation : ${esc(m.nom)}${m.adresse ? ', ' + esc(m.adresse) : ''}${m.site ? `, <a href="${esc(m.site)}" rel="noopener">${esc(m.site.replace(/^https?:\/\//, ''))}</a>` : ''}. Ce recours est facultatif : vous gardez le droit de saisir le juge.`
    : 'En cas de litige, après une réclamation écrite auprès de nous, vous pouvez saisir gratuitement un médiateur de la consommation. <span class="note-soft">Coordonnées en cours de désignation.</span>'; };
  function renderCGV() {
    const v = SITE.vendeur, d = SITE.livraison.delais, R = SITE.retours.delaiJours;
    const pl1 = (pl) => (/^\d|coussins/.test(pl.cadeau) ? 's' : '');
    const r = docPage({
      title: 'Conditions de vente',
      lead: 'Ce que vous achetez, comment vous êtes livré, et vos droits, écrits simplement.',
      sections: [
        { id: 'objet', title: 'Objet', html: `<p>Ces conditions s'appliquent aux ventes conclues sur le site Caplia entre le vendeur désigné ci-dessous et toute personne qui achète en tant que consommateur.</p>` },
        { id: 'vendeur', title: 'Vendeur', html: `<p>${esc(v.nomCommercial)}, entreprise individuelle (EI), ${esc(v.adresse)}. SIRET ${esc(v.siret)}. E-mail : <a href="mailto:${SITE.email}">${SITE.email}</a>. L'identité complète de l'entrepreneur et son numéro de téléphone figurent dans les <a href="#/mentions-legales">mentions légales</a>.</p>` },
        { id: 'produits', title: 'Produits', html: `<p>Les caractéristiques essentielles de chaque produit sont présentées sur sa fiche : dimensions, matière, couleurs, contenu des colis, pays d'expédition. Les photos d'ambiance montrent la pièce mise en scène ; les dimensions, la matière et la couleur qui font foi sont celles de la fiche.</p>` },
        { id: 'prix', title: 'Prix', html: `<p>Les prix sont indiqués en euros, toutes taxes comprises. TVA non applicable, article 293 B du CGI. Ils comprennent la livraison en France métropolitaine et l'éco-participation mobilier, versée à l'éco-organisme Ecomaison pour la collecte, le réemploi et le recyclage des meubles usagés : le prix affiché est le prix payé.${SITE.ecomaison && !SITE.ecomaison.aConfirmer ? ` Identifiant unique (IDU) Ecomaison, filière éléments d'ameublement : ${esc(SITE.ecomaison.idu)}.` : ''}</p>` },
        { id: 'commande', title: 'Commande', html: `<p>Vous choisissez vos produits, vérifiez votre panier, indiquez votre adresse puis payez. La vente est conclue à la confirmation du paiement ; un e-mail récapitule votre commande et sa date de livraison.</p>` },
        { id: 'paiement', title: 'Paiement', html: `<p>Le prix est payé à la commande, par ${esc(andList(SITE.paiements.map((m) => m.replace(/^Carte/, 'carte'))))}. Le paiement est traité par nos prestataires de paiement : vos données de carte ne nous sont jamais transmises.</p>` },
        { id: 'livraison', title: 'Livraison', html: `<p>Nous livrons en France métropolitaine, et la livraison est offerte : ${d.FR[0]} à ${d.FR[1]} jours ouvrés pour un produit expédié depuis la France, ${euMin()} à ${euMax()} jours ouvrés depuis ${euDe()}.${accDelay()} La date la plus tardive affichée sur la fiche et dans l'e-mail de confirmation est la date limite de livraison. Une commande peut arriver en plusieurs colis. Les risques vous sont transférés quand vous prenez possession du produit.</p>
          <p>Si le produit n'est pas livré à la date limite, vous pouvez nous demander de le livrer dans un délai supplémentaire raisonnable puis, à défaut, résoudre la vente : vous êtes alors remboursé au plus tard 14 jours après.</p>` },
        { id: 'passage', title: 'Engagement « Il passe chez vous »', toc: 'Il passe chez vous', html: `<p>Avant votre commande, envoyez-nous par e-mail la largeur de votre porte la plus étroite et de votre escalier, et l'étage. Notre confirmation s'appuie sur ces mesures et sur les cotes du plus grand colis de la pièce ; lorsque ces cotes ne sont pas encore connues, nous les vérifions auprès de notre fournisseur avant de vous répondre. Si nous vous confirmons par écrit que la pièce passe et qu'elle ne peut pas entrer chez vous avec les mesures que vous nous avez envoyées, nous la reprenons à nos frais et vous remboursons la totalité de son prix, au plus tard 14 jours après votre demande. Cet engagement s'ajoute à vos droits légaux.</p>` },
        { id: 'retractation', title: 'Droit de rétractation', toc: 'Rétractation', html: `<p>Comme la loi le prévoit, vous disposez de ${R} jours à compter de la réception pour vous rétracter, sans motif. Si votre commande arrive en plusieurs colis, ce délai court à partir de la réception du dernier. Il suffit d'une déclaration claire : en ligne, sur la page <a href="#/renoncer">Renoncer au contrat ici</a>, par e-mail à <a href="mailto:${SITE.email}">${SITE.email}</a>, ou avec le formulaire ci-dessous. Le produit est renvoyé complet dans les ${R} jours qui suivent votre demande. Vous pouvez examiner le produit comme en magasin ; une dépréciation due à d'autres manipulations peut être déduite du remboursement.</p>
          <p>${retourCout()}</p>
          <p>Nous vous remboursons au plus tard ${R} jours après votre demande, sur le moyen de paiement utilisé. Le remboursement peut attendre la réception du produit ou la preuve de son expédition.</p>
          <h3>Formulaire de rétractation</h3>
          <p>À envoyer à ${esc(v.nomCommercial)}, entreprise individuelle, SIRET ${esc(v.siret)}, ${esc(v.adresse)}, <a href="mailto:${SITE.email}">${SITE.email}</a> : « Je vous notifie par la présente ma rétractation du contrat portant sur la vente du bien ci-dessous. Commandé le … , reçu le … . Nom du consommateur. Adresse du consommateur. Signature (en cas d'envoi sur papier). Date. »</p>` },
        { id: 'garanties', title: 'Garanties légales', html: `<div class="lp__box">${(SITE.encadreGarantie || []).map((t) => `<p>${esc(t)}</p>`).join('')}</div>
          <p>En clair : comme la loi le prévoit, les produits bénéficient de la garantie légale de conformité (articles L217-3 et suivants du Code de la consommation) pendant 2 ans à compter de la délivrance. Un défaut qui apparaît pendant ce délai est présumé exister au moment de la délivrance (article L217-7).</p>
          <p>Vous choisissez entre la réparation et le remplacement, sauf si l'un coûte nettement plus que l'autre ; la mise en conformité a lieu dans les 30 jours suivant votre demande, sans frais pour vous. Si elle est impossible, tardive ou cause un inconvénient majeur, vous obtenez une réduction du prix en gardant le produit, ou le remboursement en le rendant.</p>
          <p>Les produits bénéficient aussi de la garantie des vices cachés (articles 1641 et suivants du Code civil) : l'action est à engager dans les 2 ans suivant la découverte du vice (article 1648). Des exemples sont donnés sur la page <a href="#/garantie">Garantie légale, en clair</a>.</p>` },
        { id: 'cadeaux', title: 'Cadeaux', html: `<ul>${SITE.paliers.map((pl) => `<li>Dès ${price(pl.seuil)} d'achat : ${esc(pl.cadeau)}, offert${pl1(pl)}, envoyé${pl1(pl)} dans un colis séparé.</li>`).join('')}</ul><p>Les cadeaux s'ajoutent automatiquement au panier ; le palier s'apprécie sur le montant des meubles de la commande (canapés, fauteuils, décoration, lits), sans compter les coussins nœud et les plaids achetés seuls. La valeur indiquée pour chaque cadeau est le prix de vente du même article, vendu seul sur caplia.fr.</p>` },
        { id: 'parrainage', title: 'Parrainage', html: `<p>Lorsqu'une personne passe sa première commande en indiquant le nom du client Caplia qui la lui a recommandée, le parrain reçoit un coussin nœud en velours. Le filleul reçoit le premier cadeau que sa commande ne débloque pas déjà : ${(() => { const P = SITE.paliers; return `coussin nœud (moins de ${price(P[0].seuil)}), plaid (de ${price(P[0].seuil)} à ${price(P[1].seuil - 1)}), second plaid dans l’autre couleur (de ${price(P[1].seuil)} à ${price(P[2].seuil - 1)}), un coussin nœud de plus (${price(P[2].seuil)} et plus)`; })()}. Les cadeaux partent à la fin du délai de rétractation de ${R} jours de la commande du filleul. Un cadeau par filleul.</p>` },
        { id: 'ancien', title: 'Votre ancien meuble', html: `<p>Votre ancien canapé peut avoir une seconde vie, gratuitement : déposez-le dans un point de collecte de meubles ou une déchèterie, où il sera réutilisé ou recyclé ; donnez-le à une association ou à un voisin ; ou revendez-le s'il est en bon état.</p>` },
        { id: 'donnees', title: 'Données personnelles', toc: 'Données', html: `<p>Vos données servent à traiter votre commande. Si vous commandez, nous pourrons vous écrire au sujet de pièces semblables à votre achat ; vous pouvez refuser à la commande ou à tout moment, d'un clic, dans chaque e-mail. Voir la page <a href="#/confidentialite">Confidentialité</a>.</p>` },
        { id: 'litiges', title: 'Médiation et droit applicable', toc: 'Médiation', html: `<p>Les présentes conditions sont soumises au droit français. ${mediationTxt()}</p>` }
      ],
      scene: { img: tab('meridienne-platre', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Conditions de vente · Caplia' });
  }

  function renderPrivacy() {
    const v = SITE.vendeur;
    const r = docPage({
      title: 'Confidentialité',
      lead: 'Les données que nous gardons, pourquoi, et comment les faire effacer.',
      sections: [
        { id: 'responsable', title: 'Responsable du traitement', toc: 'Responsable', html: `<p>${esc(v.nomCommercial)}, entreprise individuelle (identité complète dans les <a href="#/mentions-legales">mentions légales</a>), ${esc(v.adresse)}. Contact : <a href="mailto:${SITE.email}">${SITE.email}</a>.</p>` },
        { id: 'donnees', title: 'Données collectées', html: `<ul><li>Identité et coordonnées : nom, e-mail, téléphone, adresse de livraison.</li><li>Commande : produits, montants, historique.</li><li>Paiement : traité par les prestataires de paiement ; nous ne conservons pas vos numéros de carte.</li><li>Messages que vous nous envoyez.</li></ul>` },
        { id: 'finalites', title: 'Pourquoi', html: `<p>Traiter et livrer votre commande, répondre à vos messages, gérer les retours et les garanties, respecter nos obligations comptables.</p><p>Base légale : l'exécution de votre commande, nos obligations comptables, votre accord pour les e-mails et la mesure d'audience.</p>` },
        { id: 'destinataires', title: 'Destinataires', html: `<p>L'hébergeur du site (${esc(SITE.hebergeur.nom)}), les prestataires de paiement et les transporteurs, chacun pour ce qui le concerne. Vos données ne sont pas vendues. Certains prestataires (Shopify, Google) peuvent traiter des données hors de l'Union européenne, avec les garanties prévues par le RGPD.</p>` },
        { id: 'duree', title: 'Durée de conservation', toc: 'Conservation', html: `<p>Les données de commande sont conservées le temps de la relation commerciale puis archivées pour la durée légale ; les pièces comptables sont conservées 10 ans.</p>` },
        { id: 'stockage', title: 'Stockage dans votre navigateur', toc: 'Navigateur', html: `<p>Votre panier est enregistré par Shopify pour le retrouver à votre prochaine visite ; votre sélection reste dans votre navigateur.</p><p>Si vous cochez la case d'inscription, nous vous écrivons au sujet de nos pièces, de nos conseils et des pièces que vous avez regardées ou mises au panier. Si vous commandez, nous pourrons vous écrire au sujet de pièces semblables à votre achat ; vous pouvez refuser à la commande ou à tout moment. Chaque e-mail contient un lien pour vous désinscrire.</p><p>« Recevoir cette fiche par e-mail », sur les fiches : sans la case cochée, rien n’est enregistré, la fiche part depuis votre propre messagerie ou en PDF. Case cochée, votre adresse sert à vous envoyer la fiche et nos e-mails, avec votre accord, jusqu’à votre désinscription et au plus trois ans après notre dernier échange.</p>` },
        { id: 'mesure', title: 'Mesure d’audience et publicité', toc: 'Publicité', html: `<p>Avec votre accord, donné dans le bandeau des cookies, nous mesurons la fréquentation du site et l'efficacité de nos annonces Google. Vous pouvez changer d'avis à tout moment depuis ce bandeau.</p><p>Si vous êtes client ou inscrit, votre adresse e-mail peut être transmise à Google sous une forme brouillée, pour vous éviter des publicités inutiles. Vous pouvez vous y opposer à tout moment en nous écrivant.</p>` },
        { id: 'droits', title: 'Vos droits', html: `<p>Vous pouvez demander l'accès, la rectification, l'effacement, la limitation ou la portabilité de vos données, et vous opposer à leur traitement, en écrivant à <a href="mailto:${SITE.email}">${SITE.email}</a>. Vous pouvez aussi adresser une réclamation à la CNIL.</p>` }
      ],
      scene: { img: tab('petit-incurve-galerie', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Confidentialité · Caplia' });
  }

  /* Garantie légale, en clair : la peur n° 2 du marché (« usure normale », MANQUES-DU-MARCHE.md §2).
     Droit légal présenté comme tel (art. L121-4), jamais comme un cadeau Caplia. Sources : Code de la consommation
     L217-3 à L217-17, Code civil 1641 à 1649, fiche service-public.fr F11094 (lue le 04/10/2026). */
  function renderGarantie() {
    const cas = [
      ["L'assise", "Une place qui se creuse nettement plus que les autres, une mousse qui ne reprend plus sa forme après une nuit.", 'Une mousse neuve qui s’assouplit un peu les premières semaines, puis se fait à vous.'],
      ['Les coutures', 'Une couture qui s’ouvre ou un fil qui lâche le long d’une assise, sans choc ni accroc.', 'Un accroc de griffe ou de boucle de ceinture : la vie de tous les jours.'],
      ['La couleur', 'Une couleur reçue différente de la fiche. La loi le dit : la pièce doit correspondre à sa description.', 'Un tissu qui se patine doucement, après des années au soleil.'],
      ['Le tissu', 'Des bouloches qui couvrent l’assise en quelques mois.', 'Quelques bouloches isolées, qui partent d’un passage de rasoir à tissu.'],
      ['À la livraison', 'Un pied cassé, une pièce qui manque, un tissu taché à l’ouverture du carton.', 'Un carton marqué par le voyage, avec une pièce intacte à l’intérieur.']
    ];
    const r = docPage({
      title: 'Garantie légale, en clair',
      lead: 'Deux ans pour signaler un défaut. Vous montrez le défaut (une photo suffit), sans avoir à prouver qu’il existait à la livraison, et la réparation est pour nous. Voici ce qui est couvert, avec des exemples.',
      sections: [
        { id: 'en-bref', title: 'En bref', html: `<p>Comme la loi le prévoit, chaque pièce Caplia doit être conforme à sa fiche et à l'usage qu'on attend d'un canapé, d'un fauteuil ou d'un objet de décoration. C'est la <strong>garantie légale de conformité</strong>. Elle dure <strong>2 ans à partir de la livraison</strong> et elle est gratuite.</p>
          <p>Vous montrez le défaut, une photo suffit. Vous n'avez pas à prouver qu'il existait à la livraison : un défaut qui apparaît pendant ces 2 ans est considéré comme présent dès la livraison.</p>` },
        { id: 'exemples', title: 'Défaut ou usure : des exemples', toc: 'Des exemples', html: `<p>La garantie couvre les défauts. La vie de tous les jours, elle, laisse quelques traces normales, comme sur tout meuble. Voici où passe la limite.</p>
          <div class="gx">${cas.map(([k, oui, non]) => `<div class="gx__row"><h3 class="gx__k">${k}</h3><dl class="gx__d"><dt>Couvert</dt><dd>${oui}</dd><dt>Usage normal</dt><dd>${non}</dd></dl></div>`).join('')}</div>` },
        { id: 'droits', title: 'Ce que vous obtenez', html: `<ul>
            <li><strong>La réparation ou le remplacement</strong>, au choix, sauf si l'un coûte nettement plus cher que l'autre.</li>
            <li><strong>Dans les 30 jours</strong> qui suivent votre demande.</li>
            <li><strong>Sans frais</strong> : transport, pièces et main-d'œuvre sont pour nous.</li>
            <li>Si réparer ou remplacer est impossible ou trop long : <strong>une réduction du prix</strong> si vous gardez la pièce, ou <strong>le remboursement</strong> si vous la rendez, au plus tard 14 jours après votre décision.</li>
          </ul>` },
        { id: 'demarche', title: 'Comment faire', html: `<ol class="lp__steps">
            <li><strong>Prenez une photo du défaut</strong> et envoyez-la à <a href="mailto:${SITE.email}">${SITE.email}</a> avec votre numéro de commande.</li>
            <li><strong>Nous vous répondons ${reponse()}</strong> et nous organisons la réparation ou le remplacement, selon votre choix.</li>
            <li><strong>Nous organisons tout</strong> : l'envoi de la pièce de rechange ou l'enlèvement, à nos frais.</li>
          </ol>
          <p class="lp__cta"><a class="btn" href="#/un-souci">Signaler un défaut</a></p>` },
        { id: 'vices', title: 'La garantie des vices cachés', toc: 'Vices cachés', html: `<p>En plus, comme la loi le prévoit, la garantie des vices cachés couvre un défaut invisible à l'achat qui rend la pièce impropre à son usage. Vous avez 2 ans à partir de la découverte du défaut pour la faire jouer.</p>` },
        { id: 'textes', title: 'Les textes de loi', html: `<ul>
            <li>Garantie légale de conformité : Code de la consommation, articles L217-3 et suivants.</li>
            <li>Garantie des vices cachés : Code civil, articles 1641 à 1649.</li>
          </ul>
          <p>Cette page explique vos droits avec des mots simples. En cas de doute, ce sont les textes de loi qui comptent.</p>` }
      ],
      scene: { img: tab('meridienne-platre', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Garantie légale, en clair · Caplia' });
  }

  /* Paiement et sécurité (09/10, analyse des créateurs e-commerce, GROUPE-1 n° 2) : seulement les moyens vraiment proposés
     par la page de paiement Shopify (relevés le 09/10 sur caplia.fr : carte Visa, Mastercard, American Express, CB et Maestro,
     Shop Pay, PayPal ; Apple Pay sur les appareils Apple ; Google Pay retiré le 12/10 : Shopify ne le propose pas aux boutiques établies en France, absent de la page de paiement), dans l'ordre de site.json > paiements (pied de page). */
  function renderPaiement() {
    const r = docPage({
      title: 'Paiement et sécurité',
      lead: 'Vous payez sur la page de paiement sécurisée de Shopify, en une fois, à la commande. Voici les moyens acceptés et ce qui protège votre achat.',
      sections: [
        { id: 'moyens', title: 'Les moyens acceptés', html: `<ul>
            <li><strong>Carte bancaire</strong> : Visa, Mastercard, American Express, CB et Maestro.</li>
            <li><strong>Shop Pay</strong>, le paiement rapide de Shopify.</li>
            <li><strong>PayPal</strong>, avec votre compte PayPal.</li>
            <li><strong>Apple Pay</strong>, sur iPhone, iPad et Mac.</li>
          </ul>
          <p>Aucuns frais ne s'ajoutent au prix, quel que soit le moyen choisi.</p>` },
        { id: 'chiffre', title: 'Un paiement chiffré', html: `<p>Le paiement est traité par Shopify Payments, le service de paiement de Shopify. La connexion est chiffrée et Shopify applique la norme de sécurité des cartes bancaires (PCI DSS).</p>
          <p><strong>Votre numéro de carte ne nous est jamais transmis</strong> : nous ne voyons ni le numéro complet, ni le code de sécurité. Votre banque peut vous demander de confirmer le paiement sur votre téléphone (3D Secure) : c'est une protection de plus.</p>` },
        { id: 'paypal', title: 'PayPal et sa protection des achats', toc: 'PayPal', html: `<p>En payant avec PayPal, vous profitez de la Protection des achats PayPal, selon ses conditions : si un colis n'arrive pas ou ne correspond pas à sa description, vous pouvez le signaler à PayPal.</p>` },
        { id: 'remboursement', title: 'Si vous changez d’avis', toc: 'Remboursement', html: `<p>Vous avez <strong>${SITE.retours.delaiJours} jours</strong> après la réception pour vous rétracter, sans donner de raison. Nous vous remboursons <strong>au plus tard 14 jours après votre demande</strong>, sur le moyen de paiement utilisé. Le remboursement peut attendre la réception de la pièce ou la preuve de son envoi.</p>
          <p>Les frais de retour, pièce par pièce : <a class="u" href="#/livraison?s=retractation">Livraison et retours</a>. Pour nous prévenir : <a class="u" href="#/renoncer">Renoncer au contrat ici</a>.</p>` }
      ],
      scene: { img: tab('capiton-matin', '960'), soft: true }
    });
    return Object.assign(r, { title: 'Paiement et sécurité · Caplia' });
  }

  /* =========================================================
     PAGES D'ENTRÉE, SÉLECTION, MERCI
     ========================================================= */
  /* Grande image + carte de verre : le haut de chaque page d'entrée */
  function lhero({ img, imgM, alt, title, line, pos = '50% 50%' }) {
    return `<section class="wrap">
      <div class="lhero reveal">
        <picture class="lhero__img">${imgM ? `<source media="(max-width: 760px)" srcset="${imgM}">` : ''}<img src="${img}" alt="${esc(alt)}" decoding="async" fetchpriority="high" style="object-position:${pos}"></picture>
        <div class="lhero__card glass glass--strong">
          <h1 class="display">${title}</h1>
          ${line ? `<p class="lhero__line">${esc(line)}</p>` : ''}
        </div>
      </div>
    </section>`;
  }

  const PASSE = { slug: 'petit-mouton' };
  /* Petits espaces : persona « 4e sans ascenseur » (marketing/PERSONAS.md, P4). Affiche Flocon, preuves chiffrées,
     « Passera-t-il ? », les trois pièces qui passent, l'ensemble Flocon + Perle, questions (seo-pages.json : petit-canape). */
  function renderSmall() {
    const f = BY['petit-mouton'], o = BY['petit-incurve'], pe = BY.galet;
    const mid = BY.capiton;   /* au-delà de 200 cm : Nacre (211 cm, 3 places), comme sur #/collections/petit-canape */
    PASSE.slug = f.slug;
    const ei = ENS.findIndex((e) => e.items[0][0] === 'petit-mouton');
    const ens = ei >= 0 ? ENS[ei] : null;
    const tot = ens ? ensTotal(ens) : 0;
    const gifts = ens ? giftsFor(tot) : [];
    const SZ3 = '(max-width: 760px) calc(100vw - 32px), 31vw';
    const piece = (p, line) => `<article class="en-piece">
        <a class="en-piece__link" href="#/p/${p.slug}" aria-label="${esc(p.nom)}, ${esc(lc1(cardType(p)))}, ${price(p.prix)}"></a>
        <span class="en-piece__img">${studioImg(p, { alt: `${p.nom}, ${p.type.toLowerCase()}, sur fond clair`, sizes: SZ3, cadres: ['11'] })}</span>
        <div class="en-piece__row"><h3 class="t-3">${esc(p.nom)}</h3><p class="price">${price(p.prix)}</p></div>
        <p class="en-piece__line">${line}</p>
      </article>`;
    const faq = [
      ['Quel canapé pour un petit espace ?', 'Un canapé de 140 à 190 cm de large, aux accoudoirs arrondis, livré compressé si l’accès est étroit. Flocon (142 cm) et Opaline (188 cm) répondent à ces trois points.'],
      ['Quelles sont les dimensions d’un petit canapé 2 places ?', 'En général 130 à 160 cm de large et 80 à 90 cm de profondeur. Flocon mesure 142 × 85 cm, pour 73,5 cm de haut.'],
      ['Un petit canapé peut-il aller dans une chambre ?', 'Oui : avec 142 cm de large, Flocon tient au pied d’un lit double ou sous une fenêtre. Il devient un coin lecture.'],
      ['Comment savoir si le canapé passera ma porte ?', `Mesurez la porte la plus étroite et l’escalier, puis envoyez-nous ces mesures à <a class="u" href="mailto:${SITE.email}">${SITE.email}</a> : nous vérifions que la pièce passe et vous répondons par écrit dans la journée. Si nous avons dit oui et qu’elle ne passe pas, nous la reprenons à nos frais.`]
    ];
    const html = `<section class="wrap en-hero">
      <div class="en-hero__text">
        <h1 class="t-display en-hero__t">4<sup>e</sup> sans ascenseur ? Un seul carton.</h1>
        <p class="lead en-hero__lead">Flocon arrive compressé dans un carton plus petit que lui, qui se porte à deux. Ouvert, il retrouve sa vraie taille : 142 cm de large, assise à 42 cm du sol.</p>
        <div class="en-hero__buy"><a class="btn" href="#/p/${f.slug}">Voir Flocon</a><p class="price en-hero__price">${price(f.prix)}</p></div>
        <p class="en-hero__date">Livraison offerte, chez vous ${delivery(f)}.</p>
      </div>
      <div class="en-hero__img">${studioImg(f, { alt: 'Flocon, canapé 2 places en tissu effet peau de mouton Crème guimauve, sur fond clair', sizes: '(max-width: 760px) calc(100vw - 32px), (max-width: 980px) 50vw, (min-width: 1440px) 800px, 56vw', eager: true, cadres: [['(max-width: 760px)', '11'], ['(max-width: 980px)', '45'], [null, '54']] })}</div>
    </section>

    <section class="wrap sec">
      <h2 class="t-2 en-h">Un vrai canapé, en format petit.</h2>
      <dl class="en-facts">
        <div><dt>142 cm</dt><dd>De large. Sur un mur de 2,20 m, il laisse la place d’une lampe ou d’une petite table.</dd></div>
        <div><dt>1 carton</dt><dd>Un seul colis à monter jusqu’à l’étage, et un seul numéro de suivi.</dd></div>
        <div><dt>42 cm</dt><dd>Du sol à l’assise, plus haut que la moyenne des canapés (38 cm) : on se relève sans effort.</dd></div>
        <div><dt>72 h</dt><dd>Le temps qu’il reprenne sa forme, une fois le carton ouvert. Aucun outil, rien à monter.</dd></div>
      </dl>
    </section>

    <section class="wrap sec en-passe" data-passe>
      <div class="en-passe__intro">
        <h2 class="t-2"><span class="en-nowrap">Passera-t-il</span> chez vous ?</h2>
        <p class="lead">Indiquez la largeur de votre porte la plus étroite, puis envoyez-nous aussi celle de l’escalier : nous vérifions que la pièce passe et vous répondons par écrit dans la journée. Si nous avons dit oui et qu’elle ne passe pas, nous la reprenons à nos frais.</p>
      </div>
      <div class="en-passe__tool">
        <div class="en-passe__pick" role="radiogroup" aria-label="Pièce à vérifier">
          ${[f, o, pe].map((p, i) => `<button class="pill" type="button" role="radio" aria-checked="${i === 0}" data-action="passe-pick" data-slug="${p.slug}">${esc(p.nom)}</button>`).join('')}
        </div>
        <form class="passe__form" data-passe-form novalidate>
          <label class="passe__lbl" for="passe-w">Largeur de la porte, en centimètres</label>
          <div class="passe__row">
            <span class="passe__field"><input id="passe-w" name="w" type="number" inputmode="numeric" min="30" max="300" placeholder="80"><span aria-hidden="true">cm</span></span>
            <button class="btn" type="submit">Vérifier</button>
          </div>
        </form>
        <p class="passe__a" data-passe-msg aria-live="polite">${passeHint()}</p>
      </div>
    </section>

    <section class="wrap sec">
      <h2 class="t-2 en-h">Trois pièces pour les petits salons</h2>
      <div class="en-trio">
        ${piece(f, '142 cm, deux places. Un seul colis compressé, rien à monter.')}
        ${piece(o, '188 cm, 2 à 3 places. Deux parties compressées, réunies sur place.')}
        ${piece(pe, '67 × 67 cm : une place de plus, dans un coin ou près de la fenêtre. Il passe une porte de 69 cm.')}
      </div>
    </section>

    <section class="wrap sec en-split">
      <div>
        <h2 class="t-2">Quelle largeur pour votre pièce ?</h2>
        <p class="en-split__p">Un repère simple : le canapé occupe environ les deux tiers du mur sur lequel il s’appuie.</p>
      </div>
      <table class="en-table">
        <thead><tr><th scope="col">Largeur</th><th scope="col">Pièce</th><th scope="col">Chez Caplia</th></tr></thead>
        <tbody>
          <tr><td class="num">140 à 160 cm</td><td>Studio, chambre, petit salon</td><td><a class="u" href="#/p/${f.slug}">Flocon</a>, 142 cm</td></tr>
          <tr><td class="num">180 à 200 cm</td><td>Salon de 12 à 18 m²</td><td><a class="u" href="#/p/${o.slug}">Opaline</a>, 188 cm</td></tr>
          ${mid ? `<tr><td class="num">200 à 215 cm</td><td>Salon moyen</td><td><a class="u" href="#/p/${mid.slug}">${esc(mid.nom)}</a>, ${cm(mid.dimensions.largeur)}</td></tr>` : ''}
        </tbody>
      </table>
    </section>

    ${ens ? `<section class="wrap sec en-ens">
      <div class="en-ens__img en-ens__img--photo">${ensPic('petit-mouton', 'Flocon et Perle côte à côte dans le studio Caplia', '(max-width: 980px) calc(100vw - 32px), 58vw')}</div>
      <div class="en-ens__text">
        <h2 class="t-2">${esc(ens.nom)}</h2>
        <p class="lead">Flocon et Perle, dans le même ton crème : un canapé, un fauteuil, un petit salon complet. ${gifts.length ? `Ensemble, ils dépassent ${price(gifts[0].seuil)} : ${esc(gifts[0].cadeau)} offerts.` : ''}</p>
        <div class="en-hero__buy"><button class="btn" type="button" data-action="ens-add" data-i="${ei}">Ajouter l’ensemble</button><p class="price en-hero__price">${price(tot)}</p></div>
      </div>
    </section>` : ''}

    <section class="wrap sec en-faq">
      <h2 class="t-2">Vos questions</h2>
      <div>${faq.map(([q, r]) => acc(esc(q), r)).join('')}</div>
    </section>
    ${footer()}`;
    return { title: 'Petit canapé pour petits espaces, livré compressé · Caplia', html };
  }
  /* Avant la saisie : le fait, selon la pièce (même règle que doorAnswer). Pièce compressée : son carton est plus petit
     qu'elle, et elle ne « passe » une porte chiffrée que si les cotes du carton sont connues ; les autres passent de profil
     une porte un peu plus large que leur plus petite mesure. */
  const passeHint = () => {
    const p = BY[PASSE.slug];
    const e = isFem(p), dm = doorMin(p);
    const parts = (p.carton || []).find((t) => /^\d+ (modules|parties)/i.test(t));
    if (isCompressed(p) && dm == null) return `${esc(p.nom)} voyage ${parts ? `en ${esc(parts.toLowerCase())}` : `compressé${e ? 'e' : ''}`}, dans ${parts || colisN(p) > 1 ? 'des cartons plus petits' : 'un carton plus petit'} ${e ? "qu'elle" : 'que lui'}. Indiquez la largeur de votre porte la plus étroite.`;
    return `${isCompressed(p) ? `Le plus grand carton ${deN(esc(p.nom))}` : esc(p.nom)} passe de profil une porte de ${cm(Math.ceil(dm + 2))} ou plus. Indiquez la vôtre pour en être sûr.`;
  };

  /* Jeunes parents : persona « bébé arrive » (marketing/PERSONAS.md, P3). Affiche Aurore, ce qui compte la nuit,
     les repères Aurore / Valse, la liste de naissance, après bébé, questions (seo-pages.json : fauteuil-allaitement). */
  function renderParents() {
    const a = BY.veilleuse, v = BY.berceuse;
    const SZ2 = '(max-width: 760px) calc(100vw - 32px), 46vw';
    const piece = (p, line) => `<article class="en-piece">
        <a class="en-piece__link" href="#/p/${p.slug}" aria-label="${esc(p.nom)}, ${esc(lc1(cardType(p)))}, ${price(p.prix)}"></a>
        <span class="en-piece__img">${studioImg(p, { alt: `${p.nom}, ${p.type.toLowerCase()}, sur fond clair`, sizes: SZ2, cadres: [['(max-width: 760px)', '11'], [null, '54']] })}</span>
        <div class="en-piece__row"><h3 class="t-3">${esc(p.nom)}</h3><p class="price">${price(p.prix)}</p></div>
        <p class="en-piece__line">${line}</p>
        <div class="en-piece__acts">${birthBtn(p)}</div>
      </article>`;
    const rows = [
      ['Hauteur d’assise', '40 à 45 cm : les pieds à plat, les genoux à angle droit', '43 cm', '42 cm'],
      ['Dossier', 'Haut et enveloppant, pour tenir le dos pendant les tétées de nuit', 'À oreilles, 47 cm au-dessus de l’assise', 'Capitonné, 49 cm au-dessus de l’assise, coussin d’appui-tête'],
      ['Accoudoirs', 'Rembourrés, pour soutenir le bras qui porte bébé', 'Oui', 'Oui'],
      ['Bascule', 'Un balancement doux, sans à-coup', 'Bois courbé', 'Patins en bois'],
      ['Repose-pieds', 'Pour lever les genoux et rapprocher bébé', 'Livré avec', 'Pieds à plat, à 42 cm'],
      ['Tissu', 'Doux, qui se nettoie en tamponnant', 'Effet lin', 'Moumoute']
    ];
    const faq = [
      ['Quel fauteuil choisir pour allaiter ?', 'Celui qui garde votre dos droit et soutenu : une assise entre 40 et 45 cm, un dossier haut, des accoudoirs rembourrés et un repose-pieds. Une bascule douce aide à bercer bébé après la tétée.'],
      ['Faut-il un repose-pieds ?', 'Il lève les genoux pour rapprocher bébé, et détend les jambes la nuit. Aurore est livré avec le sien, dans le même colis et le même tissu.'],
      ['Quelle place prévoir pour un fauteuil à bascule ?', 'Comptez ses 64 × 89 cm, un peu d’espace devant et derrière pour le balancement, et la place du repose-pieds devant. Un coin près de la fenêtre suffit.'],
      ['Quand le commander ?', `Au troisième trimestre, quand vous préparez la chambre. Commandé aujourd’hui, Aurore arrive ${delivery(a)} : vous avez le temps de lui trouver sa place.`]
    ];
    const html = `<section class="wrap en-hero">
      <div class="en-hero__text">
        <h1 class="t-display en-hero__t">3 h du matin, enfin bien assise.</h1>
        <p class="lead en-hero__lead">Aurore berce en douceur, vous enveloppe le dos dans son dossier à oreilles et arrive avec son repose-pieds. Quand bébé fait ses nuits, il descend au salon.</p>
        <div class="en-hero__buy"><a class="btn" href="#/p/${a.slug}">Voir Aurore</a><p class="price en-hero__price">${price(a.prix)}</p></div>
        <p class="en-hero__date">Livraison offerte, chez vous ${delivery(a)}.</p>
      </div>
      <div class="en-hero__img">${studioImg(a, { alt: 'Aurore, fauteuil d’allaitement à bascule en tissu effet lin Blanc petit matin, avec son repose-pieds, sur fond clair', sizes: '(max-width: 760px) calc(100vw - 32px), (max-width: 980px) 50vw, (min-width: 1440px) 800px, 56vw', eager: true, cadres: [['(max-width: 760px)', '11'], ['(max-width: 980px)', '45'], [null, '54']] })}</div>
    </section>

    <section class="wrap sec">
      <h2 class="t-2 en-h">Ce qui compte, la nuit</h2>
      <dl class="en-facts">
        <div><dt>43 cm</dt><dd>Du sol à l’assise, à peu près une chaise : les pieds à plat, on se relève sans s’enfoncer.</dd></div>
        <div><dt>90 cm</dt><dd>La hauteur du fauteuil, dont un dossier à oreilles de 47 cm au-dessus de l’assise : il enveloppe le dos pendant la tétée.</dd></div>
        <div><dt>45 × 37 cm</dt><dd>Le repose-pieds, livré avec, dans le même tissu : les jambes se détendent.</dd></div>
        <div><dt>1 colis</dt><dd>Fauteuil et repose-pieds ensemble, livrés depuis ${PAYS_DE[a.pays]} en ${delayTxt(a)}.</dd></div>
      </dl>
    </section>

    <section class="wrap sec">
      <h2 class="t-2 en-h">Deux fauteuils qui bercent</h2>
      <div class="en-duo">
        ${piece(a, `Bascule en bois courbé, dossier à oreilles, repose-pieds assorti, en ${andList(a.couleurs.filter((c) => !isOut(c)).map((c) => c.nom)).replace(/ et ([^,]*)$/, ' ou $1')}.`)}
        ${piece(v, 'Bascule sur patins en bois, appui-tête, poche pour le livre ou le téléphone.')}
      </div>
    </section>

    <section class="wrap sec en-split en-split--vs">
      <div>
        <h2 class="t-2">Les six repères</h2>
        <p class="en-split__p">Ce qu’il faut vérifier sur un fauteuil d’allaitement, et ce que font les nôtres.</p>
      </div>
      <table class="en-table en-table--4">
        <thead><tr><th scope="col">Repère</th><th scope="col">À chercher</th><th scope="col">Aurore</th><th scope="col">Valse</th></tr></thead>
        <tbody>${rows.map(([k, c, x, y]) => `<tr><th scope="row">${k}</th><td>${c}</td><td data-l="Aurore">${x}</td><td data-l="Valse">${y}</td></tr>`).join('')}</tbody>
      </table>
    </section>

    <section class="wrap sec en-times">
      <h2 class="t-2 en-h">Les nuits, puis le salon</h2>
      <div class="en-times__grid">
        <div><p class="en-times__h">3 h</p><p>La maison dort, vous bercez. Vous comptez les allers-retours du fauteuil plutôt que les heures.</p></div>
        <div><p class="en-times__h">21 h</p><p>Bébé fait ses nuits. Le fauteuil est au salon, le livre ouvert, les pieds sur le repose-pieds.</p></div>
      </div>
    </section>

    <section class="wrap sec en-faq">
      <h2 class="t-2">Vos questions</h2>
      <div>${faq.map(([q, r]) => acc(esc(q), esc(r))).join('')}</div>
    </section>
    ${footer()}`;
    return { title: 'Fauteuil d’allaitement à bascule avec repose-pieds · Caplia', html };
  }

  /* Pourquoi Caplia : le « pourquoi chez nous » de l'angle « la certitude » (marketing/STRATEGIE-MARKETING.md §1), sans
     jamais écrire « achetez chez nous » ni comparer à d'autres vendeurs. Les trois questions qui font acheter un canapé
     (quand arrive-t-il, passera-t-il chez moi, son prix va-t-il baisser ?), chacune avec sa réponse avant de payer, sa
     preuve sur la page et le lien vers la page qui la montre ; puis la réponse écrite (reponse()), les faits de chaque
     fiche et trois canapés pour commencer. */
  function renderWhy() {
    const d = SITE.livraison.delais;
    const j = BY['noix-de-cajou'] || BY.incurve, o = BY['petit-incurve'], f = BY['petit-mouton'];
    PASSE.slug = j.slug;   /* l'outil de la porte s'ouvre sur Éclipse, la pièce de l'affiche */
    const SZ3 = '(max-width: 760px) calc(100vw - 32px), 31vw';
    const piece = (p, line) => `<article class="en-piece">
        <a class="en-piece__link" href="#/p/${p.slug}" aria-label="${esc(p.nom)}, ${esc(lc1(cardType(p)))}, ${price(p.prix)}"></a>
        <span class="en-piece__img">${scenesFor(p, '').length ? sceneImg(p, scenesFor(p, '')[0], { alt: `${p.nom}, ${p.type.toLowerCase()}`, sizes: SZ3, eager: false, cls: '' }) : studioImg(p, { alt: `${p.nom}, ${p.type.toLowerCase()}, sur fond clair`, sizes: SZ3, cadres: ['11'] })}</span>
        <div class="en-piece__row"><h3 class="t-3">${esc(p.nom)}</h3><p class="price">${price(p.prix)}</p></div>
        <p class="en-piece__line">${line}</p>
      </article>`;
    const html = `<section class="wrap en-hero">
      <div class="en-hero__text">
        <h1 class="t-1 en-hero__t">Un canapé se choisit avec les yeux</h1>
        <p class="lead en-hero__lead">Il s’achète quand trois questions ont leur réponse : quand <span class="en-nowrap">arrive-t-il</span>, <span class="en-nowrap">passera-t-il</span> chez moi, son prix <span class="en-nowrap">va-t-il</span> baisser ? Chez Caplia, chacune a sa réponse avant que vous payiez.</p>
        <div class="en-hero__buy"><a class="btn" href="#/canapes">Voir les canapés</a></div>
        <p class="en-hero__date">Livraison offerte en ${d.FR[0]} à ${euMax()} jours ouvrés, depuis ${orList(['FR', ...EU_KEYS()].map((k) => PAYS_DE[k])).replace(/'/g, '’')}.</p>
      </div>
      <div class="en-hero__img en-hero__img--scene">${scenesFor(j, '').length ? sceneImg(j, scenesFor(j, '')[0], { alt: `${j.nom}, ${lc1(j.type)}, dans un salon lumineux`, sizes: '(max-width: 760px) 100vw, 56vw', eager: true, cls: '', wide: true }) : ''}</div>
    </section>

    <section class="wrap sec en-split en-q" aria-labelledby="q-date">
      <div>
        <h2 class="t-2" id="q-date">Quand <span class="en-nowrap">arrive-t-il</span> ?</h2>
        <p class="en-split__p">La date est sur la fiche, avant de payer.</p>
      </div>
      <div class="en-q__a">
        <p class="en-q__proof"><span>${esc(j.nom)}, commandé aujourd’hui</span><strong>Chez vous ${delivery(j)}</strong></p>
        <p>Chaque fiche calcule sa date le jour de votre visite, selon l’entrepôt d’où part la pièce : ${d.FR[0]} à ${d.FR[1]} jours ouvrés depuis la France, ${euMin()} à ${euMax()} depuis ${euDe('’')}.</p>
        <p>Ensuite, des nouvelles à chaque étape : un e-mail à la commande, un autre avec le suivi de chaque colis, un dernier à l’approche de la livraison. Si un colis prend du retard, nous vous écrivons avant que vous ayez à le demander.</p>
        <p class="en-q__links"><a class="link" href="#/p/${j.slug}">Voir la date ${deN(esc(j.nom))}</a><a class="link" href="#/livraison?s=nouvelles">Les nouvelles, étape par étape</a></p>
      </div>
    </section>

    <section class="wrap sec en-passe en-q" data-passe aria-labelledby="q-passe">
      <div class="en-passe__intro">
        <h2 class="t-2" id="q-passe"><span class="en-nowrap">Passera-t-il</span> chez moi ?</h2>
        <p class="lead">Envoyez-nous la largeur de votre porte la plus étroite et de votre escalier : nous vérifions qu’il passe et vous répondons par écrit, avant l’achat. Si nous avons dit oui et qu’il ne passe pas, nous le reprenons à nos frais.</p>
        <p class="en-q__links"><a class="link" href="#/conditions-de-vente?s=passage">L’engagement, écrit dans nos conditions</a></p>
      </div>
      <div class="en-passe__tool">
        <div class="en-passe__pick" role="radiogroup" aria-label="Pièce à vérifier">
          ${[j, o, f].map((p, i) => `<button class="pill" type="button" role="radio" aria-checked="${i === 0}" data-action="passe-pick" data-slug="${p.slug}">${esc(p.nom)}</button>`).join('')}
        </div>
        <form class="passe__form" data-passe-form novalidate>
          <label class="passe__lbl" for="passe-w">Largeur de la porte, en centimètres</label>
          <div class="passe__row">
            <span class="passe__field"><input id="passe-w" name="w" type="number" inputmode="numeric" min="30" max="300" placeholder="80"><span aria-hidden="true">cm</span></span>
            <button class="btn" type="submit">Vérifier</button>
          </div>
        </form>
        <p class="passe__a" data-passe-msg aria-live="polite">${passeHint()}</p>
      </div>
    </section>

    <section class="wrap sec en-who en-q" aria-labelledby="q-reponse">
      <h2 class="t-2" id="q-reponse">Une réponse ${reponse()}</h2>
      <div class="en-who__text">
        <p class="lead">Et quand vous nous écrivez ? Une question sur une mesure, une couleur, votre escalier : une personne vous répond par écrit, avant que vous commandiez.</p>
        <p class="en-who__links">${mailLink()}</p>
      </div>
    </section>

    <section class="wrap sec">
      <h2 class="t-2 en-h">Le reste est écrit sur chaque fiche</h2>
      <dl class="en-facts">
        <div><figure class="en-fig en-fig--plan" aria-hidden="true">${planSVG(j)}</figure><dt>${cm(j.dimensions.hauteurAssise)}</dt><dd>La hauteur d’assise ${deN(esc(j.nom))}, avec la profondeur de son assise et ses mesures au centimètre.</dd></div>
        <div><figure class="en-fig"><img src="/site/assets/arrivee/cartons-640.webp" alt="Les cartons d’une pièce compressée, ouverts à la livraison" loading="lazy" decoding="async" draggable="false"></figure><dt>Plan coté</dt><dd>Chaque mesure de la pièce, le nombre de colis et ce qu’il y a dans le carton.</dd></div>
        <div><figure class="en-fig"><img src="/site/assets/arrivee/en-place-640.webp" alt="Un canapé installé, sorti de ses cartons" loading="lazy" decoding="async" draggable="false"></figure><dt>0${NB}€</dt><dd>De livraison, éco-participation comprise : le prix affiché est le prix payé.</dd></div>
        <div><figure class="en-fig"><img src="/site/assets/arrivee/ouverture-640.webp" alt="Un canapé roulé dans son film, sur son carton ouvert" loading="lazy" decoding="async" draggable="false"></figure><dt>1 photo</dt><dd>${esc(SITE.soutien || 'Un souci à la livraison ? Une photo par e-mail suffit : nous nous occupons du reste.')}</dd></div>
      </dl>
    </section>

    <section class="wrap sec">
      <h2 class="t-2 en-h">Trois canapés pour commencer</h2>
      <div class="en-trio">
        ${piece(j, j.slug === 'noix-de-cajou' ? '223 cm en chenille au fil bouclé, livré compressé en 2 modules. Deux couleurs, un seul prix.' : `${cm(j.dimensions.largeur)} en ${lc1(j.matiere)}.`)}
        ${piece(o, '188 cm en chenille, 68 cm de profondeur d’assise pour replier les jambes.')}
        ${piece(f, '142 cm, deux places, un seul carton. Notre canapé le plus abordable.')}
      </div>
    </section>
    ${footer()}`;
    return { title: 'Pourquoi Caplia : la date, le passage et le prix connus avant de payer · Caplia', html };
  }

  function renderSelection() {
    takeShared('selection');
    const items = fav.map((s) => BY[s]).filter(Boolean);
    const sizes = '(max-width: 760px) 100vw, (max-width: 1100px) 50vw, 32vw';
    /* Une ligne vraie et utile : le total des pièces gardées et les cadeaux qu'il débloque, ou ce qu'il manque pour le premier */
    const sumLine = () => {
      const list = fav.map((s) => BY[s]).filter(Boolean);
      const total = list.reduce((s, p) => s + p.prix, 0);
      const base = list.filter((p) => !isAcc(p)).reduce((s, p) => s + p.prix, 0);
      const g = giftsFor(base);
      const next = SITE.paliers.find((pl) => base < pl.seuil);
      const n = `${list.length}${NB}pièce${list.length > 1 ? 's' : ''}`;
      if (g.length) return `${n} pour ${price(total)}. ${list.length > 1 ? 'Commandées ensemble' : 'Avec elle'} : ${esc(andList(g.map((pl) => pl.cadeau)))} offert${g.length > 1 || /^\d|coussins/.test(g[0].cadeau) ? 's' : ''}.`;
      return `${n} pour ${price(total)}. ${esc(cap1(next.cadeau))} offerts dès ${price(next.seuil)} d’achat.`;
    };
    /* cartes de la sélection, sans affiche large (la grille se recompose quand on retire une pièce) */
    const selCards = (list) => { const sz = list.length === 4 ? CG_SIZES_2 : list.length <= 2 ? CG_SIZES_BIG : sizes; return list.map((p, i) => `<div class="sel-item">${pcard(p, { eager: i < 3, sizes: sz })}<button class="link sel-item__x" type="button" data-action="fav-remove" data-slug="${p.slug}" aria-label="Retirer ${esc(p.nom)} de ma sélection">Retirer</button></div>`).join(''); };
    const picks = ['causeuse', 'noix-de-cajou', 'incurve', 'galet'].map((k) => BY[k]).filter(Boolean).slice(0, 3);
    const html = `<section class="wrap cpage spage">
      <header class="chead">
        <h1 class="t-display chead__title">Ma sélection</h1>
        <p class="lead chead__intro" data-sel-sum>${items.length ? sumLine() : 'Gardez ici les pièces qui vous plaisent, pour les comparer au calme ou les montrer à la maison. Sur une fiche, choisissez « Enregistrer dans ma sélection ».'}</p>
        ${items.length ? `<div class="spage__share">${shareUi('selection', 'Envoyer ma sélection')}</div>` : ''}
      </header>
      ${items.length ? `<div class="${cgClass(items)} sel-grid">${selCards(items)}</div>
      <form class="selmail" data-selmail novalidate>
        <h2 class="t-3">Recevoir ma sélection par e-mail</h2>
        <p class="selmail__txt">Les liens de vos pièces, pour les retrouver sur votre téléphone ou les montrer à la personne avec qui vous choisissez.</p>
        <div class="news__row">
          <label class="sr-only" for="sel-m">Votre adresse e-mail</label>
          <input id="sel-m" name="email" type="email" autocomplete="email" inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="nom@exemple.fr">
          <button class="btn" type="submit">Recevoir</button>
        </div>
        <label class="check" for="sel-c"><input id="sel-c" name="ok" type="checkbox"><span>Recevoir aussi les nouvelles couleurs et le guide des formes douces</span></label>
        <p class="news__msg" data-news-msg aria-live="polite" hidden></p>
      </form>` : `<div class="sempty">
        <a class="btn" href="#/canapes">Voir les canapés</a>
        <p class="sempty__links"><a class="link" href="#/fauteuils">Fauteuils</a><a class="link" href="#/decoration">Décoration</a></p>
      </div>
      ${picks.length ? `<h2 class="t-3 spage__h">Trois pièces pour commencer</h2><div class="cgrid">${cgCards(picks, 0)}</div>` : ''}`}
    </section>${footer()}`;
    return {
      title: 'Ma sélection · Caplia',
      html,
      scene: {},
      after: () => {
        setDesc('Les pièces Caplia que vous avez gardées, avec leur total et les cadeaux offerts qu’elles débloquent ensemble.');
        const grid = $('.sel-grid');
        const sum = $('[data-sel-sum]');
        if (grid && sum) grid.addEventListener('click', (e) => { if (e.target.closest('[data-action="fav-remove"]')) setTimeout(() => {
          if (!fav.length || !document.body.contains(sum)) return;
          const list = fav.map((s) => BY[s]).filter(Boolean);
          sum.innerHTML = sumLine();
          grid.className = `${cgClass(list)} sel-grid`;
          grid.innerHTML = selCards(list);
        }, 0); });
      }
    };
  }

  /* Page Merci : la suite en trois étapes datées, le récapitulatif, une pièce assortie, le parrainage */
  function renderThanks() {
    const o = loadOrder();
    if (!o) {
      return { title: 'Merci · Caplia', html: `<section class="wrap"><div class="cart-empty"><h1 class="t-1">Aucune commande en cours</h1><p class="lead">Votre récapitulatif s'affichera ici après votre commande.</p><a class="btn" href="#/canapes">Voir les canapés</a></div></section>${footer()}`, scene: { img: tab('incurve-sel', '960'), soft: true } };
    }
    /* une couleur vide vaut la couleur par défaut : deux lignes de la même pièce n'en font qu'une */
    const items = [];
    o.items.filter((l) => BY[l.slug]).forEach((l) => { const c = colorIn(BY[l.slug], l.color || ''); const x = items.find((y) => y.slug === l.slug && y.color === c && (y.size || '') === (l.size || '')); if (x) x.qty += l.qty; else items.push({ ...l, color: c }); });
    const prods = items.map((l) => BY[l.slug]);
    const main = prods.slice().sort((a, b) => b.prix - a.prix)[0];
    const inOrder = new Set(items.map((l) => l.slug));
    const ens = main && ensFor(main.slug);
    const mate = (ens && ens.items.slice(1).map(([s]) => BY[s]).find((p) => p && !inOrder.has(p.slug)))
      || PRODS.filter((p) => sameWorld(p, main) && p.collection !== 'canapes' && !isBed(p) && !inOrder.has(p.slug) && !p.couleurs.every(isOut) && !notYet(p)).sort((a, b) => a.prix - b.prix)[0];
    const slowest = slowestOf(prods);
    const ordered = new Date(o.date);
    const start = ordered;
    const [da, db] = DL(slowest);
    const d1 = addBusiness(start, da), d2 = addBusiness(start, db);
    const span = `entre le ${dayLbl(d1, d1.getMonth() !== d2.getMonth())} et le ${dayLbl(d2, true)}`;
    const steps = [['Aujourd’hui', 'Un e-mail récapitulatif arrive dans quelques minutes. Gardez-le : votre numéro de commande y figure.'],
         ['Au départ du colis', 'Vous recevez le lien de suivi par e-mail, pour voir où en est la livraison.'],
         ['Livraison chez vous', `Offerte, à la date annoncée plus haut${giftsFor(o.base != null ? o.base : o.total).length ? '. Les cadeaux arrivent dans un colis séparé' : ''}.`]];
    const html = `<section class="wrap thx">
      <header class="thx__head">
        <h1 class="t-1">Merci, c’est commandé</h1>
        <p class="lead">Votre commande arrive ${span}.</p>
      </header>
      <section class="thx__steps" aria-labelledby="thx-suite">
        <h2 class="sr-only" id="thx-suite">La suite</h2>
        <ol class="steps">${steps.map(([t, d]) => `<li><h3 class="t-4">${t}</h3><p>${d}</p></li>`).join('')}</ol>
      </section>
      <div class="thx__grid">
        <section class="thx__order" aria-labelledby="thx-cmd">
          <h2 class="t-3" id="thx-cmd">Votre commande</h2>
          <ul class="lines">${items.map((l) => { const p = BY[l.slug]; return `<li class="line line--ro">
              <a class="line__thumb" href="#/p/${p.slug}" aria-label="${esc(p.nom)}">${cartThumb(p, l.color)}</a>
              <div class="line__info"><a class="line__name" href="#/p/${p.slug}">${esc(p.nom)}</a><p class="line__var">${p.couleurs.length > 1 ? esc(l.color) + ' · ' : ''}${esc(cardType(p))}${l.size ? ' · ' + esc(l.size) : ''}${l.qty > 1 ? ' · ' + l.qty + ' exemplaires' : ''}</p></div>
              <p class="line__total">${price(unitPriceOf(p, l.size) * l.qty)}</p>
            </li>`; }).join('')}
          </ul>
          ${giftsHtml(giftsFor(o.base != null ? o.base : o.total).map((pl) => [giftLabel(pl), 'Dans un colis séparé', giftWord(pl), pl]))}
          <dl class="thanks__sum"><div><dt>Livraison</dt><dd>Offerte</dd></div><div class="total"><dt>Total</dt><dd>${price(o.total)}</dd></div></dl>
          <p class="thanks__demo">Commande simulée : cette maquette n’encaisse rien.</p>
        </section>
        ${mate ? `<section class="thx__mate" aria-labelledby="thx-mate">
          <a class="thx__mateimg" href="#/p/${mate.slug}" aria-label="${esc(mate.nom)}">${studioImg(mate, { sizes: '(max-width: 980px) 92vw, 40vw', cadres: [['(max-width: 760px)', '54'], [null, '43']] })}</a>
          <h2 class="t-3" id="thx-mate">${esc(mate.nom)}, pour aller avec ${esc(main.nom)}</h2>
          <p class="thx__matep">${esc(mate.type)} · ${fromOf(mate)}${price(mate.prix)}</p>
          <button class="btn" type="button" data-action="quick-add" data-slug="${mate.slug}">Ajouter au panier</button>
        </section>` : ''}
      </div>
      <section class="thx-ask" data-ask aria-labelledby="thx-ask">
        <h2 class="t-3" id="thx-ask">Une question, en une seconde</h2>
        <div class="thx-ask__q" data-ask-step="1">
          <p>Qu’est-ce qui a failli vous faire renoncer ?</p>
          <div class="thx-ask__opts">${['La taille ou le passage', 'La couleur', 'Le confort sans l’essayer', 'Le délai', 'Le prix', 'Rien', 'Autre chose'].map((t) => `<button class="pill" type="button" aria-pressed="false">${t}</button>`).join('')}</div>
        </div>
        <div class="thx-ask__q" data-ask-step="2" hidden>
          <p>Et comment nous avez-vous trouvés ?</p>
          <div class="thx-ask__opts">${['Sur Google', 'Par un proche', 'Sur Instagram ou Pinterest', 'Autrement'].map((t) => `<button class="pill" type="button" aria-pressed="false">${t}</button>`).join('')}</div>
        </div>
        <p class="thx-ask__ok" data-ask-ok aria-live="polite" hidden>Merci. Vos réponses nous aident à mieux expliquer nos pièces à ceux qui hésitent encore.</p>
      </section>
      <section class="parrain" aria-labelledby="thx-ami">
        <h2 class="t-2" id="thx-ami">Un ami aime votre salon ?</h2>
        <div class="parrain__body">
          <p>S’il passe sa première commande en donnant votre nom, vous recevez chacun un coussin nœud en velours, offert. Les deux coussins partent après les ${SITE.retours.delaiJours} jours pour changer d’avis de sa commande.</p>
          <button class="link" type="button" data-action="share">Copier le lien à lui envoyer</button>
          <p class="parrain__ok" data-share-msg aria-live="polite" hidden></p>
        </div>
      </section>
    </section>${footer()}`;
    /* Deux questions facultatives (PLAN-MAITRE K9) : une réponse par question, puis un merci. Rien n'est envoyé dans la maquette. */
    const after = (root) => {
      const box = $('[data-ask]', root);
      if (!box) return;
      const onClick = (e) => {
        const b = e.target.closest('.pill');
        if (!b) return;
        const q = b.closest('[data-ask-step]');
        $$('.pill', q).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        const next = q.nextElementSibling;
        if (next && next.hasAttribute('data-ask-step')) { next.hidden = false; return; }
        $('[data-ask-ok]', box).hidden = false;
      };
      box.addEventListener('click', onClick);
      cleanups.push(() => box.removeEventListener('click', onClick));
    };
    return { title: 'Merci · Caplia', html, after, scene: { img: tab('incurve-sel', '960'), soft: true } };
  }

  /* =========================================================
     CLASSEMENT (site/data/categories.json, source unique) : menu, pages de catégorie et de sous-catégorie, fil
     d'Ariane, accueil. Chaque sous-catégorie est une page de site/data/seo-pages.json (h1, intro, questions,
     « produits ») et une campagne Google : la recherche, l'annonce et la page disent les mêmes mots.
     Univers « sleep » : Caplia Sleep, jamais mêlé au salon (ni accueil, ni grilles, ni suggestions du salon).
     ========================================================= */
  let CATS = [];            /* catégories, dans l'ordre du menu */
  const SUBS = {};          /* sous-catégorie -> { sub, cat } */
  const PRIM = {};          /* pièce -> { cat, sub } : la première sous-catégorie où elle apparaît (sa place principale) */
  const SEO = {};           /* page de seo-pages.json (collections), par slug */
  const isSleep = (p) => !!p && p.collection === 'sleep';
  const sameWorld = (a, b) => isSleep(a) === isSleep(b);
  const catBy = (slug) => CATS.find((c) => c.slug === slug);
  function indexCats(cj, sj) {
    CATS = ((cj && cj.categories) || []).map((c) => ({ ...c, sous: c.sous.map((s) => ({ ...s, produits: s.produits.filter((k) => BY[k]) })) }));
    CATS.forEach((c) => c.sous.forEach((s) => {
      SUBS[s.slug] = { sub: s, cat: c };
      s.produits.forEach((k) => { if (!PRIM[k]) PRIM[k] = { cat: c, sub: s }; });
    }));
    ((sj && sj.pages) || []).filter((pg) => /^collection/.test(pg.type || '')).forEach((pg) => { SEO[pg.slug] = pg; });
  }
  /* « minimum » (categories.json) : une sous-catégorie ne s'affiche qu'avec au moins ce nombre de pièces visibles */
  const subsOf = (c) => c.sous.filter((s) => s.produits.length >= (s.minimum || 1));
  const subHref = (s) => `#/collections/${s.slug}`;
  /* délai d'une liste de pièces, du plus court au plus long */
  const delaysOf = (list) => { const ds = list.map((p) => DL(p)); return `${Math.min(...ds.map((d) => d[0]))} à ${Math.max(...ds.map((d) => d[1]))}${NB}jours ouvrés`; };
  /* phrase d'introduction tirée des fiches, quand la page n'a pas encore la sienne (seo-pages.json) */
  /* une ligne au plus en tête de page : la première phrase, si elle est courte */
  const subLine = (list) => { const ws = list.map((p) => p.dimensions.largeur); return catLine({ min: Math.min(...ws), max: Math.max(...ws) }); };
  const catLine = (r) => (r.min < r.max ? `De ${numFr(r.min)} à ${cm(r.max)} de large, livraison offerte.` : 'Livraison offerte.');
  function autoIntro(list, h1) {
    if (!list.length) return '';
    const mats = [...new Set(list.map((p) => p.matiere.toLowerCase()))];
    const en = `en ${mats.join(' ou en ')}`;
    if (list.length === 1) return `${list[0].nom}, ${lc1(cardType(list[0]))}, ${en}. Livraison offerte, chez vous en ${delaysOf(list)}.`;
    const sz = list.map((p) => Math.max(p.dimensions.largeur, p.dimensions.hauteur));
    const range = Math.min(...sz) === Math.max(...sz) ? '' : `, de ${numFr(Math.min(...sz))} à ${cm(Math.max(...sz))}`;
    return `${list.length} ${h1.toLowerCase()}${range}, ${en}. Livraison offerte, chez vous en ${delaysOf(list)}.`;
  }
  /* Textes de l'univers Caplia Sleep (chambre calme, rangement caché, toucher) : les pages n'en ont pas encore */
  const SLEEP_COPY = {
    sleep: 'Une chambre calme, des formes douces. Chaque lit arrive avec son sommier à lattes ; sous Songe, un coffre de la taille du lit.',
    lits: 'Deux lits rembourrés, livrés avec leur sommier à lattes. Songe se relève sur vérins : dessous, un coffre de la taille du lit. Brume a une tête de lit capitonnée, en trois tailles.',
    'bouts-de-lit': 'Au pied du lit, un banc pour s’asseoir et un coffre pour le linge. En bouclette crème, ou en velours cannelé sur pieds dorés.'
  };
  /* sans Songe (pièce masquée), la chambre se présente avec Brume et les bancs coffres */
  const SLEEP_SANS_SONGE = {
    sleep: 'Une chambre calme, des formes douces. Le lit arrive avec son sommier à lattes ; à son pied, un banc coffre pour le linge.',
    lits: 'Brume, un lit rembourré à la tête de lit capitonnée, livré avec son sommier à lattes.'
  };
  const sleepCopy = (k) => (!BY.songe && SLEEP_SANS_SONGE[k]) || SLEEP_COPY[k] || '';
  /* titres : les formes de la catégorie encore en ligne (pièces masquées : la forme disparaît du titre avec elles) */
  const CAT_TITLE = {
    canapes: (f) => `Canapés ${andList([['canape-arrondi', 'arrondis'], ['canape-nuage', 'nuage'], ['canape-angle', 'd’angle'], ['canape-convertible', 'convertibles'], ['meridienne', 'méridiennes']].filter(([k]) => f.subs.includes(k)).map(([, w]) => w))} · Caplia`,
    fauteuils: 'Fauteuils de salon, à bascule et d’allaitement · Caplia',
    decoration: (f) => `${f.subs.includes('tables') && f.subs.includes('miroirs') ? 'Miroirs et tables' : f.subs.includes('tables') ? 'Tables' : 'Miroirs'} aux formes douces · Caplia`,
    sleep: 'Caplia Sleep : lits et bouts de lit · Caplia'
  };
  /* le mot-logo de l'univers : « Caplia. » en gras, puis « Sleep » */
  const sleepMark = (tag = 'p', cls = '') => `<${tag} class="sleepmark${cls ? ' ' + cls : ''}"><b>Caplia.</b> <span>Sleep</span></${tag}>`;

  /* Fil d'Ariane : « Canapés / Arrondis / Corolle », chaque étape cliquable sauf la dernière */
  function crumbHtml(steps, cls = '') {
    return `<nav class="crumb${cls ? ' ' + cls : ''}" aria-label="Fil d’Ariane"><ol>${steps.map(([href, t], i) => `<li>${i ? '<span class="crumb__sep" aria-hidden="true">/</span>' : ''}${href && i < steps.length - 1 ? `<a href="${href}">${esc(t)}</a>` : `<span aria-current="page">${esc(t)}</span>`}</li>`).join('')}</ol></nav>`;
  }
  const crumbOf = (p) => { const r = PRIM[p.slug]; return r ? crumbHtml([[r.cat.route, r.cat.nom], [subHref(r.sub), r.sub.nom], [null, p.nom]], 'fp__crumb') : ''; };
  /* Pastilles des sous-catégories (chacune a son adresse) ; current : la page ouverte */
  const subPills = (c, current = '') => `<nav class="cpills" aria-label="${esc(c.nom)}, par forme">${subsOf(c).map((s) => `<a class="pill pill--sm${s.slug === current ? ' is-active' : ''}" href="${subHref(s)}"${s.slug === current ? ' aria-current="page"' : ''}>${esc(s.nom)}</a>`).join('')}</nav>`;
  /* Bas de page d'une catégorie : les autres catégories du même univers (Sleep : ses sous-catégories) */
  function catNext(c, current = '') {
    const others = c.univers === 'sleep'
      ? subsOf(c).filter((s) => s.slug !== current).map((s) => [subHref(s), s.nom, cfNoun('', s.produits.length)])
      : CATS.filter((x) => x.univers === c.univers && x.slug !== c.slug).map((x) => [x.route, x.nom, cfNoun(x.slug, new Set(x.sous.flatMap((s) => s.produits)).size)]);
    if (current && c.univers !== 'sleep') others.unshift([c.route, `Tous les ${c.nom.toLowerCase()}`.replace('Tous les décoration', 'Toute la décoration'), cfNoun(c.slug, new Set(c.sous.flatMap((s) => s.produits)).size)]);
    /* refonte du 07/10 : chaque renvoi est une grande image en situation (la première pièce de l'univers qui en a une),
       le nom posé dessus */
    const picOf = (h) => {
      const cs = CATS.find((x) => x.route === h);
      const sub = !cs && SUBS[(h.match(/collections\/([\w-]+)/) || [])[1]];
      const keys = cs ? cs.sous.flatMap((s) => s.produits) : sub ? sub.sub.produits : [];
      const p = keys.map((k) => BY[k]).find((x) => x && scenesFor(x, '').length);
      if (!p) return '';
      const sc = scenesFor(p, '');
      return sceneImg(p, sc[1] || sc[0], { alt: '', sizes: '(max-width: 760px) 100vw, 50vw', eager: false, cls: 'cnext__img', wide: true });
    };
    return others.length ? `<nav class="cnext cnext--img" aria-label="Continuer">${others.map(([h, n, k]) => `<a class="cnext__a" href="${h}">${picOf(h)}<span class="cnext__txt"><span class="cnext__name">${esc(n)}</span><span class="cnext__n">${k}</span></span></a>`).join('')}</nav>` : '';
  }

  /* Page de catégorie : ses sous-catégories en pastilles, puis ses pièces rangées par sous-catégorie (chaque pièce une
     seule fois, à sa place principale). Caplia Sleep : son mot-logo, son image, ses chambres assorties. */
  /* Rangées de la page de catégorie (refonte du 07/10) : les grandes sous-catégories d'abord, puis les petites (1 ou 2
     pièces) côte à côte ; une rangée qui ne se remplit pas reçoit une grande photo en situation d'une de ses pièces,
     jamais un trou. */
  function packFlow(groups) {
    const big = groups.filter((g) => g.list.length > 2), small = groups.filter((g) => g.list.length <= 2);
    const out = [...big];
    let row = [], used = 0;
    /* cadrages du 07/10 : plus d'image d'ambiance en bout de rangée (avec son nom posé dessus, elle se lisait comme une
       carte d'un autre gabarit) ; une rangée incomplète garde sa place libre */
    const close = () => { out.push(...row); row = []; used = 0; };
    small.forEach((g) => { const n = Math.min(g.list.length, 3); if (used + n > 3) close(); row.push(g); used += n; });
    close();
    return out;
  }
  function renderCategory(slug) {
    const c = catBy(slug);
    if (!c) return render404();
    const sleep = c.univers === 'sleep';
    const groups = subsOf(c).map((s) => ({ s, list: s.produits.filter((k) => PRIM[k] && PRIM[k].sub.slug === s.slug).map((k) => BY[k]) })).filter((g) => g.list.length);
    const all = [...new Set(c.sous.flatMap((s) => s.produits))].map((k) => BY[k]);
    const dl = delaysOf(all);
    const ws = all.map((p) => p.dimensions.largeur);
    const cc = COL_COPY[slug];
    /* faits de la catégorie pour ses textes : largeurs, matières et pièces en ligne (les pièces masquées n'y sont pas) */
    const facts = { min: Math.min(...ws), max: Math.max(...ws), large: all.reduce((a, b) => (b.dimensions.largeur > a.dimensions.largeur ? b : a)), mats: [...new Set(all.map((p) => p.matiere.toLowerCase()))], slugs: all.map((p) => p.slug), subs: subsOf(c).map((s) => s.slug) };
    const intro = sleep ? sleepCopy('sleep') : cc && cc.intro ? cc.intro(facts, dl) : '';
    /* une seule sous-catégorie en ligne : la page en reprend la grille (une pièce seule s'affiche en grand), les conseils
       et les questions, comme sa page de collection */
    const one = !sleep && groups.length === 1 ? groups[0] : null;
    const onePg = one ? SEO[one.s.slug] : null;
    const oneFaq = onePg ? seoFaq(onePg) : [];
    const head = sleep
      ? `<header class="sleephero">
          ${sleepMark('h1', 'sleepmark--display')}
          <div class="sleephero__row"><div class="sleephero__txt"><p class="lead sleephero__lead">${esc(intro)}</p><p class="sleephero__date">Livraison offerte, chez vous en ${dl}.</p></div>
          <div class="sleephero__img">${(BY.songe && ensPic('songe', 'Songe et Dune côte à côte dans le studio Caplia', '(max-width: 980px) calc(100vw - 32px), 50vw')) || (BY.brume && BY.sillon && ensPic('brume', 'Brume et Sillon côte à côte dans le studio Caplia', '(max-width: 980px) calc(100vw - 32px), 50vw')) || pieceImg(all[0], { cadres: ['43'], eager: true })}</div></div>
        </header>`
      : CAT_UNI[slug] ? ''
      : `<header class="chead"><h1 class="t-display chead__title">${esc(c.nom)}</h1><p class="lead chead__intro">${esc(catLine(facts))}</p></header>`;
    const html = `
    ${CAT_UNI[slug] ? uniBanner(CAT_UNI[slug], c.nom, '', 'h1', catLine(facts)) : ''}
    <section class="wrap cpage cat${sleep ? ' cat--sleep' : ''}${CAT_UNI[slug] ? ' csubpage--uni' : ''}">
      ${head}
      ${subPills(c)}
      ${one ? `<section class="csub csub--one" aria-labelledby="csub-${one.s.slug}">
        <div class="csub__head"><h2 class="t-2 csub__t" id="csub-${one.s.slug}">${esc(one.s.nom)}</h2><a class="link" href="${subHref(one.s)}">Tout voir</a></div>
        <div class="${cgClass(one.list)}">${cgCards(one.list)}</div>
      </section>
      ${seoSections(onePg)}
      ${oneFaq.length ? `<section class="cfaq" aria-labelledby="cfaq-t"><h2 class="t-2" id="cfaq-t">Vos questions</h2><div>${oneFaq.map((x) => acc(esc(x.q), `<p>${esc(nbTxt(x.r))}</p>`)).join('')}</div></section>` : ''}`
      : `<div class="cflow">${packFlow(groups).map((g) => typeof g === 'string' ? g : (({ s, list }) => {
        /* grand écran : une sous-catégorie de une ou deux pièces se range à côté de la suivante (--n colonnes sur trois),
           les pièces gardent la taille de leurs voisines ; quatre pièces : la première et la dernière en large (cgLayout) */
        const { big } = cgLayout(list);
        return `<section class="csub" style="--n:${Math.min(list.length, 3)}" aria-labelledby="csub-${s.slug}">
        <div class="csub__head"><h2 class="t-2 csub__t" id="csub-${s.slug}">${esc(s.nom)}</h2><a class="link" href="${subHref(s)}">Tout voir</a></div>
        <div class="cgrid">${list.map((p, i) => pcard(p, { eager: i < 3, sizes: big[i] ? CG_SIZES_BIG : CG_SIZES, cls: big[i] && !/solo/.test(big[i]) ? big[i] : '' })).join('')}</div>
      </section>`;
      })(g)).join('')}</div>`}
      ${sleep ? sleepSets() : ''}
      ${catNext(c)}
    </section>
    ${footer()}`;
    return {
      title: (typeof CAT_TITLE[slug] === 'function' ? CAT_TITLE[slug](facts) : CAT_TITLE[slug]) || `${c.nom} · Caplia`, html, scene: {}, nav: slug,
      after: () => { if (cc && cc.desc) setDesc(cc.desc(facts, dl)); else if (sleep) setDesc(`${sleepCopy('sleep')} Livraison offerte, chez vous en ${dl}.`); }
    };
  }

  /* Page de sous-catégorie (#/collections/<slug>) : exactement les pièces de sa page (seo-pages.json > produits),
     puis ses sections et ses questions. Une page d'annonce hors du classement (« canapé compressé »…) prend la catégorie
     de sa première pièce pour son fil d'Ariane. */
  /* Bannières univers (refonte du 07/10) : une vraie photo de campagne par collection, la pièce rendue dans la scène
     (maquettes/_audit/bannieres-univers-v2/METHODE.md), le titre en Unbounded posé dans l'image. ink : couleur du texte
     lisible sur cette image ; shade : une ombre douce sous le texte (murs terre cuite, nuit). */
  /* tz : la zone calme de l'image, en fraction de sa largeur (début, fin), où se pose le texte sur ordinateur et tablette ;
     ty : texte posé en haut à cette hauteur (fraction) au lieu d'être centré, quand la zone calme est le mur au-dessus du
     canapé (Modulables) ; lw : largeur maximale du texte courant (fraction), pour qu'il s'arrête avant le canapé ; mr : au téléphone,
     marge droite du texte (fraction), pour laisser de l'air à un élément du décor (la lune des Convertibles) ; va : force du
     voile sous le texte quand l'image est chargée (contraste mesuré par maquettes/outils/contraste-bannieres.py). La bannière garde le format de son image à toutes les largeurs (rien n'est coupé), donc la zone
     ne bouge pas par rapport au canapé. Au téléphone (image -tel), le texte va dans le ciel ou le mur du haut. Relevé sur l'image le 07/10. */
  const uniVars = (u) => `--uni-ink:${u.ink};--tz0:${u.tz[0]};--tzw:${+(u.tz[1] - u.tz[0]).toFixed(2)}${u.ty != null ? `;--tzy:${u.ty * 100}%;--tzt:0%` : ''}${u.lw ? `;--lw:${u.lw}` : ''}${u.mr ? `;--mr:${u.mr}` : ''}${u.va ? `;--va:${u.va};--vb:${+(u.va * .6).toFixed(2)}` : ''}`;
  const UNIVERS = {
    canapes: { tz: [0.22, 0.72], ty: 0.08, lw: 0.46, img: 'bulle-c', ink: '#3B2C66', pos: '50% 50%', alt: 'Mise en scène : canapé arrondi en bouclette crème dans un studio en dégradé pastel, entouré de perles satinées', line: '' },
    'canape-arrondi': { tz: [0.05, 0.44], img: 'arrondis', ink: '#4A2A1C', pos: '66% 50%', alt: 'Mise en scène : canapé arrondi Éclipse en bouclette crème sur une dune au soleil couchant', line: 'Des courbes du dossier jusqu’au sol, sans un angle.' },
    'canape-bulle': { tz: [0.04, 0.36], img: 'bulle-a', ink: '#3B2C66', pos: '70% 50%', alt: 'Mise en scène : canapé en bouclette crème aux formes gonflées sur une mer de nuages au coucher du soleil', line: 'Des formes gonflées, rondes de partout.' },
    'canape-nuage': { tz: [0.04, 0.3], img: 'bulle-b', ink: '#3B2C66', pos: '50% 50%', alt: 'Mise en scène : canapé Opaline en bouclette crème devant un décor de nuages en papier découpé, dans une pièce claire', line: 'Des coussins généreux et des courbes douces, du dossier jusqu’au sol.' },
    'canape-angle': { tz: [0.04, 0.42], va: 0.66, img: 'angles', ink: '#FFF6EA', shade: 1, pos: '64% 50%', alt: 'Mise en scène : canapé d’angle crème dans une cour aux murs terre cuite, en plein soleil', line: 'De quoi s’allonger à plusieurs, chacun dans son coin.' },
    'canape-convertible': { tz: [0.04, 0.47], mr: 0.3, img: 'convertibles', ink: '#2B2350', pos: '64% 50%', alt: 'Mise en scène : canapé convertible Alizé gris sur une colline à l’heure bleue, sous la pleine lune', line: 'Un canapé le jour, un lit le soir.' },
    'canape-velours': { tz: [0.04, 0.46], img: 'velours', ink: '#FBEBD3', shade: 1, pos: '64% 50%', alt: 'Mise en scène : canapé en velours crème devant de grands drapés de velours cognac, dans un rayon de soleil', line: 'Du velours ras au côtelé, qui prend la lumière.' },
    'canape-modulable': { tz: [0.12, 0.62], ty: 0.12, lw: 0.25, img: 'modulables', ink: '#3A2A1E', pos: '62% 50%', alt: 'Mise en scène : canapé d’angle Cocon en tissu effet lin crème dans une pièce aux murs à la chaux, au soleil de fin d’après-midi', line: 'Des modules à rapprocher ou à écarter, pour un canapé droit ou en angle.' },
    fauteuils: { tz: [0.18, 0.62], img: 'fauteuils', ink: '#3A2A1E', pos: '62% 50%', alt: 'Mise en scène : fauteuil Perle en bouclette sherpa crème dans une pièce aux murs à la chaux, au soleil de fin d’après-midi', line: '' },
    decoration: { tz: [0.2, 0.6], img: 'decoration', ink: '#3A2A1E', pos: '62% 50%', alt: 'Mise en scène : miroir Mirage blanc plâtre posé contre un mur à la chaux, au soleil de fin d’après-midi', line: '' },
    'chauffeuse-convertible': { tz: [0.04, 0.36], img: 'chauffeuses', ink: '#2B2350', pos: '66% 50%', alt: 'Mise en scène : chauffeuse Escale bleu nuit sur un podium corail, entourée de volumes colorés', line: 'Un fauteuil qui se déplie en couchage.' }
  };
  const uniImg = (u, eager = true) => `<picture class="uni__img"><source media="(max-width: 700px)" srcset="/site/assets/univers/${u.img}-tel.webp" width="780" height="1140"><img src="/site/assets/univers/${u.img}-ordi.webp" width="1680" height="720" alt="${esc(u.alt)}" style="object-position:${u.pos}" ${eager ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async" draggable="false"></picture>`;
  /* catégorie qui ouvre sur la bannière d'un de ses univers */
  const CAT_UNI = { canapes: 'canapes', fauteuils: 'fauteuils', decoration: 'decoration' };
  function uniBanner(slug, h1, crumbs, tag = 'h1', line = '') {
    const u = UNIVERS[slug];
    if (!u) return '';
    return `<section class="uni${u.shade ? ' uni--shade' : ''}${u.ty != null ? ' uni--top' : ''}" style="${uniVars(u)}" aria-labelledby="uni-t">${uniImg(u)}
      <div class="uni__txt">${crumbs ? `<p class="uni__fil">${crumbs}</p>` : ''}<${tag} class="t-1 uni__t" id="uni-t">${esc(h1)}</${tag}><p class="uni__l">${esc(line || u.line)}</p></div></section>`;
  }
  /* textes SEO d'une page de collection : {pieces}, {couleurs} et {largeurs} comptés sur les pièces vraiment montrées
     (08/10 : « 5 couleurs » annoncées pour 4 pièces d'une seule couleur chacune). Repris par donnees-theme.mjs. */
  const seoFill = (t, list) => { if (!t || !/\{(pieces|couleurs|largeurs)\}/.test(t)) return t; const n = new Set(list.flatMap((p) => p.couleurs.filter((c) => !c.retiree).map((c) => c.nom))).size; const w = list.map((p) => (p.dimensions || {}).largeur).filter(Boolean); const lo = Math.min(...w), hi = Math.max(...w); return t.replace(/\{pieces\}/g, list.length).replace(/\{couleurs\}/g, n).replace(/\{largeurs\}/g, !w.length ? '' : lo === hi ? lo : `${lo} à ${hi}`).replace(/(^|\D)1 (canapé|couleur|pièce)s/g, (m, a, b) => `${a}1 ${b}`); };
  const seoDeep = (o, list) => (typeof o === 'string' ? seoFill(o, list) : Array.isArray(o) ? o.map((x) => seoDeep(x, list)) : o && typeof o === 'object' ? Object.fromEntries(Object.entries(o).map(([k, v]) => [k, seoDeep(v, list)])) : o);
  function renderSub(slug) {
    const pg0 = SEO[slug], ref = SUBS[slug];
    /* une pièce de la page est masquée : ses textes écrits pour ce cas (seo-pages.json > sansMasquees) */
    const alt = pg0 && pg0.sansMasquees;
    const pg = alt && alt.si.some((k) => !BY[k] && CAT.produits.some((x) => x.slug === k)) ? { ...pg0, ...alt } : pg0;
    if (!pg && !ref) return render404();
    const list = ((pg && pg.produits) || ref.sub.produits).filter((k) => BY[k]).map((k) => BY[k]);
    if (pg && pg !== pg0) Object.assign(pg, seoDeep(alt, list));   /* tous les textes de remplacement : titre, h1, intro, sections, questions */
    const c = ref ? ref.cat : list[0] && PRIM[list[0].slug] ? PRIM[list[0].slug].cat : null;
    if (!c || !list.length) return render404();
    const sleep = c.univers === 'sleep';
    const name = ref ? ref.sub.nom : (pg.h1 || slug);
    const h1 = (pg && pg.h1) || ref.sub.h1 || name;
    const intro = (pg && pg.intro && sansMasque(pg.intro)) || sleepCopy(slug) || autoIntro(list, h1);
    const faq = seoFaq(pg);
    const html = `
    ${UNIVERS[slug] ? uniBanner(slug, h1, `<a href="${c.route}">${esc(c.nom)}</a><span aria-hidden="true">/</span><span>${esc(name)}</span>`) : ''}
    <section class="wrap cpage csubpage${sleep ? ' cat--sleep' : ''}${UNIVERS[slug] ? ' csubpage--uni' : ''}">
      ${UNIVERS[slug] ? '' : crumbHtml([[c.route, c.nom], [null, name]])}
      ${UNIVERS[slug] ? `<p class="lead csub-uni__line">${esc(subLine(list))}</p>` : `<header class="chead">
        <div class="chead__t">${sleep ? sleepMark('p', 'sleepmark--small') : ''}<h1 class="${h1.length > 22 ? 't-1' : 't-display'} chead__title">${esc(h1)}</h1></div>
        <p class="lead chead__intro">${esc(subLine(list))}</p>
      </header>`}
      ${subPills(c, ref ? slug : '')}
      <div class="${cgClass(list)}">${cgCards(list)}</div>
      ${seoSections(pg, intro)}
      ${faq.length ? `<section class="cfaq" aria-labelledby="cfaq-t"><h2 class="t-2" id="cfaq-t">Vos questions</h2><div>${faq.map((x) => acc(esc(x.q), `<p>${esc(nbTxt(x.r))}</p>`)).join('')}</div></section>` : ''}
      ${catNext(c, slug)}
    </section>
    ${footer()}`;
    return { title: (pg && pg.title) || `${h1} · Caplia`, html, scene: {}, nav: c.slug, after: () => { if (pg && pg.metaDescription) setDesc(pg.metaDescription); } };
  }
  /* Pièces masquées : aucun texte de page ne les cite. La phrase, l'élément de liste, la ligne de tableau ou la question
     qui en parle est sauté ; il revient de lui-même quand la pièce revient (champ « masque » retiré). */
  const cite = (t) => !!(MASK_RE && MASK_RE.test(String(t)));
  const sansMasque = (t) => (MASK_RE ? String(t).split(/(?<=[.!?])\s+(?=[A-ZÀ-ÖØ-Þ«])/).filter((x) => !cite(x)).join(' ') : String(t));
  const cellSans = (c) => String(c).split(' ; ').filter((x) => !cite(x)).join(' ; ');
  const seoFaq = (pg) => ((pg && pg.faq) || []).filter((x) => !cite(x.q)).map((x) => ({ q: x.q, r: sansMasque(x.r) })).filter((x) => x.r);
  /* sections d'une page (seo-pages.json) : titre, paragraphes, liste, étapes, tableau */
  function seoSections(pg, lead = '') {
    const secs = ((pg && pg.sections) || []).filter((x) => !cite(x.h2)).map((x) => ({
      ...x,
      paragraphes: (x.paragraphes || []).map(sansMasque).filter(Boolean),
      liste: x.liste ? x.liste.filter((t) => !cite(t)) : x.liste,
      /* une étape garde sa place (« en 4 étapes ») : seul le membre de phrase qui cite la pièce masquée part */
      etapes: x.etapes ? x.etapes.map((t) => (cite(t) ? t.split(', ').filter((y, i) => !i || !cite(y)).join(', ').replace(/([^.!?])$/, '$1.') : t)).filter((t) => !cite(t)) : x.etapes,
      tableau: x.tableau ? { ...x.tableau, lignes: x.tableau.lignes.filter((l) => !cite(l[0])).map((l) => l.map(cellSans)).filter((l) => l.every((c, i) => !i || c)) } : x.tableau
    })).filter((x) => x.paragraphes.length || (x.liste && x.liste.length) || (x.etapes && x.etapes.length) || (x.tableau && x.tableau.lignes.length));
    if (!secs.length && !lead) return '';
    const table = (t) => `<div class="cseo__table"><table class="table"><thead><tr>${t.colonnes.map((x) => `<th scope="col">${esc(x)}</th>`).join('')}</tr></thead><tbody>${t.lignes.map((l) => `<tr>${l.map((x, i) => (i ? `<td>${esc(nbTxt(x))}</td>` : `<th scope="row">${esc(nbTxt(x))}</th>`)).join('')}</tr>`).join('')}</tbody></table></div>`;
    /* textes de conseil (utiles au référencement et aux indécis) : repliés, un volet par section */
    const intro = lead ? `<p>${esc(nbTxt(lead))}</p>` : '';
    if (!secs.length) return `<div class="cseo cseo--acc">${acc('<h2 class="cseo__h">En savoir plus</h2>', intro)}</div>`;
    return `<div class="cseo cseo--acc">${secs.map((s, i) => acc(`<h2 class="cseo__h">${esc(s.h2)}</h2>`, `${i ? '' : intro}
      ${(s.paragraphes || []).map((t) => `<p>${esc(nbTxt(t))}</p>`).join('')}
      ${s.liste && s.liste.length ? `<ul>${s.liste.map((t) => `<li>${esc(nbTxt(t))}</li>`).join('')}</ul>` : ''}
      ${s.etapes && s.etapes.length ? `<ol>${s.etapes.map((t) => `<li>${esc(nbTxt(t))}</li>`).join('')}</ol>` : ''}
      ${s.tableau && s.tableau.lignes.length ? table(s.tableau) : ''}`)).join('')}</div>`;
  }

  /* Chambres assorties de Caplia Sleep (lit + bout de lit) : même carte que les salons assortis, prix exact, cadeaux */
  function sleepSets() {
    const sets = ENS.map((e, i) => [e, i]).filter(([e]) => e.sleep && ensOk(e));
    if (!sets.length) return '';
    return `<section class="ens-sec sleep-sets" aria-labelledby="sleep-sets-t">
      <div class="ens-sec__head"><h2 class="h-big" id="sleep-sets-t">La chambre assortie</h2>
        <p class="lead">Le lit et son banc, dans le même ton. Avec votre commande, offerts : ${andList(SITE.paliers.map((pl, k) => `${GIFT_HOME[k] || pl.cadeau} dès ${price(pl.seuil)}`))}.</p></div>
      <div class="ens-grid">${sets.map(([e, i]) => ensCard(e, i)).join('')}</div>
    </section>`;
  }

  /* Accueil : une entrée par catégorie du salon (Canapés, Fauteuils, Décoration), ses meilleures pièces (une par
     sous-catégorie, puis la suivante), ses formes en liens, et le lien vers toute la catégorie. Jamais Caplia Sleep. */
  const CAT_LINK = { canapes: 'Voir les canapés', fauteuils: 'Voir les fauteuils', decoration: 'Voir la décoration' };
  function picksOf(c, n = 4) {
    /* pièces « pratique » (convertibles, chauffeuses, petit velours) : dans leurs catégories, jamais sur l'accueil ;
       cadrages du 07/10 : seulement des pièces qui ont leur photo studio (une rangée toute au même gabarit ; Lou, le tapis,
       n'en a pas) */
    const out = [], lists = subsOf(c).map((s) => s.produits.filter((k) => BY[k] && !BY[k].pratique && carteOf(BY[k])));
    for (let r = 0; out.length < n && lists.some((l) => l.length); r++) lists.forEach((l) => { const k = l.shift(); if (k && out.length < n && !out.includes(k)) out.push(k); });
    return out.map((k) => BY[k]);
  }

  /* Menu : chaque catégorie ouvre un panneau de ses sous-catégories (une vraie photo par forme), « Tout voir » ;
     au téléphone, un accordéon par catégorie. Construit une fois, depuis categories.json. */
  function buildMenu() {
    const links = $('.nav__links');
    if (links && CATS.length) {
      /* refonte du 07/10 : à gauche la liste des formes, à droite quatre grandes cartes photo (bannière de l'univers,
         sinon la photo en situation de sa première pièce) */
      links.innerHTML = fr(CATS.map((c) => {
        const subs = subsOf(c);
        const pick = (MEGA_PICK[c.slug] || []).map((k) => subs.find((s) => s.slug === k)).filter(Boolean);
        const cards = [...pick, ...subs.filter((s) => !pick.includes(s))].slice(0, 4);
        return `<li class="nav__cat"><a href="${c.route}" data-nav="${c.slug}">${esc(c.nom)}</a>
        <div class="mega" role="group" aria-label="${esc(c.nom)}"><div class="wrap mega__in mega__in--img">
          <div class="mega__col"><p class="mega__lead">${c.univers === 'sleep' ? sleepMark('span', 'sleepmark--menu') : `<span class="mega__t">${esc(c.nom)}</span>`}</p>
            <ul class="mega__list">${subs.map((s) => `<li><a href="${subHref(s)}">${esc(s.nom)}</a></li>`).join('')}</ul>
            <a class="link mega__all" href="${c.route}">Tout voir</a></div>
          <ul class="mega__cards" style="--n:${cards.length}">${cards.map((s) => `<li><a class="mega__card" href="${subHref(s)}"><span class="mega__img">${subPic(s, '(max-width: 1100px) 22vw, 260px')}</span><span class="mega__name">${esc(s.nom)}<span class="mega__n">${cfNoun(c.slug, s.produits.filter((k) => BY[k]).length)}</span></span></a></li>`).join('')}</ul>
        </div></div></li>`;
      }).join(''));
      /* après un clic dans un panneau, il se referme même si le pointeur reste dessus */
      links.addEventListener('click', (e) => { const li = e.target.closest('.nav__cat'); if (li && e.target.closest('a')) { li.classList.add('is-shut'); li.addEventListener('mouseleave', () => li.classList.remove('is-shut'), { once: true }); } });
    }
    const main = $('#menu .menu__main');
    if (main && CATS.length) {
      main.innerHTML = fr(CATS.map((c) => `<li><details class="mcat"><summary><span class="mcat__img" aria-hidden="true">${subPic(subsOf(c)[0], '64px', true)}</span><span class="mcat__name">${c.univers === 'sleep' ? sleepMark('span', 'sleepmark--mmenu') : esc(c.nom)}</span></summary>
        <ul>${subsOf(c).map((s) => `<li><a href="${subHref(s)}">${esc(s.nom)}<span>${cfNoun(c.slug, s.produits.length)}</span></a></li>`).join('')}<li><a class="mcat__all" href="${c.route}">Tout voir</a></li></ul>
      </details></li>`).join(''));
    }
  }
  const MEGA_PICK = { canapes: ['canape-arrondi', 'canape-bulle', 'canape-angle', 'canape-modulable'] };
  /* photo d'une forme (menu) : sa bannière d'univers, sinon la 1re photo en situation de ses pièces */
  function subPic(s, sizes, small = false) {
    if (!s) return '';
    const u = UNIVERS[s.slug];
    if (u && !small) return `<img src="/site/assets/univers/${u.img}-ordi.webp" alt="" width="1680" height="720" loading="lazy" decoding="async" draggable="false" style="object-position:${u.pos}">`;
    const p = s.produits.map((k) => BY[k]).find((x) => x && scenesFor(x, '').length);
    if (!p) { const q = s.produits.map((k) => BY[k]).find(Boolean); return q ? pieceFit(q, '', 64) : ''; }
    return sceneImg(p, scenesFor(p, '')[0], { alt: '', sizes, eager: false, cls: '' });
  }

  function render404() {
    const p = BY['petit-mouton'];
    return {
      title: 'Page introuvable · Caplia',
      html: `<section class="wrap">
        <div class="lp-mid lp-mid--lost">
          ${p ? `<div class="lp-mid__img">${studioImg(p, { alt: `${p.nom}, ${p.type}`, sizes: '(max-width: 760px) 70vw, 340px', eager: true, cadres: ['45'] })}</div>` : ''}
          <h1 class="t-1">Cette page s'est assoupie</h1>
          <p class="lead">Le lien est peut-être ancien. Les pièces, elles, sont toujours là.</p>
          <a class="btn" href="#/">Retour à l'accueil</a>
          <p class="lp-mid__links"><a class="link" href="#/canapes">Canapés</a><a class="link" href="#/fauteuils">Fauteuils</a><a class="link" href="#/questions">Vos questions</a></p>
        </div>
      </section>${footer()}`,
      scene: { img: tab('incurve-sel', '960'), soft: true }
    };
  }

  /* =========================================================
     ROUTAGE
     ========================================================= */
  const ROUTES = [
    [/^\/?$/, () => renderHome()],
    /* catégories et sous-catégories (categories.json) ; sans le classement, l'ancienne page de collection */
    [/^\/(canapes|fauteuils|decoration|sleep)\/?$/, (m) => (catBy(m[1]) ? renderCategory(m[1]) : m[1] === 'sleep' ? render404() : renderCollection(m[1]))],
    [/^\/(?:collections|sleep)\/([\w-]+)\/?$/, (m) => renderSub(m[1])],
    [/^\/p\/([\w-]+)\/?$/, (m) => renderProduct(m[1])],
    [/^\/panier\/?$/, () => renderCart()],
    [/^\/livraison\/?$/, () => renderLivraison()],
    [/^\/matieres\/?$/, () => renderMatieres()],
    [/^\/arrivee\/?$/, () => renderArrivee()],
    [/^\/cadeaux\/?$/, () => renderCadeaux()],
    [/^\/a-propos\/?$/, () => renderAbout()],
    [/^\/questions\/?$/, () => renderFaq()],
    [/^\/contact\/?$/, () => renderContact()],
    [/^\/renoncer\/?$/, () => renderRenoncer()],
    [/^\/mentions-legales\/?$/, () => renderMentions()],
    [/^\/conditions-de-vente\/?$/, () => renderCGV()],
    [/^\/confidentialite\/?$/, () => renderPrivacy()],
    [/^\/garantie\/?$/, () => renderGarantie()],
    [/^\/paiement\/?$/, () => renderPaiement()],
    [/^\/tout-va-bien\/?$/, () => renderWell()],
    [/^\/un-souci\/?$/, () => renderIssue()],
    [/^\/petits-espaces\/?$/, () => renderSmall()],
    [/^\/jeunes-parents\/?$/, () => renderParents()],
    [/^\/pourquoi-caplia\/?$/, () => renderWhy()],
    [/^\/selection\/?$/, () => renderSelection()],
    [/^\/merci\/?$/, () => renderThanks()],
    /* ancienne adresse retirée : elle mène au panier, sans page d'erreur */
    [/^\/reserver-en-3-fois\/?$/, () => { try { history.replaceState(null, '', '#/panier'); } catch (e) { /* rien */ } return renderCart(); }]
  ];
  function resolve() {
    const path = CAPLIA_PATH();
    if (path == null) return null;
    for (const [re, fn] of ROUTES) { const m = path.match(re); if (m) return fn(m); }
    return render404();
  }

  function teardown() {
    cleanups.forEach((fn) => { try { fn(); } catch (e) { /* rien */ } });
    cleanups = [];
    const st = ST();
    if (st) st.getAll().forEach((t) => t.kill(true));
    const g = G();
  }

  /* Chaque changement de « # » refait la page. Tant que les données ne sont pas chargées, rien ne s'affiche
     (jamais la page introuvable) : boot() appelle navigate() dès qu'elles sont là. Un numéro de passage écarte
     les rendus dépassés quand le client clique vite ou quand l'onglet est en arrière-plan. */
  let navSeq = 0;
  function navigate() {
    if (!CAT || !SITE) return;
    const seq = ++navSeq;
    let page;
    try { page = resolve(); } catch (err) { console.error(err); page = null; }
    if (!page || (/^Page introuvable/.test(page.title || '') && (CAPLIA.route || {}).gabarit !== '404')) { KEEP_SSR(); return; }
    const app = $('#app');
    const run = () => {
      if (seq !== navSeq) return;
      teardown();
      const kept = KEEP_TAKE(app);
      app.innerHTML = fr(page.html);
      KEEP_PUT(app, kept);
      document.documentElement.classList.add('caplia-pret');
      try { const r = decodeURIComponent((location.hash || '#/').slice(2).split('?')[0]).replace(/\/$/, ''); if (PAGE_DESC[r]) setDesc(PAGE_DESC[r]()); } catch (e) { /* adresse mal formée : description par défaut */ }
      $$('[data-nav]').forEach((a) => a.classList.toggle('is-active', a.dataset.nav === page.nav));
      closeMenu();
      if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
      if (!firstRender) window.scrollTo(0, 0);
      /* fond uni en plâtre chaud sur tout le site : plus de photo floue derrière les pages */
      if (page.after) { try { page.after(app); } catch (err) { console.error(err); } }
      enhance(app);
    };
    if (!firstRender && document.startViewTransition && !reduce && !document.hidden) {
      const vt = document.startViewTransition(run);
      [vt.ready, vt.finished, vt.updateCallbackDone].forEach((pr) => pr && pr.catch && pr.catch(() => {}));
    } else {
      const g = G();
      if (!firstRender && g && !reduce && !document.hidden) {
        g.to(app, { opacity: 0, duration: .25, onComplete: () => { run(); g.fromTo(app, { opacity: 0 }, { opacity: 1, duration: .5 }); } });
      } else run();
    }
    if (!firstRender) setTimeout(() => app.focus({ preventScroll: true }), 60);
    firstRender = false;
  }

  /* Entrées au défilement + zoom lent du fond */
  function enhance(root) {
    const g = G(), st = ST();
    if (!g || !st || reduce) return;
    const els = $$('.reveal', root);
    g.set(els, { opacity: 0, y: 32 });
    // Ce qui est déjà à l'écran entre tout de suite, sans attendre un défilement
    const vus = els.filter((el) => el.getBoundingClientRect().top < innerHeight * .94);
    if (vus.length) g.to(vus, { opacity: 1, y: 0, duration: .9, ease: 'expo.out', stagger: .07, delay: .05, clearProps: 'transform' });
    // Le reste entre quand il arrive à l'écran (IntersectionObserver : fiable même quand le défilement est doux ou rapide)
    const io = new IntersectionObserver((entrees) => {
      const arrives = entrees.filter((e) => e.isIntersecting).map((e) => e.target);
      if (!arrives.length) return;
      arrives.forEach((el) => io.unobserve(el));
      g.to(arrives, { opacity: 1, y: 0, duration: .9, ease: 'expo.out', stagger: .07, overwrite: true, clearProps: 'transform' });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.filter((el) => !vus.includes(el)).forEach((el) => io.observe(el));
    g.fromTo('.scene__zoom', { scale: 1.04 }, { scale: 1.13, ease: 'none', scrollTrigger: { start: 0, end: () => st.maxScroll(window), scrub: .8, invalidateOnRefresh: true } });
    requestAnimationFrame(() => st.refresh());
    setTimeout(() => st.refresh(), 700);
  }

  /* ---------------- Menu mobile ---------------- */
  /* Le bouton dit « Menu » ou « Fermer » ; la page derrière ne défile pas quand le menu est ouvert */
  function menuState(open) {
    const b = $('.nav__burger');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    const t = $('.nav__burger-t', b); if (t) t.textContent = open ? 'Fermer' : 'Menu';
    document.documentElement.classList.toggle('menu-open', open);
  }
  function closeMenu(refocus) {
    const m = $('#menu');
    if (!m || m.hidden) return;
    m.hidden = true;
    menuState(false);
    if (refocus === true) $('.nav__burger').focus();
  }
  function toggleMenu() {
    const m = $('#menu');
    const open = m.hidden;
    m.hidden = !open;
    menuState(open);
    if (open) { const f = $('summary, a', m); if (f) f.focus(); }
  }
  /* Un filet sous la barre dès que la page défile */
  const navWrap = $('.nav-wrap');
  const navLine = () => { if (navWrap) navWrap.classList.toggle('is-scrolled', window.scrollY > 8); };
  window.addEventListener('scroll', navLine, { passive: true });
  navLine();
  /* Changer de page referme le message « Ajouté au panier » : il ne doit pas couvrir la page suivante */
  window.addEventListener('hashchange', () => { const t = $('#toast'); if (t) t.classList.remove('is-on'); });

  /* ---------------- Visionneuse ---------------- */
  /* les images de la galerie en cours (couleur choisie seulement) */
  const LB = { i: 0 };
  const lbList = () => (PDP.slides || []).filter((s) => s.zoom);
  function lbShow(i) {
    const L = lbList(), n = L.length; if (!n) return;
    LB.i = (i + n) % n;
    const s = L[LB.i];
    $('#lightbox-img').src = s.zoom;
    $('#lightbox-img').alt = s.label;
    $('#lightbox-cap').textContent = '';
  }

  /* ---------------- Photos des cartes (cardGal) ----------------
     Les photos suivantes reçoivent leur adresse au premier survol, toucher, focus ou glissement ; les points suivent le
     défilement ; la photo est cadrée comme dans la galerie de la fiche (fitOne : la pièce jamais coupée). */
  function cgalWake(g) {
    if (!g || g.dataset.awake) return;
    g.dataset.awake = '1';
    const card = g.closest('[data-piece]'), slug = card ? card.dataset.piece : '';
    $$('img[data-srcset]', g).forEach((im) => {
      im.srcset = im.dataset.srcset; im.src = im.dataset.src;
      im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
      if (slug) fitOne(im.parentElement, im, slug);
    });
  }
  const cgalAt = (t) => Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
  function cgalDots(t) {
    const i = cgalAt(t);
    $$('.cgal__dots i', t.parentElement).forEach((d, k) => d.classList.toggle('is-on', k === i));
  }
  function cgalGo(btn) {
    const g = btn.closest('.cgal'), t = g && $('.cgal__track', g);
    if (!t) return;
    cgalWake(g);
    const n = t.children.length, j = (cgalAt(t) + Number(btn.dataset.d) + n) % n;
    t.scrollTo({ left: j * t.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  }
  let cgalRaf = 0;
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (!t.classList || !t.classList.contains('cgal__track')) return;
    cgalWake(t.parentElement);
    cancelAnimationFrame(cgalRaf); cgalRaf = requestAnimationFrame(() => cgalDots(t));
  }, { capture: true, passive: true });
  document.addEventListener('pointerover', (e) => { if (e.pointerType === 'mouse' && e.target.closest) cgalWake(e.target.closest('.pcard') && $('.cgal', e.target.closest('.pcard'))); }, { passive: true });
  document.addEventListener('touchstart', (e) => { if (e.target.closest) cgalWake(e.target.closest('.cgal')); }, { passive: true });
  document.addEventListener('focusin', (e) => { if (e.target.closest) cgalWake(e.target.closest('.cgal')); });
  let cgalT = 0;
  window.addEventListener('resize', () => { clearTimeout(cgalT); cgalT = setTimeout(() => $$('.cgal[data-awake] .cimg--more').forEach((box) => fitOne(box, $('img', box), box.closest('[data-piece]').dataset.piece)), 150); });

  /* ---------------- Actions (délégation) ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;
    const a = btn.dataset.action;
    switch (a) {
      case 'rack-filter': rackFilter(btn); break;
      case 'up-add': e.preventDefault(); cartFx(null, null); upAdd(btn); break;
      case 'up-color': e.preventDefault(); upColorPick(btn); break;
      case 'quick-add': e.preventDefault(); addToCart(btn.dataset.slug, '', btn.dataset.size || ''); refreshCart(); break;
      case 'ens-add': {
        e.preventDefault();
        const pc = btn.dataset.pdp && PDP.p ? PDP.p.couleurs[PDP.color] : null;
        addEnsemble(Number(btn.dataset.i), pc && !isOut(pc) ? pc.nom : '');
        cartFx(btn, btn.closest('.fp-ens, .ens') && $('.fp-ens__pics, .ens__media', btn.closest('.fp-ens, .ens')));
        break;
      }
      case 'qa-color': quickColorPick(btn); break;
      case 'cgal': e.preventDefault(); cgalGo(btn); break;
      case 'qa-add': {
        e.preventDefault();
        const p = BY[btn.dataset.slug];
        if (!p) break;
        const ok = addToCart(p.slug, btn.dataset.color, '');
        if (ok !== false) cartFx(btn, $('.cimg', btn.closest('.pcard')));
        break;
      }
      case 'hero-next': heroStop(); heroGo(H.i + 1, 1); break;
      case 'hero-prev': heroStop(); heroGo(H.i - 1, -1); break;
      case 'hero-pick': { heroStop(); const t = Number(btn.dataset.i); heroGo(t, t >= H.i ? 1 : -1); break; }
      case 'hero-color': heroStop(); heroColor(Number(btn.dataset.k)); break;
      case 'hero-size': heroStop(); heroSize(Number(btn.dataset.k), btn); break;
      case 'hero-add': {
        heroStop();
        const p = PRODS[H.i];
        if (isOut(p.couleurs[H.k]) || notYet(p)) break;
        addToCart(p.slug, p.couleurs[H.k].nom, p.tailles ? p.tailles[H.s].nom : '');
        btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1200);
        break;
      }
      case 'video-toggle': {
        SC.userPaused = !SC.userPaused;
        if (SC.userPaused) pauseVideo(); else playVideo();
        $$('.layers-sec video').forEach((v) => { if (SC.userPaused) v.pause(); });
        syncVideoButtons();
        break;
      }
      case 'rail': {
        const rail = btn.closest('.panel, .glass').querySelector('[data-rail]');
        if (rail) { const card = rail.firstElementChild; const w = card ? card.getBoundingClientRect().width + 14 : 300; rail.scrollBy({ left: w * Number(btn.dataset.dir) * (isMobile() ? 1 : 2), behavior: reduce ? 'auto' : 'smooth' }); }
        break;
      }
      case 'filter': applyFilter(btn.dataset.group, btn.dataset.value, btn); break;
      case 'goto': { const t = $(btn.dataset.to); if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); break; }
      case 'open-retour': e.preventDefault(); openAcc('#fp-retour'); break;
      case 'open-passe': { e.preventDefault(); if (openAcc('#fp-passe')) { const w = $('#door-w'); if (w) setTimeout(() => w.focus({ preventScroll: true }), 500); } break; }
      case 'pdp-thumb': pdpShow(Number(btn.dataset.img)); break;
      case 'pdp-img': {
        const n = PDP.p.images.length;
        let k = PDP.img + Number(btn.dataset.dir);
        if (k < -1) k = n - 1; if (k > n - 1) k = -1;
        pdpShow(k);
        break;
      }
      case 'pdp-color': pdpColor(Number(btn.dataset.k)); break;
      case 'pdp-size': pdpSize(Number(btn.dataset.k)); break;
      case 'pdp-add': {
        const p = PDP.p;
        if (isOut(p.couleurs[PDP.color]) || notYet(p)) { const f = $('[data-notify] input[type="email"]'); if (f) { f.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); f.focus({ preventScroll: true }); } break; }
        addToCart(p.slug, p.couleurs[PDP.color].nom, p.tailles ? p.tailles[PDP.size].nom : '');
        /* la vignette qui part vers le panier : la photo de la galerie si elle est à l'écran, sinon celle de la barre */
        $$('[data-action="pdp-add"]').forEach((b) => cartFx(b, null));
        const shown = $$('.fp-track img').find((im) => { const r = im.getBoundingClientRect(); return r.width > 0 && r.left >= -2 && r.left < innerWidth / 2 && r.bottom > 60 && r.top < innerHeight; });
        cartFx(null, shown || $('#buybar .buybar__thumb'));
        break;
      }
      case 'keep-open': {
        const f = $('[data-keep-form]');
        if (!f) break;
        const open = f.hidden;
        f.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) { const m = $('#keep-mail', f); if (m) m.focus(); }
        break;
      }
      case 'keep-pdf': {
        /* version imprimable : les volets utiles ouverts, le reste de la page masqué (feuille d'impression, fiche.css) */
        const fermes = $$('.fp-more details.acc').filter((d) => !d.open);
        fermes.forEach((d) => { d.open = true; });
        document.documentElement.classList.add('print-fiche');
        let fait = false;
        const done = () => { if (fait) return; fait = true; document.documentElement.classList.remove('print-fiche'); fermes.forEach((d) => { d.open = false; }); window.removeEventListener('afterprint', done); };
        window.addEventListener('afterprint', done);
        window.print();
        /* afterprint manque sur certains navigateurs (Safari iOS) : retour à la fiche normale de toute façon */
        setTimeout(done, 1500);
        break;
      }
      case 'pdp-express': {
        /* aperçu de la maquette : achat express de la pièce seule, sans passer par le panier (dans la boutique, ce sont
           les boutons de Shopify qui ouvrent le paiement) */
        const p = PDP.p;
        if (isOut(p.couleurs[PDP.color]) || notYet(p)) break;
        const size = p.tailles ? p.tailles[PDP.size].nom : '';
        const it = { slug: p.slug, color: p.couleurs[PDP.color].nom, size, qty: 1 };
        saveOrder({ items: [it], total: unitPriceOf(p, size), base: isAcc(p) ? 0 : unitPriceOf(p, size), mode: 'express', date: Date.now() });
        location.hash = '#/merci';
        break;
      }
      case 'pdp-zoom': {
        const d = $('#lightbox');
        lbShow(Math.max(0, lbList().indexOf(PDP.slides[PDP.slide])));
        if (d.showModal) d.showModal(); else d.setAttribute('open', '');
        if (lenis) lenis.stop();
        break;
      }
      case 'lb-prev': lbShow(LB.i - 1); break;
      case 'lb-next': lbShow(LB.i + 1); break;
      case 'lb-close': $('#lightbox').close(); break;
      case 'qty': case 'remove': {
        const key = btn.dataset.key;
        const l = cart.find((x) => lineKey(x) === key);
        if (!l) break;
        const done = () => { saveCart(); updateBadge(a === 'qty'); refreshCart(); };
        if (a === 'qty') {
          l.qty += Number(btn.dataset.d);
          if (l.qty < 1) l.qty = 1;
          if (l.qty > 9) l.qty = 9;
          done();
        } else {
          const li = btn.closest('.line');
          cart = cart.filter((x) => x !== l);
          if (li && !reduce) { li.classList.add('is-out'); setTimeout(done, 380); } else done();
        }
        break;
      }
      case 'checkout': {
        /* Commande simulée : on garde le récapitulatif pour la page Merci, puis le panier se vide */
        if (!cart.length) break;
        SHOP_CHECKOUT(btn);
        break;
      }
      case 'fav': {
        const s = btn.dataset.slug;
        toggleFav(s);
        if (isFav(s)) toast(null, `${BY[s].nom} est dans votre sélection.`, true);
        break;
      }
      case 'fav-remove': {
        toggleFav(btn.dataset.slug, false);
        const it = btn.closest('.sel-item');
        if (it && !fav.length) navigate();
        else if (it) it.remove();
        break;
      }
      case 'save-cart': {
        [...cart].reverse().forEach((l) => toggleFav(l.slug, true));
        toast(null, 'Votre sélection est enregistrée : retrouvez-la dans « Sélection », en haut.', true);
        break;
      }
      case 'share-open': {
        const box = btn.closest('[data-share]');
        if (!box) break;
        if (touchShare()) {
          const d = shareData(box.dataset.share);
          navigator.share({ title: d.title, text: d.line, url: d.url }).catch((err) => { if (!err || err.name !== 'AbortError') shareMenu(box, true); });
          break;
        }
        shareMenu(box, $('.share__menu', box).hidden);
        break;
      }
      case 'share-copy': {
        const box = btn.closest('[data-share]');
        const d = shareData(box.dataset.share), msg = $('.share__msg', box);
        copyText(d.url).then((ok) => { msg.textContent = ok ? 'Lien copié : collez-le dans un e-mail ou un message.' : d.url; });
        break;
      }
      case 'birth': {
        const box = btn.closest('[data-birth]');
        const inp = $('.birth__url', box);
        const url = pageUrl(`#/p/${btn.dataset.slug}`);
        inp.value = url;
        $('.birth__help', box).hidden = false;
        copyText(url, inp).then((ok) => { const b = $('.birth__help b', box); if (b) b.textContent = ok ? 'Lien copié.' : 'Copiez ce lien.'; });
        break;
      }
      case 'share': {
        const msg = $('[data-share-msg]');
        const url = pageUrl('#/');
        copyText(url).then((ok) => { msg.hidden = false; msg.textContent = ok ? 'Lien copié : il ne reste qu’à l’envoyer.' : `Le lien à envoyer : ${url}`; });
        break;
      }
      case 'passe-pick': {
        PASSE.slug = btn.dataset.slug;
        $$('[data-action="passe-pick"]').forEach((b) => b.setAttribute('aria-checked', String(b === btn)));
        const f = $('[data-passe-form]');
        const msg = $('[data-passe-msg]');
        const w = f && Number(String(f.w.value).replace(',', '.'));
        if (msg) { msg.classList.remove('is-ok', 'is-warn'); msg.innerHTML = fr(w ? doorAnswer(BY[PASSE.slug], w).html : passeHint()); }
        break;
      }
      case 'toc': {
        const el = document.getElementById(btn.dataset.target);
        if (!el) break;
        $$('[data-action="toc"]').forEach((b) => b.classList.toggle('is-active', b === btn));
        if (lenis) lenis.scrollTo(el, { offset: -110 }); else el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
        break;
      }
      default: break;
    }
  });

  document.addEventListener('submit', (e) => {
    const nt = e.target.closest('[data-notify]');
    if (nt) {
      e.preventDefault();
      const m = $('[data-notify-msg]', nt);
      const mail = nt.email.value.trim();
      m.hidden = false;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) { m.textContent = 'Indiquez une adresse e-mail valide.'; m.classList.add('is-warn'); nt.email.focus(); return; }
      if (!nt.ok.checked) { m.textContent = 'Cochez la case pour que nous puissions vous écrire.'; m.classList.add('is-warn'); return; }
      const p = PDP.p, c = p.couleurs[PDP.color];
      m.classList.remove('is-warn');
      m.textContent = notYet(p) ? `C'est noté : nous vous écrivons à ${mail} le jour de la mise en vente ${/^[aeiouyéèêh]/i.test(p.nom) ? "d'" : 'de '}${p.nom}.` : `C'est noté : nous vous écrivons à ${mail} dès le retour ${/^[aeiouyéèêh]/i.test(p.nom) ? "d'" : 'de '}${p.nom} en ${c.nom}.`;
      SHOP_SUBSCRIBE(mail, ['prevenir', 'piece-' + p.slug, notYet(p) ? 'mise-en-vente' : 'couleur-' + colorSlug(c.nom)]);
      nt.classList.add('is-sent');
      return;
    }
    const door = e.target.closest('[data-door]');
    if (door) {
      e.preventDefault();
      const num = (f) => (f && f.value ? Number(String(f.value).replace(',', '.')) : 0);
      const a = doorAnswer(PDP.p, num(door.w), { esc: num(door.s), etage: door.etage ? door.etage.value : '' });
      const msg = $('[data-door-msg]');
      msg.hidden = false;
      msg.innerHTML = fr(a.html);
      msg.classList.toggle('is-warn', a.ok === false);
      if (a.done) { PDP.done.door = true; pdpSteps(); }
      return;
    }
    const pf = e.target.closest('[data-passe-form]');
    if (pf) {
      e.preventDefault();
      const a = doorAnswer(BY[PASSE.slug], Number(String(pf.w.value).replace(',', '.')));
      const msg = $('[data-passe-msg]');
      msg.innerHTML = fr(a.html);
      /* ok : true = elle passe, false = c'est juste, null = cotes du carton à vérifier (ton neutre) */
      msg.classList.toggle('is-warn', a.done && a.ok === false);
      msg.classList.toggle('is-ok', a.done && a.ok === true);
      return;
    }
    /* Inscription e-mail (pied de page, sélection) : aucun envoi réel dans la maquette */
    const nf = e.target.closest('[data-news], [data-selmail]');
    if (nf) { SHOP_NEWS(e, nf); return; }
    const f = e.target.closest('[data-form]');
    if (!f) return;
    e.preventDefault();
    const msg = $('[data-form-msg]', f);
    const nom = f.nom.value.trim(), mail = f.email.value.trim(), txt = f.message.value.trim();
    if (!nom || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail) || !txt) {
      msg.hidden = false;
      msg.textContent = fr('Merci d’indiquer votre nom, une adresse e-mail valide et votre message.');
      return;
    }
    const issue = f.hasAttribute('data-issue');
    const cmd = issue && f.commande.value.trim() ? `Commande ${f.commande.value.trim()}\n\n` : '';
    const body = `${cmd}${txt}\n\n${nom}\n${mail}`;
    const hasPhoto = issue && f.photo.files && f.photo.files.length;
    msg.hidden = false;
    msg.textContent = fr(hasPhoto ? 'Votre messagerie va s’ouvrir avec le message prêt : joignez-y la photo avant d’envoyer.' : 'Votre logiciel de messagerie va s’ouvrir avec le message prêt à envoyer.');
    window.location.href = `mailto:${SITE.email}?subject=${encodeURIComponent((issue ? 'Un souci · ' : 'Caplia · ') + f.sujet.value)}&body=${encodeURIComponent(body)}`;
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(true); });
  $('.nav__burger').addEventListener('click', toggleMenu);
  $('#lightbox').addEventListener('close', () => { if (lenis) lenis.start(); });
  $('#lightbox').addEventListener('click', (e) => { if (e.target.id === 'lightbox') e.target.close(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) pauseVideo(); else if ($('[data-hero]')) playVideo(); });
  window.addEventListener('hashchange', () => { if (/^#\/./.test(location.hash)) location.replace(TO_URL(location.hash)); });
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) { loadCart(); updateBadge(); refreshCart(); }
    if (e.key === FAV_KEY) { loadFav(); favBadge(); favBtnSync(); }
  });

  /* ---------------- Démarrage ---------------- */
  function initMotion() {
    const g = G(), st = ST();
    if (g && st) { g.registerPlugin(st); st.config({ ignoreMobileResize: true }); }
    if (!reduce && window.Lenis) {
      try {
        lenis = new window.Lenis({ duration: 1.15, smoothWheel: true, prevent: (node) => !!(node && node.hasAttribute && node.hasAttribute('data-rail')) });
        if (g && st) {
          lenis.on('scroll', st.update);
          g.ticker.add((t) => lenis.raf(t * 1000));
          g.ticker.lagSmoothing(0);
        } else {
          const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
          requestAnimationFrame(raf);
        }
      } catch (err) { lenis = null; }
    }
    /* parallaxe du fond à la souris (bureau seulement) */
    if (g && fine && !reduce) {
      const el = $('.scene__mouse');
      const qx = g.quickTo(el, 'x', { duration: 1.6, ease: 'power3.out' });
      const qy = g.quickTo(el, 'y', { duration: 1.6, ease: 'power3.out' });
      window.addEventListener('mousemove', (e) => {
        qx((e.clientX / window.innerWidth - .5) * -26);
        qy((e.clientY / window.innerHeight - .5) * -18);
      }, { passive: true });
    }
  }

  async function boot() {
    try {
      /* deux nouvelles tentatives si le réseau hoquette */
      const getJSON = async (u, n = 2) => { try { const r = await fetch(u); if (!r.ok) throw new Error(u); return await r.json(); } catch (e) { if (n > 0) { await new Promise((ok) => setTimeout(ok, 600)); return getJSON(u, n - 1); } throw e; } };
      /* studio.json est facultatif : sans lui, studioImg() montre les détourés */
      /* galeries, vues et modèles 3D : facultatifs ; préchargés par index.html (le serveur demande de toujours revalider) */
      const opt = (u) => fetch(u).then((r) => (r.ok ? r.json() : null)).catch(() => null);
      const D0 = await getJSON(CAPLIA.donnees);
      HANDLES = D0.handles || {};
      IMGV = D0.imgv || "";
      MEDIAS_IMPORT = D0.mediasImport || {};
      (D0.photosTheme || []).forEach((u) => THEME_PHOTOS.add(u));
      delete D0.photosTheme;
      const D = MAP_DATA(D0);
      const [c, s, st, ca, ga, vu, mo, cj, sj, mt, lv, cx, av, cp, nt, ft] = [D.catalogue, D.site, D.studio, D.cartes, D.galeries, null, null, D.categories, D.seo, D.matieres, D.livraison, D.cadeaux, D.avis, D.cadrage, D.notices || null, D.fiches || null];
      CAT = c; SITE = s;
      GALERIES = ga || {}; VUES = vu || {}; MODELES = (mo && mo.modeles) || {}; CADRAGE = cp || {}; NOTICES = nt || {};
      MAT = mt; ARR = lv; GIFTS = cx; AVIS = av; FT = (ft && ft.pieces) || {};
      kScenes();
      if (st) { (st.pieces || []).forEach((x) => { STUDIO[x.slug] = x; }); DETOURE = st.detoures || {}; }
      if (ca && ca.cartes) CARTES = { cartes: ca.cartes, large: ca.large || null, ensembles: ca.ensembles || {} };
      if (ca && ca.photo && ca.photo.pieces && ca.photo.largeurs) PHOTO = ca.photo;
      // Les pièces les plus chères d'abord : elles servent de repère, les autres paraissent ensuite raisonnables
      /* une pièce masquée n'existe pas pour le site : ni grille, ni suggestion, ni ensemble ; #/p/<slug> mène à la page introuvable */
      /* leurs noms, et les couleurs (en deux mots au moins) qu'aucune pièce en ligne ne porte : « Vert sous-bois », « Kaki garrigue »… */
      const vues = new Set(CAT.produits.filter((p) => !p.masque).flatMap((p) => p.couleurs.filter((c) => !c.retiree).map((c) => c.nom)));
      const caches = [...new Set(CAT.produits.filter((p) => p.masque).flatMap((p) => [p.nom, ...p.couleurs.map((c) => c.nom).filter((n) => /\s/.test(n) && !vues.has(n))]))]
        .map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      MASK_RE = caches.length ? new RegExp(`(^|[^\\p{L}])(${caches.join('|')})(?![\\p{L}])`, 'u') : null;
      PRODS = CAT.produits.filter((p) => !p.masque && SHOP_KEEP(p)).map((p) => prepare(SHOP_MERGE(p))).sort((x, y) => y.prix - x.prix);
      PRODS.forEach((p) => { BY[p.slug] = p; });
      indexCats(cj, sj);
      INDEX_VARIANTS();
      const cur = PRODS.find((p) => (CAPLIA.route || {}).gabarit === 'product' && p._h && p._h === CAPLIA.route.handle);
      if (cur) LINK_MEDIA(cur);
    } catch (err) {
      console.error(err);
      KEEP_SSR();
      return;
    }
    if (/^#\/./.test(location.hash)) { location.replace(TO_URL(location.hash)); return; }
    loadCart();
    updateBadge();
    loadFav();
    favBadge();
    initMotion();
    buildMenu();
    FIX_LINKS($('.nav-wrap'));
    navigate();
    SHOP_CART_RELOAD();
    if (location.hash.length > 1) { const t = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (t) setTimeout(() => t.scrollIntoView({ block: 'center' }), 120); }
    window.addEventListener('load', () => { if (ST()) ST().refresh(); });
  }

  const bootApresAffichage = () => requestAnimationFrame(() => setTimeout(boot, 0));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootApresAffichage);
  else bootApresAffichage();
})();
